const langCN = {
    add: "添加",
    after: "后",
    app: "应用",
    activated: "已启用",
    stoped: "已停止",
    all: "全部",
    allMember: "全部成员",
    avg: "平均",
    array: "数组",
    allow: "允许",
    abuseReport: "我要举报",
    ascending: "升序",
    average: "平均值",
    back: "返回",
    backTo: "返回",
    batchAdd: "批量添加",
    batchEdit: "批量编辑",
    before: "前",
    bind: "绑定",
    between: "在{{begin}}到{{end}}之间",
    bold: "粗体",
    batchOperation: "批量操作",
    briefing: "简报",
    cancel: "取消",
    checked: "勾选",
    china: "中国",
    city: "市",
    close: "关闭",
    clear: "清空",
    clearConfig: "清空配置",
    clearLink: "取消联动",
    collect: "收起",
    color: "颜色",
    comment: "评论",
    config: "配置",
    contact: "联系人",
    contacts: "通讯录",
    copy: "复制",
    generate: '生成',
    copies: "{{- name}}_拷贝",
    count: "计数",
    county: "县",
    current: "当前",
    custom: "自定义",
    chart: "流转图",
    data: "数据",
    dataSource: "数据来源",
    date: "日期",
    change: "更改",
    datetime: "日期时间",
    detail: "详情",
    displayName: "显示名",
    create: "新建",
    createDate: "提交日期",
    dash: "报表",
    dashboard: "工作台",
    "go.dashboard": "返回工作台",
    day: "日",
    days: "天",
    deal: "处理",
    defaults: "默认值",
    default: "默认",
    delete: "删除",
    deleted: "已删除",
    description: "描述信息",
    dingtalk: "钉钉",
    done: "完成",
    doned: "已完成",
    disabled: "不可用",
    disable: "禁用",
    district: "区",
    download: "下载",
    dynamic: "动态",
    dynamicEmpty: "暂无动态",
    dynamicParameter: "动态参数",
    dynamicNotifier: "动态提醒人",
    department: "部门",
    descending: "降序",
    error: "错误",
    line: "行",
    lineHeight: "行高",
    height1: "高",
    middle: "中",
    low: "低",
    adaptive: '自适应',
    auto: "自动",
    Left: "还剩 ",
    "subform.mobile.mode": "移动端显示样式",
    "chinese.descending": "中文降序",
    "ascii.descending": "Ascii降序",
    "chinese.ascending": "中文升序",
    "ascii.ascending": "Ascii升序",
    earliest: "最早",
    excel: "工作表",
    etl: "数据视图",
    edit: "编辑",
    qickedit: '快捷编辑',
    'qickedit.open': '打开快捷编辑',
    'qickedit.close': '关闭快捷编辑',
    'data.manager.qickedit': '打开快捷编辑后，在数据管理界面，编辑数据不触发公式联动扩展效验',
    editable: "可编辑",
    equal: "等于",
    empty: "「空」",
    emptyValue: "空值",
    enabled: "可用",
    enable: "启用",
    export: "导出",
    explain: "说明",
    expr: "表达式",
    every: "每",
    exemption: "限免",
    fail: "失败",
    field: "字段",
    filter: "筛选",
    fixedChars: "固定字符",
    fontFamily: "字体",
    fontSize: "字号",
    format: "格式",
    formerName: "原名：{{- name}}",
    formula: "公式",
    functionIntro: "功能介绍",
    future: "未来",
    free: "免费",
    email: "邮箱",
    already: "已",
    fullScreen: "全屏",
    exitfullScreen: "退出全屏",
    fx: "平台",
    form: "表单",
    gather: "汇总",
    goHome: "返回首页",
    goImport: "继续导入",
    group: "分组",
    halfLine: "1/2",
    help: "帮助",
    helpCenter: "帮助中心",
    hide: "隐藏",
    home: "首页",
    hongkong: "中国香港",
    hour: "时",
    IDNum: "身份证号码",
    iSee: "我知道了",
    import: "导入",
    invite: "邀请",
    incNumber: "自动计数",
    italic: "斜体",
    language: "语言",
    label: "标题",
    latLng: "纬度：{{latitude}}，经度：{{longitude}}",
    learnMore: "了解更多",
    leaveNotSaveTip: "离开当前页后，您所做的修改不会被保存",
    latest: "最新",
    layout: "排列方式",
    legend: "图例",
    loading: "加载中...",
    loadMore: "加载更多",
    log: "日志",
    source: "源码",
    more: "更多",
    move: "移动",
    macao: "中国澳门",
    max: "最大值",
    min: "最小值",
    mingdao: "明道",
    minute: "分",
    meaning: "含义",
    member: "成员",
    outsider: "外部联系人",
    outsiderGroup: "外部联系人分组",
    meter: "米",
    meters: "{{meters}}米",
    mobileNum: "手机号码",
    modify: "修改",
    modifyConfig: "修改配置",
    manager: "管理员",
    money: "金额",
    month: "月",
    months: "个月",
    must: "必须",
    name: "姓名",
    nextStep: "下一步",
    new: "创建",
    navigator: "导航器",
    nickname: "昵称",
    nothing: "无",
    notSupport: "不支持",
    support: "支持",
    off: "关",
    official: "官方",
    ok: "确定",
    on: "开",
    openBrowser: "在浏览器中打开",
    openDashboard: "打开工作台",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    open: "打开",
    openLink: "打开链接",
    operator: "操作人",
    option: "选项",
    optional: "选填",
    or: "或",
    organization: "组织架构",
    other: "<其他>",
    'other.ext': "<其他>",
    print: "打印",
    pause: "暂停",
    paused: "已暂停",
    qrCode: "二维码",
    query: "查询",
    querying: "正在查询...",
    past: "过去",
    colorful: "彩色",
    params: "参数",
    password: "密码",
    passForget: "忘记密码",
    passReset: "重置密码",
    emailPassReset: "邮箱找回密码",
    phonePassReset: "手机找回密码",
    preview: "预览",
    previewFail: "预览失败",
    province: "省",
    phone: "手机",
    'phone.email': "手机/邮箱",
    "phone.code.qr.tip": "手机扫码上传",
    prevStep: "上一步",
    quarter: "季",
    read: "已读",
    recover: "恢复",
    remove: "删除",
    redo: "重做",
    refresh: "刷新",
    release: "发布",
    rename: "重命名",
    "rename.group": "重命名分组",
    "delete.group": "删除分组",
    renew: "续费",
    resigned: "已删除",
    robot: "系统机器人",
    role: "角色",
    required: "必填",
    report: "报表",
    reselect: "重新选择",
    reimport: "重新导入",
    save: "保存",
    "save.as": "另存",
    scanCode: "扫码",
    search: "搜索",
    second: "秒",
    share: "分享",
    searching: "搜索中...",
    select: "--请选择--",
    selectAll: "全选",
    selectAllSearchResult: "搜索结果全选",
    send: "发送",
    setting: "设置",
    settingDone: "已设置",
    server: "服务器",
    show: "显示",
    signin: "登录",
    signout: "退出账号",
    signup: "注册",
    sinaWeibo: "新浪微博",
    skip: "跳过",
    state: "状态",
    submit: "提交",
    sum: "求和",
    success: "成功",
    sort: "排序",
    'sort.value.same': "按相同值排序",
    tax: "税率",
    taiwan: "中国台湾",
    talkLater: "以后再说",
    telNum: "电话号码",
    text: "文本",
    tencentQQ: "腾讯QQ",
    time: "时间",
    times: "次",
    timeBegin: "开始时间",
    timeEnd: "结束时间",
    timeout: "已超时",
    timestamp: "时间戳",
    title: "标题",
    today: "今天",
    total: "共计",
    transparent: "透明",
    translate: "转换",
    type: "类型",
    unbind: "解绑",
    unbindqywx: "解绑企业微信",
    unchecked: "不勾选",
    underline: "下划线",
    undo: "撤销",
    unbindSuccess: "解绑成功",
    unbindFail: "解绑失败",
    unfilled: "未填写",
    unknown: "未知",
    unlimited: "不限",
    unnamed: "未命名",
    unnamedData: "未命名数据",
    unread: "未读",
    update: "更新",
    updated: "已修改",
    updater: "修改人",
    upgrade: "升级",
    username: "用户名",
    use: "使用",
    validate: "校验",
    validCode: "验证码",
    variable: "变量",
    verify: "验证",
    view: "查看",
    visible: "可见",
    wework: "企业微信",
    wechat: "微信",
    "wechat.enhance.title": "微信增强",
    "wechat.enhance.desc": "开启后，仅支持在手机微信中填写，可获取填写者微信信息。只适应于表单外链和表单内链直接访问链接的场景",
    "wechat.enhance.getEditorInfo": "获取填写者信息",
    "wechat.enhance.notice": "注：通过微信公众号获取信息",
    "wechat.enhance.get.automatic": "静默获取",
    "wechat.enhance.get.automatic.tooltip": "直接填写表单，后台自动获取，仅获取微信OpenID",
    "wechat.enhance.get.fromDialog": "弹窗获取",
    "wechat.enhance.get.fromDialog.tooltip": "填表前会弹窗请求授权，填写者确认后，可获取微信个人信息",
    "wechat.enhance.scan.fill": "请使用微信扫码填写",
    wechatQRCode: "请使用微信扫描二维码登录",
    week: "周",
    when: "当",
    wholeLine: "全部",
    widget: "字段",
    widgetName: "字段名称",
    year: "年",
    years: "年",
    yes: "是",
    zipCode: "邮政编码",
    zoomIn: "放大",
    zoomOut: "缩小",
    top: "上",
    bottom: "下",
    left: "左",
    right: "右",
    "account.setting": "账号设置",
    "account.bind": "账号绑定",
    "account.fx.bind": "绑定已有账号",
    "account.mode": "账号模式",
    "account.mode.weChat": "企业微信集成模式",
    "account.mode.dingTalk": "钉钉集成模式",
    "account.mode.public": "公共模式",
    "account.info.update.fail": "账号信息修改失败",
    "account.unbind": "账号解绑",
    "account.unbind.confirm": "确定解绑该{{type}}账号?",
    "account.cancel": "注销企业账号",
    "account.cancel.apply": "企业账号注销申请",
    "account.cancel.apply.publicLetter": "申请公函",
    "account.cancel.apply.publicLetter.name": "《注销企业申请公函模板》",
    "account.cancel.apply.publicLetter.download": "请先下载{{- link}}，填写完成并加盖公章后拍照上传。",
    "account.cancel.warning": "注销企业账号会清空所有通讯录数据以及已经产生的所有业务数据和应用，且无法恢复，请谨慎操作！",
    "account.cancel.tip": "如确定要注销账号，请认真填写以下信息，我司将在3个工作日内联系您并完成账号注销的后续工作，请保持电话畅通。",
    "account.cancel.success.tip": "您已经提交注销申请，我司将在3个工作日内联系您并完成账号注销的后续工作，请保持电话畅通。",
    "account.cancel.reason": "账号注销原因",
    "account.passForget.login": "返回登录",
    "account.passForget.loginName.placeholder": "您注册时使用手机号或邮箱",
    "account.passForget.loginName.errTip": "手机号/邮箱错误",
    "account.passReset.success": "密码重置成功",
    "account.passReset.fail": "密码重置失败!",
    "account.passReset.login": "立即登录",
    "account.passReset.newPass.placeholder": "新密码，至少6位",
    "account.register.account": "注册账号",
    "account.register.captcha.placeholder": "图片验证码",
    "account.register.phone.errTip": "手机号错误",
    "account.register.email.errTip": "邮箱不正确",
    "account.register.email.placeholder": "请输入您的邮箱",
    "account.register.hasAccount": "已有账号？",
    "account.register.incomplete": "注册信息填写不完整!",
    "account.register.invite.guide": "您的团队中还没有成员，现在邀请成员协同办公吧～",
    "account.register.password.placeholder": "密码，至少6位",
    "account.register.phone.placeholder": "您的手机号",
    "account.register.readAccept": "点击注册表明您已阅读并同意",
    "account.register.signin": "直接登录",
    "account.register.success": "注册成功",
    "account.register.switch.email": "手机号无法注册？点击此处",
    "account.register.switch.phone": "邮箱无法注册？点击此处",
    "account.register.term": "《服务条款》",
    "account.register.userName.errTip": "账号支持字母、数字和下划线，需以字母开头，至少需要3位",
    "account.register.phone.exist": "手机号已存在，请直接登录",
    "account.register.validCode.placeholder": "收到的验证码",
    "account.signin.account": "账号登录",
    "account.signin.dingtalk": "钉钉登录",
    "account.signin.wechat": "企业微信登录",
    "account.signin.wechat1": "微信登录",
    "account.signin.sso": "单点登录",
    "account.signin.sso.tip": "请配置完单点登录后再来勾选",
    "account.signin.autoSignin": "记住密码",
    "account.signin.forgetPass": "忘记密码了?",
    "account.signin.hasNoAccount": "还没有账号？",
    "account.signin.register": "立即注册",
    "account.signin.otherAccount": "其他登录",
    "account.signin.wechatOpenTip": "还未开通企业微信？",
    "account.signin.dingtalkOpenTip": "还未开通钉钉？",
    "account.signin.corpOpen": "立即开通",
    "account.signin.qrcode": "点击扫码登录",
    "account.signin.signinWithFX": "普通账号登录",
    "account.signin.user.placeholder": "手机号/邮箱/账号",
    "account.signin.user.emptyTip": "请输入手机号/邮箱/账号",
    "account.signin.phone.email": "请输入手机号/邮箱号",
    "account.signin.failTip": "账号或密码错误",
    "account.signin.wework.member": "企业微信成员登录",
    "account.signin.wework.admin": "企业微信管理员登录",
    "account.signin.banner.text": "点击获取「设备管理2.0」方案",
    "account.signinCorp.dingtalkTitle": "使用钉钉客户端扫描二维码即可登录企业应用系统",
    "account.signinCorp.wechatTitle": "使用企业微信扫描二维码即可登录企业应用系统",
    "account.success.teamJoin": "您已加入团队",
    "account.success.enter": "进入系统",
    "account.info": "我的账号信息",
    "align.top": "顶部对齐",
    "align.center": "居中对齐",
    "align.bottom": "底部对齐",
    "align.left": "左对齐",
    "align.right": "右对齐",
    "repeat.tip": '此项内容已存在，不允许重复提交',
    "validate.tip": '请正确填写【{{name}}】',
    "api.aliasOrId": "字段别名/字段ID",
    "api.alias.format.tip": "存在格式不正确的值",
    "api.alias.notSaveTip": "离开当前页后，您的设置不会被保存",
    "api.alias.reserve.tip": "使用了保留字",
    "api.alias.repeat.tip": "存在重复值",
    "api.alias.set": "设置字段别名",
    "api.alias.set.tip": "数据推送、发送API请求和返回响应数据时，使用字段别名来替换字段ID",
    "api.alias.rule.lowercase": "「小写字母」",
    "api.alias.rule.number": "「数字」",
    "api.alias.rule.underline": "「下划线」",
    "api.alias.set.info": "注：字段别名仅允许使用{{- lowercase}}{{- number}}和{{- underline}}组合，且必须以{{- begin}}开头",
    "api.auth": "认证方式",
    "api.auth.token": "使用基于简单令牌的身份验证{{- where}}，APIKey默认未生成，需要点击{{- button}}生成。 生成方式：{{- step1}} >> {{- step2}} >> {{- step3}}，点击右侧的{{- document}}可以查看对应的API文档。",
    "api.auth.genTokenInAccount": "（在「开放平台」>>「密钥管理」生成或管理您的密钥）",
    "api.auth.key": "API Key",
    "api.auth.key.reset": "对于生成的APIKey还可以进行重置和删除。",
    "api.auth.setHttpHeaders": "通过 HTTP Headers 设置{{- auth}}的值为{{- yourKey}}来进行安全性认证",
    "api.auth.example": "示例如下：",
    "api.auth.warning": "请注意：APIKey与您的账户拥有相同的权限，请务必保密！",
    "api.create": "新建单条数据接口",
    "api.createData": "新增数据",
    "api.create.desc": "在指定表单中添加一条数据。",
    "api.CeateKey": "创建API Key",
    "api.CeateKey.success": "创建成功",
    "api.doc": "API文档",
    "api.doc.alias.idNotChange": "表单字段一旦添加，会以_widget_为前缀的固定字段ID来表示字段，无论修改字段的任何信息都不会变更字段ID。",
    "api.doc.alias.set": "每个字段都对应着一个字段。用户可以自己设置{{- alias}}。{{- setTip}}",
    "api.doc.alias.set.tip": "如果设置了别名，则在之后所有的API中，字段所对应的字段名都将以{{- widgetAlias}}作为实际字段名；如果没有设置别名，则字段将采用{{- widgetId}}作为实际字段名。",
    "api.desc": "您可以通过我们提供的API接口来整合数据及其他外部数据。",
    "api.delete": "删除单条数据接口",
    "api.delete.desc": "按照指定数据ID删除表单中的数据，删除的数据进入回收站。",
    "api.deleteData": "删除数据",
    "api.selectApp": "请选择应用来查看API文档",
    "api.error.example": "当状态返回码为400时，服务器会返回具体的错误码 code 和错误信息 message，对照表如下：",
    "api.error.table": "错误对照表",
    "api.error.table.tip": "所有API使用{{- code}}的响应方式来表示错误原因。接口正确统一返回HTTP状态码为{{- successCode}}的正确响应。接口错误统一返回HTTP状态码为{{- errorCode400}}的错误响应，同时响应内容会返回{{- errorCode}}和{{- errorMessage}}。",
    "api.error.table.example": "状态返回码对照表如下：",
    "api.error.statusCode": "状态返回码（status code）",
    "api.error.res": "接口错误统一返回",
    "api.error.code": "错误码（code）",
    "api.error.2009": "没有应用操作权限",
    "api.error.3005": "接口参数不正确",
    "api.error.4000": "数据提交失败",
    "api.error.4001": "数据不存在",
    "api.error.8301": "签名校验失败",
    "api.error.8302": "没有接口请求权限",
    "api.error.8303": "超出请求频率限制",
    "api.error.statusAndErrorCode": "状态码+错误码",
    "api.error.message": "错误信息（message）",
    "api.key.view.click": "点击查看API Key",
    "api.getMultiData": "读取多条数据",
    "api.getOneData": "读取单条数据",
    "api.intro": "介绍",
    "api.key.reset": "重置API Key",
    "api.key.reset.confirm": "您确定要重置API Key吗？",
    "api.key.reset.tip": "重置API Key后，现有的API集成将停止工作。",
    "api.key.reset.success": "重置成功",
    "api.key.delete": "删除API Key",
    "api.key.delete.confirm": "您确定要删除API Key吗？",
    "api.key.delete.tip": "删除API Key后，现有的API集成将停止工作。",
    "api.key.warning": "API Key与您的管理员账户具有相同的权限，请务必保密",
    "api.key.auth": "安全认证",
    "api.key.auth.tip": "为确保信息安全，请输入您的登录密码",
    "api.limit": "频率限制",
    "api.limit.num": "5次/秒",
    "api.notSupport": "另外，系统字段 和 以下所列举的字段{{- notSupport}}添加和修改数据：",
    "api.notSupport.file": "图片、附件、手写签名",
    "api.notSupport.link": "关联数据、关联查询",
    "api.overview": "下面的API文档是专门为您根据当前表单的配置生成的，提供了完整的样例数据结构和请求路径。如果您删除/添加字段或者修改字段标题，则该文档里所对应的字段字段的其他信息也会相应更改。",
    "api.params.data": "数据内容",
    "api.params.desc.dataId": "上一次查询数据结果的最后一条数据的ID，没有则留空",
    "api.params.desc.fields": "需要查询的数据字段",
    "api.params.desc.data": "数据内容，同数据提交",
    "api.params.desc.filter": "数据筛选器",
    "api.params.desc.items": "仅子表单字段有；数组里包含了每个子字段的信息",
    "api.params.desc.isTriggerFlow": "用来控制是否触发流程，默认不触发流程",
    "api.params.desc.isStartTrigger": "用来控制是否触发智能助手，默认不触发智能助手",
    "api.params.desc.limit": "查询的数据条数，1~100，默认100",
    "api.params.desc.name": "字段名、字段ID（可设置字段别名）",
    "api.params.desc.title": "字段标题",
    "api.params.desc.type": "字段类型；每种字段类型都有对应的数据类型",
    "api.query": "查询多条数据接口",
    "api.query.desc": "该接口的返回数据，始终{{- order}}。",
    "api.query.order": "按照提交时间正序排列",
    "api.query.single": "查询单条数据接口",
    "api.query.single.desc": "按照指定数据ID获取表单中的数据。",
    "api.req.example": "请求示例：",
    "api.req.params": "请求参数：",
    "api.req.noParams": "请求参数：无",
    "api.res": "响应内容：",
    "api.res.example": "响应数据样例：",
    "api.res.getFields": "每一个表单字段都表示一个字段，只要字段不删除，字段ID就不会变化。",
    "api.res.order": "按照数据ID正序排列",
    "api.res.success": "响应成功",
    "api.rule": "规则",
    "api.rule.host": "API的统一访问地址为",
    "api.rule.https": "所有API请求都必须通过HTTPS进行身份验证和发起",
    "api.rule.post": "统一采用POST请求的形式",
    "api.rule.utf8": "数据传输编码为UTF-8",
    "api.rule.json": "所有数据均为JSON格式",
    "api.supply.phoneAndPass": "请补充手机号和密码",
    "api.supply.phoneAndPass.tip": "API Key与您的管理员账户具有相同的权限，为了您的账号安全，请先绑定手机号并设置密码。",
    "api.update": "修改单条数据接口",
    "api.updateData": "编辑数据",
    "api.update.desc": "按照指定数据ID修改表单中的数据。",
    "api.warning": "请注意：表单字段一旦添加，则以_widget_为前缀的字段ID将不再会发生变更。",
    "api.widget.info": "字段信息",
    "api.widget.alias": "字段别名",
    "api.widget.linkquery": "关联查询字段",
    "api.widget.separator": "分割线字段",
    "api.widget.valueTable": "字段与数据类型对照表",
    "api.widgets": "表单字段查询接口",
    "api.widgets.desc": "获取指定表单的字段/字段信息，除{{- separator}}和{{- linkquery}}以外。具体可以查阅{{- widgetsTable}}。",
    "app.category.quickStart": "快速上手",
    "app.category.rank": "精选推荐",
    "app.category.application": "用途",
    "app.category.common": "行业",
    "app.category.feature": "功能",
    "app.category.it": "IT互联网",
    "app.category.manufacturing": "制造业",
    "app.category.trade": "贸易零售",
    "app.category.service": "服务业",
    "app.category.education": "教育培训",
    "app.category.housing": "建筑房产",
    "app.category.financial": "金融",
    "app.category.medicine": "医疗医药",
    "app.category.government": "政府单位",
    "app.category.logistics": "物流运输",
    "app.category.businessService": "商业服务",
    "app.category.hr": "人力行政",
    "app.category.audit": "财务报销",
    "app.category.office": "办公协作",
    "app.category.inventory": "进销存",
    "app.category.store": "门店管理",
    "app.category.crm": "客户关系",
    "app.category.sales": "销售",
    "app.category.project": "项目任务",
    "app.category.production": "生产管理",
    "app.category.assetEquipment": "资产设备",
    "app.category.formula": "公式函数",
    "app.category.flow": "流程",
    "app.category.aggregate": "聚合表",
    "app.category.print": "自定义打印",
    "app.category.dataRely": "数据联动",
    "app.category.dataAuth": "数据权限",
    "app.category.dataAuth1": "数据权限",
    "app.category.notify": "推送提醒",
    "app.category.association": "选项关联",
    "app.category.dataSubmit": "提交扩展",
    "app.category.signature": "手写签名",
    "app.category.dashboard": "报表",
    "app.list": "应用列表",
    "app.set.share": "表单/报表发布",
    "app.set.auth": "报表数据权限",
    "app.set.bridge.emptyTip": "请选择需要跨应用使用的表单",
    "app.set.url": "应用URL",
    "app.set.url.tip": "自定义应用URL, 可使用URL直接打开该应用",
    "app.set.url.placeholder": "请输入url",
    "app.set.entry": "1.选择表单/报表",
    "app.set.auth.fail1": "权限获取失败！",
    "app.set.auth.fail2": "请先选择需要授权的页面！",
    "app.set.filter.tip": "添加表单过滤条件设定报表的数据查看范围",
    "app.set.save.fail1": "应用名称不能为空！",
    "app.set.save.fail2": "应用URL包含非法字符！",
    "app.set.auth.tip": "成员不在列表中？请点击同步成员",
    "app.set.range": "2.选择发布范围",
    "app.set.data.auth.member": "1.选择部门/成员",
    "app.set.data.auth.filter": "2.设置过滤条件",
    "app.mine": "我的应用",
    "my.app": "我的应用",
    "dash.mine": "我的图表",
    "dash.mine.empty": "暂无图表",
    "dash.favorites.empty": "暂无收藏",
    "app.carousel.map": "轮播图",
    "app.recent.use": "最近使用",
    "app.rich.text": "富文本",
    "app.notice.board": "公告栏",
    "app.favorites": "我的收藏",
    "app.favorites.tip": "收藏",
    "app.favorites.cancel": "取消收藏",
    "app.favorites.fail": "收藏已失效",
    "app.favorites.max.tip": "最多只能收藏{{count}}个",
    "image.upload.rules": '支持jpg、jpeg、png、gif格式,单张5M以内',
    "image.upload.rules.one": '支持jpg、jpeg、png、gif格式,单张{{count}}M以内',
    "image.upload.length.rules": '不能超过10张图片',
    "image.upload.size.rules": '超过5M',
    "image.upload.size.rules.one": '超过{{count}}M',
    "form.theme.imageMore.center": "原图居中",
    "form.theme.imageMore.centerCover": "居中填满",
    "form.theme.imageMore.stretchCover": "拉伸填满",
    "dash.image.position": "填充方式",
    "dash.image.automatic.seeding": "自动轮播",
    "image.between.rotations": "轮播间隔",
    "app.template.owned": "我的应用模板",
    "app.notFound": "应用不存在或没有访问权限，请联系团队管理员",
    "app.dotGuide.appList": "创建的应用展示在这里。点击此处进入应用管理",
    "app.create": "创建应用",
    "app.create.new": "创建新应用",
    "app.empty": "当前没有可访问应用",
    "app.empty.tip": "您当前没有应用，请到工作台创建应用",
    "app.empty.tip.creatOwnCorp": "您当前没有任何团队，请创建",
    "app.create.tip": "请联系贵司管理员将表单/报表共享给您",
    "app.create.empty": "创建空白应用",
    "app.create.empty.tip": "从零开始创建全新应用",
    "app.create.fromTemplate": "模板中心创建",
    "app.create.fromTemplate.tip": "安装模板，快速开展您的业务",
    "app.custom": "定制应用",
    "app.custom.tip": "官方团队为您个性化定制",
    "app.manage": "管理应用",
    "app.install.report.convert": "应用安装成功，安装时已将报表升级为报表",
    "app.install.guide": "点击此处安装应用",
    "app.installing": "正在安装应用...",
    "app.name": "应用名称",
    "app.name.update.fail": "修改名称失败!",
    "app.copy": "复制应用",
    "app.copy.confirm": "您是否要复制“{{- name}}”?",
    "app.copy.tip": "复制应用会复制该应用的表单、报表等，但不会复制应用内数据",
    "app.copy.success": "应用已复制",
    "app.copy.fail": "应用复制失败",
    "app.delete": "删除应用",
    "app.delete.success": "应用已删除",
    "app.delete.warning": "删除应用则表单、报表以及数据也都将一并删除，且无法还原。",
    "app.delete.warning.extraFunc": "此应用内有表单被{{- func}}功能调用！删除应用则表单、报表以及数据也都一并删除，同时将删除表单的数据使用权限，无法还原。",
    "app.delete.typeName": "如确定删除，请输入应用名称：",
    "app.desc": "应用描述",
    "app.desc.placeholder": "请输入对应的描述，帮助其他用户了解应用功能",
    "app.style.edit": "修改样式",
    "app.state.review": "正在审核",
    "app.publish.template": "发布到模板中心",
    "app.publish.enable.tip": "未启用的报表不会发布到模板中心，如需发布请先启用",
    "app.publish.continue": "继续发布",
    "app.cannot.publish": "该应用无法发布到模板中心",
    "app.publish.template.confirm": "确定要发布此应用到模板中心吗？",
    "app.publish.template.fail": "应用发布失败!",
    "app.publish.template.tip": "此应用本身及其部分数据会被提交到模板中心，如果不希望公开当前应用数据，请复制此应用并准备示例数据后发布。",
    "app.publish.noLongerDisplay": "以后不再显示",
    "app.review.tip": "已提交审核，请等待…",
    "app.noAuth.operate": "您没有应用操作权限",
    "app.noAuth.visit": "您没有应用访问权限",
    "app.noAuth.visit.tip": "在当前团队「{{corp}}」内没有权限，请联系管理员分配权限或切换至其他团队",
    "app.deleted.tip": "应用已被删除，去工作台转转吧～",
    "app.visit.enter": "进入应用访问",
    "app.edit.enter": "进入应用管理",
    "app.trial": "还可以试用{{day}}天{{hour}}小时{{minute}}分",
    "app.trial.tip": "试用结束后应用内高级功能将纳入用量统计",
    "auth.group": "权限组",
    "auth.group.empty": "暂无相关权限组",
    "auth.group.submit.name": "直接提交数据",
    "auth.group.submit.description": "在此分组内的成员只可以填报数据，设置了页面共享的成员自动加入此分组",
    "auth.group.manage.name": "管理全部数据",
    "auth.group.manage.description": "在此分组内的成员可以管理全部数据",
    "auth.group.manage.description.dash": "在此分组内的成员可以管理全部数据，并拥有所有菜单权限",
    "auth.group.manage.description.dash.chart": "在此分组内的成员可以查看全部数据，并拥有所有菜单权限",
    "auth.group.review.name": "查看全部数据",
    "auth.group.review.description": "在此分组内的成员可以查看所有数据",
    "auth.group.manageOwn.name": "管理本人数据",
    "auth.group.manageOwn.description": "在此分组内的成员可以管理自己填报的数据",
    "auth.group.manageOwn.description.dash": "在此分组内的成员可以管理自己数据，并拥有所有菜单权限",
    "auth.group.manageOwn.description.dash.chart": "在此分组内的成员可以查看自己数据，并拥有所有菜单权限",
    "auth.group.deleteTip1": "该权限组中有多名成员，",
    "auth.group.deleteTip2": "删除后该权限组将失效，且无法还原",
    "app.set": "应用设置",
    "app.group": "应用分组",
    "app.log": "应用日志",
    "app.defaultName": "未命名应用",
    "app.edit.group.create": "新建分组",
    "app.edit.group.placeholder": "请输入分组名称",
    "app.edit.group.fail1": "分组新建失败",
    "app.edit.group.fail2": "分组信息不能为空",
    "app.edit.group.fail3": "获取分组信息失败",
    "app.edit.group.empty": "--无分组--",
    "app.edit.group.deleteTip": "非空分组不能删除!",
    "app.edit.group.moveTo": "移动到「{{- groupName}}」",
    "app.edit.sequenceChange": "调整顺序",
    "app.edit.sequenceDone": "完成排序",
    "app.edit.move.success": "移动成功",
    "app.edit.exist": "已创建的",
    "app.edit.folder.select": "请选择目标文件夹",
    "app.edit.menu.guideTip": "支持拖拽排序啦",
    "app.edit.coopForm.create": "新建表单",
    "app.edit.coopForm.createTip": "表单可用来搜集数据，并带有数据协作功能，适合进行数据上报",
    "app.edit.flowForm.create": "新建流程表单",
    "app.edit.flowForm.createTip": "流程表单适合报销、请假申请或其他工作流",
    "app.edit.dash.create": "新建报表",
    "app.edit.dash.createTip": "报表是数据可视化工具，适合进行数据展现和分析",
    "app.edit.report.create": "新建报表",
    "app.edit.report.createTip": "报表适合用来进行数据汇总、结果展示，趋势分析等",
    "app.edit.formCreate.empty": "创建空白表单",
    "app.edit.formCreate.excel": "从Excel创建表单",
    "app.edit.toCoopForm": "切换为普通表单",
    "app.edit.toCoopForm.msg": "切换为普通表单，流程相关功能将不可用，是否确认切换？",
    "app.edit.toFlowForm": "切换为流程表单",
    "app.edit.toFlowForm.msg": "切换为流程表单，数据管理权限设置将不可用，是否确认切换？",
    "app.edit.change.success": "切换成功",
    "app.edit.copyToCurrent": "复制到当前应用",
    "app.edit.copyToOther": "复制到其他应用",
    "app.edit.target.select": "请选择目标应用",
    "app.edit.copy.success": "复制成功",
    "app.edit.copy.fail": "复制失败",
    "app.edit.delete.confirm": "如确定删除，请输入表单名称：",
    "app.edit.appBridge": "『跨应用』",
    "app.edit.delete.hasAppBridge": "此表单中有{{count}}条数据，且已被{{ref}}功能调用！删除表单将清空数据，同时将删除表单的数据使用权限，无法还原。",
    "app.edit.delete": "此表单中有{{count}}条数据！删除表单将清空数据，且无法还原。",
    "app.edit.dashDelete.msg": "删除报表会同时删除报表的访问权限，且无法还原。",
    "app.edit.entryDelete.msg": "删除报表会同时删除报表的访问权限，且无法还原。",
    "app.load.empty.title": "该应用已被删除",
    "app.load.empty.msg": "该应用已被管理员删除，请打开工作台选择其他应用",
    alliance: "服务商联盟",
    "alliance.guide.title": "加入推广联盟",
    "alliance.guide.subTitle": "获得高额推广奖励",
    "alliance.guide.join": "立刻加入",
    "alliance.guide.step.title": "只需三步，轻松获取推广收益",
    "alliance.guide.step1": "第一步：填写个人资料，申请加入推广联盟",
    "alliance.guide.step2": "第二步：获得推广链接，推广产品",
    "alliance.guide.step3": "第三步：如果您推荐的用户购买了高级版本，至少400元的现金分成",
    "alliance.guide.bannerText": "抢先推广，享受前期红利",
    "alliance.guide.company": "公司简介",
    "alliance.guide.phone": "咨询热线",
    "alliance.guide.social": "用户交流群",
    "alliance.guide.marketing": "市场合作",
    "alliance.guide.copyRight": "©2016-2020 长沙异次元网络科技有限公司版权所有",
    "alliance.apply.state.noApply": "申请理由未达到要求。",
    "alliance.apply.state.empty": "该页面不存在!",
    "alliance.apply.state.noPass": "很抱歉，您的申请未通过审核",
    "alliance.apply.broadcast": "推广平台将带来经济收入，为避免可能的经济纠纷，请确保您对平台账号的完全所有权。如果您不确定自己对账号的所有权，我们推荐您注册新账号",
    "alliance.apply.reason": "原因：",
    "alliance.apply.forbidden": "很抱歉，您的账号已被禁用",
    "alliance.apply.inquiry": "如有疑议，请咨询",
    "alliance.apply.check.fail": "此项有误",
    "alliance.apply.submit": "提交申请",
    "alliance.apply.reSubmit": "重新申请",
    "alliance.apply.success": "您的申请已提交，请等待审核",
    "alliance.apply.successTip": "推广联盟正在小范围测试阶段，部分用户的申请可能受到影响，别担心，我们会尽快审核您的申请。",
    "alliance.apply.faq": "常见问题",
    "alliance.apply.faq.q1": "什么是平台推广联盟？",
    "alliance.apply.faq.a1": "平台推广联盟是平台合作伙伴的一种类型，参与平台联盟可获得推广奖励、应用迁移、参与扶持计划助力事业发展等特殊待遇。",
    "alliance.apply.faq.q2": "我是否应该加入平台推广联盟？",
    "alliance.apply.faq.a2": "首先要认可平台，相信平台的发展空间。拥有合法的流量资源或者客户资源，或者需要迁移应用，希望借助平台助力事业发展等，欢迎加入推广联盟获得更多回报。",
    "alliance.apply.faq.q3": "向朋友推荐了平台，会获得什么？",
    "alliance.apply.faq.a3": "丰厚的佣金回报，能力强者可获得平台官方资源支持帮你更好的推广。",
    "alliance.manage.alliance": "推广平台",
    "alliance.manage.own": "我的推广",
    "alliance.manage.account": "我的账户",
    "alliance.manage.datum": "个人资料",
    "alliance.account.income": "累计赚取佣金",
    "alliance.account.cashed": "累计提现金额",
    "alliance.account.cashable": "可提现佣金",
    "alliance.account.apply": "申请提现",
    "alliance.account.record": "交易记录",
    "alliance.account.category": "类别",
    "alliance.account.order": "推荐佣金",
    "alliance.account.cash": "提现",
    "alliance.account.tax": "扣税",
    "alliance.account.tax.tooltip": "我司按国家法定政策代扣代缴相关税费，缴纳比例以实际结算金额为准",
    "alliance.account.ordered": "已到账",
    "alliance.account.state.waiting": "审核中",
    "alliance.account.state.denied": "提现失败",
    "alliance.account.state.paid": "提现成功",
    "alliance.account.money": "元",
    "alliance.profile.authenticated": "已认证",
    "alliance.profile.fullName.errMsg": "请输入姓名",
    "alliance.profile.alipay": "支付宝",
    "alliance.profile.alipay.errMsg": "请输入支付宝账号",
    "alliance.profile.pass": "提现密码",
    "alliance.profile.placeholder": "提现密码8-20位，包含字母和数字",
    "alliance.profile.noPassTip": "您有正在进行的提现，无法修改支付宝。",
    "alliance.profile.phone": "手机号",
    "alliance.profile.apply.tip1": "1.建议绑定实名认证的支付宝；",
    "alliance.profile.apply.tip2": "2.填写支付宝昵称和支付宝认证姓名，方便我们核对支付宝账号正确性。",
    "alliance.profile.alipay.nickname": "支付宝昵称",
    "alliance.profile.alipay.nickname.errMsg": "请填写支付宝昵称",
    "alliance.profile.alipay.name": "支付宝认证姓名",
    "alliance.profile.alipay.name.errMsg": "请填写支付宝认证姓名",
    "alliance.share.onLine": "线上推广",
    "alliance.share.link": "推广链接",
    "alliance.share.link.tip": "好友点击会进入含有您推荐码的注册页",
    "alliance.share.link.copy": "复制推广链接",
    "alliance.share.link.result": "如何提高推广效果",
    "alliance.share.rule": "平台联盟规则详解",
    "alliance.share.income": "我的推广收益",
    "alliance.share.income.get": "如何获得推广收益",
    "alliance.share.income.text": "推荐一个高级版客户：客户首次购买平台的订单金额10%作为推广奖励；推荐两个及以上高级版客户：客户首次购买平台的订单金额20%作为推广奖励。",
    "alliance.share.allIncome": "累计获得佣金",
    "alliance.share.allCash": "累计提现",
    "alliance.share.accurateLink": "精准推广",
    "alliance.share.accurateLink.title": "什么是精准推广",
    "alliance.share.accurateLink.description": "精准推广是指将你制作的应用，通过应用安装链接的形式，分享给可能需要这个应用的人，他注册平台后即可安装使用此应用。",
    "alliance.share.accurateLink.tip1": "为方便您对应用的管理，应用安装链接默认情况下是关闭的。如果需要分享应用安装链接，请先启用。",
    "alliance.share.accurateLink.tip2": "如果您发布的链接不符合{{-linkDescription}}，平台有权随时封禁您的应用外链。",
    "alliance.share.state.forbidden": "被禁用",
    "alliance.share.state.using": "使用中",
    "alliance.share.state.noUsing": "未使用",
    "alliance.share.app.link.on": "启用应用安装链接",
    "alliance.share.app.link.off": "停用应用安装链接",
    "alliance.share.app.open.title": "您确定要启用应用安装链接吗？",
    "alliance.share.app.open.msg": "启用后其他用户可以通过您分享的应用安装链接安装此应用。",
    "alliance.share.app.open.success": "启用成功",
    "alliance.share.app.open.fail": "该应用无法开启应用安装外链",
    "alliance.share.app.enter": "进入应用",
    "alliance.share.app.forbidden.title": "您确定要停用应用安装链接吗？",
    "alliance.share.app.forbidden.msg": "停用后其他用户将不可通过应用安装链接安装此应用。已安装此应用的用户不受影响",
    "alliance.share.app.forbidden.success": "停用成功",
    "alliance.share.app.copy": "复制应用安装链接",
    "alliance.share.title": "{{- name}}分享给您一个应用：{{- appName}}。点击链接进行安装:",
    "alliance.user.register": "已注册",
    "alliance.user.registerTime": "注册日期",
    "alliance.user.orderPrice": "实际支付金额",
    "alliance.user.payTime": "支付日期",
    "alliance.cash.alipay": "支付宝：",
    "alliance.cash.amount": "提现金额：",
    "alliance.cash.taxTip": "提现金额为税前金额，我司按国家法定政策代扣代缴相关税费，缴纳 比例以实际结算金额为准。",
    "alliance.cash.applyTip": "您提交的申请我们会在每个月中旬进行统一处理，请耐心等待。",
    "alliance.cash.apply.infoTitle": "个人资料信息不完整，是否现在去补全信息？",
    "alliance.cash.apply.info": "您需要进行实名认证，并设置支付宝和提现密码后才能提现",
    "alliance.cash.apply.text4Ok": "去补全",
    "alliance.cash.apply.minCount": "（超过 {{ count }} 元方可提现）",
    "alliance.cash.pass": "提现密码：",
    "alliance.cash.pass.errMsg": "请输入提现密码",
    "alliance.cash.fullName": "真实姓名",
    "alliance.cash.fullName.emptyTip": "请填写姓名",
    "alliance.cash.IDNum.emptyTip": "请填写身份证号码",
    "alliance.cash.certification.tip": "（请保证照片清晰，大小在 5M 以内）",
    "alliance.cash.idCard.front": "身份证正面照片",
    "alliance.cash.idCard.back": "身份证反面照片",
    "alliance.cash.idCard.emptyTip": "请上传身份证照片",
    "alliance.cash.apply.fail": "你的提现申请未能通过",
    "alliance.cash.apply.success": "提现申请已提交",
    "alliance.cash.apply.success.tip1": "会在两个工作日内处理您的提现申请。",
    "alliance.cash.apply.success.tip2": "预计到账时间：",
    "alliance.cash.certification.success": "实名认证已提交",
    "alliance.cash.certification.success.tip1": "会在两个工作日内处理您的实名认证申请。",
    "alliance.cash.certification.success.tip2": "预计处理时间：",
    "alliance.cash.certification.title": "实名认证",
    "aggregate.defaultName": "未命名聚合表",
    "aggregate.delete.msg": "删除聚合表会同时删除该聚合表的数据使用权限，且无法还原",
    "aggregate.create": "新建聚合表",
    "aggregate.design": "聚合表设计",
    "aggregate.fieldAdd.tip": "请从右侧面板添加字段",
    "aggregate.tip": "聚合表可以对表单数据进行预处理，并在表单中再次调用，常用于进-销-存等场景。",
    "bind.click": "点击绑定",
    "bind.fail": "绑定失败",
    "bindTip.back": "点击返回登录页",
    "bindTip.login": "秒后自动跳转登录页",
    "bindTip.social": "QQ/微博登录",
    "bindTip.tip": "由于业务调整，不再支持使用新的QQ/微博账号登录，请使用其他方式登录注册！给您带来不便，十分抱歉！",
    "content.empty": "暂无内容",
    "content.type": "请输入内容",
    "coupon.renew": "续费专享优惠券",
    "coupon.validity": "有效期：{{dateRange}}",
    "coupon.count": "我的优惠券：{{count}}张",
    "copy.translate.dash": "复制并转换为报表",
    "corp.create": "创建我的团队",
    "corp.current": "当前团队",
    "corp.enter": "进入团队",
    "corp.name": "{{- user}}的团队",
    "corp.name.label": "我的团队",
    "corp.name.update": "修改团队名",
    "corp.name.update.success": "团队名修改成功",
    "corp.name.placeholder": "请输入团队名称",
    "corp.name.notEmpty": "团队名不能为空",
    "corp.name.tooLong": "团队名最多为{{length}}个字",
    "corp.joined": "我加入的团队",
    "corp.owned": "我创建的团队",
    "corp.owner": "企业创建者",
    "corp.url": "企业账号URL",
    "corp.dd.url": "钉钉专属扫码URL",
    "corp.url.tip": "当前企业专属的登录入口",
    "corp.url.placeholder": "支持字母、数字、下划线，需以字母开头，最少{{length}}位",
    "corp.url.validate.fail": "不符合格式要求",
    "corp.url.update.success": "企业账号URL修改成功",
    "corp.authInfo": "授权信息",
    "corp.email": "企业邮箱",
    "corp.email.invalid.tip": "请输入正确的企业邮箱",
    "corp.join.success": "加入团队成功！",
    "corp.unbind.confirm": "确定解绑企业套件",
    "corp.unbind.msg": "解绑企业套件后，企业通讯录将丢失，已提交的数据中成员昵称将无法显示，请在解绑前做好数据备份。",
    "corp.dingtalk.unbind": "解绑钉钉",
    "corp.dingtalk.authorization": "钉钉应用授权",
    "corp.dingtalk.explain": "钉钉应用绑定说明",
    "corp.dingtalk.href": "需要联系【团队管理员】登录钉钉开放平台 <a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url}}</a> 进行绑定配置 ",
    "corp.dingtalk.text1": "钉钉应用绑定采用了钉钉【企业内部开发】的模式对接",
    "corp.dingtalk.text2": "为什么采用【企业内部开发】的模式",
    "corp.dingtalk.text3": "采用【企业内部开发】的模式可以获取更多的能力：比如，通讯录自动同步等，节约大量时间",
    "corp.dingtalk.help": "请根据 <a href='/dingding/guide' target='_blank' style='color: #FFB200;'><i class='icon-bsy-guide'></i>参数配置操作引导</a> 完成操作 ",
    "corp.dingtalk.start.btn": "开始操作",
    "corp.dingtalk.Step.help": "<i class='icon-bsy-guide'></i>参数配置操作引导",
    "corp.dingtalk.Step.unbind": "是否解除钉钉授权？",
    "corp.dingtalk.Step.unbind.tip": "解除钉钉绑定以后，账号将还原到本账号原来的通讯录信息，应用和数据信息将保留，重新绑定原钉钉应用可以恢复。",
    "corp.dingtalk.Step.unbin.btn": "解除钉钉授权",
    "corp.qywework.Step.unbin.btn": "解除企业微信授权",
    "corp.dingtalk.Step1.title": "Step1：基本信息填写",
    "corp.dingtalk.Step2.title": "Step2：创建应用并填写应用凭证和配置访问地址",
    "corp.feishu.Step2.title": "Step2：配置事件订阅请求网址",
    "corp.dingtalk.Step3.title": "Step3：开通通讯录权限和待办权限",
    "corp.feishu.Step3.title": "Step3：配置访问地址和应用权限并发布应用",
    "corp.dingtalk.Step4.title": "Step4：发布应用并配置扫码登录参数",
    "corp.dingtalk.Step1.title.tip": "（请先打开链接<a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>创建应用）",
    "corp.feishu.Step1.title.tip": "（请先打开链接<a href='https://open.feishu.cn/' style='color:var(--bsy-base-color);' target='_blank'>https://open.feishu.cn/</a>创建应用）",
    "corp.dingtalk.team.Step1.title.tip": "（自定义）",
    "corp.dingtalk.Step2.title.tip": "（请先打开链接<a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>创建应用）",
    "corp.dingtalk.Step3.title.tip": "（继续在链接<a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/4' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/4</a>中完成以下操作）",
    "corp.dingtalk.Step4.title.tip": "（继续在链接<a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/12' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/12</a>中完成以下操作）",
    "corp.dingtalk.Step1.corpId.title": "企业信息参数<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step1.name.title": "团队名称<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step1.corpId.title.tip": "（在钉钉开放平台【首页】中获取）",
    "corp.feishu.Step1.corpId.title.tip": "（在飞书应用中获取下列参数，详见参数配置操作引导）",
    "corp.dingtalk.Step1.corpId.waterMark": "请输入团队ID",
    "corp.dingtalk.Step1.SSOsecret.title": "开发信息<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step1.SSOsecret.title.tip": "（在钉钉开放平台首【基本信息】中获取）",
    "corp.dingtalk.Step1.SSOsecret.waterMark": "请输入免登密钥",
    "corp.dingtalk.Step2.app.title": "1.应用凭证<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step2.app.title.tip": "（在上面链接创建应用后获取）",
    "corp.dingtalk.Step2.agent.waterMark": "请输入AgentId",
    "corp.dingtalk.Step2.AppKey.waterMark": "请输入AppKey",
    "corp.dingtalk.Step2.AppSecret.waterMark": "请输入AppSecret",
    "corp.dingtalk.Step3.corpId.title": "2.配置访问地址<span style='color:#F5222D;'>*</span>",
    "corp.feishu.Step3.corpId.title": "1.配置访问地址<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step3.corpId.title.tip": "（请将以下地址信息复制粘贴到上面链接的【开发管理】，详见参数配置操作引导）",
    "corp.dingtalk.Step3.SSOsecret.title": "1.开通通讯录权限<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step3.SSOsecret.title2": "2.开通待办权限<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step3.SSOsecret.title.tip": "（请前往钉钉开放平台进行操作，详见参数配置操作引导）",
    "corp.dingtalk.Step3.Tip": "注意：必须开通以上权限才能进入下一步",
    "corp.dingtalk.Step3.ip": "服务器出口IP",
    "corp.dingtalk.Step3.index": "应用首页地址",
    "corp.dingtalk.Step3.pc": "PC端首页地址",
    "corp.dingtalk.Step3.address": "后台管理地址",
    "corp.dingtalk.Step4.corpId.title": "1.扫码登录应用授权信息<span style='color:#F5222D;'>*</span>",
    "corp.feishu.Step4.corpId.title": "订阅事件请求网址<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step4.corpId.title.tip": "（请将以下授权信息复制粘贴到上面链接相关位置，详见参数配置操作引导）",
    "corp.feishu.Step4.corpId.title.tip": "（请将以下参数复制粘贴到相关位置，详见参数配置操作引导）",
    "corp.feishu.corpId.title.tip": "（详见参数配置操作引导）",
    "corp.feishu.Step42.corpId.title.tip": "（请将以下网址信息复制粘贴到相关位置，详见参数配置操作引导）",
    "corp.dingtalk.Step4.SSOsecret.title": "2.登录信息参数<span style='color:#F5222D;'>*</span>",
    "corp.dingtalk.Step4.SSOsecret.title.tip": "（在钉钉开放平台【应用开发-移动应用接入-登录】中获取）",
    "corp.dingtalk.Step4.name": "名称",
    "corp.dingtalk.Step4.desc": "描述",
    "corp.dingtalk.Step4.logo": "授权LOGO地址",
    "corp.dingtalk.Step4.url": "回调域名",
    "corp.dingtalk.Step4.appId.waterMark": "请输入appId",
    "corp.dingtalk.Step4.appSecret.waterMark": "请输入appSecret",
    "corp.dingtalk.SSO.tip": "用于钉钉后台进入应用操作",
    "corp.dingtalk.add.SSOsecret.waterMark": "请输入SSOsecret",
    "corp.dingtalk.add.SSOsecret.errorEmpty": "SSOsecret不能为空",
    "corp.authorization": "应用授权",
    "corp.dingtalk.authorization.ok": "确认授权",
    "corp.dingtalk.authorization.tip": "注：绑定SSOSecret可实现钉钉应用后台免登跳转平台后台",
    "corp.dingtalk.authorization.success": "授权成功",
    "corp.dingtalk.print.fail": "客户端中不支持系统打印，请在浏览器中打开进行操作",
    "corp.dingtalk.print.ok": "立即前往",
    "corp.dingtalk.print.cancel": "暂不打印",
    "corp.wechat.bindFail1": "微信绑定失败",
    "corp.wechat.bindFail2": "微信绑定失败，此微信账号已绑定平台账号",
    "corp.wechat.title": "平台·快速创建企业管理应用",
    "corp.wechat.enter": "进入应用中心",
    "corp.wework.bind.tip": "如需绑定企业微信，{{- info}}",
    "corp.wework.bind.info": "点此咨询",
    "corp.bind.confirm": "绑定已有账号",
    "corp.bind.confirm.msg": "绑定已有平台账号，会将该账号中的应用合并到当前账号，该账号中的用户和权限数据也会被清除，此操作不可逆。是否确认绑定已有账号？",
    "corp.bind.ok": "确认绑定",
    "corp.integrate.wechat.account": "集成自己的微信公众号",
    "corp.request": "申请",
    "corp.switch": "团队切换",
    "code.reget": "重新获取({{num}})",
    "city.withMark": "(市)",
    "day.short": "日",
    "day.week.Monday": "星期一",
    "day.week.Tuesday": "星期二",
    "day.week.Wednesday": "星期三",
    "day.week.Thursday": "星期四",
    "day.week.Friday": "星期五",
    "day.week.Saturday": "星期六",
    "day.week.Sunday": "星期日",
    "dash.data.component": "数据控件",
    "dash.add.tip": "从左上角添加控件，进行数据展示和分析。",
    "dash.add.tip.learnMore": "了解这些控件",
    "dash.auth.errorTip": "仅登录用户可查看数据",
    "dash.auth.noAuth": "您没有查看数据的权限",
    "dash.areaChart": "面积图",
    "dash.aggregateFunc": "聚合函数",
    "dash.auto.calc": "自动计算",
    "dash.axis.x": "坐标X轴",
    "dash.axis.y": "坐标Y轴",
    "dash.barChart": "条形图",
    "dash.config.error": "控件配置异常",
    "dash.chart": "统计表",
    "dash.chart.add": "添加图表",
    "dash.chart.design": "图表设计",
    "dash.chart.relySet": "图表联动",
    "dash.chart.customizeRelySet": "图表自定义联动",
    "dash.chart.relyEmpty": "没有可以联动的图表",
    "dash.chart.tip": "1个维度，1个或多个指标\n2个维度，1个指标",
    "dash.chart.type": "图表类型",
    "dash.chart.unnamed": "未命名图表",
    "dash.chart.sort.empty": "没有支持排序的字段",
    "dash.calendar.empty": "当日无数据",
    "dash.copy.success": "复制成功！",
    "dash.copy.title": "{{- title }}_拷贝",
    "dash.copy.maxCountExceed": "复制失败！最多存在{{ limit }}个图表",
    "dash.data.manage": "数据管理控件",
    "dash.data.manageTable": "数据管理表格",
    "dash.data.manage.select": "选择控件类型",
    "dash.data.manage.selectPlaceholder": "请选择",
    "dash.data.manage.formSelect": "请选择数据源",
    "dash.data.manage.dateSelect": "请选择时间维度",
    "dash.data.manage.date": "时间维度",
    "dash.data.manage.filterAdd": "添加数据源过滤条件",
    "dash.data.manage.getAuth": "数据获取权限",
    "dash.data.manage.allData": "全部数据",
    "dash.data.manage.userAuth": "使用成员对数据源表单的权限",
    "dash.data.manage.formTip": "用户访问控件时，根据他在数据源表单中所在的权限组，仅可查看有权限的数据。",
    "dash.data.manage.allTip": "用户访问控件时可以查看控件中的全部数据",
    "dash.data.manage.authTip": "数据源表单尚未配置数据权限，用户访问控件时无法查看数据。你可以现在去配置数据源权限，或完成控件设置后配置",
    "dash.dataSource.empty": "没有可选择的数据源",
    "dash.thresholds.tip": "成员用户必须绑定邮箱或关注微信服务号，才能收到提醒。",
    "dash.thresholds.set": "如何设置",
    "dash.thresholds.name": "预警名称",
    "dash.thresholds.filter": "预警条件",
    "dash.thresholds.field.placeholder": "请选择指标字段",
    "dash.thresholds.num.placeholder": "请输入数值",
    "dash.thresholds.mem.tip": "请确保已将报表发布给以下部门或成员",
    "dash.thresholds.msg.wx": "微信提醒",
    "dash.thresholds.msg.wechat": "企业微信提醒",
    "dash.thresholds.msg.dd": "钉钉提醒",
    "dash.thresholds.nameTip": "请输入预警名称",
    "dash.thresholds.nameTip2": "预警名称不能超过{{ count }}字",
    "dash.thresholds.filterTip": "预警条件未设置完整",
    "dash.thresholds.timeTip": "预警时间未设置完整",
    "dash.thresholds.msgTip": "预警提醒方式未设置完整",
    "dash.thresholds": "数据预警",
    "dash.thresholds.add": "添加预警",
    "dash.thresholds.setTip": "如何设置数据预警？",
    "dash.thresholds.deleteConfirm": "确定删除该预警吗？",
    "dash.guideline": "辅助线",
    "dash.guideline.add": "添加辅助线",
    "dash.guideline.label": "辅助线名称",
    "dash.guideline.label.placeholder": "请输入辅助线名称，最多{{ count }}个字符",
    "dash.guideline.label.required": "请输入辅助线名称",
    "dash.guideline.label.length": "辅助线名称不能超过{{ count }}个字符",
    "dash.guideline.dynamic": "动态值",
    "dash.guideline.nameAndValue": "名称和值",
    "dash.chart.thresholds.maxCountTip": "单个图表最多开启{{ count }}个数据预警",
    "dash.countdown": "试用期倒计时：",
    "dash.color": "颜色设置",
    "dash.color.bg": "指标图背景色",
    "dash.color.custom00": "炽热",
    "dash.color.custom01": "希望",
    "dash.color.custom02": "低调",
    "dash.color.custom03": "马卡龙",
    "dash.color.custom04": "质感",
    "dash.color.custom05": "风情海滩",
    "dash.color.custom06": "丛林深处",
    "dash.color.custom07": "忧郁蓝调",
    "dash.color.custom08": "轻快现代",
    "dash.color.custom09": "春日花园",
    "dash.color.customMap01": "星空",
    "dash.color.customMap02": "极光",
    "dash.color.customMap03": "月色",
    "dash.color.customMap04": "朝霞",
    "dash.color.customMap05": "杜鹃",
    "dash.color.customMap06": "清晨",
    "dash.color.customMap07": "日光",
    "dash.color.set": "配色方案",
    "dash.color.item": "支持设置颜色的项",
    "dash.color.empty": "请先添加维度/指标",
    "dash.color.preset": "预设颜色",
    "dash.color.valueSize.s": "宽松",
    "dash.color.valueSize.m": "标准",
    "dash.color.valueSize.l": "紧凑",
    "dash.display": "显示模式",
    "dash.chartLabel": "数据标签",
    "dash.chartLabel.display": "显示数据标签",
    "dash.xFields.display": "显示维度值",
    "dash.chartLabel.value.display": "显示指标值",
    "dash.percent.display": "显示百分比",
    "dash.legend.display": "显示图例",
    "dash.legend.position": "图例显示在图表",
    "dash.legend.type": "类型",
    "dash.legend.type.plain": "普通图例",
    "dash.legend.type.scroll": "带分页的图例",
    "dash.position.bottom": "底部",
    "dash.position.top": "顶部",
    "dash.position.left": "左侧",
    "dash.position.right": "右侧",
    "dash.xAxis.display": "显示刻度标签",
    "dash.cond": "过滤条件",
    "dash.cond.add.fail": "添加失败，同一字段不能重复添加筛选条件",
    "dash.cond.delete": "删除筛选条件",
    "dash.cond.drag.tip": "拖动左侧字段到此处来添加过滤条件",
    "dash.cond.edit": "修改筛选条件",
    "dash.cond.set": "设置过滤条件",
    "dash.cond.set.fail": "过滤条件设置不正确",
    "dash.columnChart": "柱形图",
    "dash.columnChart.stack": "堆积柱形图",
    "dash.data.canExport": "可导出数据",
    "dash.defaultName": "未命名报表",
    "dash.design": "报表设计",
    "dash.dimension": "维度",
    "dash.dimension.single": "单项",
    "dash.dimension.sticky": "维度冻结",
    "dash.dimension.add.fail": "添加失败，同一字段不能重复添加维度",
    "dash.dimension.drag.tip": "拖动左侧字段到此处来添加维度",
    "dash.dimension.map.drag.tip": "拖动左侧地址或定位字段到此处来添加维度",
    "dash.dimension.provinceCity": "省-市",
    "dash.dimension.provinceCityDistrict": "省-市-区",
    "dash.dimension.x": "维度（行）",
    "dash.dimension.y": "维度（列）",
    "dash.dimension.x.sticky": "冻结行维度",
    "dash.dimension.y.sticky": "冻结列维度",
    "dash.dimension.yearQuarter": "年-季",
    "dash.dimension.yearMonth": "年-月",
    "dash.dimension.yearWeek": "年-周",
    "dash.dimension.yearMonthDay": "年-月-日",
    "dash.dotGuide.func": "统计表的基本功能是对数据做分类统计，「维度」是对数据做分类的依据。",
    "dash.dotGuide.metric": "「指标」是要统计的数据，会根据「维度」中设置的分组方式进行汇总计算。",
    "dash.dotGuide.drag": "拖动字段到「维度」和「指标」上，即可完成添加。",
    "dash.dotGuide.type": "设置图表的「维度」和「指标」后，可以选择合适的图表类型。",
    "dash.error.chartNumExceed": "添加失败！最多存在{{ limit }}个图表",
    "dash.error.canNotDeleteMetric": "此指标正在被使用，无法删除",
    "dash.externalLink": "报表查看链接",
    "dash.enable": "启用报表",
    "dash.enable.done": "报表已启用",
    "dash.enable.title": "已将您的报表转换为报表，但尚未启用",
    "dash.enable.tip1": "未启用的报表不支持发布，您可以在未启用状态下调整报表的设计。",
    "dash.enable.tip2": "注意，一旦您启用报表，那么可访问原报表的成员也将立即获取报表的访问权限，我们建议您在启用前，确保报表已正确设置，可以覆盖报表的功能。",

    "dash.field.add.fail": "添加失败，同一字段不能重复添加",
    "dash.field.add.guide": "拖入字段来添加数据",
    "dash.field.changeName": "修改显示名",
    "dash.field.changeName.tip": "请输入显示名称",
    "dash.field.drag.tip": "拖动左侧字段到此处来添加显示字段",
    "dash.field.delete": "删除字段",
    "dash.field.groupResultShow": "高级计算",
    "dash.field.group.showReal": "无",
    "dash.field.group.showPercent": "占比",
    "dash.field.group.showGrowth": "同比/环比",
    "dash.field.group.showConversion": "转化率",
    "dash.field.growthRate.yoy": "环比增长率",
    "dash.field.growthRate.yoy2": "上年同比增长率",
    "dash.field.growthRate.qoq": "环比增长率",
    "dash.field.growthRate.mom": "环比增长率",
    "dash.field.growthRate.mom2": "上月同比增长率",
    "dash.field.growthRate.wow": "环比增长率",
    "dash.field.growthRate.wow2": "上周同比增长率",
    "dash.field.growthRate.dod": "环比增长率",
    "dash.field.growthValue.yoy": "环比增长值",
    "dash.field.growthValue.yoy2": "上年同比增长值",
    "dash.field.growthValue.qoq": "环比增长值",
    "dash.field.growthValue.mom": "环比增长值",
    "dash.field.growthValue.mom2": "上月同比增长值",
    "dash.field.growthValue.wow": "环比增长值",
    "dash.field.growthValue.wow2": "上周同比增长值",
    "dash.field.growthValue.dod": "环比增长值",
    "dash.field.subformSet": "子表单字段设置",
    "dash.growth.disabled.tip": "维度中有且仅有1个日期时间字段时，才能设置同比/环比。",
    "dash.filter": "筛选控件",
    "dash.clear.filter": "清空筛选",
    "dash.descriptionBtn": "文本控件",
    "dash.image": "图片控件",
    "dash.real.time": "实时时间",
    "dash.filter.quick": "快捷筛选",
    "dash.embedded.iframe": "嵌入页面",
    "dash.embedded.layout.container": "容器组件",
    "dash.description.empty": "暂无文本内容",
    "dash.filter.add": "添加筛选器",
    "dash.filter.btn": "筛选按钮",
    "dash.filter.sizer": "筛选器",
    "dash.filter.btn.info": "按钮用于解决数据量过大导致的筛选缓慢问题。添加筛选按钮前，请先添加筛选控件",
    "dash.filter.name": "筛选器名称",
    "dash.filter.selectChart": "1.选择需要筛选的图表",
    "dash.filter.selectField": "2.选择筛选字段",
    "dash.filter.setDefault": "3.设置筛选器",
    "dash.filter.chart.empty": "当前无可用图表，请添加图表或修改已有图表配置",
    "dash.filter.method": "筛选方式",
    "dash.filter.select.text": "选择选项",
    "dash.filter.select.custom": "输入文本",
    "dash.filter.select.input": "精确查询",
    "dash.filter.field.emptyTip": "无可选字段，请调整筛选字段或图表",
    "dash.filter.chart.emptyMsg": "请选择筛选图表",
    "dash.filter.fields.emptyMsg": "请选择筛选字段",
    "dash.filter.title.emptyMsg": "请输入筛选器名称",
    "dash.format.input.tip": "请输入自定义格式",
    "dash.format.preview": "效果预览",
    "dash.lineChart": "折线图",
    "dash.link.canceled": "联动已取消",
    "dash.link.empty": "当前没有图表与本图表联动",
    "dash.max.exceed.title": "汇总计算后数据量过大，仅显示前2000条",
    "dash.max.exceed.msg": "您可以添加或修改过滤条件来缩小数据范围",
    "dash.metric": "指标",
    "dash.metric.left": "指标（左）",
    "dash.metric.right": "指标（右）",
    "dash.metric.add": "添加指标",
    "dash.metric.add.tip": "请先添加指标",
    "dash.metric.drag.tip": "拖动左侧字段到此处来添加指标",
    "dash.metric.delete.tip": "删除此指标？",
    "dash.metric.edit": "编辑指标",
    "dash.metric.exist": "现有指标",
    "dash.metric.add.success": "计算字段添加成功",
    "dash.metric.inputExpr.tip": "请输入公式",
    "dash.metricTable": "指标图",
    "dash.metricTable.tip": "0个维度，1个指标\n1个维度，1个指标",
    "dash.multiAxesChart": "双轴图",
    "dash.multiAxesChart.tip": "1个维度，1个或多个指标",
    "dash.multiAxesChart.type": "双轴图类型",
    "dash.multiAxesChart.left": "左轴",
    "dash.multiAxesChart.right": "右轴",
    "dash.pivotTable": "透视表",
    "dash.pivotTable.tip": "1个维度，1个或多个指标\n多个维度，1个或多个指标",
    "dash.pieChart": "饼图",
    "dash.pieChart.tip": "1个维度，1个指标",
    "dash.radarChart": "雷达图",
    "dash.mapChart.tip": "1个地理维度，1个指标",
    "dash.mapChart.display": "地图显示范围",
    "dash.drilling": "钻取",
    "dash.mapChart.drilling": "地图钻取",
    "dash.mapChart.drilling.p": "可钻取到省",
    "dash.mapChart.drilling.pc": "可钻取到省、市",
    "dash.mapChart.drilling.c": "可钻取到市",
    "dash.mapChart.drilling.none": "不启用",
    "dash.mapChart.type": "地图类型",
    "dash.funnelChart.type": "漏斗图类型",
    "dash.pieChart.type": "饼图类型",
    "dash.columnChart.type": "柱形图类型",
    "dash.barChart.type": "条形图类型",
    "dash.mapChart.displayEffect": "显示效果",
    "dash.mapChart.bubble": "气泡地图",
    "dash.mapChart.area": "区域地图",
    "dash.funnel.common": "基础漏斗图",
    "dash.funnel.customized": "对比漏斗图",
    "dash.mapChart.unknownCountry": "有{{- count }}个未知地名",
    "dash.mapChart.unknownProvince": "该省有{{- count }}个未知地名",
    "dash.mapChart.unknownCity": "该市有{{- count }}个未知地名",
    "dash.release": "发布报表",
    "dash.release.mem": "将报表发布给团队成员，成员登录系统后即可查看报表",
    "dash.release.link": "将报表发布为公开链接，无需登录即可查看报表",
    "dash.release.team": "报表访问内链",
    "dash.source": "数据源",
    "dash.source.description1": "即以当前已存在的表单已经录入的数据作为数据源，可与其他表单或本表单已经录入的数据进行各种数据处理操作。",
    "dash.source.description2": "如：",
    "dash.source.description3": "页面录入数据后，和其他输入源的数据可以进行横向连接、追加合并、分组汇总等操作。",
    "dash.source.description4": "下图以追加合并为例",
    "dash.source.etl": "数据视图输出表",
    "dash.source.stale": "数据源已失效",
    "dash.source.stale.tip": "数据源已失效，请更改数据源后重新配置图表",
    "dash.source.select": "请选择图表数据源",
    "dash.source.update": "更改数据源",
    "dash.source.update.tip": "更改数据源将清空当前图表配置，是否确认修改？",
    "dash.subform.fields.set": "请设置需显示的字段",
    "dash.subform.fields.select": "选择显示字段",
    "dash.sort.maxCount.tip": "最多能添加{{- count}}个排序规则",
    "dash.sort.add": "添加排序规则",
    "dash.sort.empty": "无排序规则，请添加",
    "dash.sort.setting": "排序规则设置",
    "dash.sort.field.empty": "没有支持排序的字段",
    "dash.sort.rule": "排序规则优先级由高到低",
    "dash.table": "明细表",
    "dash.table.editCustomField": "编辑自定义字段",
    "dash.table.addCustomField.tip": "使用数学运算符编辑公式",
    "dash.table.inputName.tip": "请输入字段名称",
    "dash.top.limit": "仅支持1～1000的正整数",
    "dash.permission": "数据获取权限",
    "dash.permission.all": "数据源表单中的全部数据",
    "dash.permission.form": "使用成员对数据源表单的权限",
    "dash.permission.all.desc": "用户访问控件时可以查看控件中的全部数据。",
    "dash.permission.form.desc": "用户访问控件时，根据他在数据源表单所在的权限组，仅可查看有权限的数据。",
    "dash.notify": "定时提醒",
    "dash.notify.sub": "提醒成员定时查看报表",
    "dash.notify.help": "如何设置定时提醒？",
    "dash.xAxis.showTag": "强制显示所有标签",
    "dash.xAxis.showTag.warning": "勾选此项会导致标签重叠，影响展示效果，请谨慎",
    "dash.xAxis.tag.direction": "标签文字显示方向",
    "dash.xAxis.tag.horizontal": "横向",
    "dash.xAxis.tag.vertical": "竖向",
    "dash.xAxis.tag.leftBank": "左倾斜",
    "dash.xAxis.tag.rightBank": "右倾斜",
    "dash.yAxis.title.tip": "请输入标题",
    "dash.statistical.table.tip": "提供多种图表样式，对数据进行汇总统计",
    "dash.list.tip": "提炼部分或全部数据到表格中进行查看",
    "dash.calendar.tip": "根据成员权限，以日历的形式呈现和管理数据",
    "dash.manage.table.tip": "根据成员权限，以表格的形式呈现和管理数据",
    "dash.filter.tip": "用于解决数据量过大导致的筛选缓慢问题，添加筛选按钮前，请先添加筛选器",
    "dash.filter.btn.tip": "用于筛选报表数据",
    "dash.showSubtotal.tip": "小计",
    "dash.description.tip": "对数据分析结果进行描述性说明",
    "dash.mobileLayout": "移动端布局",
    "dash.mobileLayout.tip": "开启移动端布局，即可自定义控件大小、位置等",
    "dash.mobileLayout.open": "开启",
    "dash.mobileLayout.close": "关闭移动端布局",
    "dash.mobileLayout.hide": "隐藏的控件",
    "dash.mobileLayout.hideEmpty": "没有隐藏的控件\n（隐藏的控件在移动端不显示）",
    "dash.mobileLayout.closeTip": "离开当前页后，已有设置不会保存，此操作无法还原。",
    "dash.mobileLayout.closeConfirm": "您确定要关闭移动端样式吗？",
    "dash.mobileLayout.closeMsg": "关闭后，已有设置不会保存，此操作无法还原。",
    "dashboard.desc": "工作台可以创建和切换应用，管理通讯录，处理待办任务",
    "dashboard.dingtalk.trial.tip": "当前为试用版本，剩余{{- days}}天，{{- click}}。",
    "dashboard.dingtalk.trial.click": "请点击这里升级",
    "dashboard.dingtalk.trial.marketQr": "打开手机钉钉，扫一扫升级版本",
    "dashboard.broadcast.vipTrial": "想要体验平台全部强大功能？现在赠送你高级功能30天试用期 ",
    "dashboard.broadcast.overLimit": "您的使用量已超出系统限制，为保障试用版到期后的正常使用，请升级版本。 ",
    "dashboard.dotGuide.app1": "应用由表单、流程表单和报表等组成。创建的表单和报表展示在左侧列表中",
    "dashboard.dotGuide.app2": "做好的应用可快速访问和使用。点击此处进入应用访问",
    "dashboard.dotGuide.formAndReport": "访问表单可以提交数据，访问报表可以查看数据",
    "dashboard.dotGuide.enter": "点击此处进入工作台",
    "dashboard.enter": "进入后台",
    "dashboard.guide.title": "新手引导",
    "dashboard.guide.invite.title": "邀请成员加入",
    "dashboard.guide.invite.desc": "在新手引导中快速邀请成员（您也可以在左上角切换至通讯录后邀请成员）",
    "dashboard.guide.invite.corp": "通过钉钉/企业微信安装平台的用户可跳过此步骤",
    "dashboard.guide.invite.action": "邀请成员",
    "dashboard.guide.create.title": "创建流程/表单/报表",
    "dashboard.guide.create.desc": "创建一个应用，并在应用中添加流程/表单/报表",
    "dashboard.guide.create.action": "了解如何创建",
    "dashboard.guide.publish.title": "发布给成员填报和查看",
    "dashboard.guide.publish.desc": "把创建好的流程/表单/报表发布给成员，即可开始使用",
    "dashboard.guide.publish.action": "了解成员使用方式",
    "data.access.tip": "成员登录系统访问数据",
    "data.batch.export.file": "批量导出附件",
    "data.batch.edit": "批量修改",
    "data.batch.edit.peview.btn": "修改并预览",
    "data.batch.edit.peview": "批量修改数据预览",
    "data.batch.edit.peview.subtitle": "<i class='icon-bsy-warning'></i>请先仔细对比【修改后的值】是否是自己需要的结果后，确认修改后结果不可撤回",
    "data.batch.edit.subtitle": "本次操作将修改 <span style='color:red;'>{{len}}</span> 条数据",
    "data.batch.edit.tip": "数据批量修改后将无法撤销，请谨慎操作；",
    "data.batch.edit.tip.distinct": "设置不允许重复值的字段不支持修改；",
    "data.batch.edit.tip.field": "图片、附件、定位、手写签名、关联数据、关联查询、分割线字段不支持批量修改。",
    "data.batch.edit.tip.empty": "如需清空字段，保留此项为空即可",
    "data.batch.edit.field.select": "请选择需要修改的字段",
    "data.batch.edit.warning.distinct": "该字段不允许重复，不支持批量修改",
    "data.batch.edit.record.view": "查看修改记录",
    "data.batch.edit.warning.field": "该字段不支持批量修改",
    "data.batch.edit.busy": "正在修改数据，无法批量修改",
    "data.batch.print.qrCode": "批量打印二维码",
    "data.batch.transfer": "批量调整负责人",
    "data.batch.transfer.busy": "正在调整负责人，无法批量调整负责人",
    "batch.export.app.packge.title": "应用包导出",
    "batch.export.app.packge": "批量导出应用",
    "move.sort": "移动排序",
    "app.group.empty": "拖拽应用到此处来添加或点击",
    "data.doCount": "统计数据量",
    "data.counting": "正在统计...",
    "data.doCount.timeout": "统计超时，数据量超出统计范围",
    "data.comment.empty": "暂无评论",
    "data.comment.noSupport.tip": "回收站中的数据不支持新增评论",
    "data.comment.publish": "发表评论",
    "data.delete.all": "清空全部",
    "data.delete.noAuth.tip": "没有删除此数据的权限",
    "data.display": "数据显示",
    "data.display.order": "显示序号",
    "data.display.top.before": "显示前",
    "data.display.top.after": "条数据",
    "data.transfer.all": "调整全部",
    "data.transfer.selected": "调整选中",
    "data.edit.all": "修改全部",
    "data.edit.selected": "修改选中",
    "data.clear": "清空数据",
    "data.current": "当前数据",
    "data.empty": "暂无数据",
    "data.dock.empty": "该企业没有给你分享应用/表单权限，请联系对方负责人处理",
    "data.content.empty": "暂无内容",
    "data.empty.publish.tip": "暂无数据，你可以将表单发布给团队成员或公开发布来搜集数据",
    "data.first": "已经是本页第一条数据",
    "data.last": "已经是本页最后一条数据",
    "data.link.tip": "访问数据链接需要登录系统并授权",
    "data.noFlow.inProgress": "没有进行中的流程",
    "data.noFlow.inProgress.selected": "没有选中进行中的流程，请重新选择",
    "data.next": "下一条",
    "data.edit.next": "编辑下一条",
    "data.view.next": "查看下一条",
    "data.next.tip": "查看下一条数据，快捷键「→」",
    "data.openLink": "公开链接",
    "data.openLink.tip": "通过公开链接访问数据",
    "data.openLink.desc": "通过公开链接，无需登录即可访问数据",
    "data.openLink.subtitle": "通过公开链接，无需登录即可访问表单和数据",
    "data.pdf": "PDF预览",
    "data.prev": "上一条",
    "data.none": "没有数据",
    "data.permission.get": "数据获取权限",
    "data.edit.prev": "编辑上一条",
    "data.view.prev": "查看上一条",
    "data.prev.tip": "查看上一条数据，快捷键「←」",
    "data.print": "正在生成打印文件，请等待",
    "data.qr.private": "数据内链二维码",
    "data.qr.public": "数据外链二维码",
    "data.rely": "数据联动",
    "data.cancelOperation": "取消操作",
    "data.operation.select": "请选择需要操作的数据",
    "data.select": "当前选中了{{- count}}条数据",
    "data.select.all": "您当前选中了全部数据",
    "data.print.selected": "打印选中",
    "data.print.all": "打印全部",
    "data.file.export.selected": "导出选中数据的附件",
    "data.file.export.all": "导出全部数据的附件",
    "data.file.export.waitingTip": "正在打包附件，请等待",
    "data.file.export.packingTip": "您可以关闭页面，系统将会继续打包附件",
    "data.recover.select": "恢复选中",
    "data.recover.all": "恢复全部",
    "data.recover.confirm": "您确定要恢复所选数据吗？",
    "data.recover.tip": "{{- selectText}}，数据恢复后可在数据管理中查看",
    "data.hardDelete.confirm": "您确定要彻底删除所选数据吗？",
    "data.hardDelete.tip": "{{- selectText}}，彻底删除后数据无法恢复",
    "data.selected": '选中的数据',
    "data.any": "任意数据",
    "data.id": "数据ID",
    "data.id.only": "数据的唯一ID",
    "data.label": "数据标题",
    "data.label.add.field": "添加字段",
    "data.label.subTitle": "数据标题用于快速辨识一条数据，适用于数据表格首列标题、关联数据、数据详情页等功能场景中",
    "data.label.firstField": "第一个字段的值",
    "data.label.custom": "自定义标题",
    "data.label.tip": "输入文字或添加字段，至少需要添加一个字段",
    "data.label.required": "自定义标题不能为空",
    "data.label.fail1": "自定义标题至少需要添加一个字段",
    "data.label.fail2": "数据标题最多支持20个字段",
    "data.auth": "数据权限",
    "data.auth.short": "数据权限",
    "data.auth.title": "可以查看到哪些数据",
    "data.auth.subTitle": "设置对应的「数据权限」，可以让团队成员管理表单搜集到的数据",
    "data.auth.add": "添加权限组",
    "data.auth.create": "新建权限组",
    "data.auth.edit": "编辑权限组",
    "data.auth.select": "选择权限组",
    "data.auth.required": "权限组名称不能为空",
    "data.auth.name": "名称信息",
    "data.auth.name.title": "可设置权限组名称和描述信息",
    "data.auth.name.placeholder": "填写权限组名称",
    "data.auth.description.placeholder": "填写描述信息",
    "data.auth.options": "操作权限",
    "data.auth.options.short": "操作权限",
    "data.auth.options.coopTitle": "可对数据进行哪些操作",
    "data.auth.options.flowTitle": "可对流程进行哪些操作",
    "data.auth.field.title": "可以查看和编辑数据的哪些字段",
    "data.notify": "推送提醒",
    "data.notify.subTitle": "通过设置推送提醒可以到期查看提醒内容",
    "data.notify.create": "新建推送提醒",
    "data.notify.delete.confirm": "您确定要删除这条推送提醒吗？",
    "data.notify.delete.msg": "删除推送提醒后被提醒人将无法收到消息提醒，此操作无法还原",
    "data.notify.time": "提醒时间",
    "data.notify.overTime": "结束提醒时间",
    "data.notify.dataCreate": "新数据提交时提醒",
    "data.notify.dataUpdate": "数据修改后提醒",
    "data.notify.custom": "自定义时间提醒",
    "data.notify.custom.tip": "提示：设置自定义时间提醒前，请先将本表单共享给成员或将成员加入相关协作权限组。",
    "data.notify.update.tip": "提示：被提醒人若不在相关权限组中，收到提醒时无法查看数据。",
    "data.notify.update.any": "任意字段修改后提醒",
    "data.notify.update.detail.single": "{{- field}}字段修改后提醒",
    "data.notify.update.detail.multi": "{{- fields}}中的任意字段修改后提醒",
    "data.notify.field.set": "提醒字段设置",
    "data.notify.field.set.tip": "请至少选择一个提醒字段",
    "data.notify.field.set.desc": "请选择修改数据会触发提醒的字段",
    "data.notify.update.fields": "指定字段修改后提醒",
    "data.notify.update.fields.tip": "提示：如果设置了多个提醒字段，任意一个字段被修改就会触发提醒",
    "data.notify.update.set": "指定字段修改后提醒",
    "data.notify.byWidget": "根据表单内日期时间字段提醒",
    "data.notify.byWidget.tip": "提示：被提醒人若不在相关权限组中，收到提醒时无法查看数据。",
    "data.notify.byWidget.placeholder": "请选择表单内的日期时间字段",
    "data.notify.startTime.set": "请设置开始提醒时间",
    "data.notify.customRange": "在{{time}}提醒",
    "data.notify.customRange.repeat": "（{{repeat}}提醒一次，于{{time}}结束）",
    "data.at.repeat": "（{{repeat}}重复，于{{time}}结束）",
    "data.notify.widgetLabel": "在{{- label}}",
    "data.notify.today": "当天，",
    "data.notify.current": "当时提醒",
    "data.notify.widgetResult": "于{{time}}提醒",
    "data.notify.offsetTime": "{{time}}提醒",
    "data.notify.condition": "提醒条件",
    "data.notifier": "被提醒人：",
    "data.notify.type": "提醒方式",
    "data.notify.everyday": "每天",
    "data.notify.everyWeek": "每周",
    "data.notify.everyTwiceWeek": "每两周",
    "data.notify.everyMonth": "每月",
    "data.notify.everyYear": "每年",
    "data.notify.leave.msg": "离开当前页后，您的推送提醒设置不会被保存",
    "data.notify.defaultMsg": "请及时处理",
    "data.notify.title": "如何设置推送提醒？",
    "data.notify.over": "请设置结束提醒时间",
    "data.notify.target": "被提醒人",
    "data.notify.target.set": "点击设置被提醒人",
    "data.notify.onlyOnce": "只提醒一次",
    "data.notify.once": "{{time}}提醒一次",
    "data.notify.customRepeat": "自定义重复",
    "data.notify.repeatText": "的{{ repeat}}",
    "data.notify.repeatType": "重复类型",
    "data.notify.mode": "提醒类型",
    "data.notify.lastDay": "最后一个自然日",
    "data.notify.assign": "指定日期",
    "data.notify.relative": "相对日期",
    "data.notify.repeat.week": "按周重复",
    "data.notify.repeat.month": "按月重复",
    "data.notify.currentTime": "当时",
    "data.notify.before": "之前",
    "data.notify.after": "之后",
    "data.notify.accordWithCondition": "满足条件的数据",
    "data.notify.condition.add": "添加条件",
    "data.notify.condition.addTip": "（请添加表单内字段，当提交的数据满足您设置的表单字段条件时收到提醒）",
    "data.notify.msg": "提醒文字",
    "data.notify.corp": "{{corp}}提醒",
    "data.notify.typeTip": "（可多选，至少选择一种提醒方式）",
    "data.notify.corpTip": "成员用户必须绑定邮箱或关注微信服务号，才能收到提醒。",
    "data.notify.corpText": "如何设置？",
    "data.notify.createMsg": "有新数据提交，请及时处理",
    "data.notify.customMsg": "已到提醒时间，请及时处理",
    "data.notify.widgetMsg": "有数据到期，请及时处理",
    "data.notify.updateMsg": "有数据被修改，请及时处理",
    "data.notify.fail1": "未设置被提醒人",
    "data.notify.fail2": "未设置提醒时间",
    "data.notify.fail3": "未设置结束时间",
    "data.notify.fail4": "未选择表单内的时间日期字段",
    "data.notify.fail5": "重复类型未设置完整",
    "data.submitPrompt": "提交跳转",
    "data.submitPrompt.subTitle": "自定义表单提交成功后的提示内容，以及可以跳转指定链接",
    "data.submitPrompt.label": "表单提交后显示",
    "data.submitPrompt.system": "系统默认提示",
    "data.submitPrompt.custom": "自定义提示页面",
    "data.submitPrompt.insert": "插入表单字段",
    "data.submitPrompt.maxWordCount": "富文本的字数上限为200个字，提交页面的实际显示内容也为前200个字",
    "data.submitPrompt.wordsCount": "还可以输入{{words}}个字",
    "data.submitPrompt.nextTip": "显示“继续添加”按钮",
    "data.submitPrompt.tip": "可以添加文字、表单字段和系统字段，可对文字和字段进行富文本编辑",
    "data.submitPrompt.tip1": "弹出表单提交后自动关闭",
    "data.submitPrompt.href": "表单提交后跳转指定链接",
    "data.submitPrompt.href.tip1": "新页面打开",
    "data.submitPrompt.href.externalUrl": "外部链接",
    "data.submitPrompt.href.internalFrom": "内部表单",
    "data.submit.check": "数据提交校验",
    "data.submit.c.base": "数据提交，正在计算",
    "data.submit.c.zhong": "中",
    "data.submit.c.ing": "正在计算",
    "data.submit.c.timeout.tip": "提交时间过长？请联系管理员调整表单设计",
    "data.printTemplate": "打印模板:",
    "data.printTemplate.select": "选择打印模板",
    "data.printTemplate.system": "系统打印模板",
    "data.printTemplate.custom": "自定义打印模板",
    "data.printTemplate.learnMore": "了解打印模板",
    "data.printTemplate.failForFree": "免费版用户无法使用自定义打印模板功能",
    "data.printTemplate.empty": "您还没有为此表单创建过打印模板",
    "data.printTemplate.createCustom": "创建自定义打印模板",
    "data.printTemplate.customEmpty": "暂无相关打印模板",
    "data.printTemplate.set": "打印模板设置",
    "data.printTemplate.subTitle": "打印表单时将按照使用中的模板格式打印",
    "data.printTemplate.emptyTip": "此模板未被任何位置使用",
    "data.printTemplate.create": "新建打印模板",
    "data.printTemplate.deleteMsg": "删除此模板后，原先使用此模板的位置将会使用默认打印模板来打印表单。",
    "data.printTemplate.rangeTip": "此模板在以下位置使用",
    "data.printTemplate.rangeView": "查看使用范围",
    "data.printTemplate.emptyInfo": "此模板未被该流程版本中的节点使用",
    "data.printTemplate.word.edit": "编辑word模板信息",
    "data.printTemplate.word.name": "打印模板名称",
    "data.printTemplate.word.push": "上传模板",
    "data.operation.record": "操作记录",
    "data.api": "数据推送",
    "data.api.subTitle": "数据推送可将表单数据推送至您指定的服务器",
    "data.api.create": "新建数据推送",
    "data.api.custom": "推送到自定义服务器",
    "data.api.fr": "推送到FineReport服务器",
    "data.api.log": "推送日志",
    "data.api.deleteTitle": "您确定要删除这条数据推送吗？",
    "data.api.deleteMsg": "删除数据推送后目标服务器将无法收到推送数据，此操作无法还原",
    "data.api.fail.tip1": "{{count}} 条数据推送失败，请调整配置后重新推送",
    "data.api.fail.tip2": "超过 100 条数据推送失败，推送已暂停。系统为您保留了前 100 条失败数据，请调整配置后重新推送",
    "data.api.trigger.create": "有新数据提交时推送",
    "data.api.trigger.update": "有数据被修改时推送",
    "data.api.trigger.remove": "有数据被删除时推送",
    "data.api.trigger.recover": "有数据被恢复时推送",
    "data.api.trigger.formUpdate": "表单结构有变化时推送",
    "data.api.trigger.comment": "有新增评论时推送",
    "data.api.trigger.comment.edit": "有评论被修改时推送",
    "data.api.flow.status": "当新增，修改数据，或流程状态更改时，推送数据和流程状态信息",
    "data.api.serverUrl": "服务器地址：{{- url}}",
    "data.api.serverUrl.config": "服务器地址",
    "data.api.push.now": "正在推送，请稍后",
    "data.api.push.finish": "推送完成",
    "data.api.push.finish.detail": "{{- success}}条数据推送成功，{{- fail}}条数据推送失败",
    "data.api.push.again": "重新推送",
    "data.api.push.again.tip": "确定要重新推送这些数据吗？",
    "data.api.push.again.detail": "重新推送前，请确保您的数据推送已正确配置。",
    "data.api.push.discard": "放弃推送",
    "data.api.push.discard.tip": "确定要放弃推送这些数据吗？",
    "data.api.push.discard.detail": "放弃推送会删除失败记录，此操作不可撤销。",
    "data.api.pushTime": "推送时间：{{time}}",
    "data.api.doc.title": "字段对照表及JSON样例",
    "data.api.form.structure": "表单数据结构",
    "data.api.flowState.explain": "2表示流程手动结束；1表示流程已完成；0表示流程进行中",
    "data.api.leaveMsg": "离开当前页后，您的数据推送设置不会被保存",
    "data.api.log.fail": "推送失败日志",
    "data.api.log.success": "推送成功日志",
    "data.api.allLog": "全部日志",
    "data.api.logTip": "仅保留6个月的推送日志",
    "data.api.logTime": "推送时间",
    "data.api.logUrl": "推送地址",
    "data.api.logResult": "推送结果",
    "data.api.logDetail": "推送详情",
    "data.api.logEmpty": "暂无推送日志",
    "data.api.fail": "推送失败",
    "data.api.code": "状态码",
    "data.api.server": "目标服务器",
    "data.api.server.custom": "自定义服务器",
    "data.api.server.fr": "FineReport服务器",
    "data.api.server.test": "服务器连接测试",
    "data.api.secret.create": "生成Secret",
    "data.api.server.target": "请填写目标服务器地址",
    "data.api.server.connecting": "正在连接服务器...",
    "data.api.server.connectSuccess": "服务器连接成功！",
    "data.externalLink": "数据外链",
    "data.externalLink.subTitle": "将表单中的数据发布为独立的公开链接，无需登录即可访问数据",
    "data.externalLink.allEnabled": "可查看全部字段，可编辑全部字段",
    "data.externalLink.enabledCount": "可查看全部字段，可编辑{{count}}个字段",
    "data.externalLink.enabled": "可查看全部字段",
    "data.externalLink.visibleEnabledCount": "可查看{{visibleCount}}个字段，可编辑{{enableCount}}个字段",
    "data.externalLink.visibleCount": "可查看{{count}}个字段",
    "data.externalLink.auth": "外链权限配置",
    "data.externalLink.info": "可以查看和编辑数据外链的哪些字段",
    "data.view": "查看数据",
    "date.ago.minute": "{{value}}分钟前",
    "date.day": "{{day}}日",
    "date.days": "{{day}}天",
    "date.number": "{{number}}号",
    "date.hours": "{{hour}}小时",
    "date.minutes": "{{minute}}分钟",
    "date.end": "结束日期",
    "date.just": "刚刚",
    "date.lastMonth": "上月",
    "date.lastWeek": "上周",
    "date.lastSevenDays": "过去7天",
    "date.month": "{{month}}月",
    "date.quarter": "第{{quarter}}季度",
    "date.static": "固定值",
    "date.formula": "公式计算值",
    "date.start": "起始日期",
    "date.thisMonth": "本月",
    "date.thisWeek": "本周",
    "date.today": "当天",
    "date.today.after": "今天之后",
    "date.today.before": "今天之前",
    "date.today.time": "今天{{hour}}:{{minute}}",
    "date.week": "{{week}}周",
    "date.year": "{{year}}年",
    "date.thisYear": "今年",
    "date.lastYear": "去年",
    "date.year_quarter": "{{year}}年第{{quarter}}季度",
    "date.year_month": "{{year}}年{{month}}月",
    "date.year_week": "{{year}}年{{week}}周",
    "date.year_month_day": "{{year}}年{{month}}月{{day}}日",
    "date.month_day": "{{month}}月{{day}}日",
    "date.yesterday": "昨天",
    "date.sunday": "星期日",
    "date.monday": "星期一",
    "date.tuesday": "星期二",
    "date.wednesday": "星期三",
    "date.thursday": "星期四",
    "date.friday": "星期五",
    "date.saturday": "星期六",
    "date.sunday.short": "日",
    "date.monday.short": "一",
    "date.tuesday.short": "二",
    "date.wednesday.short": "三",
    "date.thursday.short": "四",
    "date.friday.short": "五",
    "date.saturday.short": "六",
    "date.sunday.custom": "周日",
    "date.monday.custom": "周一",
    "date.tuesday.custom": "周二",
    "date.wednesday.custom": "周三",
    "date.thursday.custom": "周四",
    "date.friday.custom": "周五",
    "date.saturday.custom": "周六",
    "date.january": "一月",
    "date.january.short": "1月",
    "date.january.short.chain": "一",
    "date.february": "二月",
    "date.february.short": "2月",
    "date.february.short.chain": "二",
    "date.march": "三月",
    "date.march.short": "3月",
    "date.march.short.chain": "三",
    "date.april": "四月",
    "date.april.short": "4月",
    "date.april.short.chain": "四",
    "date.may": "五月",
    "date.may.short": "5月",
    "date.may.short.chain": "五",
    "date.june": "六月",
    "date.june.short": "6月",
    "date.june.short.chain": "六",
    "date.july": "七月",
    "date.july.short": "7月",
    "date.july.short.chain": "七",
    "date.august": "八月",
    "date.august.short": "8月",
    "date.august.short.chain": "八",
    "date.september": "九月",
    "date.september.short": "9月",
    "date.september.short.chain": "九",
    "date.october": "十月",
    "date.october.short": "10月",
    "date.october.short.chain": "十",
    "date.november": "十一月",
    "date.november.short": "11月",
    "date.november.short.chain": "十一",
    "date.december": "十二月",
    "date.december.short": "12月",
    "date.december.short.chain": "十二",
    "date.format": "yyyy年MM月dd日 HH:mm",
    "dataTable.deleteAllTip": "您当前选中了全部数据，数据删除后可在回收站中恢复",
    "dataTable.deleteAllTip.mergeAuth": "根据数据权限的设置，你可能无法删除全部可见数据。",
    "dataTable.deleteAllSelectDataTip": "您确定要删除所选数据吗？",
    "dataTable.dataRecover": "恢复删除数据？了解高级版本",
    "dataTable.deleteTip": "您当前选中了{{- length}}条数据，数据删除后可在回收站中恢复",
    "dataTable.deleteTipForFree": "您当前选中了{{- length}}条数据，免费版删除的数据无法恢复",
    "dataTable.deleteAllTipForFree": "您当前选中了全部数据，免费版删除的数据无法恢复",
    "dataTable.deleteAllDataTip": "您确定要清空所有数据吗？",
    "dataTable.editor.exit": "退出编辑",
    "dataLimitTip.link": "该账号的本月数据流量已用完，无法提交新数据，请联系链接发布者升级版本",
    "dataLimitTip.account": "该账号的本月数据流量已用完，无法提交新数据，请联系账号创建者升级版本",
    "dataLimitTip.account.admin": "您的本月数据流量已用完，无法提交新数据，请升级版本",
    "dingtalkCorp.corpSelect": " 企业选择",
    "dingtalkCorp.empty.title": "您还不在平台成员列表中",
    "dingtalkCorp.empty.subTitle": "请联系贵司管理员同步成员",
    "dingtalkCorp.bind": "绑定您的平台账号",
    "delete.hard": "彻底删除",
    "delete.multi": "批量删除",
    "delete.selected": "删除选中",
    "delete.all": "删除全部",
    "delete.success": "删除成功!",
    "delete.fail": "删除失败!",
    "delete.confirm": "您确定要删除“{{- name}}”吗？",
    "dept.add": "添加部门",
    "dept.add.level.fail": "部门层级超过{{- level}}层，无法添加",
    "dept.current": "当前用户所处部门",
    "dept.delete.tip": "删除部门会将部门所关联的权限一并删除，此操作不可逆",
    "dept.empty": "暂无相关部门",
    "dept.manager": "部门主管",
    "dept.manager.grade.suffix": "的主管级别：",
    "dept.manager.set": "设置部门主管",
    "dept.set": "设置部门",
    "dept.sub.add": "添加子部门",
    "dept.name.placeholder": "请输入名称",
    "dept.name.required": "请输入部门名称",
    "dept.name.notEmpty": "部门名称不能为空",
    "dept.name.tooLong": "部门名称不能超过{{length}}个字",
    "dept.select.tip": "请至少选择一个部门",
    "dept.manager.grade.one": "直接部门主管",
    "dept.manager.grade.two": "上级部门主管",
    "dept.manager.grade.three": "三级部门主管",
    "dept.manager.grade.four": "四级部门主管",
    "dept.manager.grade.five": "五级部门主管",
    "combine.date": "日期汇总",
    "combine.yearAndMonth": "年、月",
    "combine.yearAndMonthAndDay": "年、月、日",
    "combine.address": "地址汇总",
    "combine.provinceAndCity": "省、市",
    "combine.detail": "关联释义",
    "combine.rule": "汇总方式",
    "combine.percent": "汇总占比",
    "contact.all": "全部联系人",
    "contact.edit": "编辑联系人",
    "contact.search": "搜索联系人",
    "contact.search.emptyTip": "当前分组无搜索结果，请检查搜索值或在「全部联系人」中搜索",
    "contact.all.search.emptyTip": "无搜索结果，请检查搜索值",
    "contact.group": "联系人分组",
    "contact.group.default": "未分组",
    "contact.group.add": "添加分组",
    "contact.group.delete.confirm": "您是否要删除“{{- name}}”？",
    "contact.group.delete.tip": "删除分组后该分组内联系人仍然保留在「全部联系人」内。",
    "contact.group.placeholder": "请输入联系人分组名称",
    "contact.group.name.notEmpty": "联系人分组名称不能为空",
    "contact.group.name.tooLong": "联系人分组名称不能超过32个字",
    "contact.add": "添加联系人",
    "contact.add.success": "添加联系人成功",
    "contact.delete": "删除联系人",
    "contact.delete.confirm": "您确定要删除所选联系人吗？",
    "contact.delete.tip": "删除联系人会同时删除该联系人的权限，且无法还原",
    "contact.delete.select.tip": "请选择要删除的联系人",
    "contact.notSave.warning": "您的联系人未保存,确认离开当前页面?",
    "contact.notSave.tip": "离开当前页您的联系人信息将不会被保存",
    "contact.phone.valid.tip": "手机格式不正确",
    "contact.note": "备注",
    "contact.name.placeholder": "请输入名称",
    "contact.name.tooLong": "分组名称不能超过{{length}}个字",
    "contact.position": "联系人职位",
    "contact.phone": "联系人手机号",
    "contact.template": "通讯录模板",
    "contact.template.import.tip": "每次最多导入200名成员，已经在通讯录内或信息有误的成员不导入",
    "custom.color": "自定义颜色",
    "custom.login": "自定义登录页",
    "custom.login.style": "自定义登录样式",
    "custom.login.mode": "登录方式",
    "custom.login.range.tip": "应用于企业账号URL和发布给成员的内链接中",
    "custom.login.config.close.title": "您确定要关闭配置页面吗？",
    "custom.login.config.close.msg": "关闭后已更改的配置项不会保存，此操作无法还原",
    "custom.login.auto.close.option": "自动登录选项",
    "custom.login.language.option": "语言选项",
    "custom.login.register.entrance": "注册入口",
    "custom.login.showFigure": "展示图",
    "custom.login.corpLogo": "企业 logo",
    "custom.login.save.title": "您尚未开启单点登录功能，确认保存？",
    "custom.login.save.mag": "您在「登录方式」中勾选了「单点登录」，保存配置后，使用单点登录时将登录失败",
    "design.withMark": "（设计）",
    "dataSource.update.confirm": "您确定要修改数据源吗？",
    "dataSource.update.tip": "修改数据来源设置会清空已有的字段配置和条件过滤等选项，且无法还原",
    "dataSource.update.msg": "修改数据来源设置会清空已有的字段配置，是否确认修改？",
    "dataSource.singleForm": "单表数据",
    "dataSource.multiForm": "多表关联",
    "dataSource.joinField.required": "请选择表单字段建立关联",
    "dataSource.joinField.invalid.warning": "所选关联字段数据类型不一致或关联字段不存在!",
    "dataSource.joinTable.required": "请先选择关联表",
    "effective.client.tip": "该功能仅对微信服务号/企业微信和钉钉移动客户端有效",
    "email.invalid.warning": "请输入正确的邮箱",
    "email.bind": "绑定邮箱",
    "email.new": "新邮箱",
    "email.current": "当前邮箱",
    "email.set.success": "邮箱设置成功",
    "email.verify": "验证邮箱",
    "email.update": "修改邮箱",
    "email.update.success": "邮箱修改成功",
    "email.unbind": "解绑邮箱",
    "email.unbind.success": "邮箱解绑成功",
    "email.unbind.confirm": "您确定要解绑邮箱吗？",
    "email.unbind.tip": "解绑邮箱需验证当前绑定邮箱的真实性，且解绑后将无法通过原邮箱登录平台，如需继续使用邮箱登录，可以在解绑后重新绑定新邮箱",
    "equidistance.horizontal": "水平等距",
    "equidistance.vertical": "垂直等距",
    "error.1": "错误的请求",
    "error.201": "操作失败，请刷新页面后重试",
    "error.1000": "该账号不存在",
    "error.1001": "密码不正确",
    "error.1002": "该账号尚未激活",
    "error.1003": "微信绑定失败",
    "error.1004": "URL已被使用",
    "error.1005": "邮箱已存在",
    "error.1006": "信息不符合规范",
    "error.1007": "注册失败",
    "error.1008": "用户名已被占用，请更换用户名",
    "error.1009": "该邮箱已被占用",
    "error.1010": "用户不存在",
    "error.1011": "密码格式不符合规则",
    "error.1012": "您未设置密码",
    "error.1013": "密码错误超过5次，账号已被锁定，请1小时后重试或重置密码",
    "error.1014": "用户创建失败",
    "error.1015": "用户信息缓存失败",
    "error.1016": "用户激活码已过期",
    "error.1017": "用户名不符合格式要求",
    "error.1018": "用户邮箱不符合格式要求",
    "error.1019": "用户昵称不符合格式要求",
    "error.1020": "用户校验参数不存在",
    "error.1021": "用户校验参数与当前用户不匹配",
    "error.1022": "用户团队不存在",
    "error.1023": "账号与邮箱不能同时为空",
    "error.1024": "手机号错误",
    "error.1025": "图片验证码错误",
    "error.1026": "验证码错误",
    "error.1027": "手机号码已存在",
    "error.1028": "操作过于频繁，获取验证码失败。请在1分钟后再获取验证码",
    "error.1029": "该功能仅供共创用户使用",
    "error.1030": "用户未登录",
    "error.1031": "邮箱验证码不正确",
    "error.1032": "邮箱地址不正确",
    "error.1033": "用户已被禁止访问",
    "error.1034": "oauth认证access_token获取失败",
    "error.1035": "oauth认证用户信息获取失败",
    "error.1036": "用户团队创建失败",
    "error.1037": "用户团队已经创建或当前用户已绑定企业",
    "error.1038": "用户未进行该类型绑定或已解绑",
    "error.1039": "用户需保留至少一种登录方式",
    "error.1040": "由于业务调整，平台不再支持使用新的QQ/微博账号登录，请使用其他方式登录或注册！给您带来不便，十分抱歉",
    "error.1041": "该第三方账号已被其他平台用户绑定",
    "error.1042": "当前用户无法试用高级版功能",
    "error.1043": "用户不属于当前团队",
    "error.1044": "您的账号不满足申请条件",
    "error.1045": "当前账号未绑定手机号",
    "error.1046": "当前账号不属于推广者",
    "error.1047": "当前账号未加入推广联盟",
    "error.1048": "当前账号推广码已被禁用",
    "error.1049": "当前用户已提交认证申请，请勿重复提交",
    "error.1050": "实名制认证创建失败",
    "error.1051": "实名制认证信息不存在",
    "error.1052": "当前不可修改实名制认证信息",
    "error.1053": "当前用户提现或实名制认证中，禁止修改支付宝相关信息",
    "error.1054": "当前用户没有收到邀请或已加入团队",
    "error.1055": "钉钉推广申请不存在",
    "error.1056": "当前不可修改钉钉推广信息",
    "error.1057": "邀请链接已过期",
    "error.1058": "用户操作权限不足",
    "error.1059": "未做任何修改",
    "error.1061": "联系人数量已达到上限，无法创建",
    "error.1062": "已存在同名联系人分组",
    "error.1063": "当前用户不允许修改团队名称",
    "error.1064": "团队名称不符合规范",
    "error.1065": "当前用户已加入团队",
    "error.1066": "已存在 API KEY，不能重复创建",
    "error.1067": "提交了规范外的信息",
    "error.1068": "当前企业不匹配",
    "error.1069": "当前用户需要补充用户画像信息后才能开启高级版功能试用",
    "error.1070": "只有一种账号登录方式时无法解绑",
    "error.1071": "当前手机号不正确",
    "error.1072": "当前邮箱不正确",
    "error.1073": "非企业微信集成模式不能注销企业账号",
    "error.1074": "您已提交过注销申请，请等候处理",
    "error.1075": "微信绑定失败，此微信账号已绑定平台账号",
    "error.1076": "连续多次密码错误",
    "error.1079": "当前账号不是企业微信管理员",
    "error.1082": "手机号和邮箱不能同时为空",
    "error.1085": "成员姓名不能超过12个字符",
    "error.1087": "企业用户id已存在",
    "error.1090": "同步成员不能加入其他企业",
    "error.1092": "成员编号最长12个字符",
    "error.1101": "管理组不存在",
    "error.1102": "当前部门不在管理组可管理范围内",
    "error.1103": "请先切换到对应企业",
    "error.1104": "没有管理组操作权限",
    "error.1105": "不合法的管理组ID",
    "error.1106": "不能将自己移除管理组",
    "error.1107": "存在其它管理组成员",
    "error.1108": "企业创建者不能加入任何管理组",
    "error.1200": "不合法的角色ID",
    "error.1201": "企业角色信息不存在",
    "error.2000": "应用名称不能为空",
    "error.2001": "应用URL已存在",
    "error.2002": "应用URL存在非法字符",
    "error.2003": "应用管理员不存在",
    "error.2004": "该应用已被删除，请打开工作台选择其他应用",
    "error.2005": "应用无法复制",
    "error.2006": "该应用无法发布",
    "error.2007": "应用发布失败",
    "error.2008": "应用发布拷贝失败",
    "error.2009": "没有应用操作权限",
    "error.2010": "没有跨应用操作权限",
    "error.2011": "该应用使用了『跨应用』功能，暂不支持发布到模板中心",
    "error.2012": "由于应用内存在违规信息，已被禁止访问",
    "error.2013": "应用未开启推广链接，无法访问",
    "error.2014": "您不是系统管理员或企业创建者，请登录相关账户安装或将链接发送给相关人员进行安装。",
    "error.2015": "该应用使用了『跨应用』功能，暂不支持开启推广链接",
    "error.2016": "已存在推广中的同源应用，该应用无法开启推广链接",
    "error.2017": "该应用已开启推广链接，暂不支持使用『跨应用』功能",
    "error.2018": "没有应用删除权限",
    "error.2019": "没有应用编辑权限",
    "error.2020": "仅系统管理员能复制发布应用",
    "error.2021": "没有应用创建权限",
    "error.2022": "没有应用安装权限",
    "error.2023": "默认应用不能重复安装",
    "error.2027": "仅系统管理员能调整应用顺序",
    "error.2029": "移动失败，拖拽文件已被其他管理员删除，请刷新页面",
    "error.2030": "移动失败，文件列表已被其他管理员改动，请刷新页面",
    "error.2031": "试用中的应用不支持复制",
    "error.2032": "试用中的应用不支持开启安装链接",
    "error.2033": "试用中的应用不支持发布至模板中心",
    "error.3000": "表单不存在",
    "error.3001": "名称不能为空",
    "error.3002": "非指定类型",
    "error.3003": "父节点不存在",
    "error.3004": "表单成员字段不存在",
    "error.3005": "参数不正确",
    "error.3006": "聚合表不存在",
    "error.3007": "该表单已被聚合表引用，无法删除",
    "error.3008": "不支持数据编辑操作",
    "error.3009": "操作权限不足",
    "error.3010": "表单流程版本不正确",
    "error.3011": "外链扩展参数不正确",
    "error.3012": "密码不正确",
    "error.3013": "由于网页存在违规信息，已被禁止访问。",
    "error.3014": "当前应用内聚合表数量已达到上限",
    "error.3015": "发布对外链接,请先完成手机绑定",
    "error.3016": "您的表单链接暂时不可用，我们会在24小时内审核您的表单，审核通过之后链接方可使用。",
    "error.3017": "表单打印模板不存在",
    "error.3018": "表单打印模板创建失败",
    "error.3019": "当前表单打印模板数量已达到上限",
    "error.3020": "表单提醒配置不存在",
    "error.3021": "表单提醒配置发生变更，无法执行",
    "error.3022": "表单提醒周期已超出结束时间",
    "error.3023": "当前任务正在执行中，无法修改",
    "error.3024": "表单权限组不存在",
    "error.3025": "表单提醒数据发生变更，无法执行",
    "error.3026": "应用未安装，请先安装应用再提交数据。",
    "error.3027": "表单自增 Id 获取失败",
    "error.3028": "服务器 URL 格式不正确",
    "error.3029": "当前登录团队为：{{corpName}}\n如果确认团队无误，请联系管理员分配页面权限",
    "error.3031": "数据推送组已达上限，请删除多余推送组后再新建",
    "error.3032": "表单数据推送创建失败",
    "error.3033": "表单数据推送配置不存在",
    "error.3034": "报表字段不存在",
    "error.3035": "连接失败, 请检查您的服务器配置",
    "error.3036": "添加的图片数量已达上限",
    "error.3037": "无效的手写签名二维码链接",
    "error.3038": "表单字段不存在",
    "error.3039": "表单字段类型不匹配",
    "error.3040": "表单字段配置校验失败",
    "error.3041": "单个表单流水号字段数量超出上限",
    "error.3042": "字段别名校验失败",
    "error.3043": "报表字段不存在",
    "error.3044": "表单流程节点配置不正确",
    "error.3045": "报表缓存获取超时",
    "error.3046": "外链表单推送失败",
    "error.3047": "没有需要重新推送的数据",
    "error.3048": "已有重新推送任务",
    "error.3049": "重新推送失败",
    "error.3050": "非空分组不能删除",
    "error.3057": "报表功能已下线，使用报表实现相关功能",
    "error.4000": "数据提交失败",
    "error.4001": "数据不存在",
    "error.4002": "提交值重复",
    "error.4003": "未选择有效的字段",
    "error.4004": "操作失败,不允许关闭",
    "error.4005": "操作失败,不允许撤回",
    "error.4006": "操作失败,不允许回退",
    "error.4007": "操作失败,没有流程处理人",
    "error.4008": "操作失败,流程已经关闭",
    "error.4009": "操作失败,无权限",
    "error.4010": "数据操作权限不足",
    "error.4011": "数据流转时无流程状态变变更",
    "error.4012": "操作失败，当前表单正在执行其他批量编辑任务，请稍后重试",
    "error.4013": "批量编辑含有失败的操作",
    "error.4014": "操作失败，没有可回退的节点",
    "error.4015": "操作失败，当前节点不存在该候选人",
    "error.4016": "操作失败，流程不能转交给自己",
    "error.4017": "您没有数据访问权限",
    "error.4018": "数据计数统计已修正",
    "error.4019": "评论功能仅适用于协作表单",
    "error.4020": "评论失败",
    "error.4021": "单个流程节点超时流转不能超过 10 次",
    "error.4101": "取数超出使用量限制",
    "error.4201": "汇总指标字段配置不正确",
    "error.4202": "汇总条件字段配置不正确",
    "error.4203": "汇总表单配置不正确",
    "error.4204": "存在重复的汇总指标字段",
    "error.4205": "存在重复的汇总条件字段",
    "error.4206": "没有可以编辑的字段，无法导入数据",
    "error.4207": "存在重复的数据表字段",
    "error.4208": "数据表单配置不正确",
    "error.4209": "汇总公式配置不正确",
    "error.4210": "无法生成汇总结果，无法导出 Excel",
    "error.4211": "公式中存在循环引用",
    "error.4212": "维度含子表单字段时，指标仅支持子表单字段，请调整",
    "error.4213": "来自不同子表单的字段无法汇总，请调整",
    "error.4214": "请求超时",
    "error.4215": "多个多选类字段不能同时作为维度，请调整",
    "error.4216": "多选类字段和子表单字段无法汇总，请调整",
    "error.4301": "未上传有效的 Excel 文件",
    "error.4302": "未提供 Excel 文档标识码",
    "error.4303": "指定的 Excel 表不存在",
    "error.4304": "不被支持的 Excel 文件格式",
    "error.4305": "加密的 Excel 文件",
    "error.4306": "导入的表单中无可用字段",
    "error.4307": "导入数据失败！每条数据记录的子表单数据不能超过200条，您的Excel数据已经超出限制，请调整您的Excel文件！",
    "error.4308": "将数据导入为部门成员字段时不能超过10000行*200列，您的Excel数据已超上限，请调整后重新导入",
    "error.4309": "Excel 文件中数据不能超过 50000 行、200 列",
    "error.4401": "聚合数据计算失败",
    "error.4402": "聚合计算校验失败",
    "error.4403": "聚合校验公式配置不正确",
    "error.4501": "无打包文件",
    "error.4502": "未选择文件字段",
    "error.4503": "文件打包任务已过期",
    "error.4504": "文件不存在",
    "error.4505": "文件打包任务失败",
    "error.4506": "文件打包任务尚未完成",
    "error.4507": "文件创建失败",
    "error.4508": "七牛回调鉴权参数不正确",
    "error.4509": "OSS回调鉴权参数不正确",
    "error.4510": "文件过期时间设定失败",
    "error.4511": "文件任务获取失败",
    "error.4512": "不允许删除未完成或过期的文件任务",
    "error.4513": "该表单中有正在执行的文件打包任务",
    "error.4514": "重命名中包含不符合类型规定的字段",
    "error.4515": "文件信息获取失败",
    "error.4516": "没有可导出的附件",
    "error.4517": "获取文件失败",
    "error.4518": "无效的手写签名 Token",
    "error.4519": "手写签名上传 Token 已过期",
    "error.4520": "WebSocket Token 已过期",
    "error.4601": "打印服务尚未初始化完成，无法打印",
    "error.4602": "无效的打印模板配置，保存失败",
    "error.4603": "打印模板图片加载失败",
    "error.4604": "未选择有效打印数据",
    "error.4605": "无效的二维码打印配置，无法打印",
    "error.4606": "仅自定义打印模板支持批量打印",
    "error.4607": "您有文件正在生成，请稍候",
    "error.4608": "批量打印任务创建失败",
    "error.4700": "数据流执行失败",
    "error.4701": "当前数据流正在执行中",
    "error.4702": "无效ETL任务Id",
    "error.4703": "数据流不存在",
    "error.4704": "数据流连线存在循环",
    "error.4705": "无输出节点，数据流无法执行",
    "error.4706": "数据流配置不正确",
    "error.4707": "横向连接存在笛卡尔积",
    "error.4708": "输出数据量超出限制",
    "error.4750": "数据流中应该至少存在一个输入节点",
    "error.4751": "同一来源的数据无法进行横向连接",
    "error.4752": "输入节点不能直接连接到输出节点",
    "error.4753": "节点的输入连线不正确",
    "error.4754": "横向连接至少有一组连接字段",
    "error.4755": "横向连接配置不正确",
    "error.4756": "分组统计阶段至少有一组分组和汇总字段",
    "error.4757": "请至少添加一个字段",
    "error.4758": "当前数据流存在孤立节点",
    "error.4759": "当前数据流存在多个流程",
    "error.4800": "触发器不存在",
    "error.4801": "触发器数量已达上限",
    "error.4802": "执行动作数量超过限制",
    "error.4803": "请选择触发表单",
    "error.4804": "无效的触发动作",
    "error.4805": "请添加执行动作",
    "error.4806": "请选择目标表单",
    "error.4807": "请指定要修改的数据",
    "error.4808": "请指定要修改的字段",
    "error.4809": "循环计算错误",
    "error.4810": "触发表单是其他智能助手的目标表单，且嵌套超过3层",
    "error.4811": "目标表单是其他智能助手的触发表单，且嵌套超过3层",
    "error.4812": "触发器修改数据量超过限制",
    "error.4813": "触发器超过最大嵌套层级",
    "error.4814": "触发器已停用",
    "error.4815": "过滤条件设置有误",
    "error.4817": "主字段或单个子表单不能使用不同子表单赋值",
    "error.4818": "子表单字段不能使用主字段赋值",
    "error.4819": "目标表单主字段和子字段不能同时使用子字段赋值",
    "error.4820": "主字段或单个子表单不能使用不同子表单字段赋值",
    "error.4821": "最多新建200条数据",
    "error.4822": "修改字段设置有误",
    "error.4826": "请指定要删除的数据",
    "error.4827": "过滤条件目标表单子表单不支持使用触发表单子表单赋值",
    "error.4828": "过滤条件不支持配置子表单",
    "error.4829": "过滤条件未配置目标表单子表单字段使用触发表单主字段赋值",
    "error.4830": "过滤条件未配置目标表单主字段使用触发表单子表单字段赋值",
    "error.4831": "过滤条件子字段不支持使用触发表单主字段赋值",
    "error.4832": "过滤条件目标表单主字段仅可使用触发表单相同子表单字段赋值",
    "error.4833": "不支持对目标表单子字段修改",
    "error.4834": "过滤条件仅支持对目标表单同一个子表单的子字段进行过滤",
    "error.4835": "仅支持对目标表单同一个子表单的子字段进行赋值",
    "error.4836": "目标表单子表单不支持使用触发表单子表单赋值",
    "error.4837": "目标表单主字段仅可使用触发表单相同子表单字段赋值",
    "error.4838": "字段赋值和过滤条件中目标表单子表单字段不一致",
    "error.4839": "字段赋值和过滤条件中触发表单子表单字段不一致",
    "error.5000": "流程节点删除失败",
    "error.5001": "无法删除带有子节点的流程",
    "error.5002": "该版本的流程正在使用中,无法删除",
    "error.5003": "流程节点不存在",
    "error.5004": "未提交流程审批意见",
    "error.5005": "版本内有数据,无法删除",
    "error.5006": "无法将数据流转到抄送节点",
    "error.5007": "无法对已关闭的流程执行转交",
    "error.5008": "找不到对应的负责人",
    "error.5009": "找不到回退后的负责人",
    "error.5010": "无效的流程数据",
    "error.5011": "找不到流转节点",
    "error.5012": "未提交流程手写签名",
    "error.5013": "请添加节点自动处理",
    "error.5014": "最多添加5个自动处理",
    "error.5015": "最多添加1个自动提交或自动回退",
    "error.5016": "无法同时设置自动提交和自动回退",
    "error.5017": "未设置被提醒人",
    "error.5018": "提醒文字不能为空",
    "error.5019": "自动提醒的时间需早于自动提交的时间",
    "error.5020": "自动提醒的时间需早于自动回退的时间",
    "error.5023": "该节点不允许批量提交",
    "error.5024": "当前用户对该节点无提交权限",
    "error.5025": "当前节点已经流转完成",
    "error.5026": "流程节点批量审批失败",
    "error.5028": "数据已过期，已为您自动清理",
    "error.6000": "已存在同名部门",
    "error.6001": "父部门不存在",
    "error.6002": "部门不存在",
    "error.6003": "存在子部门,不能删除",
    "error.6004": "部门修改失败",
    "error.6005": "部门创建失败",
    "error.6006": "部门内存在成员,不能删除",
    "error.6007": "没有成员管理权限",
    "error.6008": "部门主管只能是部门的直属成员",
    "error.6009": "根部门无法设置部门主管",
    "error.6010": "企业微信模式无法删除成员",
    "error.6011": '外部联系人分组名称只能中文,英文,数字,下划线,(,),-,空格;空格不能在头尾',
    "error.7000": "订单创建失败",
    "error.7001": "订单不存在",
    "error.7002": "订单已过期",
    "error.7003": "订单已取消",
    "error.7004": "订单已支付",
    "error.7005": "订单无法删除",
    "error.7006": "订单无法开票",
    "error.7007": "存在未完成的订单",
    "error.7008": "订单开票失败",
    "error.7009": "按用户数计费版本无法切换版本类型",
    "error.7010": "已购买版本无法降级",
    "error.7011": "当前版本级别无法购买指定服务",
    "error.7012": "版本续费无法变更版本级别",
    "error.7013": "版本信息有误，请联系平台客服协助处理，电话 400-011-1850",
    "error.7014": "免费用户无法购买任何服务",
    "error.7015": "可开票订单总金额不足 1000 元，无法开票",
    "error.7016": "优惠券无效",
    "error.7017": "当前用户无法开启试用功能",
    "error.7018": "未上传支付凭证",
    "error.7019": "当前用户已领取优惠券",
    "error.7021": "您尚未设置支付宝账号和提现密码，无法提现",
    "error.7022": "您尚未设置支付宝账号，无法提现",
    "error.7023": "您尚未设置提现密码，无法提现",
    "error.7024": "提现密码错误",
    "error.7925": "提现金额不得少于 1000 元",
    "error.7026": "提现金额不能超过可提现佣金",
    "error.7027": "优惠券活动已过期",
    "error.7028": "优惠券获取失败",
    "error.7029": "订单已失效",
    "error.7030": "此用户存在未支付的订单，请联系用户取消后重新创建",
    "error.7031": "支付参数签名校验失败",
    "error.7038": "用户数不能少于版本最低限制",
    "error.7102": "您的系统用量已超出当前版本限制，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7103": "系统用量超出限制，系统已暂停使用，您可以至会员中心查看版本使用详情和升级版本以恢复系统。",
    "error.7104": "聚合表数量已达上限，您可以至会员中心查看版本使用情况和升级版本。或删除无用聚合表后再进行新建。",
    "error.7105": "您所安装的应用内聚合表数量超出当前版本限制。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7106": "您的聚合表数量已超出当前版本限制，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7107": "您的附件上传量已超出当前版本限制，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7108": "您系统内的总数据量已超出当前版本限制，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7109": "您系统内的单表数据量已超出当前版本限制，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7110": "成员数量已超出上限，为了不影响您的正常使用，请尽快升级系统，否则系统将被禁用。",
    "error.7111": "成员数量超出限制可以至会员中心查看版本使用详情和升级版本，以同步/邀请更多成员。",
    "error.7112": "您当前使用的版本不包含自定义打印功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7113": "自定义打印模板数量已达上限，您可以至会员中心查看版本使用情况和升级版本。或删除无用自定义打印模板后再进行新建。",
    "error.7114": "您所安装的应用内自定义打印模板数量超出当前版本限制。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7115": "子管理员数量已达上限，您可以至账户中心查看版本使用情况和升级版本或减少管理员数量。",
    "error.7116": "子管理员数量已达上限，请联系企业创建者升级版本或减少管理员数量。",
    "error.7117": "您当前的版本只能设置一个系统管理员，如需更多子管理员请升级版本。",
    "error.7118": "子管理员数量已超出当前版本限制，该功能已被禁用。请联系您企业的账号创建者，升级版本或减少管理员数量。",
    "error.7119": "您当前的版本只能设置一个系统管理员，请联系您企业的账号创建者升级版本。",
    "error.7120": "您当前使用的版本不包含数据推送功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7121": "您当前使用的版本不包含数据回收站功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7122": "您当前使用的版本不包含导出附件功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7123": "您当前使用的版本不包含跨应用功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7124": "您当前使用的版本不包含自动同步功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7125": "您当前使用的版本不包含自定义提交成功页面功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7126": "此模板中包含的功能已超出您当前使用的版本，是否领取高级功能30天试用期",
    "error.7127": "此模板中包含的功能已超出您当前使用的版本，是否领取高级功能7天试用期",
    "error.7128": "您所安装的应用内聚合表数量与打印模板数量均超出当前版本限制。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7129": "您复制的数据量已经超出免费版限制，请升级版本后再使用该功能",
    "error.7130": "您所安装的应用内包含手写签名字段。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7132": "当前账号最多可以创建5个数据流，您可以点击查看详情查看数据流使用情况，删除无用数据流后再新建。",
    "error.7133": "数据流数量已超出当前版本限制，为避免系统受限影响您的正常使用，您可以点击查看详情删除无用数据流。",
    "error.7135": "每个账号仅可创建5个智能助手，请删除无用的智能助手后再新建",
    "error.7136": "智能助手数量已超出当前版本限制，为避免系统受限影响您的正常使用，请点击查看详情删除无用智能助手。",
    "error.7137": "您所安装的应用内数据流数量超出当前版本限制。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7138": "您所安装的应用内智能助手数量超出当前版本限制。您可以至会员中心查看版本使用情况和升级版本之后再来安装应用。",
    "error.7139": "您当前使用的版本不包含自定义样式功能，您可以至会员中心查看版本使用详情和升级版本。",
    "error.7201": "数据量已达上限，请尽快联系贵司平台管理者升级版本或调整系统用量。",
    "error.7202": "数据量已达上限，请尽快联系链接发布者升级版本或调整系统用量。",
    "error.7203": "数据量已超出限制，不可提交数据，请尽快联系链接发布者升级版本以恢复使用。",
    "error.7204": "您的系统用量已超出限制，请尽快联系贵司平台管理者升级版本或调整系统用量。",
    "error.7205": "系统用量超出限制，请尽快联系链接发布者升级版本或调整系统用量。",
    "error.7206": "系统用量超出限制，系统已暂停使用，请尽快联系贵司平台管理者升级版本以恢复系统。",
    "error.7207": "系统用量超出限制，系统已暂停使用，请尽快联系链接发布者升级版本以恢复使用。",
    "error.7208": "文件过大，上传失败；请联系贵司平台管理者升级版本以获得更大上传大小。",
    "error.7209": "单表数据量已达上限，请尽快联系贵司平台管理者升级版本或调整系统用量。",
    "error.7210": "聚合表数量已达上限，请尽快联系贵司平台管理者升级版本或调整系统用量。",
    "error.7211": "自定义打印模板数量已达上限，请尽快联系贵司平台管理者升级版本或调整系统用量。",
    "error.7212": "该账号的本月数据流量已用完，无法提交新数据，请联系账号创建者升级版本。",
    "error.7213": "手写签名功能已禁用，请联系企业创建者升级版本",
    "error.7214": "数据流数量已超上限，请联系企业创建者升级版本或调整系统用量。",
    "error.7215": "智能助手数量超出限制，请联系企业创建者升级版本或调整系统用量",
    "error.7216": "附件量超出当前版本限制，请尽快联系贵司平台管理者升级版本。",
    "error.7217": "附件量超出当前版本限制，请尽快联系链接发布者升级版本以恢复使用。",
    "error.8000": "企业授权信息不存在",
    "error.8001": "当前用户已经是企业用户",
    "error.8002": "企业用户未同步",
    "error.8003": "企业根部门不存在",
    "error.8004": "企业组织结构初次同步失败",
    "error.8005": "企业应用安装失败",
    "error.8006": "企业永久授权码获取失败",
    "error.8007": "企业授权信息获取失败",
    "error.8008": "企业套件激活失败",
    "error.8009": "企业授权令牌获取失败",
    "error.8010": "服务商套件凭据获取失败",
    "error.8011": "企业预授权码获取失败",
    "error.8012": "企业用户列表获取失败",
    "error.8013": "企业登录授权凭据不存在",
    "error.8014": "不合法的企业后台路径",
    "error.8015": "授权状态码校验失败",
    "error.8016": "当前用户与待绑定用户均已购买版本，无法绑定",
    "error.8017": "企业不存在或者已经被解散",
    "error.8018": "需要先在钉钉/微信后台解绑后操作",
    "error.8019": "用户开启自动同步功能",
    "error.8020": "用户未关注该企业号或公众号",
    "error.8022": "服务暂时不可用，请稍后重试",
    "error.8023": "corpId 或 corpSecret 错误",
    "error.8024": "corpId 或 ssoSecret 错误",
    "error.8025": "该 corpId 已被其他账号绑定",
    "error.8026": "corpSecret 需要有根部门权限",
    "error.8027": "用户信息获取失败",
    "error.8101": "无效的企业管理员",
    "error.8102": "未提供有效企业 Id",
    "error.8103": "绑定的企业不符合K12认证标准",
    "error.8104": "该企业已被其他平台账号用于认证",
    "error.8105": "认证申请已提交，请不要重复认证",
    "error.8106": "申请信息格式不正确",
    "error.8107": "申请信息提交失败，请重新尝试",
    "error.8108": "钉钉URL域错误",
    "error.8109": "已加入推广者联盟的钉钉账户不支持绑定到其他平台账户",
    "error.8110": "已设置手机或邮箱的钉钉账户不支持绑定到其他平台账户",
    "error.8111": "已创建应用的钉钉账户不支持绑定到其他平台账户",
    "error.8200": "企业套件错误，等待转换",
    "error.8201": "代理节点通讯失败",
    "error.8202": "所有代理节点通讯失败",
    "error.8301": "API 签名校验失败",
    "error.8302": "没有接口请求权限",
    "error.8303": "API 请求次数达到频率上限",
    "error.9001": "未配置有效的队列任务处理方法",
    "error.9002": "队列任务处理失败",
    "error.9003": "队列任务失败重试",
    "error.9004": "队列任务创建失败",
    "error.9005": "队列等待任务过多",
    "error.9006": "队列无效任务清理失败",
    "error.9007": "锁获取失败",
    "error.9008": "锁解除失败",
    "error.9900": "邮件发送失败",
    "error.9901": "消息不存在",
    "error.9902": "部分用户未能成功发送消息",
    "error.9903": "消息模板不存在",
    "error.9904": "短信余量不足，获取验证码失败。请联系企业创建者调整表单设计或购买短信容量包",
    "error.9905": "操作过于频繁，获取验证码失败。请在1个小时后再获取验证码",
    "error.9906": "短信发送失败",
    "error.9907": "手机号未验证或短信验证码已失效",
    "error.9908": "短信验证码获取失败，请安装应用后再使用此功能",
    "error.9909": "请输入正确格式的手机号或邮箱",
    "error.9914": "消息额外通知人不存在, 已被修改或已被删除",
    "error.9915": "消息额外通知人必须至少设置姓名和任意一种联系方式",
    "error.9916": "请在60秒后重试",
    "error.9917": "同一邮箱/手机号每天最多发送两次验证",
    "error.10001": "登录失败",
    "error.10003": "成员不存在",
    "error.10007": "配置错误",
    "error.10009": "单点登录不允许切换团队",
    "error.10010": "单点登录不允许创建团队",
    "error.10011": "已启用单点登录，无法进行换绑操作",
    "error.10012": "请联系管理员将你加入当前团队通讯录",
    "error.10013": "请联系管理员检查单点登录配置",
    "error.10014": "账号不可用",
    "error.4319": "data_id未匹配字段",
    "error.info.403": "服务器拒绝了您的浏览请求，请确认您所拥有的访问权限。",
    "error.info.404": "您可能输错了地址，或该网页已删除或移动。",
    "error.status.400": "错误的请求",
    "error.status.401": "用户未登录",
    "error.status.402": "当前会话已过期，请刷新页面后重试",
    "error.status.403": "没有数据请求权限",
    "error.status.404": "找不到数据资源",
    "error.status.429": "当前访问人数过多，请稍后重试",
    "error.status.fail": "与服务器通信失败",
    "error.status.corpSwitch": "您已离开当前团队，无法操作",
    "error.status.corpSwitch.tip": "同一浏览器，账号只能处于一个团队。如果要继续操作，请在其他标签页内切换到当前团队。",
    "error.title.403": "请求被拒",
    "error.title.404": "该页面不知飘去何处了",
    "error.title.409": "操作权限不足",
    "error.tip.corpName": "当前登录团队为「{{corp}}」",
    "error.tip.switchCorp": "如果要继续操作，请切换团队或联系管理员处理",
    "error.tip.switchCorp.mobile": "您没有加入任何团队，请到PC端创建团队或联系管理员处理",
    "error.qiniu.violation": "上传的附件「{{file}}」存在违规内容",
    "etl.clear": "清空输入源",
    "etl.clear.confirm": "您确定要清空该输入源吗？",
    "etl.clear.info": "清空输入源会同步清空后续节点包含当前输入源的配置，您确定要清空该输入源吗？",
    "etl.create": "新建数据流",
    "etl.clickToViewIntro": "点击查看功能介绍",
    "etl.dataProcess": "数据处理",
    "etl.dataSource": "数据来源：",
    "etl.dataFlow.empty": "数据流可对一个或多个数据源进行关联、聚合、追加合并等操作，形成输出表。\n 您可在报表中将输出表作为数据源使用。",
    "etl.dataFlow.fail": "数据流更新失败，请检查数据流设置",
    "etl.delete.msg": "删除数据流后，该数据流的输出数据也会一并被删除，删除的数据无法还原",
    "etl.design": "数据流设计",
    "etl.doIt": "执行",
    "etl.empty": "您当前没有数据输出集<br/>请先创建数据流再查看数据",
    "etl.empty.linkText": "什么是数据流？",
    "etl.emptyTip": "请先添加数据源，并将数据源连接到本节点",
    "etl.error.addInput": "请添加输入源",
    "etl.error.circle": "节点连线不能形成环",
    "etl.error.directToOutput": "输入节点不能直接连接输出节点",
    "etl.error.exceed": "节点输入连线超出限制",
    "etl.error.expr": "请输入表达式",
    "etl.error.fieldName": "请输入字段名称",
    "etl.error.formulaName": "请输入计算字段名称",
    "etl.error.isolateNode": "当前数据流存在孤立节点或孤立流程",
    "etl.error.noInputOrOutput": "当前数据流没有输入/输出节点",
    "etl.error.finishRely": "请先完成依赖节点的配置",
    "etl.error.line": "请将连接线连接至本节点",
    "etl.error.line.two": "请将2条连接线连接至本节点",
    "etl.error.line.more": "请将2-4条连接线连接至本节点",
    "etl.existFields": "现有字段",
    "etl.fail": "数据流执行失败，输出结果不再更新",
    "etl.dataUpdate": "更新数据",
    "etl.filter": "数据筛选",
    "etl.group": "分组汇总",
    "etl.group.addFields": "添加分组字段",
    "etl.groups.addMetrics": "添加汇总字段",
    "etl.group.metrics": "汇总字段",
    "etl.group.fields": "分组字段",
    "etl.group.rule": "分组方式",
    "etl.group.atLeastOneField": "请至少添加一组分组汇总字段",
    "etl.hasStage": "当前数据流已有{{title}}节点",
    "etl.inputAndOutput": "输入输出",
    "etl.input": "输入",
    "etl.input.data": "输入数据",
    "etl.input.subform.data": "子表单当前行",
    "etl.input.subform.data.tip": " (普通字段+子表单当前正在编辑行的数据)",
    "etl.input.subform.data.tip1": "指当前子表单选择的这一行。",
    "etl.input.subform.data.tip2": "当前表子表单某行选择输入数据，和其他输入",
    "etl.input.subform.data.tip3": "下图以追加合并为例",
    "etl.input.subform.data.tip4": "以短信方式发送多条数据到指定号码",
    "etl.input.news.tip": "将与之连接的输出结果集以",
    "etl.input.news.tip1": "短信/邮件/语音通知/微信提醒",
    "etl.input.news.tip2": "的方式发给指定人",
    "etl.input.news.tip3": "将输出表内的一条或多条数据进行",
    "etl.input.news.tip4": "将输出表内的所有数据进行以",
    "etl.input.news.tip5": "的方式发送给指定的成员或部门或手机号。",
    "etl.input.news.tip6": "短信通知",
    "etl.input.news.tip7": "如果有多个接收人，则符合条件的接收人都会收到所有符合条件的短信内容。",
    "etl.input.news.tip8": "1、如果接收人为单个成员或手机号码，则发送单条短信内容。",
    "etl.input.news.tip9": "2、如果接收人为多个成员或手机号码，则每个符合条件的接收人都会收到第一条数据的短信内容。",
    "etl.input.subformrely.tip": "将输出的结果联动到当前子表单，按照类型可分为：联动子表单当前行、联动子表单指定行、子表单添加数据、子表单删除数据。",
    "etl.input.subformrely.tip1": "根据设定的条件，取出输出表内符合条件的第一条数据，联动到当前所选择的子表单所在行。",
    "etl.input.subformrely.tip2": "根据设定的条件，取出输出表内符合条件的第一条数据，联动到符合的子表单数据所在行。",
    "etl.input.subformrely.tip3": "根据设定的条件，将符合的数据添加到子表单内。",
    "etl.input.subformrely.tip4": "根据设定的条件，将目标子表单内符合条件的数据删除。",
    "etl.input.data.description1": "即以表单当前所录入的数据作为数据源，可与其他表单或本表单已经录入的数据进行各种数据处理操作",
    "etl.input.data.description2": "输入数据在",
    "etl.input.data.description3": "初始化、新增数据、编辑数据、删除数据、提交数据、流程节点操作、控件触发、数据表菜单",
    "etl.input.data.description4": "时进行触发，仅指当前所操作的",
    "etl.input.data.description5": "数据",
    "etl.input.data.description6": "如：",
    "etl.input.data.description7": "页面录入数据后，和其他数据源的数据可以进行横向连接、追加合并、分组汇总等操作",
    "etl.input.data.description8": "下图以追加合并为例",
    "etl.inputSource": "输入源",
    "etl.inputSource.select.empty": "没有可选择的输入源",
    "etl.inputSource.add": "添加输入源",
    "etl.inputSource.update": "更改输入源",
    "etl.inputSource.update.tip": "确定要更改输入源？",
    "etl.inputSource.update.confirm": "此操作会同步更改后续节点的配置，无法还原？",
    "etl.inputSource.select": "1.选择输入源",
    "etl.field.select": "2.选择字段",
    "etl.field.select.cur": "选择字段",
    "etl.formula.empty.tip": "请在输入源添加数字字段",
    "etl.input.emptyTip": "请选择表单数据进行查看",
    "etl.input.subform": "子表单",
    "etl.input.form": "主表",
    "etl.input.selected.field": "已选字段",
    "etl.input.atLeastOneField": "至少选择1个字段",
    "etl.input.atLeastOneSubformField": "至少选择1个子表单字段",
    "etl.input.multisubform.tip": "所选输入源中含有多个子表单，请选择要使用的子表单",
    "etl.input.subformfield.empty": "没有子表单字段",
    "etl.intro.join": "主要是将2张数据表根据连接字段左右相连接，根据连接的方式不同又分为：内连接、左连接以及右连接。",
    "etl.intro.join.inner": "：根据连接字段，返回左右两侧表单连接字段相等的数据，即返回左右两个表单的数据交集。",
    "etl.intro.join.left": "：返回左侧表单的全部数据，根据连接字段，逐行匹配并连接右侧表单的数据，匹配不到则留空。",
    "etl.intro.join.right": "：返回右侧表单的全部数据，根据连接字段，逐行匹配并连接左侧表单的数据，匹配不到则留空。",
    "etl.intro.union": "支持将2-4张数据表，按照字段对应关系纵向连接，合并为1张数据表，可用于整合分散的同类数据。",
    "etl.intro.filter": "支持给单张数据表添加筛选条件，可用于过滤掉无用的数据，只保留需要的数据。",
    "etl.intro.group": "其实就是先分组再汇总。",
    "etl.intro.group.detail": "{{- group}}就是把分组字段值相同的数据分为一组，而{{- aggregate}}则是将分好组的数据各自按照指定的汇总方式计算汇总字段的值。",
    "etl.intro.map": "可以对数据表中的字段进行排序、隐藏；也可以增加计算字段，对当前表单数据进行简单计算。",
    "etl.intro.tip": "点击这里可以查看各个数据处理节点的功能介绍哦~",
    "etl.intro.view": "立即查看",
    "etl.io": "输入／输出",
    "etl.join": "横向连接",
    "etl.join.inner": "内连接",
    "etl.join.inner.info": "返回左右两侧表单中连接字段相等的数据",
    "etl.join.left": "左连接",
    "etl.join.left.info": "返回左侧表单的全部数据和右侧表单中匹配到的数据",
    "etl.join.right": "右连接",
    "etl.join.right.info": "返回右侧表单的全部数据和左侧表单中匹配的数据",
    "etl.join.rule.select": "选择连接方式",
    "etl.join.field.add": "添加连接字段",
    "etl.join.form.left": "左侧表单：",
    "etl.join.form.right": "右侧表单：",
    "etl.join.tip.atLeastOne": "横向连接至少要有一组连接字段",
    "etl.join.tip.sameSource": "同一来源的数据无法进行横向连接",
    "etl.join.tip.differentType": "连接字段的类型不一致",
    "etl.join.fuzzy": "设置模糊关联",
    "etl.join.fuzzy.precision": "模糊关联精度",
    "etl.join.fuzzy.time": "设置模糊关联匹配的时间单位",
    "etl.join.cartesian product": "预览出现笛卡尔结果集，建议更改横向连接配置，或修改数据",
    "etl.lastUpdate": "最后更新：{{time}}",
    "etl.log.just": "少于1分钟",
    "etl.log.minute": "{{minute}}分钟",
    "etl.log.execute": "更新日志",
    "etl.log.startTime": "开始时间：{{time}}",
    "etl.log.time": "更新时长：{{time}}",
    "etl.log.endTime": "结束时间：{{time}}",
    "etl.log.result": "更新结果：",
    "etl.log.resultWithoutMark": "执行结果",
    "etl.log.fail.reason": "失败原因：{{reason}}",
    "etl.log.fail.detail": "查看错误详情",
    "etl.map": "字段设置",
    "etl.map.addCalcField": "添加计算字段",
    "etl.map.showOriginField": "显示原始字段",
    "etl.map.editField": "编辑字段",
    "etl.map.hideField": "隐藏字段",
    "etl.map.editCalcField": "编辑计算字段",
    "etl.map.tip.atLeastOneField": "请至少添加一个字段",
    "etl.needSourceTable": "请先添加需要连接的表格，并将相关表格连接到本节点",
    "etl.output": "输出",
    "etl.output.emptyTip": "请先添加数据源连接至本节点，在点击预览后可查看数据",
    "etl.output.table": "输出表：",
    "etl.output.tableInfo": "（输出表请到报表中使用）",
    "etl.preview.maxCount": "最多可预览前{{count}}条数据",
    "etl.running": "正在更新",
    "etl.stage.config": "节点配置",
    "etl.stage.preview": "数据预览",
    "etl.stage.preview.error": "预览数据前，请先完成节点配置",
    "etl.stage.preview.loading": "加载中",
    "etl.stage.title": "节点名称：",
    "etl.status.running": "执行中",
    "etl.save.success": "保存成功，可以去「报表」使用输出的数据啦！",
    "etl.union": "追加合并",
    "etl.union.add.field.type.tip": "仅可添加同类型字段",
    "etl.union.add.field.empty": "没有可添加的字段",
    "etl.union.result": "合并结果",
    "etl.union.tip.atLeastOneField": "每张表请至少添加一个字段",
    "etl.unnamed": "未命名数据流",
    "enable.withMark": "（启用）",
    "export.failTip": "导出失败",
    "export.fail.timeout": "导出超时",
    "export.excel.notice": "准备中",
    "export.dataId": "同时导出data_id",
    "export.userAcount": "导出时成员带账户信息、部门带id，方便导入",
    "export.excel.notice.title": "导出文件准备中...",
    "export.excel.notice.content": "您可以进行其他操作，准备工作会在后台进行。\n准备完成后，您可以在导出记录下载。",
    "export.excel.fileSuccess": "导出文件准备完成",
    "export.excel.fileSuccess.content": "「{{name}}」的导出文件已准备完成。文件下载链接将于{{time}}小时后失效，请尽快下载。",
    "export.excel": "导出Excel",
    "export.data.all": "导出所有数据",
    "export.data.filtered": "导出过滤后的数据",
    "export.field.select": "请选择导出字段",
    "export.field.mode": "请选择图片/附件导出的方式",
    "export.field.mode.0": "图片保存在excel文件中(图片计算上传流量)",
    "export.field.mode.1": "图片/附件保存在excel同级目录以zip格式导出(图片/附件计算上传流量)",
    "export.field.mode.2": "图片/附件使用超链接方式保存在excel(不计算上传流量)",
    "export.file.all": "导出所有数据中附件",
    "export.file.filtered": "导出过滤后的数据中的附件",
    "export.file.widgetAndName": "导出附件与命名方式",
    "export.file.name": "导出时附件命名方式",
    "export.file.name.origin": "保持文件原始名称",
    "export.file.name.field": "按照表单中字段命名",
    "export.file.empty": "表单中没有附件可以导出",
    "export.file.selectAll": "附件（已全选）",
    "export.generate.downloadLink": "生成下载链接",
    "export.record": "导出记录",
    "export.record.delete.confirm": "您确定要删除导出记录吗？",
    "export.record.delete.tip": "删除导出记录后将不可下载这次导出的附件，且无法还原",
    "export.record.none": "无导出记录",
    "export.record.view": "查看导出记录",
    "export.link.expired.tip": "下载链接已失效，如需下载请重新导出附件",
    "export.link.tip": "下载链接将于{{expireDate}}失效，请尽快下载",
    "export.file.fail.tip": "附件导出失败，请稍后重试",
    "export.file.select.tip": "请选择需要批量导出的附件",
    "export.name.select.tip": "请选择用来命名的字段",
    "external.link.password.form": "填写该表单需输入密码，请输入密码：",
    "external.link.password.report": "查看该报表需输入密码，请输入密码：",
    "external.link.password.dash": "查看该报表需输入密码，请输入密码：",
    "external.link.scan": '微信"扫一扫"，分享给好友',
    "external.link.tip": "本内容由用户制作发布，不代表官方立场。",
    "fail.detail": "错误详情",
    "field.add": "请添加字段",
    "field.address": "地址字段",
    "field.alias": "字段别名",
    "field.asyncData": "关联其他表单数据",
    "field.auth": "字段权限",
    "field.auth.short": "字段权限",
    "field.no_view_auth": "无查看权限",
    "field.auth.add": "前往添加",
    "field.auth.emptyTip": "请先为表单添加字段",
    "field.auth.flowTip.warning": "已启用流程，字段权限以流程节点的设置为准",
    "field.auth.flowTip.info": "启用流程后，字段权限以流程节点的设置为准",
    "field.auth.set": "设置操作权限",
    "field.auth.systemTip": "系统字段不可修改",
    "field.auth.visibleTip": "请至少选择一个可见字段",
    "field.chargers": "当前节点/负责人",
    "field.createTime": "提交时间",
    "field.creator": "提交人",
    "field.date": "日期字段",
    "field.datetime": "日期时间字段",
    "field.defaults.set": "设置默认值",
    "field.defaults.today": "填写当天",
    "field.deleted.tip": "该字段已删除",
    "field.deleted.tip1": "配置已经失效，请重新配置",
    "field.deleter": "删除人",
    "field.deleted": "已删除字段",
    "field.deleteTime": "删除时间",
    "field.dept": "部门字段",
    "field.dept.empty": "表单中没有部门字段",
    "field.ext": "扩展字段",
    "field.edit.tip": "请选择一个字段来设置属性",
    "field.file.single": "仅允许上传单个文件",
    "field.flowState": "流程状态",
    "field.flow.chart": "流程图",
    "field.form": "关联表",
    "field.formula.edit": "编辑公式",
    "field.formula.edit.done": "已设置公式",
    "field.formula.empty.tip": "无可用变量，请添加或保存表单后重试",
    "field.formula.deleted.tip": "存在已删除字段，点击重新设置",
    "field.img.camera": "仅允许拍照上传",
    "field.img.compress": "自动压缩图片",
    "field.img.watermark": "拍照时添加水印",
    "field.img.watermarkTip": "水印中包括提交人、提交时间、定位，仅对钉钉移动客户端有效",
    "field.img.single": "仅允许上传一张图片",
    "field.id": "字段ID",
    "field.idOrAlias": "字段ID/字段别名",
    "field.scan.input": "扫码输入",
    "field.scan.barCode": "扫描条形码",
    "field.scan.editable": "可修改扫码结果",
    "field.scan.qrCode": "扫描二维码",
    "field.invalid": "无效字段",
    "field.key": "主键字段",
    "field.label": "字段标题",
    "field.layout": "布局",
    "field.layout.tip": "打开表单属性 > 双列布局才可使用",
    "field.layout.width": "显示宽度占用整行的",
    "field.lineType": "线型",
    "field.lineType.none": "无线框",
    "field.link": "关联字段",
    "field.link.tip": "仅可关联此字段之后的字段，请调整表单字段顺序后设置",
    "field.linkFilter": "数据过滤",
    "field.linkFilter.add": "添加过滤条件",
    "field.linkFilter.add.done": "已添加过滤条件",
    "field.linkFilter.form": "关联表字段",
    "field.linkFilter.invalid": "关联条件设置失效，点击重新设置",
    "field.linkFilter.line": "显示数据条数",
    "field.linkFilter.line.single": "一条",
    "field.linkFilter.line.multi": "多条",
    "field.linkFilter.msg.invalid": "关联条件设置失效，请重新设置",
    "field.linkFilter.operation": "关联表操作",
    "field.linkFilter.operation.add": "允许新增关联表数据",
    "field.linkFilter.scan": "开启后扫描数据二维码即可录入数据",
    "field.linkFilter.tip": "添加过滤条件来限定关联数据范围",
    "field.location.adjustable": "允许微调",
    "field.location.center.add": "新增定位中心",
    "field.location.center.select": "请选择定位中心",
    "field.location.empty": "当前无搜索结果",
    "field.location.lngLat.show": "显示经纬度坐标",
    "field.location.lngLat.tip": "勾选后可以获取当前位置的经纬度坐标，支持6位小数。",
    "field.location.radius": "以定位中心为圆心设置定位半径，建议范围500-1000",
    "field.location.range": "定位范围",
    "field.location.range.set": "设置定位范围",
    "field.location.range.tip": "可添加多个定位关键字，当定位位置满足其中一条关键字时通过校验",
    "field.noRepeat": "不允许重复值",
    "field.number": "数字字段",
    "field.number.integer": "仅允许填写整数",
    "field.number.integer.input": "请输入整数",
    "field.number.range": "限定数值范围",
    "field.number.range.btw": "请输入{{min}}~{{max}}之间的数",
    "field.number.range.gte": "请输入大于等于{{min}}的数",
    "field.number.range.lte": "请输入小于等于{{max}}的数",
    "field.name": "字段名称",
    "field.name.type": "输入字段名",
    "field.option.add": "添加选项",
    "field.option.add.other": "添加其他选项",
    "field.option.contact": "选项关联设置",
    "field.option.contact.done": "已设置选项关联",
    "field.option.line": "每行对应一个选项",
    "field.options": "选项{{num}}",
    "field.optionalRange": "可选范围",
    "field.phone": "手机字段",
    "field.file": "文件字段",
    "field.rely.set": "数据联动设置",
    "field.rely.set.done": "已设置数据联动",
    "field.rely.network.error": "『{{name}}』配置已失效，请联系管理员重新调整表单设计",
    "field.rely.request.error": "接口请求出现错误<br>字段名：{{name}}<br>错误信息：{{msg}}({{time}}，{{api}})",
    "field.rely.error": "数据联动异常",
    "field.rely.disable.default": "以子表单联动为准，不支持设置默认值",
    "field.rely.disable.option": "以子表单联动为准，不支持设置选项联动",
    "field.rely.disable.limit": "以子表单联动为准，不支持设置范围联动",
    "field.rely.doc": "什么是数据联动？",
    "field.rely.msg.inComplete": "请设置完整的数据联动条件",
    "field.rely.msg.invalid": "数据联动条件失效，请重新设置",
    "field.rely.invalid": "联动条件失效，点击重新设置",
    "field.rely.form": "联动表单",
    "field.rely.form.placeholder": "请选择联动表单",
    "field.rely.currentForm": "当前表单字段",
    "field.rely.relyForm": "联动表单字段",
    "field.rely.subField": "被联动子表单子字段",
    "field.rely.equal": "值等于",
    "field.rely.when": "的值时",
    "field.rely.show": "联动显示",
    "field.rely.result": "的值",
    "field.rely.sub": "子字段数据联动",
    "field.rely.sub.add": "添加子字段",
    "field.rely.sub.show": "显示为",
    "field.show": "显示字段",
    "field.subform.auth.tip": "勾选后可配置子表单的具体操作权限，包括新增记录，编辑已有记录，删除已有记录。",
    "field.subform.auth.add": "可新增记录",
    "field.subform.auth.edit": "可编辑已有记录",
    "field.subform.auth.sort": "可对已有记录排序",
    "field.subform.auth.delete": "可删除已有记录",
    "field.subform.copy.end": "复制到最后一行",
    "field.subform.copy.next": "复制到下一行",
    "field.subform.insert.up": "向上插入行",
    "field.subform.insert.next": "向下插入行",
    "field.text": "文本字段",
    "field.typeChange.rely": "该字段包含数据联动/公式编辑，无法转换",
    "field.typeChange.formula": "该字段包含公式编辑，无法转换",
    "field.typeChange.contact": "该字段包含选项关联，无法转换",
    "field.typeChange.async": "字段中选项来源于其他表单数据/包含数据联动，无法转换",
    "field.type": "字段类型",
    "field.updateTime": "更新时间",
    "field.user": "成员字段",
    "field.user.deptLimit": "由部门字段确定",
    "field.width": "字段宽度",
    "field.width.half": "1/2宽度",
    "field.width.normal": "标准宽度",
    "field.width.double": "2倍宽度",
    "field.update": "修改为",
    "field.userDept.add": "添加部门或成员",
    "field.detailOnly": "仅详情显示",
    "file.preview.noSupport": "当前文件类型不支持在线预览",
    "file.preview.support": "支持预览的文件？",
    "filter.addCondition": "添加筛选条件",
    "filter.check.placeholder": "请输入选项内容，多个值用‘enter’分开输入",
    "filter.flowNode.formEmptyTip": "请先选择表单",
    "filter.flowNode.list": "流程节点历史版本名称",
    "filter.method.eq": "等于",
    "filter.method.ne": "不等于",
    "filter.method.all": "同时包含",
    "filter.method.all.address": "属于",
    "filter.method.in.one": "等于任意一个",
    "filter.method.in.many": "包含任意一个",
    "filter.method.in.flowNode": "包含",
    "filter.method.nin": "不等于任意一个",
    "filter.method.nin.address": "不属于",
    "filter.method.lk": "包含",
    "filter.method.ulk": "不包含",
    "filter.method.ep": "为空",
    "filter.method.nep": "不为空",
    "filter.method.gt": "大于",
    "filter.method.gte": "大于等于",
    "filter.method.lt": "小于",
    "filter.method.lte": "小于等于",
    "filter.method.rg": "选择范围",
    "filter.method.vf": "已验证",
    "filter.method.nvf": "未验证",
    "filter.method.fm": "动态筛选",
    "filter.rel.tip": "筛选出符合以下",
    "filter.rel.tip1": "符合以下",
    "filter.rel.and": "所有",
    "filter.rel.or": "任一",
    "filter.rel.cond": "条件的数据",
    "filter.text.placeholder": "请输入文本内容",
    "filter.condition": "筛选条件",
    "filter.condition.add": "添加过滤条件",
    "filter.condition.stick": "固定显示",
    "filter.condition.cancelStick": "取消固定",
    "flow.activate": "激活流程",
    "datahelper.curform": "当前数据源 - {{name}}",
    "datahelper.output.field.tip": "设置当前字段为 {{name}} 字段",
    "flow.attr": "流程属性",
    "flow.attr.base": "基础属性",
    "flow.attr.more": "更多属性",
    "flow.action.disable": "未开启",
    "flow.action.enable": "已开启",
    "flow.action.forward": "提交",
    "flow.action.forward.tip": "用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，流程数据流转至后续节点。",
    "flow.action.save": "暂存",
    "flow.action.save.success": "暂存成功",
    "flow.action.save.tip1": "用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，流程不发生流转。",
    "flow.action.save.tip2": "暂存会将数据保存至数据库，触发字段「不允许重复值」校验。",
    "flow.action.print": "提交并打印",
    "flow.action.print.tip": "开启后，用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，流程流转至后续节点，同时进入打印界面进行数据打印。",
    "flow.action.back": "回退",
    "flow.action.back.tip": "开启后，用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，同时流程退回到指定的节点中。",
    "flow.action.transfer": "转交",
    "flow.action.transfer.candidates": "转交候选人",
    "flow.action.transfer.tip": "开启后，用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，流程转交至指定的负责人处理。",
    "flow.action.close": "结束流程",
    "flow.action.close.tip": "开启后，用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，并且终止流程，不再进行流转。",
    "flow.action.revoke": "撤回",
    "flow.action.validate.empty": "请设置按钮文字",
    "flow.action.validate.exceed": "超出按钮文字上限",
    "flow.action.failTip": "流转失败提示",
    "flow.action.time": "处理时间",
    "flow.action.activate": "激活",
    "flow.action.sign": "加签",
    "flow.action.sign.tip": "开启后，用户在处理流程时点击此按钮，可以添加临时审批人。临时审批人的字段权限、审批意见和节点操作权限与本节点属性一致。",
    "flow.action.sign_before": "前加签",
    "flow.action.sign_after": "后加签",
    "flow.action.sign_parallel": "添加审批人",
    "flow.sign.pane": "加签",
    "flow.sign.pane.black1.title": "加签方式",
    "flow.sign.pane.black1.tip": "请选择加签方式",
    "flow.sign.pane.black1.type1": "前加签",
    "flow.sign.pane.black1.type1.desc": "被加签人先处理，之后我处理",
    "flow.sign.pane.black1.type2": "后加签",
    "flow.sign.pane.black1.type2.desc": "我已同意提交，之后让被加签人处理",
    "flow.sign.pane.black1.type3": "添加审批人",
    "flow.sign.pane.black1.type3.desc": "为当前节点新增一位审批人",
    "flow.sign.pane.black2.title": "选择审批人",
    "flow.sign.pane.black2.tip": "请选择审批人",
    "flow.auth.group.submit.description": "在此分组内的成员可以发起流程，设置了表单共享的成员自动加入此分组",
    "flow.auth.group.review.name": "查看全部流程",
    "flow.auth.group.review.description": "在此分组内的成员可以查看全部流程",
    "flow.auth.group.manage.name": "管理全部流程",
    "flow.auth.group.manage.description": "在此分组内的成员可以管理全部流程",
    "flow.back.allow": "可回退到的节点",
    "flow.back.parent": "上一节点",
    "flow.back.placeholder": "请选择可回退节点",
    "flow.back.range": "指定范围内节点",
    "flow.back.tip": "没有可回退节点",
    "flow.back.to": "回退到",
    "flow.batch.close": "批量结束流程",
    "flow.batch.forward": "批量提交",
    "flow.batch.close.tip": "此操作会终止进行中的流程，不影响已结束的流程",
    "flow.briefing.tip": "选中的字段显示在访问应用的流程处理列表中，最多显示三个",
    "flow.briefing.exceed": "最多选择3个流程简报选项",
    "flow.btnText": "按钮文字",
    "flow.btnText.limit": "按钮文字最多为{{limit}}个字",
    "flow.btnText.tip": "修改后的按钮文字将替换节点操作的默认按钮文字，该功能对PC端和移动客户端均有效",
    "flow.btnText.required": "该项为必填项",
    "flow.btnText.restore": "恢复默认按钮文字",
    "flow.candidate.tip": "无可用负责人",
    "flow.cc": "抄送人",
    "flow.cc.dynamic": "动态抄送人",
    "flow.cc.enable": "启用抄送",
    "flow.cc.set": "点击设置抄送人",
    "flow.charger": "负责人",
    "flow.charger.current": "当前负责人",
    "flow.charger.deptManager": "节点负责人部门主管",
    "flow.charger.dynamic": "动态负责人",
    "flow.charger.name": "负责人名称",
    "flow.charger.select": "请选择负责人",
    "flow.charger.set": "点击设置负责人",
    "flow.charger.change": "调整流程负责人",
    "flow.charge.fail.noNextCharger": "找不到下个节点负责人，可联系管理员",
    "flow.charge.fail.noCondition": "不符合流转条件，可联系管理员",
    "flow.charge.fail.noBackCharger": "找不到回退后的负责人，请联系管理员",
    "flow.create": "发起流程",
    "flow.creator": "发起人",
    "flow.createTime": "发起时间",
    "flow.creator.depManager": "发起人部门主管",
    "flow.close": "结束流程",
    "flow.batch.active": "批量激活流程",
    "flow.batch.active.subtitle": '<span style="color:#4D609F" >*选择每个流程版本需要激活的流程节点可以批量激活<span>',
    "flow.batch.active.flow.hint": "请选择需要激活的流程节点",
    "flow.close.confirm": "您确定要{{ text }}吗？",
    "flow.close.desc": "保存在此节点中的操作，并且将流程直接结束掉，不再往下流转",
    "flow.close.tip": "结束流程后数据将停止流转，是否确认结束此流程？",
    "flow.close.all": "结束全部流程",
    "flow.close.all.confirm": "您确定要结束全部流程吗？",
    "flow.close.all.done": "已结束全部流程",
    "flow.close.selected": "结束选中的流程",
    "flow.close.selected.confirm": "您确定要结束选中的流程吗？",
    "flow.close.selected.done": "已结束选中的流程",
    "flow.chart.empty": "暂无流转图",
    "flow.cond": "数据流转条件",
    "flow.cond.add": "添加流转条件",
    "flow.cond.custom": "使用自定义流转条件",
    "flow.cond.custom.tip": "当数据满足流转条件时，进入这条连接线下的节点；不添加流转条件时，所有数据都会进入这条连接线下的节点。",
    "flow.cond.else": "使用Else条件",
    "flow.cond.else.tip": "当数据不满足同级的其他流转条件时，进入这条连接线下的节点。",
    "flow.comment.empty": "暂无审批意见",
    "flow.done": "该流程已被处理",
    "flow.done.tip": "该流程已被处理，无法再次操作，请选择其他流程。",
    "flow.done.viewReason": "查看详细原因",
    "flow.done.clickToViewReason": "如需查看详细原因，请点击此处",
    "flow.drag.node.guide": "拖拽添加节点",
    "flow.enable": "开始使用",
    "flow.enable.tip": "绘制上图所示流程图，设定数据流转方式，即可搭建线上工作流",
    "flow.enable.qa": "如有问题，请参考",
    "flow.fail.hint.forward": "提交失败",
    "flow.fail.hint.autoBack": "自动回退失败",
    "flow.fail.hint.autoForward": "自动提交失败",
    "flow.fail.hint.back": "回退失败",
    "flow.fail.hint.charger": "找不到下个节点负责人。",
    "flow.fail.hint.cond": "不符合流转条件。",
    "flow.fail.hint.reason": "出错原因：",
    "flow.fail.hint.title": "流程出错了，可联系链接发布者寻求帮助",
    "flow.fail.hint.detail": "您的数据已保存，请勿重复提交!",
    "flow.flowCreator": "流程发起人",
    "flow.launch": "发起流程",
    "flow.launch.empty": "当前没有可发起的流程",
    "flow.list.empty": "没有筛选出符合条件的流程",
    "flow.list.todo.empty": "没有新的待办任务",
    "flow.list.part.empty": "您还没有参与流程",
    "flow.list.create.empty": "您没有发起过流程",
    "flow.list.multiNode": "多个节点",
    "flow.list.current": "当前:",
    "flow.list.date.just": "小于1分钟",
    "flow.list.date.longAgo": "大于30天",
    "flow.list.date.remaining": "剩余处理时间",
    "flow.list.loaded": "已加载全部数据",
    "flow.logAndState": "流程日志/流转图",
    "flow.log.enable": "允许查看流程日志和流转图",
    "flow.log.tip": "开启此功能后，处理流程时可以查看流程日志和流转图。",
    "flow.log.startTime": "开始时间：{{time}}",
    "flow.log.dealTime": "处理时间：{{time}}",
    "flow.log": "流程日志",
    "flow.log.empty": "暂无流程日志",
    "flow.manage": "流程管理",
    "flow.msg": "流程提醒",
    "flow.msg.dingtalk": "使用钉钉提醒节点负责人、抄送人",
    "flow.msg.wework": "使用企业微信提醒节点负责人、抄送人",
    "flow.msg.wechat": "使用微信提醒节点负责人、抄送人",
    "flow.msg.email": "使用邮件提醒节点负责人、抄送人",
    "flow.node": "流程节点",
    "flow.node.action": "节点操作",
    "flow.node.action.tip": "定义流程负责人在处理流程时可以进行的操作",
    "flow.node.attr": "节点属性",
    "flow.node.auth.empty": "节点字段权限未配置",
    "flow.node.cc": "抄送节点",
    "flow.node.cc.empty": "抄送人未设置",
    "flow.node.charger": "节点负责人",
    "flow.node.charger.empty": "节点负责人未设置",
    "flow.node.copy": "复制节点",
    "flow.node.current": "当前节点",
    "flow.node.del": "删除节点",
    "flow.node.empty": "存在节点未设置负责人或全部字段不可见",
    "flow.node.end": "流程结束",
    "flow.node.end.del": "流程结束不能删除",
    "flow.node.end.unconnect": "流程结束节点未连接，流程无法启用",
    "flow.node.end.desc": "没有下级节点的节点会自动连接至流程结束；如果您需要在中途结束流程，请将需要结束流程的节点，连接到流程结束，并设置相应的流转条件。",
    "flow.node.isolated": "存在无数据流转的节点，请删除后启用",
    "flow.node.name": "节点名称",
    "flow.node.path": "节点连接线",
    "flow.node.pt": "节点打印模板",
    "flow.node.pt.set": "模板设置",
    "flow.node.select": "请选择节点",
    "flow.back.node.select": "请选择回退节点",
    "flow.node.signature.disable": "手写签名不可用",
    "flow.node.start": "流程发起节点",
    "flow.node.start.del": "流程发起节点不能删除",
    "flow.node.validate": "节点校验条件",
    "flow.node.validate.any": "所有数据均可提交",
    "flow.node.validate.meet": "满足条件的数据才可提交",
    "flow.node.cancelReminder": "提交不触发提醒",
    "flow.node.doing": "处理中节点",
    "flow.node.done": "已流转节点",
    "flow.node.undone": "未流转节点",
    "flow.node.prostatus": "处理状态",
    "flow.node.protime": "流程处理时长",
    "flow.node.outtime": "流程超时时长",
    "flow.node.pro.text": "流程时效统计",
    // "flow.node.flow_sub": "子流程",
    "flow.node.flow_sub": "子流程发起人",
    "flow.node.flow_sub.name": "子流程表单",
    "flow.node.flow_sub.set": "点击设置发起人",
    "flow.node.flow_sub.tooltip": "流转至此节点时，将自动为所选的流程表单创建流程",
    "flow.node.flow_sub.transfer": "数据传递",
    "flow.node.flow_sub.transfer.set": "设置数据传递规则",
    "flow.node.flow_sub.transfer.done": "已设置数据传递规则",
    "flow.node.flow_sub.transfer.rule": "流转规则",
    "flow.node.flow_sub.transfer.end": "子流程结束后进入下一节点",
    "flow.node.flow_sub.transfer.start": "子流程发起后进入下一节点",
    "flow.node.flow_sub.transfer.warning": "最多添加{{ count}}个子流程节点",
    "flow.node.flow_sub.rule.warning": "请先选择子流程表单",
    "flow.node.flow_sub.rule.same": "确定要使用该子表单字段赋值吗？",
    "flow.node.flow_sub.rule.same.desc": "单个子表单不能使用不同子表单字段赋值，此操作会清除部分已设置的规则",
    "flow.node.flow_sub.auto.submit": "子流程发起后自动提交",
    "flow.node.flow_sub.transfer.tooltip": "开启后，流转至子流程节点时，将自动为发起人创建流程并提交，直接进入后续节点；",
    "flow.node.flow_sub.transfer.tooltip.desc": "关闭时，仅为发起人创建待办，停留在发起节点",
    "flow.node.flow_sub.transfer.tip.in": "当父流程流转到子流程节点时，以下父流程字段值将赋给对应子流程字段",
    "flow.node.flow_sub.transfer.tip.out": "当子流程流转完成时，以下子流程字段值将赋给对应父流程字段",
    "flow.node.flow_sub.complete.tip": "请设置完整的传递规则",
    "flow.node.flow_sub.form.fail": "表单已删除/无跨应用权限",
    "flow.node.flow_sub.to": "赋值给",
    "flow.node.flow_sub.parent": "父流程",
    "flow.node.flow_sub.child": "子流程",
    "flow.node.flow_sub.child.watermark": "请选择子流程字段",
    "flow.node.flow_sub.parent.watermark": "请选择父流程字段",
    "flow.node.flow_sub.add.rule": "添加规则",
    "flow.node.flow_sub.parent.child": "父流程 -> 子流程",
    "flow.node.flow_sub.child.parent": "子流程 -> 父流程",
    "flow.node.flow_sub.dynamic": "动态发起人",
    "flow.node.flow_sub.creator": "子流程发起人",
    "flow.node.flow_sub.close.confirm": "确定要关闭「数据传递」设置界面吗？",
    "flow.node.flow_sub.close.detail": "关闭后本次设置不会保存，此操作无法还原",
    "flow.node.flow_sub.log.inprocess": "子流程进行中（完成 {{ now}}/{{ total}}）",
    "flow.node.flow_sub.log.complete": "子流程已完成（完成 {{ total}}/{{ total}}）",
    "flow.node.flow_sub.empty": "存在子流程节点的表单或发起人配置有误",
    "flow.node.flow_sub.maximum": "存在子流程表单设置出现循环或嵌套超过三层",
    "form.sub.data.deleted": "该条数据已被删除",
    "form.sub.chargers.empty": "子流程发起人未设置",
    "flow.node.flow_sub.access.fail": "没有对应数据查看权限",
    "form.chargersEmptyRule": "负责人为空处理规则",
    "form.chargersEmptyRule.items1": "不启用",
    "form.chargersEmptyRule.items2": "跳过并到下一节点",
    "form.chargersEmptyRule.items3": "转交给指定负责人",
    "form.chargersEmptyRule.spareChargers.empty": "负责人为空的备选负责人不能为空",
    "form.chargersEmptyRule.spareChargers.log": "系统自动转交给备选负责人",
    "form.sub.form.empty": "子流程表单未设置",
    "form.sub.form.error": "子流程表单配置有误",
    "form.sub.invalid.in": "可联系管理员激活至上一节点重新提交",
    "form.sub.invalid.msg": "触发失败",
    "mobile.flow.node.doing": "处理中",
    "mobile.flow.node.done": "已流转",
    "mobile.flow.node.undone": "未流转",
    "flow.node.selectActivate": "选择激活节点",
    "flow.node.activate.required": "激活节点不能为空",
    "flow.node.activate.success": "激活节点成功",
    "flow.node.activate.fail": "激活节点失败",
    "flow.node.required": "当前节点不能为空",
    "flow.part": "我参与的",
    "flow.print.allow": "允许查看时打印",
    "flow.release": "启用流程",
    "flow.release.confirm": "确定要启用流程吗？",
    "flow.release.tip": "启用后，新提交的数据将按此版本的流程流转。",
    "flow.release.empty.tip": "您的流程尚未启用，请至「流程设定」中启用流程。",
    "flow.revoke.allow": "流程发起后允许撤回",
    "flow.revoke.tip": "选中后允许流程发起人在后续节点负责人尚未处理的情况下撤回流程",
    "flow.Urge": "催办",
    "flow.Urge.one": "催",
    "flow.Urge.allow": "允许流程发起人催办",
    "flow.Urge.tip": "开启功能后，当某节点负责人尚未处理时，发起人可向其发送催办通知",
    "flow.Urge.process.all": "全部处理中的节点",
    "flow.rule": "流转规则",
    "flow.rule.any": "任意负责人提交后进入下一节点",
    "flow.rule.all": "所有负责人提交后进入下一节点",
    "flow.save.fail": "流程保存失败",
    "flow.save.log": "暂存记录",
    "flow.save.success": "流程保存成功",
    "flow.schedule": "节点限时处理",
    "flow.schedule.arrive": "流程到达节点",
    "flow.schedule.action.add": "添加自动处理",
    "flow.schedule.action.detail": "自动处理详情",
    "flow.schedule.action.defaultMessage": "有待办未完成，请及时处理",
    "flow.schedule.action.op": "处理方式",
    "flow.schedule.action.set": "自动处理设置",
    "flow.schedule.action.set.tip": "如何添加自动处理？",
    "flow.schedule.back": "自动回退",
    "flow.schedule.back.time": "自动回退时间",
    "flow.schedule.back.to": "回退到",
    "flow.schedule.brief.timeLimit": "流程到达该节点{{ time }}后",
    "flow.schedule.del.confirm": "您确定要删除节点限时处理吗？",
    "flow.schedule.del.tip": "删除节点限时处理后，您设置的自动处理也将一并删除，该操作不可逆。",
    "flow.schedule.doc": "如何设置限时处理？",
    "flow.schedule.forward": "自动提交",
    "flow.schedule.forward.time": "自动提交时间",
    "flow.schedule.forward.execDataExtend": "执行扩展功能",
    "flow.schedule.limit": "节点处理截止时间",
    "flow.schedule.limit.on": "在节点处理截止时间",
    "flow.schedule.limit.custom": "自定义时间",
    "flow.schedule.limit.widget": "表单内日期时间字段",
    "flow.schedule.limit.widget.tip": "请选择日期时间字段",
    "flow.schedule.node.tooltip": "已设置节点限时处理",
    "flow.schedule.notify": "自动提醒",
    "flow.schedule.notify.msg": "提醒文字",
    "flow.schedule.notify.time": "自动提醒时间",
    "flow.schedule.op.forward": "自动提交",
    "flow.schedule.op.back": "自动回退",
    "flow.schedule.set": "设置限时处理",
    "flow.schedule.timeLimit": "在节点处理截止时间{{ time }}{{ op }}",
    "flow.schedule.tip": "为节点设置处理截止时间，并可自动提醒节点负责人处理待办，如果长时间不处理可自动提交或回退，避免流程停滞。",
    "flow.schedule.validate.actionEmpty": "请添加节点自动处理",
    "flow.schedule.validate.actionConflict": "节点处理截止时间和自动处理时间存在冲突",
    "flow.schedule.validate.target": "未设置被提醒人",
    "flow.schedule.validate.msg": "提醒文字不能为空",
    "flow.schedule.validate.maxCount": "添加失败，最多添加{{ count }}个自动处理",
    "flow.schedule.validate.onlyOne": "已设置{{ hasSet }}，最多添加1个{{ action }}",
    "flow.schedule.validate.cannot": "已设置{{ hasSet }}，无法添加{{ action }}",
    "flow.schedule.validate.earlier": "自动提醒的时间需要早于{{ action }}的时间",
    "flow.state.inProcess": "进行中",
    "flow.state.complete": "流转完成",
    "flow.state.closed": "手动结束",
    "flow.setting": "流程设定",
    "flow.transfer": "调整负责人",
    "change.flow.node": "节点管理",
    "flow.transfer1": "转交",
    "flow.transfer.set": "点击设置转交候选人",
    "flow.transferTip": "仅调整本条数据当前负责人，不影响流程配置。",
    "flow.transfer.noChange": "当前负责人未改变",
    "flow.transfer.required": "当前负责人不能为空",
    "flow.transfer.success": "调整负责人成功",
    "flow.transfer.fail": "调整负责人失败",
    "flow.currentTransfer": "此节点当前负责人",
    "flow.todo": "待办任务",
    "flow.todo.count": "当前待处理任务 {{ count }} 条",
    "flow.my.cc": "抄送我的",
    "flow.my.transactors": "我处理的",
    "flow.todo.current": "当前待办",
    "flow.todo.mission": "待办任务",
    "flow.version": "流程版本",
    "flow.version.add": "添加新版本",
    "flow.version.add.fail": "添加新版本失败",
    "flow.version.affix.current": "流程已启用，如需增删节点和连线，请",
    "flow.version.affix.history": "历史版本不可增删节点和连线，如需增删节点和连线，请切换至设计中的版本，或",
    "flow.version.btn": "版本管理",
    "flow.version.current": "启用中",
    "flow.version.del.confirm": "确定要删除流程版本吗？",
    "flow.version.del.fail": "删除版本失败",
    "flow.version.del.tip": "删除后，你将无法再编辑和启用此流程版本。",
    "flow.version.design": "设计",
    "flow.version.desc": "版本描述",
    "flow.version.desc.edit": "编辑版本描述",
    "flow.version.desc.label": "版本描述：",
    "flow.version.history": "历史",
    "flow.version.label": "版本号：",
    "flow.version.manage": "管理流程版本",
    "flow.version.name": "流程版本(V{{name}})",
    "flow.vip.signature.admin": "流程中有超出当前版本的高级功能：手写签名。超版本功能已禁用。如需使用完整功能，请至会员中心升级版本。",
    "flow.vip.signature.mem": "流程中有超出当前版本的高级功能：手写签名。超版本功能已禁用。如需使用完整功能，请联系企业创建者升级版本。",
    "form.allFields": "所有表单字段",
    "form.attr": "表单属性",
    "form.attr.field": "字段属性",
    "form.cache": "表单前台缓存",
    "form.cache.tip": "进入表单时，自动加载上次填写未提交的内容。基于浏览器缓存，无法跨设备读取。",
    "form.comment": "审批意见",
    "form.comment.copied": "已复制审批意见",
    "form.comment.copy": "复制并继续",
    "form.comment.disable": "未开启",
    "form.comment.enable": "已开启选填",
    "form.comment.flow": "开启审批意见后，节点负责人处理流程时须按要求填写审批意见",
    "form.comment.notNull": "审批意见为必填项",
    "form.comment.notNull.signature": "审批意见（手写签名）为必填项",
    "form.comment.notNull.text": "审批意见（文本意见）为必填项",
    "form.comment.required": "已开启必填",
    "form.comment.save": "审批意见不会被保存，是否复制审批意见后继续？",
    "form.comment.save.desc": "系统不会保存你已填写的审批意见。点击「复制并继续」，我们会自动复制你已填写的审批意见。",
    "form.comment.signature.notNull": "（手写签名必填）",
    "form.comment.text": "文本意见",
    "form.config.basic": "基础设置",
    "form.config.ext": "表单设置",
    "form.config.Development": "后端脚本",
    "form.copy.empty": "没有可选择的目标应用",
    "form.copy.tip": "将表单复制到其他应用时，不会保留对其他表单的引用。数据联动、公式中对其他表单字段的引用等都会丢失。",
    "form.copy.withData": "同时复制数据",
    "form.copy.withData.tip": "复制的数据会计入数据总量，请确保您的版本满足需求。",
    "form.data": "数据管理",
    "form.data.manage": "表单数据管理",
    "form.data.auth": "数据权限组",
    "form.data.auth1": "数据权限组",
    "buttom.print.auth": "扩展按钮",
    "form.data.deleted": "数据已被删除",
    "form.data.select": "您当前选中了{{length}}条数据，",
    "form.data.recover": "数据删除后可在回收站中恢复",
    "form.data.canNotRecover": "免费版删除的数据无法恢复",
    "form.design": "表单设计",
    "form.fields": "表单字段",
    "form.fields.add": "从左侧拖拽来添加字段",
    "form.fields.basis": "基础字段",
    "form.fields.delete": "若删除该字段，其对应的表单数据也会被清除。确定删除？",
    "form.fields.enhance": "增强字段",
    "form.fields.member": "部门成员字段",
    "form.fields.system": "系统字段",
    "form.guide.add1": "这里是字段列表。点击字段名可添加表单字段",
    "form.guide.add2": "这里是字段列表。选择合适字段点击后可添加到设计面板中",
    "form.guide.data": "在这里设置数据权限，成员登录系统后即可查看特定范围的数据",
    "form.guide.field": "已添加的字段显示在此处，可以在右侧的字段属性中修改字段标题、设置字段权限",
    "form.guide.flow.design": "流程设定可以设置数据的流转规则。启用流程后，数据可按照设定规则流转",
    "form.guide.flow.node": "流程节点在流程设计中使用最为广泛，拖拽可添加流程节点到设计面板中",
    "form.guide.flow.version": "流程已经启用，如需增加流程节点，请点击添加新版本",
    "form.guide.flow.charger": "拖拽添加节点后可以在右侧设置节点操作权限，不要忘记设置负责人",
    "form.guide.flow.launch": "所有节点设置完成并连接后，点击此处启用流程，数据就可以按照设置的流程流转",
    "form.guide.flow.rename": "点击重命名流程表单",
    "form.guide.rename": "点击重命名表单",
    "form.guide.release": "发布表单分为团队成员发布和公开链接发布。请根据使用场景选择合适的发布方式",
    "form.guide.save": "点击此处保存表单设计，下次进入后可继续编辑表单",
    "form.guide.share": "在这里发布表单，可以将表单发布给团队成员或外部人员填写",
    "form.item.image.limit": "上传失败，单张图片的上传上限为20M",
    "form.item.file.limit": "上传失败，单个文件的上传上限为20M",
    "form.item.error.format": "此项格式不正确",
    "form.layout": "电脑端表单布局",
    "form.layout.mobile": "移动端表单布局",
    "form.layout.standard": "标准",
    "form.layout.compact": "紧凑",
    "form.layout.normal": "单列",
    "form.layout.dc": "双列",
    "form.flow": "流程表单",
    "form.release": "发布表单",
    "form.release.mem": "将表单发布给团队成员，成员登录系统后可填写表单",
    "form.release.link": "将表单发布为公开链接，无需登录即可填写表单",
    "form.release.auth": "加载表单权限失败",
    "form.load.fail": "加载表单失败",
    "form.link": "表单访问内链",
    "form.link.subTitle": "团队成员访问该链接需要登录并授权",
    "form.externalLink": "表单外链",
    "form.externalLink.name": "表单填写链接",
    "form.externalLink.label": "凭密码填写",
    "form.ext": "外链扩展",
    "form.ext.desc": "给表单外链添加扩展字段，由此来标记数据来源",
    "form.ext.list": "扩展外链列表({{length}})",
    "form.ext.listTitle": "扩展外链列表",
    "form.ext.required": "扩展字段不能为空",
    "form.ext.failTip": "扩展外链值已存在，请重新输入",
    "form.ext.add.success": "添加成功",
    "form.ext.add.fail": "添加失败",
    "form.query": "公开查询",
    "form.query.subTitle": "通过公开查询链接可以查看已经填报的数据内容，通常用于通讯录查询、执行进度查询、成绩查询等场景。",
    "form.fields.display": "显示内容",
    "form.public.queryLink": "公开查询链接",
    "form.public.queryLink.needPass": "凭密码查询",
    "form.public.queryLink.shareTo": "分享到",
    "form.public.queryLink.shareMsg": "我在@平台 上创建了{{- entry}}，邀请大家来查看！-{{- name}}",
    "form.public.innerlinkshare": "分享内链",
    "form.public.publiclinkshare": "分享外链",
    "form.public.innerlinkshare.copy.success": "数据内链链接复制成功",
    "form.public.publiclinkshare.copy.success": "数据外链链接复制成功",
    "form.publish": "表单发布",
    "form.pass.required": "密码不能为空",
    "form.defaultName": "未命名表单",
    "form.name": "表单名称",
    "form.search.empty": "无搜索结果",
    "form.search.placeholder": "输入名称来搜索",
    "form.set": "表单设置",
    "form.group": "表单分组",
    "form.submit.async": "表单数据计算中，请勿离开页面",
    "form.submit.async.desc": "请等待计算完成后提交，否则会丢失数据。如果此提示反复出现，请联系管理员调整表单设计",
    "form.submit.continue": "继续添加",
    "form.submit.fail": "提交失败",
    "form.submit.fail.back": "回退失败，找不到回退后的负责人",
    "form.submit.fail.charger": "提交失败，找不到下个节点负责人",
    "form.submit.fail.charger.desc": "流程已暂存至「我的待办」中，可联系管理员检查节点负责人后重新提交。",
    "form.submit.fail.cond": "提交失败，不符合流转条件",
    "form.submit.fail.cond.desc": "流程已暂存至「我的待办」中，可联系管理员检查流转条件后重新提交。",
    "form.submit.fail.subflow": "提交失败，不符合子流程节点流入条件",
    "form.submit.fail.subflow.desc": "流程已暂存至「我的待办」中，可联系管理员检查流程设计后重新提交。",
    "form.submit.fail.approval": "提交失败",
    "form.submit.fail.approval.desc": "流程负责人总人数不满足按比例审批设置的最低人数要求。",
    "form.submit.invalid": "存在不符合规范的值",
    "form.submit.repeat": "此项为重复值",
    "form.submit.contain.repeat": "此项存在重复值",
    "form.submit.rule": "不可见字段赋值",
    "form.submit.rule.tip": "根据业务需要，设置不可见字段值的处理方式",
    "form.submit.rule.always": "始终重新计算",
    "form.submit.rule.alwaysTip": "不可见字段的计算、提交逻辑，与可见时保持一致",
    "form.submit.rule.keep": "保持原值",
    "form.submit.rule.keepTip": "不可见字段的原有值保持不变",
    "form.submit.rule.nullTip": "不可见字段提交为空值",
    "form.submit.rule.alwaysTip.extra": "不可见字段的计算、提交逻辑，与可见时保持一致（特殊字段按照设置的对应规则赋值）",
    "form.submit.rule.keepTip.extra": "不可见字段的原有值保持不变（特殊字段按照设置的对应规则赋值）",
    "form.submit.rule.nullTip.extra": "不可见字段提交为空值（特殊字段按照设置的对应规则赋值）",
    "form.submit.rule.special": "特殊字段赋值规则",
    "form.submit.rule.special.tip": "此处设置的字段，不可见时按照下方对应规则赋值，不受默认赋值规则的影响",
    "form.submit.rule.special.set": "已设置特殊字段赋值规则",
    "form.submit.rule.warning": "确定要更换默认赋值规则吗？",
    "form.submit.rule.warning.detail": "更换默认赋值规则后，将清空已设置的特殊字段赋值规则",
    "form.submit.rule.set": "设置特殊字段赋值规则",
    "form.submit.validate": "表单提交校验",
    "form.submit.validate.flow": "已开启流程，流程中的提交校验以节点设置为准",
    "form.submit.Confirm.settings": "表单提交确认设置",
    "form.submit.Confirm.settings.tips.1": "需要提示确认的字段",
    "form.submit.Confirm.settings.tips.2": "选择确认字段",
    "form.submit.Confirm.settings.tips.3": "填写提示语",
    "form.submit.Confirm.settings.tips.4": "请确认以下字段内容是否正确",
    "form.submit.upload.Expired": "存在已过期的附件，请重新上传后，再提交数据",
    "form.submit.async2": "计算失败，请检查网络后重试",
    "form.submit.async2.desc": "「{{name}}」计算失败。 如果此提示反复出现，请联系管理员调整表单设计。",
    "form.field.visible.label": "字段显隐规则",
    "form.field.visible.add": "添加显隐规则",
    "form.field.visible.added": "已设置{{- number}}个显隐规则",
    "form.field.visible.maxrule": "每张表单最多添加{{- number}}个显隐规则",
    "form.field.visible.maxcond": "每个显隐规则最多添加{{- number}}个条件",
    "form.field.visible.tip": "让字段在特定条件成立时显示，反之隐藏。",
    "form.field.visible.question": "如何设置显隐规则？",
    "form.field.visible.delete": "确定要删除此显隐规则？",
    "field.visible.filter.inComplete": "请设置完整的条件",
    "field.visible.fields.inComplete": "请设置要显示的字段",
    "field.visible.fields.hasUsed": "有显示字段已被其他显隐规则设置",
    "subField.visible.label": "子字段显隐规则",
    "subField.visible.tip": "让子表单的子字段在特定条件成立时显示，反之隐藏。",
    "subField.visible.add": "添加显隐规则",
    "subField.visible.added": "已设置{{- number}}个显隐规则",
    "subField.trigger.show": "显示以下子字段",
    "form.field.contact.tip": "选项关联升级为「字段显隐规则」，请到表单属性中配置。",
    "form.field.trigger.before": "满足以下",
    "form.field.trigger.after": "条件时",
    "form.field.trigger.show": "显示以下字段",
    "form.theme.align": "对齐方式",
    "form.theme.background": "页面背景",
    "dash.theme.component.background": "控件背景",
    "form.theme.banner": "表头样式",
    "form.theme.button": "提交按钮",
    "form.theme.button.errtip": "「提交」与「提交并打印」按钮必须开启1个",
    "form.theme.color": "纯色",
    "form.theme.custom": "自定义样式",
    "form.theme.external": "表单外链样式",
    "form.theme.image": "图片",
    "form.theme.image.tip": "支持jpg、gif、png格式，不超过5M的图片",
    "form.theme.style": "样式",
    "form.theme.system": "主题样式",
    "form.theme.title": "标题样式",
    "form.validator.add": "添加校验条件",
    "form.validator.add.error": "存在已删除字段，请及时修改",
    "form.vip.signature.admin": "表单中有超出当前版本的高级功能：手写签名。超版本功能已禁用。如需使用完整功能，请至会员中心升级版本。",
    "form.vip.signature.mem": "表单中有超出当前版本的高级功能：手写签名。超版本功能已禁用。如需使用完整功能，请联系企业创建者升级版本。",
    "formula.add": "添加公式",
    "formula.advance": "高级函数",
    "formula.subform": "子表单函数",
    "formula.date": "日期函数",
    "formula.empty": "没有对应的函数",
    "formula.edit.example": "公式编辑举例：",
    "formula.example": "示例：",
    "formula.example.language.grade": "语文成绩",
    "formula.example.math.grade": "数学成绩",
    "formula.example.baseVideo": "观看公式入门视频>",
    "formula.example.advanceVideo": "观看公式进阶视频>",
    "formula.example.doc": "查看所有公式的帮助文档",
    "formula.func": "函数",
    "formula.input.tip": "从左侧面板选择字段名和函数，或输入函数",
    "formula.input.placeholder": "请输入提示文字",
    "formula.inputEnglish": "请在英文输入法模式下编辑公式",
    "formula.current.form.tip": "无可用变量，请添加或保存表单后重试",
    "formula.set.success": "公式设置成功",
    "formula.valid.set.success": "校验条件设置成功",
    "formula.field.empty.tip": "无可用变量，请添加",
    "formula.learnMore": "了解详情",
    "formula.common": "常用函数",
    "formula.logic": "逻辑函数",
    "formula.math": "数学函数",
    "formula.omit": "略",
    "formula.search": "搜索函数",
    "formula.text": "文本函数",
    "formula.usage": "用法：",
    "formula.tooLong": "表达式长度超出限制",
    "formula.field.aggregate.already": "已聚合计算的字段无法再次聚合计算",
    "formula.field.aggregate.conflict": "聚合计算的字段无法和未聚合计算的字段互相计算",
    "formula.field.subform.conflict": "主表字段和子表字段无法互相计算",
    "formula.field.subform.different": "不同子表单的字段无法互相计算",
    "formula.field.number.conflict": "数字类型指标和非数字类型指标无法互相计算",
    "formula.valid.fail": "函数公式不正确",
    "formula.valid.fail.tip": "不满足校验条件时提示文字:",
    "formula.valid.field.tip": "存在无效字段,请删除",
    "formula.valid.map.tip": "MAP函数已过时,请改用MAPX函数",
    "formula.abs.intro": "ABS函数可以获取一个数的绝对值",
    "formula.abs.usage": "ABS(数字)",
    "formula.abs.example": "ABS(-8)可以返回8，也就是-8的绝对值",
    "formula.and.intro": "如果所有参数都为真，AND函数返回布尔值true，否则返回布尔值 false",
    "formula.and.usage": "AND(逻辑表达式1,逻辑表达式2,...)",
    "formula.and.example": "AND({语文成绩}>90,{数学成绩}>90,{英语成绩}>90)，如果三门课成绩都> 90，返回true，否则返回false",
    "formula.average.intro": "AVERAGE函数可以获取一组数值的算术平均值",
    "formula.average.usage": "AVERAGE(数字1,数字2,...)",
    "formula.average.usage.one.para": "AVERAGE(数字1)",
    "formula.average.example": "AVERAGE({语文成绩},{数学成绩}, {英语成绩})返回三门课程的平均分",
    "formula.average.example.one.para": "AVERAGE({语文成绩})，返回语文成绩的平均分",
    "formula.ceiling.intro": "CEILING函数可以将数字增大到最接近原值的指定因数的倍数",
    "formula.ceiling.usage": "CEILING(数字,因数)",
    "formula.ceiling.example": "CEILING(7,6)返回12，因为12比7大的同时，也是6的倍数中最接近7的数字",
    "formula.char.intro": "CHAR函数可以将计算机字符集的数字代码转换为对应字符",
    "formula.char.usage": "CHAR(数字)",
    "formula.char.example": "CHAR(10)会返回换行字符",
    "formula.count.intro": "COUNT函数可以获取参数的数量",
    "formula.count.usage": "COUNT(值,值,...)",
    "formula.count.usage.one.para": "COUNT(值)",
    "formula.count.example": "COUNT(小明,小王,小张,小李)返回4，也就是人员的数量",
    "formula.count.example.one.para": "COUNT({语文成绩})，返回有效语文成绩数据条数",
    "formula.concatenate.intro": "CONCATENATE函数可以将多个文本合并成一个文本",
    "formula.concatenate.usage": "CONCATENATE(文本1,文本2,...)",
    "formula.concatenate.example": 'CONCATENATE("三年二班","周杰伦")会返回"三年二班周杰伦"',
    "formula.countif.intro": "COUNTIF函数可以获取数组中满足条件的参数个数",
    "formula.countif.usage": 'COUNTIF(数组,"条件")',
    "formula.countif.example": 'COUNTIF(子表单.性别, "女")，可得到子表单中性别填的是"女"的数据条数；COUNTIF([1,2,3,4],">2")，可得到1,2,3,4中大于2的数字数量，结果为2。',
    "formula.date.intro": "DATE函数可以将时间戳转换为日期对象",
    "formula.date.usage": "DATE(时间戳)",
    "formula.datedelta.intro": "DATEDELTA函数可以将指定日期加/减指定天数",
    "formula.datedelta.usage": "DATEDELTA(指定日期,需要加减的天数)",
    "formula.datediff.intro": "DATEDIFF函数可以计算两个时间的差",
    "formula.datediff.usage": "DATEDIFF(指定日期1,指定日期2,类型)",
    "formula.day.intro": "DAY函数可以获取某日期是当月的第几日",
    "formula.day.usage": "DAY(时间戳)",
    "formula.days.intro": "DAYS函数可以返回两个日期之间相差的天数。",
    "formula.days.usage": "DAYS(结束日期,开始日期)",
    "formula.days360.intro": "DAYS360按照一年 360 天的算法，返回两个日期间相差的天数",
    "formula.days360.usage": "DAYS360(结束日期,开始日期)",
    "formula.exact.intro": "EXACT函数可以比较两个文本是否完全相同，完全相同则返回true，否则返回false",
    "formula.exact.usage": "EXACT(文本1, 文本2)",
    "formula.exact.example": "EXACT({手机号},{中奖手机号})，如果两者相同，返回true，如果不相同，返回false",
    "formula.false.intro": "FALSE函数返回布尔值false",
    "formula.false.usage": "FALSE()",
    "formula.fixed.intro": "FIXED函数可将数字舍入到指定的小数位数并输出为文本",
    "formula.fixed.usage": "FIXED(数字,小数位数)",
    "formula.fixed.example": 'FIXED(3.1415,2)返回"3.14"',
    "formula.floor.intro": "FLOOR函数可将数字减小到最接近原值的指定因数的倍数",
    "formula.floor.usage": "FLOOR(数字,因数)",
    "formula.floor.example": "FLOOR(7,6)返回6，因为6比7小的同时，也是6的倍数中最接近7的数字",
    "formula.getusername.intro": "GETUSERNAME函数可以获取当前用户的昵称",
    "formula.getusername.usage": "GETUSERNAME()",
    "formula.hour.intro": "HOUR函数可以返回某日期的小时数",
    "formula.hour.usage": "HOUR(时间戳)",
    "formula.if.intro": "IF函数判断一个条件能否满足；如果满足返回一个值，如果不满足则返回另外一个值",
    "formula.if.usage": "IF(逻辑表达式,为true时返回的值,为false时返回的值)",
    "formula.if.example": 'IF({语文成绩}>60,1,2)，当语文成绩>60时返回1，否则返回2。',
    "formula.ifs.intro": "IFS函数检查是否满足一个或多个条件，且返回符合第一个TRUE条件的值，IFS可以取代多个嵌套IF语句。",
    "formula.ifs.usage": "IFS(逻辑表达式1,逻辑表达式1为true返回该值,逻辑表达式2,逻辑表达式2为true返回该值,...)",
    "formula.ifs.example": 'IFS({语文成绩}>90,"优秀",{语文成绩}>80,"良好",{语文成绩}>=60,"及格",{语文成绩}<60,"不及格")，根据成绩返回对应的评价。',
    "formula.int.intro": "INT函数可以获取一个数的整数部分",
    "formula.int.usage": "INT(数字)",
    "formula.int.example": "INT(3.1415)返回3，也就是3.1415的整数部分",
    "formula.ip.intro": "IP函数获取当前操作用户的外网IP地址",
    "formula.ip.usage": "IP()",
    "formula.isempty.intro": "ISEMPTY函数可以用来判断值是否为空文本、空对象或者空数组",
    "formula.isempty.usage": "ISEMPTY(文本)",
    "formula.isoweeknum.intro": "ISOWEEKNUM函数可以返回指定日期在全年中的ISO周数",
    "formula.isoweeknum.usage": "ISOWEEKNUM(指定日期)",
    "formula.large.intro": "LARGE函数可以获取数据集中第k个最大值",
    "formula.large.usage": "LARGE(数组,k)",
    "formula.large.example": 'LARGE({学生成绩.数学成绩},1)返回子表单"学生成绩"中排名第1的"数学成绩"',
    "formula.left.intro": "LEFT函数可以从一个文本的第一个字符开始返回指定个数的字符",
    "formula.left.usage": "LEFT(文本,文本长度)",
    "formula.left.example": 'LEFT("三年二班周杰伦",2)返回"三年"，也就是"三年二班周杰伦"的从左往右的前2个字符',
    "formula.len.intro": "LEN函数可以获取文本中的字符个数",
    "formula.len.usage": "LEN(文本)",
    "formula.len.example": 'LEN("朝辞白帝彩云间")返回7，因为这句诗中有7个字符',
    "formula.log.intro": "LOG函数可以根据指定底数返回数字的对数",
    "formula.log.usage": "LOG(数字,底数)",
    "formula.log.example": "LOG(100,10)返回2，也就是以10为底数100的对数",
    "formula.lower.intro": "LOWER函数可以将一个文本中的所有大写字母转换为小写字母",
    "formula.lower.usage": "LOWER(文本)",
    "formula.lower.example": 'LOWER("JAYZ")返回"jayz"',
    "formula.mapx.intro": "MAPX函数是一个可以用来进行跨表单取数的高级函数",
    "formula.mapx.usage": "MAPX(operation,map_value,map_field,result_field)",
    "formula.max.intro": "MAX函数可以获取一组数值的最大值",
    "formula.max.usage": "MAX(数字1,数字2,...)",
    "formula.max.usage.one.para": "MAX(数字1)",
    "formula.max.example": "MAX({语文成绩},{数学成绩},{英语成绩})返回三门课程中的最高分",
    "formula.max.example.one.para": "MAX({语文成绩})，返回语文成绩的最高分",
    "formula.mid.intro": "MID返回文本中从指定位置开始的指定数目的字符",
    "formula.mid.usage": "MID(文本,开始位置_数字,指定数目)",
    "formula.mid.example": 'MID("云应用定制工具",2,6)返回"应用定制工具"',
    "formula.min.intro": "MIN函数可以获取一组数值的最小值",
    "formula.min.usage": "MIN(数字1,数字2,...)",
    "formula.min.usage.one.para": "MIN(数字1)",
    "formula.min.example": "MIN({语文成绩},{数学成绩},{英语成绩})返回三门课程中的最低分",
    "formula.min.example.one.para": "MIN({语文成绩})，返回语文成绩的最低分",
    "formula.minute.intro": "MINUTE函数可以返回某日期的分钟数",
    "formula.minute.usage": "MINUTE(时间戳)",
    "formula.mod.intro": "MOD函数可以获取两数相除的余数",
    "formula.mod.usage": "MOD(被除数,除数)",
    "formula.mod.example": "MOD(4,3)返回1，也就是4/3的余数",
    "formula.month.intro": "MONTH返回某日期的月份",
    "formula.month.usage": "MONTH(时间戳)",
    "formula.not.intro": "NOT函数返回与指定表达式相反的布尔值。",
    "formula.not.usage": "NOT(逻辑表达式)",
    "formula.not.example": "NOT({语文成绩}>60)，如果语文成绩大于60返回false，否则返回true",
    "formula.networkdays.intro": "NETWORKDAYS可以获取两个日期之间的工作日数，工作日不包括周末和任何其他指定日期。",
    "formula.networkdays.usage": "NETWORKDAYS(开始日期,结束日期,[节假日1,节假日2, ...])",
    "formula.now.intro": "NOW函数可以获取当前时间",
    "formula.now.usage": "NOW()",
    "formula.or.intro": "如果任意参数为真，OR 函数返回布尔值true；如果所有参数为假，返回布尔值false。",
    "formula.or.usage": "OR(逻辑表达式1,逻辑表达式2,...)",
    "formula.or.example": "OR({语文成绩}>90,{数学成绩}>90,{英语成绩}>90)，任何一门课成绩> 90，返回true，否则返回false",
    "formula.power.intro": "POWER函数可以获取数字乘幂的结果",
    "formula.power.usage": "POWER(数字,指数)",
    "formula.power.example": "POWER(3，2)返回9，也就是3的2次方",
    "formula.product.intro": "PRODUCT函数可以获取一组数值的乘积",
    "formula.product.usage": "PRODUCT(数字1,数字2,...)",
    "formula.product.example": "PRODUCT({单价}, {数量})获取总价，也就是单价和数量的乘积",
    "formula.rand.intro": "RAND函数可返回大于等于0且小于1的均匀分布随机实数",
    "formula.rand.usage": "RAND()",
    "formula.rand.example": "RAND()返回0.424656",
    "formula.recno.intro": "RECNO函数依据当前表单被新打开的次数进行不断累计，起始值为1。",
    "formula.recno.usage": "RECNO()",
    "formula.replace.intro": "REPLACE函数可以根据指定的字符数，将部分文本替换为不同的文本",
    "formula.replace.usage": "REPLACE(文本,开始位置,替换长度,新文本)",
    "formula.replace.example": 'REPLACE("云应用定制工具",2,6,"企业数据管理平台")返回"云企业数据管理平台"',
    "formula.rept.intro": "REPT函数可以将文本重复一定次数",
    "formula.rept.usage": "REPT(文本,重复次数)",
    "formula.rept.example": 'REPT("云应用",3)返回"云应用云应用云应用"',
    "formula.right.intro": "RIGHT函数可以获取由给定文本右端指定数量的字符构成的文本值",
    "formula.right.usage": "RIGHT(文本,文本长度)",
    "formula.right.example": 'RIGHT("三年二班周杰伦",3)返回"周杰伦"，也就是"三年二班周杰伦"从右往左的前3个字符',
    "formula.round.intro": "ROUND函数可以将数字四舍五入到指定的位数",
    "formula.round.usage": "ROUND(数字,数字位数)",
    "formula.round.example": "ROUND(3.1485,2)返回3.15",
    "formula.small.intro": "SMALL函数可以返回数据集中第k个最小值",
    "formula.small.usage": "SMALL(数组,k)",
    "formula.small.example": 'SMALL({学生成绩.数学成绩}, 1)返回子表单"学生成绩"中排名倒数第一的"数学成绩"',
    "formula.sqrt.intro": "SQRT函数可以获取一个数字的正平方根",
    "formula.sqrt.usage": "SQRT(数字)",
    "formula.sqrt.example": "SQRT(9)返回3，也就是9的正平方根",
    "formula.sum.intro": "SUM函数可以获取一组数值的总和",
    "formula.sum.usage": "SUM(数字1,数字2,...)",
    "formula.sum.usage.one.para": "SUM(数字1)",
    "formula.sum.example": "SUM({语文成绩},{数学成绩}, {英语成绩})返回三门课程的总分",
    "formula.sum.example.one.para": "SUM({语文成绩})，返回语文成绩的总分",
    "formula.sumproduct.intro": "SUMPRODUCT函数可以将数组间对应的元素相乘，并返回乘积之和，适用于加权求和",
    "formula.sumproduct.usage": "SUMPRODUCT(数组,数组...)",
    "formula.sumproduct.example": "SUMPRODUCT([1,2,3],[0.1,0.2,0.3])返回1.4，也就是 1×0.1 + 2×0.2 + 3×0.3的值",
    "formula.search.intro": "SEARCH函数可以获取文本1在文本2中的开始位置",
    "formula.search.usage": "SEARCH(文本1,文本2)",
    "formula.search.example": 'SEARCH("2020","云应用2020")返回4',
    "formula.second.intro": "SECOND函数可以返回某日期的秒数",
    "formula.second.usage": "SECOND(时间戳)",
    "formula.split.intro": "SPLIT函数可以将文本按指定分割符分割成数组",
    "formula.split.usage": "SPLIT(文本,分隔符_文本)",
    "formula.split.example": 'SPLIT("云应用-应用定制工具","-")返回"云应用，应用定制工具"',
    "formula.systime.intro": "SYSTIME函数可以获取当前服务器时间",
    "formula.systime.usage": "SYSTIME()",
    "formula.text.intro": "TEXT函数可以将数字转化成文本",
    "formula.text.usage": "TEXT(数字)",
    "formula.text.example": 'TEXT(3.1415)返回"3.1415"',
    "formula.time.intro": "TIME函数可以返回特定时间的十进制数字",
    "formula.time.usage": "TIME(时_数字,分_数字,秒_数字)",
    "formula.timestamp.intro": "TIMESTAMP函数可以将日期对象转换成时间戳。",
    "formula.timestamp.usage": "TIMESTAMP(日期)",
    "formula.today.intro": "TODAY函数可以返回今天",
    "formula.today.usage": "TODAY()",
    "formula.trim.intro": "TRIM函数可以删除文本首尾的空格",
    "formula.trim.usage": "TRIM(文本)",
    "formula.trim.example": 'TRIM("    云应用    ")返回"云应用"',
    "formula.true.intro": "TRUE函数返回布尔值true",
    "formula.true.usage": "TRUE()",
    "formula.union.intro": "UNION函数合并多个文本数组，重复文本只显示一次",
    "formula.union.usage": "UNION(文本1，文本2，文本3，文本4)或UNION([数组])",
    "formula.union.example": 'UNION("张三","李四","王五","张三","李四")返回值为["张三","李四","王五"]',
    "formula.upper.intro": "UPPER函数可以将一个文本中的所有小写字母转换为大写字母",
    "formula.upper.usage": "UPPER(文本)",
    "formula.upper.example": 'UPPER("jayz")返回"JAYZ"',
    "formula.uuid.intro": "UUID函数随机码生成器。可适用于随机流水号的使用场景等",
    "formula.uuid.usage": "UUID()",
    "formula.value.intro": "VALUE函数可以将文本转化为数字",
    "formula.value.usage": "VALUE(文本)",
    "formula.value.example": 'VALUE("3.1415")返回3.1415',
    "formula.weeknum.intro": "WEEKNUM函数可以返回指定日期在当年是第几周",
    "formula.weeknum.usage": "WEEKNUM(指定日期)",
    "formula.workday.intro": "WORKDAY函数可以获取给定日期之前或者之后指定工作日数的日期，工作日不包括周末和任何其他指定日期。",
    "formula.workday.usage": "WORKDAY(日期,工作日数,[节假日1, 节假日2, ...])",
    "formula.xor.intro": "XOR函数可以返回所有参数的异或值",
    "formula.xor.usage": "XOR(逻辑表达式1, 逻辑表达式2,...)",
    "formula.xor.example": "XOR({语文成绩}>90,{数学成绩}>90)，如果两门成绩都>90,返回false；如果两门成绩都<90，返回false；如果其中一门>90，另外一门<90，返回true",
    "formula.year.intro": "YEAR函数可以返回某日期的年份",
    "formula.year.usage": "YEAR(时间戳)",
    "formula.auto.toMetric": "自动添加为指标项",
    "formula.edit": "公式编辑",
    "formula.edit.subtitle": "使用加减运算符编辑公式",
    "formula.edit.inputName.tip": "请输入指标名称",
    "formula.edit.sample": "公式编辑样式举例：",
    "formula.edit.sample.field1": "进货数量",
    "formula.edit.sample.field2": "出货数量",
    "formula.field.tip": "请从左侧面板选择包含的字段名",
    "formula.field.required": "字段名必填",
    "formula.error": "公式不正确",
    "format.data": "数据格式",
    "format.preset": "预定义格式",
    "format.custom": "自定义格式",
    "format.custom.date.sample": "如：yyyy-mm-dd",
    "format.thousand": "千分符",
    "format.hundred": "百分比",
    "format.decimal": "小数位数",
    "format.subform.SUBFORMLESS.intro": "比较子表单里的字段value1是否小于value2，小于返回 true，反之返回false。",
    "format.subform.SUBFORMLESS.usage": "SUBFORMLESS(value1, value2)",
    "format.subform.SUBFORMLESS.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "format.subform.SUBFORMGREATER.intro": "比较子表单里的字段value1是否大于value2，大于返回 true，反之返回false。",
    "format.subform.SUBFORMGREATER.usage": "SUBFORMGREATER(value1, value2)",
    "format.subform.SUBFORMGREATER.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "format.subform.SUBFORMEQUAL.intro": "比较子表单里的字段value1是否等于value2，等于返回 true，反之返回false。",
    "format.subform.SUBFORMEQUAL.usage": "SUBFORMEQUAL(value1, value2)",
    "format.subform.SUBFORMEQUAL.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "format.subform.SUBFORMLESSOREQUAL.intro": "比较子表单里的字段value1是否小于等于value2，小于等于返回 true，反之返回false。",
    "format.subform.SUBFORMLESSOREQUAL.usage": "SUBFORMLESSOREQUAL(value1, value2)",
    "format.subform.SUBFORMLESSOREQUAL.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "format.subform.SUBFORMGREATEROREQUAL.intro": "比较子表单里的字段value1是否大于等于value2，大于等于返回 true，反之返回false。",
    "format.subform.SUBFORMGREATEROREQUAL.usage": "SUBFORMGREATEROREQUAL(value1, value2)",
    "format.subform.SUBFORMGREATEROREQUAL.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "format.subform.SUBFORMNOTEQUAL.intro": "比较子表单里的字段value1是否不等于value2，不等于返回 true，反之返回false。",
    "format.subform.SUBFORMNOTEQUAL.usage": "SUBFORMNOTEQUAL(value1, value2)",
    "format.subform.SUBFORMNOTEQUAL.example": "此函数公式只能处理子表单里的字段，不能使用子表单以外的字段。一般应用于表单提交效验里，判断子表单里的数据是否合法。",
    "get.immediate": "立即领取",
    "go.pcPlatform": "请前往电脑端体验",
    "item.required": "此项为必填项",
    "info.Incomplete": "请填写完整信息",
    "invalid.username": "用户名格式不正确",
    "invalid.email": "邮箱格式不正确",
    "invalid.phone": "手机号格式不正确",
    "invalid.nickname": "昵称不能为空",
    "invalid.password": "密码至少需要6位",
    "invalid.confirmPass": "两次输入的密码不一致",
    "invalid.url": "URL格式不正确",
    "invite.manual.add.tip1": "成员加入时无法更改您输入的内容，请输入正确的信息",
    "invite.manual.add.tip2": "按输入的联系方式发送邀请；同时输入手机和邮箱，只发送手机邀请",
    "invite.name.placeholder": "必填，最长12个字符",
    "invite.phone.placeholder": "国际化手机请添加国家码",
    "invite.phone.or.email.required": "手机和邮箱必填一项",
    "invite.phone.and.email.required": "手机和邮箱必填",
    "invite.importing": "正在导入",
    "invite.import.fail.detail": "导入失败详情",
    "invite.failList.download": "下载失败列表",
    "invite.failList.download.expire.tip": "请在1小时内下载本列表",
    "invite.accept.switch.tip": "当前登录账号与被邀请账号不同",
    "invite.accept.switch": "切换登录账号",
    "image.add": "添加图片",
    "image.insert.url": "图片 URL",
    "image.maxLimitTip": "图片大小超出限制",
    "image.reset.title": "确定恢复为默认图片？",
    "image.reset.tip": "此操作不可逆",
    "image.recommend.size": "（建议尺寸：{{- width}}*{{- height}}px）",
    "image.upload": "上传图片",
    "image.upload.tip": "图片大小不超过1MB, 每次最多上传10张",
    "image.upload.max.toast": "每次最多允许上传10张",
    "image.url.invalid": "不合法的 URL",
    "image.url.tip": "输入图片URL即可插入图片",
    "image.url.placeholder": "请输入图片URL",
    "image.maxLimitTip1": "图片大小不能超过 {{count}} MB",
    "image.select": "请选择图片",
    "import.createSuccess.count": "您成功创建并导入了{{- count}}条数据到表单[{{- name}}]中",
    "import.contact.empty": "通讯录中未匹配到：{{- name}}",
    "import.contact.multi": "通讯录中存在多个：{{- name}}",
    "import.contact.isallowBlank": "字段不允许空值",
    "import.contact.isnoRepeat": "字段不允许重复值",
    "import.contact.emptyUser": "当前通讯录中未匹配到以下成员，请修改成员姓名后重新导入",
    "import.contact.sameUser": "当前通讯录中存在同名成员，请修改成员姓名后重新导入",
    "import.contact.emptyDept": "当前通讯录中未匹配到以下部门，请修改部门名称后重新导入",
    "import.contact.sameDept": "当前通讯录中存在同名部门，请修改部门名称后重新导入",
    "import.dept.fail": "有一个或多个部门匹配失败",
    "import.doing": "正在导入数据...",
    "import.excel": "导入 Excel 数据",
    "import.excel.select": "选择Excel",
    "import.excel.preview": "预览数据",
    "import.excel.form.config": "配置表单",
    "import.excel.data": "导入数据",
    "import.excel.failTip1": "不能存在合并的单元格",
    "import.excel.failTip2": "支持 {{size}}MB 以内的xls、xlsx格式文件",
    "import.excel.failTip3": "文件中数据不能超过50000行、200列（如需导入为部门成员字段，则不能超过10000行、200列）",
    "import.excel.failTip4": "子表单明细同样占用行数",
    "import.excel.helpTip": "更多导入说明和示例，请查看",
    "import.excel.labelSet.tip": "点击任意一行可将其设置为标题行，标题行之前的数据不导入。",
    "import.excel.limitTip": "最多可预览前{{limit}}条数据",
    "import.excel.flow": "导入的数据触发流程",
    "import.excel.flowAsync": "导入完成，开始触发流程…",
    "import.excel.flowAsync.title": "成功导入 {{- count }} 条数据到表单「{{ name }}」",
    "import.excel.flowAsync.success": "流程提交成功 {{- success }} 条，提交失败 {{- fail }} 条",
    "import.excel.flowAsync.fail": "流程提交成功 {{- success}} 条，提交失败 {{- fail}} 条，提交失败的数据已为您暂存至「我的待办」中",
    "import.update.confirm": "确定导入并更新数据？",
    "import.update.confirm.tip": "导入的数据中「data_id」有重复值时，会逐条导入重复更新匹配到的数据。",
    "import.upsert.confirm": "确定导入并更新和新增数据？",
    "import.upsert.confirm.tip": "导入的数据中「data_id」有重复值时，会逐条导入重复更新匹配到的数据。\n导入的数据中「data_id」为空时或无法匹配，会新增数据。",
    "import.fail": "导入失败",
    "import.warning.tip": "当前还有 {{count}} 个错误未处理，如果不处理，系统将自动将错误项目置为空，请确认是否继续导入?",
    "import.failDetail.view": "查看问题详情",
    "import.fail.view": "问题详情",
    "import.fail.count": "表格数据存在{{- count}}个错误，请修改后再进行导入。如不修改，则错误数据导入后为空值，地址字段保留原值",
    "import.failTip": "您的导入数据错误较多，请返回上一步检查字段类型，或在原excel中进行修改后再重新导入。如不修改，则错误数据导入后为空值",
    "import.failTip.second": "提示：当错误过多时，可下载 {{- tip1}}，并按照{{- tip2}}修改Excel后重新导入。",
    "import.failTip.second.tip1": "具体错误信息",
    "import.failTip.second.tip2": "错误信息说明",
    "import.field.empty": "导入的字段名不能为空",
    "import.form": "表单导入",
    "import.formName.empty": "表单名不能为空",
    "import.notAllowed": "不导入",
    "import.prev.text": "请切换工作表或返回上一步重新选择Excel表",
    "import.recommend": "推荐使用",
    "import.rowHead": "标题行",
    "import.success.count": "您成功导入了 {{- count}} 条数据到表单「{{- name}}」中",
    "import.template": "标准模板",
    "import.tip": "导入说明和示例",
    "import.user.fail": "有一个或多个成员匹配失败",
    "layout.vertical": "纵向排列",
    "layout.horizontal": "横向排列",
    "loadMore.click": "点击加载更多",
    "log.execute": "执行日志",
    "log.execute.empty": "暂无执行日志",
    "log.update.tip": "（数据发生变动后1小时内自动更新）",
    "link.copy": "复制链接",
    "link.copySuccess": "链接已复制",
    "link.management.specification": "《平台外链管理规范》",
    "manager.normal": "普通管理组",
    "manager.add": "添加管理组",
    "manager.create.tip": "点击添加管理员",
    "manager.creator": "创建者",
    "manager.placeholder": "请输入管理组名称",
    "manager.name.notEmpty": "管理组名称不能为空",
    "manager.name.tooLong": "管理组名称不能超过{{length}}个字",
    "manager.delete.warning": "删除普通管理组则相关管理员及权限也将一并删除，且无法还原。如确定删除，请输入组名：",
    "manager.delete.success": "管理组已删除!",
    "manager.system": "系统管理员",
    "manager.appAuth": "应用权限",
    "manager.appAuth.tip": "具备所有应用的管理权限",
    "manager.appAuth.edit.tip": "点击选择可编辑的应用",
    "manager.funcAuth": "功能权限",
    "manager.funcAuth.tip": "具备所有功能权限",
    "manager.funcAuth.app": "可添加／删除应用",
    "manager.funcAuth.contacts": "通讯录管理",
    "manager.sync": "同步通讯录成员",
    "manager.contacts.range": "通讯录管理范围",
    "manager.contacts.range.tip": "具备对所有成员的管理权限",
    "manager.contacts.range.edit.tip": "点击选择可管理的部门",
    "manager.contacts.range.empty.tip": "不选择任何部门时，默认可管理所有部门",
    "role.contacts.range": "角色组管理范围",
    "role.contacts.range.tip": "具备对所有角色组的管理权限",
    "role.contacts.range.edit.tip": "点击选择可管理的角色组",
    "role.contacts.range.empty.tip": "不选择任何角色时，默认可管理所有角色",
    "outsider.contacts.range": "外部联系人管理范围",
    "outsider.contacts.range.tip": "具备对所有外部联系人的管理权限",
    "outsider.contacts.range.edit.tip": "点击选择可管理的外部联系人分组",
    "outsider.contacts.range.empty.tip": "不选择任何分组时，默认可管理所有外部联系人分组",
    "member.one": "成员1",
    "member.two": "成员2",
    "member.id": "成员编号",
    "member.id.format": "仅支持字母、数字、下划线",
    "member.id.length": "成员编号最长12个字符",
    "member.id.placeholder": "成员在企业内唯一标识，建议使用工号等公司系统内统一的ID",
    "member.import.complete": "成功导入{{-successCount}}名成员",
    "member.import.not.complete": "成功导入{{-successCount}}名成员，失败{{-failCount}}名",
    "member.async.busy": "正在同步",
    "member.async.busy.tip": "成员正在同步…",
    "member.async.start": "开始同步",
    "member.async.start.tip": "您可以进行其他操作，同步会在后台进行。",
    "member.async.error": "成员同步失败",
    "member.async.error.tip": "企业通讯录同步失败，请稍后重试。",
    "member.async.auto": "自动同步",
    "member.async.auto.set.success": "自动同步设置成功",
    "member.async.lastTime": "上次同步：{{lastTime}}",
    "member.async.manual": "手动同步成员",
    "member.async.manual.control": "手动同步",
    "member.async.weChat": "从企业微信同步成员",
    "member.async.success": "企业通讯录同步成功",
    "member.async.time": "同步时间",
    "member.async.log": "成员同步日志",
    "member.async.log.empty": "暂无同步日志",
    "member.async.log.result": "同步结果",
    "member.async.log.tip": "保存最近六个月的同步日志",
    "member.async.log.type": "同步类型",
    "member.async.log.view": "查看同步日志",
    "member.add": "添加成员",
    "member.invite": "邀请成员",
    "member.invite.accept": "接受邀请",
    "member.invite.accept.confirm": "您要接受「{{- inviter}}」的邀请吗？ ",
    "member.invite.accept.guide": "有管理员邀请您加入团队，一起协同办公",
    "member.invite.dept.required": "请设置成员部门",
    "member.invite.name.length": "姓名，最长12个字符",
    "member.invite.name.required": "请输入成员姓名",
    "member.invite.name.length.tip": "成员姓名最长12个字符",
    "member.invite.phone.required": "请输入手机/邮箱",
    "member.invite.phoneOrMail.invalid": "手机/邮箱格式不正确",
    "member.invite.after": "受到邀请用户加入你的团队后，",
    "member.invite.alreadyBindWorkWx": "已绑定企业微信",
    "member.invite.batch": "你可以批量管理成员。",
    "member.invite.begin": "团队中还没有成员，现在开始邀请成员吧",
    "member.invite.bindWorkWxInNewTab": "请在新打开的页面中绑定企业微信",
    "member.invite.byLink": "公开链接邀请",
    "member.invite.department": "你可以将他/她分配到不同的部门中。",
    "member.invite.form": "你可以发布表单给他/她填写。",
    "member.invite.manual": "手动添加成员",
    "member.invite.import": "批量导入成员",
    "member.invite.phoneOrEmail": "手机号/邮箱",
    "member.invite.phoneOrEmail.label": "手机号/邮箱：",
    "member.invite.phoneOrEmail.notEmpty": "输入手机号或邮箱",
    "member.invite.phoneOrEmail.invalid": "请输入正确格式的手机号或邮箱",
    "member.invite.phone.tip": "通过手机号邀请非中国大陆成员用户时，请在手机号前添加国际电话区号，例:+886912345689",
    "member.invite.link": "邀请链接",
    "member.invite.link.tip": "开启邀请链接后，只需访问此链接，即可加入您的团队",
    "member.invite.link.Audit": "邀请审核",
    "member.invite.link.Audit.tip": "开启邀请审核后，需要审核通过才能加入您的团队",
    "member.invite.link.Audit.list": "审核列表",
    "member.invite.mail.limit.tip": "每次最多发送200条短信和200封邀请邮件",
    "member.invite.mail.rate.limit.tip": "每个手机号或邮箱每天最多邀请3次",
    "member.invite.mail.invited.tip": "所有成员已加入团队，请勿重复邀请",
    "member.invite.list": "邀请中的成员",
    "member.reinvite": "一键再次邀请",
    "member.joined": "已加入",
    "member.inviting": "邀请中",
    "member.invite.list.empty": "没有正在邀请中的成员",
    "member.invite.error.tip": "已发送邀请，请勿重复操作",
    "member.invite.list.tip": "仅显示已邀请但尚未加团队的成员",
    "member.invite.manager": "你可以将他/她设置为管理员，协助管理平台应用。",
    "member.invite.notBind": "暂不绑定",
    "member.invite.rate.limit.tip": "已发送邀请，请勿重复操作",
    "member.invite.wait": "绑定企业微信成功后，可能需要几分钟时间来同步企业微信的通讯录，请耐心等待。",
    "member.search": "搜索成员姓名",
    "member.search1": "搜索成员",
    "member.search2": "搜索成员支持姓名、手机以及邮箱",
    "member.searching": "搜索中，请稍候...",
    "member.search.emptyTip.departmentRoot": "无搜索结果，请检查搜索值",
    "member.search.emptyTip.public": "当前部门无搜索结果，请检查搜索值或在「全部成员」中搜索",
    "member.list.fail": "获取成员列表失败！",
    "member.dept.set": "设置成员部门",
    "member.dept.alter": "调整部门",
    "member.dept.alter.select.tip": "请选择需要调整部门的成员",
    "member.dept.set.success": "调整成功",
    "member.remove": "删除成员",
    "member.delete.confirm": "您确定要删除所选成员？",
    "member.delete.tip": "删除成员会同时删除该成员权限，且无法还原",
    "member.delete.success": "成员删除成功",
    "member.delete.fail": "成员删除失败",
    "member.delete.owner.tip": "企业创建者无法删除",
    "member.delete.select.tip": "请选择需要删除的成员",
    "member.allow.edit.name": "允许成员修改姓名",
    "member.name.valid.empty": "请输入成员姓名",
    "member.name.valid.length": "成员姓名最长12个字符",
    "member.username.update.tip": "此编号仅可修改一次",
    "member.username.update.not": "不支持修改此编号",
    "member.not.invite.tip": "有{{-count}}名成员未加入",
    "member.not.verify.tip": "有{{-count}}个手机/邮箱未验证",
    "member.invite.again": "再次邀请",
    "member.invite.all.again": "全部再次邀请",
    "member.verify.all.again": "全部发送验证",
    "member.verify.success.tip": "验证信息发送成功！",
    "member.verify.error.tip": "已发送验证信息，请勿重复操作",
    "member.email.verify.tip": "未验证邮箱无法收到消息，请及时验证。",
    "member.phone.verify.tip": "未验证手机无法收到消息，请及时验证。",
    "member.number.internal.tip": "成员在企业内的唯一标识",
    "member.number.wechat.tip": "成员在企业内的唯一标识，同步自企业微信「账号」",
    "member.number.dingtalk.tip": "成员在企业内的唯一标识，同步自钉钉「成员UserID」",
    "member.team.join": "当前我加入的团队名称",
    "member.team.create": "当前我创建的团队名称",
    "member.team.current": "当前所在企业：{{-corp}}",
    "member.team.current.tip": "管理员未开启修改权限的姓名不可修改，如需修改请联系管理员",
    "member.phone.verified": "手机已验证，您无法修改。如需修改请联系成员在账户中心重新绑定。",
    "member.email.verified": "邮箱已验证，您无法修改。如需修改请联系成员在账户中心重新绑定。",
    "member.role.list.empty": "没有可选的角色",
    "migrate.report.tip": "此功能会复制原有报表然后转换为报表，不影响原有报表的使用。",
    "migrate.report.member.tip": "转换得到的报表默认不启用，不对成员开放；启用后即可对访问原报表的用户开放",
    "migrate.report.select.tip": "请选择需要转换的报表",
    "migrate.report.empty": "没有可转换的报表",
    "migrate.report.title": "报表→报表转换",
    "migrate.waiting": "正在转换，请等待...",
    "migrate.waiting.tip": "您可以关闭页面，系统将继续为您转换",
    "migrate.done": "转换功能运行完成",
    "migrate.success": "转换成功",
    "migrate.done.tip": "{{-count}}个报表完整转换为报表。",
    "migrate.not.complete.tip": "{{-count}}个报表成功转换为报表，但有部分问题需要手动调整。",
    "migrate.fail.tip": "{{-count}}个报表转换失败。",
    "migrate.record.view.tip": "请在转换记录中查看详情",
    "migrate.done.single.tip": "已将此报表完整转换为报表。",
    "migrate.done.single.not.complete.tip": "已将此报表转换为报表，但仍有部分问题需要手动调整，请在转换记录中查看详情。",
    "migrate.done.fail.tip": "报表内控件控件数量超过50个，请减少控件数量后重试",
    "migrate.dash.enable.tip": "转换得到的报表默认不启用，不对成员开放。您可根据需要自行启用，启用后报表即对可访问原报表的用户开放。",
    "migrate.record.view": "查看转换记录",
    "migrate.record.title": "报表→报表转换记录",
    "migrate.record.expire.tip": "仅保留最近一周转换记录",
    "migrate.record.export.tip": "仅保留最近一周的转换记录，请尽快处理转换问题或{{-exportBtn}}",
    "migrate.record.export": "导出转换记录",
    "migrate.record.empty": "暂无转换记录",
    "migrate.complete": "完整转换",
    "migrate.not.complete": "未完整转换",
    "migrate.fail": "转换失败",
    "migrate.report.banner": "报表→报表转换功能已上线，帮助你把报表转换为更美观易用的报表。",
    "migrate.immediate": "立即转换",
    "mobile.layout": "权限组移动端样式",
    "mobile.layout.card": "卡片样式",
    "mobile.layout.card.setting": "卡片设置",
    "mobile.layout.card.image": "在卡片标题中显示图片字段的内容",
    "mobile.layout.card.createInfo": "在卡片标题中显示提交人和提交时间",
    "mobile.layout.card.label": "在卡片内容中显示字段标题",
    "mobile.layout.card.tip": "在移动端查看数据时，每条数据显示为独立的卡片，可快速了解数据概况。",
    "mobile.layout.example.label": "灵活易用的应用搭建平台",
    "mobile.layout.example.createInfo": "小云",
    "mobile.layout.fx.user": "用户",
    "mobile.layout.table": "表格样式",
    "mobile.layout.table.tip": "在移动端查看数据时，每行显示一条数据，可以通过左右滑动查看完整数据。",
    "mobile.layout.image.select": "请选择表单中的图片字段",
    "mobile.layout.preview": "样式预览",
    "mobile.layout.product.position": "产品定位",
    "mobile.layout.product.title": "产品名称",
    "mobile.layout.project.member": "项目成员",
    "msg.corp_owner": "账号创建者",
    "msg.system_admin": "系统管理员",
    "msg.dotGuide.closeGuide": "关闭引导",
    "msg.qrCode": "扫描二维码，分享给好友",
    "msg.helpCenterGuide.info": "如需获得更多帮助，请点击此处，我们将竭诚为您服务",
    "msg.method": "提醒方式",
    "msg.system.notification": "系统消息",
    "msg.mail.notification": "邮件提醒",
    "msg.sms.free": "（免费）",
    "msg.sms.notification": "短信提醒",
    "msg.sms.notification.tip": "仅进行「数据推送失败」提醒",
    "msg.sms.purchase.tip": "当前账号的可用短信条数为0条，无法开启短信提醒功能。如需继续使用该功能，您可以选择购买短信条数后再开启。",
    "msg.notification": "消息弹窗",
    "msg.notification.tip": "开启后有新消息会在页面右上角弹窗提示",
    "msg.notification.tooltip": "开启短信提醒会耗费短信余额",
    "msg.placeholder.mail": "请输入邮箱",
    "msg.placeholder.phone": "请输入手机号",
    "msg.readAll": "全部转为已读",
    "msg.read": "转为已读",
    "msg.target.add": "添加提醒对象",
    "msg.target.delete.title": "您确定要删除该提醒对象吗？",
    "msg.target.delete.content": "删除后，该对象将不再收到任何消息提醒",
    "msg.target.email.empty": "邮箱为空，无法收到消息",
    "msg.target.email.unverified": "邮箱未验证，不能接收消息",
    "msg.target.empty": "暂无提醒对象",
    "msg.target.empty.add": "暂无提醒对象，点击",
    "msg.target.list": "提醒对象列表",
    "msg.target.phone.empty": "手机为空，无法收到消息",
    "msg.target.phone.unverified": "手机未验证，不能接收消息",
    "msg.target.set": "设置提醒对象",
    "msg.target.set.selected": "已选",
    "msg.target.set.count": "个（最多5个）",
    "msg.target.update": "修改信息",
    "msg.target.tooltip.mail": "需绑定邮箱才能收到提醒",
    "msg.target.tooltip.sms": "需绑定手机才能收到提醒",
    "msg.target.add.format": "格式不正确",
    "msg.target.add.repeat": "存在重复项",
    "msg.type": "消息类型",
    "msg.type.manage_group": "添加/删除管理组",
    "msg.type.manager": "添加/删除管理员",
    "msg.type.app": "添加/删除应用",
    "msg.type.dept_user": "添加/删除部门或成员",
    "msg.type.app_rename": "修改应用名称",
    "msg.type.api": "API Key 操作记录",
    "msg.type.webhook": "数据推送提醒",
    "msg.type.etl_cron_job": "数据流执行失败",
    "msg.type.corp_sync": "成员同步结果",
    "msg.validate": "验证",
    "msg.validate.send.all": "已发送短信和邮箱验证",
    "msg.validate.send.email": "已发送邮箱验证",
    "msg.validate.send.phone": "已发送短信验证",
    "manage.group.system.name": "系统管理组",
    "message": "通知",
    "message.expire.tip": "保存最近六个月的消息记录",
    "message.app.expire.tip": "保存最近六个月的操作记录",
    "message.sms.expire.tip": "保存最近六个月的发送日志",
    "message.system.log": "系统日志",
    "message.usage.notify": "套餐提醒",
    "message.operation.notify": "运营通知",
    "message.team.invite": "协作邀请",
    "message.setting": "通知设置",
    "message.empty": "暂无消息",
    "message.notification": "您有一条新的「{{type}}」消息",
    "message.webhook": "消息推送",
    "message.webhook.desc": "使用消息推送功能可推送消息至您指定的服务器",
    "message.webhook.leave.confirm": "离开当前页后，您的消息推送设置不会保存。",
    "message.webhook.error": "超过100条失败会自动关闭消息推送，请及时调整配置",
    "message.webhook.state.pushing": "推送中",
    "message.webhook.state.pause": "推送暂停",
    "message.webhook.state.fail": "推送失败",
    "message.webhook.toMyServer": "推送至我的服务器",
    "message.webhook.close.confirm": "您确定要关闭消息推送吗？",
    "message.webhook.close.tip": "关闭后将无法推送消息。",
    "appLog.template": "{{- operator}}{{- event}}了表单「{{- entry}}」",
    "appLog.template.rename": "{{- operator}}将表单「{{- oriEntry}}」重命名为「{{- entry}}」",
    "appLog.template.copy": "{{- operator}}复制了表单「{{- entry}}」",
    "member.select.list": "部门成员列表",
    "member.select.setting": "点击设置",
    "member.select.dept.manager": "{{- name}} | 部门主管",
    "member.select.group.tip": "该分组没有联系人",
    "member.select.role.empty": "没有角色",
    "member.select.role.empty.tip": "您可在通讯录中新建并分配角色",
    "member.select.depart.empty": "没有部门",
    "member.select.depart.empty.tip": "请到通讯录中添加或同步",
    "member.select.member.empty": "没有成员",
    "member.select.user.empty": "暂无相关联系人",
    "member.select.role.emptyTip": "暂无相关角色",
    "metric.calc": "计算指标",
    "metric.calc.add": "添加计算指标",
    "metric.add.success": "指标添加成功",
    "more.feature": "更多自定义功能",
    "multi.tab.show": "多标签显示",
    "multi.tab.name": "标签页",
    "multi.tab.nameWithNum": "标签页{{num}}",
    "multi.tab.add": "添加标签页",
    "multi.tab.delete.tip": "删除标签页后标签页内字段将移动到标签页外部，确定要删除吗？",
    "nav.getTrial": "领取试用",
    "nav.guide": "新手引导",
    "nav.profile": "账户中心",
    "nav.appstore": "应用中心",
    "nav.pack": "套餐购买",
    "nav.update": "更新日志",
    "nav.template": "模板中心",
    "nav.service": "技术支持",
    "nav.feedback": "意见反馈",
    "nav.service.guide": "您可以在这里随时联系技术支持。",
    "nav.doc": "帮助文档",
    "nav.video": "视频教程",
    "nav.message": "消息管理",
    "nav.message.tooltip": "消息",
    "nav.mobile.tooltip": "移动端",
    "nav.mobile.title": "平台没有APP，但你可以选择更多",
    "nav.mobile.msg": "您可以通过以下几种方式在移动端使用平台",
    "nav.mobile.more": "需要其他的APP方案？请点击告诉我们",
    "nav.register.dingtalk": "注册钉钉",
    "nav.register.wework": "注册企业微信",
    "nav.trial": "申请试用",
    "nav.sso": "将平台集成至外部的其他系统/产品",
    "nav.wechat": "微信服务号",
    "nav.wechat.or.dingtalk": "在企业微信或钉钉中使用",
    "nav.wechat.integrate": "集成您的微信公众号",
    "nav.wechat.fx": "平台微信服务号",
    "nav.wechat.scan": "扫码关注【平台】微信服务号，在微信中使用平台",
    "name.update": "修改名称",
    "name.placeholder": "输入名称",
    "nickname.update": "修改昵称",
    "nickname.update.success": "昵称修改成功",
    "nickname.placeholder": "输入昵称",
    "nickname.tooLong": "昵称最多为{{length}}个字",
    "nickname.user.label": "企业通讯录姓名",
    "newValue.label": "新值：",
    "order.add": "加购",
    "order.add.aggregate": "聚合表增购包 * {{value}}个/应用",
    "order.add.api": "数据接口（API）",
    "order.add.backup": "数据回收站 * {{value}}天",
    "order.add.customLogin": "自定义登录页功能",
    "order.add.data": "总数据量增购包10万条 * {{value}}",
    "order.add.data.form": "单表数据上限增购包 * {{value}}万条",
    "order.add.etl": "数据流 * {{value}}个",
    "order.add.manager": "子管理员 * {{value}}人",
    "order.add.trigger": "智能助手 * {{value}}个",
    "order.add.upload": "附件上传增购包 * {{value}}GB",
    "order.add.sms": "短信条数增购包1000条 * {{value}}",
    "order.add.sso": "单点登录功能",
    "order.add.userMaxCount": "最多能加购{{- count}}人",
    "order.calculate.loading": "计算中",
    "order.calculate.fail": "无法计算",
    "order.confirm": "确认订单",
    "order.confirm.tip": "您确定要提交该订单吗？",
    "order.confirm.noMember": "此账号内没有成员",
    "order.contract": "《购买协议》",
    "order.contract.accept": "我已阅读并同意",
    "order.contract.application": "如何申请合同？",
    "order.contract.contact": "如果您需要合同，请拨打热线：{{phone}}",
    "order.contract.hotLine": "咨询热线：{{hotLine}}",
    "order.copy": "份",
    "order.corp.name": "团队名：{{- name}}",
    "order.corp.owner": "企业创建者：{{- owner}}",
    "order.coupon": "优惠券",
    "order.coupon.empty.useful": "无可用优惠券",
    "order.coupon.empty.useless": "无不可用优惠券",
    "order.coupon.limit": "折扣仅对{{value}}「版本」生效",
    "order.coupon.useful": "可用优惠券",
    "order.coupon.useless": "不可用优惠券",
    "order.category.service": "实施订单",
    "order.data.add": "总数据量升级包",
    "order.data.add.count": "加购数据量：{{value}}份",
    "order.data.add.price": "¥500.00/份/年 1份=10万条数据",
    "order.data.api.tip": "API为具备编程能力的用户提供了一个简单的方法来整合平台数据及其他外部数据。",
    "order.data.count": "总数据量：{{value}}万条",
    "order.data.given": "赠送数据量：{{value}}万条",
    "order.data.own": "已有数据量：{{value}}万条",
    "order.data.own.pack": "版本数据量{{value}}万条",
    "order.data.own.add": "+已加购数据量{{value}}万条",
    "order.data.own.given": "+数据成长计划赠送{{value}}万条",
    "order.data.pack": "版本数据量：{{value}}万条",
    "order.user.totalCount": "总用户数：{{value}}人",
    "order.user.existingCount": "已有用户数：{{value}}人",
    "order.user.pack": "用户数增购包",
    "order.duration": "购买时长",
    "order.duration.more": "更长时间",
    "order.detail": "订单详情",
    "order.effectiveTime": "（确认支付后生效）",
    "order.effectiveTerm": "为了和其他付费功能有效期保持一致，已自动为您调整本次购买的有效期及价格",
    "order.given": "赠送",
    "order.my": "我的订单",
    "order.package": "版本",
    "order.package.contrast": "查看版本详情和对比",
    "order.price": "订单总额：",
    "order.product.info": "产品信息",
    "order.currency": "¥",
    "order.purchased": "已购买",
    "order.receipt": "发票与合同",
    "order.receipt.notice": "发票与合同须知",
    "order.receipt.apply": "申请发票",
    "order.receipt.application": "如何申请发票？",
    "order.receipt.how": "您可以在支付结束后申请开票，也可以在任意时间至账号设置中的订单管理页面申请开票",
    "order.receipt.expire": "如果六个月内未申请发票，过期将不可再申请",
    "order.receipt.mail": "开票金额不足1000元时需自付发票费用（快递方式为顺丰到付，由顺丰提供运费发票），开票金额不少于1000元时平台承担发票邮寄费用",
    "order.receipt.contact": "如有其它疑问，请咨询平台{{-service}}或拨打服务热线：{{phone}}",
    "order.receipt.notAllowed": "提前开票的订单不可合并开票",
    "order.service": "服务",
    "order.createTime": "下单时间：",
    "order.delete.confirm": "您确定要删除订单吗？",
    "order.delete.confirm.tip": "删除后无法恢复，确定要删除该订单吗？",
    "order.delete.success": "删除成功",
    "order.delete.failed": "删除失败",
    "order.no": "订单号",
    "order.no.withColon": "订单号：",
    "order.invoice.amount": "发票金额",
    "order.invoice.createTime": "创建时间",
    "order.invoice.companyName": "公司名",
    "order.invoice.sendState": "寄送状态",
    "order.invoice.sent": "已寄送",
    "order.invoice.refuse": "已退回",
    "order.invoice.refuse.reason": "退回原因：",
    "order.invoice.toSend": "待寄送",
    "order.invoice.merge": "合并开票",
    "order.invoice.my": "我的发票",
    "order.invoice.state": "发票状态",
    "order.invoice.state.label": "发票状态：",
    "order.invoice.do": "确认开票",
    "order.invoice.tooLow": "金额低于{{minCash}}，无法开票！",
    "order.price.all": "总价",
    "order.price.origin": "原价：",
    "order.state": "订单状态",
    "order.state.label": "订单状态：",
    "order.state.paid": "已支付",
    "order.state.unpaid": "未支付",
    "order.state.paid.uncollected": "待回款",
    "order.state.canceled": "已取消",
    "order.state.unreceipted": "未开票",
    "order.state.receipting": "开票中",
    "order.state.receipted": "已开票",
    "order.state.expired": "已过期",
    "order.submit.success.tip": "订单提交成功，请尽快付款",
    "order.termOfValidity": "有效期",
    "order.info": "订单信息",
    "order.inquiry": "如有疑问，请联系我们：{{phone}}",
    "order.amount": "订单金额",
    "order.pay": "支付",
    "order.pay.done": "完成支付",
    "order.pay.fail": "支付失败",
    "order.pay.fail.tip": "系统没有检测到您的支付信息，请重新支付！",
    "order.pay.immediate": "立即支付",
    "order.pay.price": "支付金额：",
    "order.pay.success": "支付成功",
    "order.payment": "付款",
    "order.payment.confirm": "确认信息正确",
    "order.payment.confirm.tip": "转账凭证提交后不可修改，请确认信息正确",
    "order.payment.modify": "返回修改",
    "order.payment.account.name": "打款账户名",
    "order.payment.account.no": "打款账户号码",
    "order.payment.alipay.tip": "请在新开支付宝页面中完成支付，请勿在支付完成前关闭此窗口。",
    "order.payment.proof": "转账凭证",
    "order.payment.proof.tip": "我们收到转账和您提交的凭证后将立即为您处理订单，感谢您的耐心等待。",
    "order.payment.tip": "如未完成支付，请点击",
    "order.payment.transfer.submit": "提交凭证",
    "order.payment.transfer.tip1": "对公支付请按以下步骤操作",
    "order.payment.transfer.tip2": "为了您的合法权益，转账时请备注您的订单编号",
    "order.payment.transfer.tip3": "汇款完成之后，请将汇款成功的凭证图片（线下汇款的凭条或线上转账的截图）提交系统",
    "order.payment.transfer.tip4": "我们收到转账和您提交的凭证后，将会立即为您开通服务，感谢您的耐心等待",
    "order.payment.transfer.tip5": "您也可以稍后在",
    "order.payment.transfer.tip6": "中提交凭证",
    "order.payment.unionpay": "银联支付",
    "order.payment.unionpay.tip": "请在新开支付页面中完成支付，请勿在支付完成前关闭此窗口。",
    "order.payTime": "支付时间",
    "order.payProof": "支付凭证",
    "order.payProof.submit": "提交支付凭证",
    "order.payProof.refuse": "支付审核不通过",
    "order.payProof.audit": "支付凭证审核中",
    "order.operation": "操作",
    "order.operation.cancel": "取消订单",
    "order.operation.cancel.confirm": "如果您已线下转账，取消订单将导致无法验证您的转账信息，确认要取消该订单吗",
    "order.operation.cancel.success": "取消成功",
    "order.operation.cancel.failed": "取消失败",
    "order.operation.invoice": "开票",
    "order.repay": "重新支付",
    "order.select.tip": "请选择订单！",
    "order.user": "用户数 * {{value}}人",
    "order.userStd": "标准版 * {{value}}人",
    "order.user.add": "增购人数",
    "order.user.purchase": "购买用户数：",
    "order.user.unit": "10人起购，购买数量为5的倍数",
    "order.user.count": "X{{count}}人",
    "order.user.count.own": "当前已购买用户数：{{count}}",
    "order.user.count.total": "增购后用户数：",
    "order.validity": "有效期：{{time}}",
    "operation.auth.importTip": "导入时不进行表单校验，不触发公式，请谨慎启用",
    "operation.auth.batchPrintTip": "仅自定义打印模板支持批量打印",
    "operation.auth.selectTip": "请至少选择一个可以进行的操作",
    "role.add": "添加角色",
    "role.create.tip": "请联系贵司系统管理员新建角色",
    "role.empty": "当前没有角色",
    "role.delete.confirm": "您是否要删除“{{- name}}”？",
    "role.delete.tip": "删除角色会同时删除该角色的权限，但不会删除此角色中包含的通讯录成员",
    "role.name": "角色名称",
    "role.name.placeholder": "请输入角色名称",
    "role.name.notEmpty": "角色名称不能为空",
    "role.name.tooLong": "角色名称不能超过{{length}}个字符",
    "role.desc1": "使用角色，让协作和流程变得更加轻松",
    "role.desc2": "角色是什么？在组织架构之外的更加灵活便捷的业务组，适用于无差别的跨部门协作任务和流程审批等场景",
    "role.removeMember.confirm": "您是否要移除所选成员？",
    "role.removeMember.tip": "移除成员会同时移除所选成员的当前角色身份，但不会在通讯录中删除所选成员",
    "role.list": "角色列表",
    "role.select": "请选择成员角色",
    "role.select.tip": "点击选择角色",
    "password.update": "修改密码",
    "password.update.success": "密码修改成功",
    "password.set": "设置密码",
    "password.set.warning": "请设置密码",
    "password.signIn": "登录密码",
    "password.signIn.error": "登录密码错误",
    "password.new": "新密码",
    "password.new.retype": "再输入一次新密码",
    "password.original": "原密码",
    "password.minLength": "最小长度为{{length}}",
    "password.tooShort": "密码长度小于{{length}}位",
    "password.confirm": "确认密码",
    "persona.template.has.vip": "模板中包含高级功能",
    "persona.template.exceed.msg": "此模板中包含的功能已超出您当前的版本，请领取试用后在「模板中心」安装",
    "persona.company.size": "{{num}}人",
    "persona.company.size.above": "{{num}}人以上",
    "persona.emptyTip.company": "团队名称不能为空",
    "persona.emptyTip.referrer": "了解渠道不能为空",
    "persona.emptyTip.industry": "行业类型不能为空",
    "persona.header": "完善信息，免费体验30天平台高级功能",
    "persona.header.hasTrial": "完善信息，享受大数据精准服务",
    "persona.industries.internet": "互联网/信息技术",
    "persona.industries.manufacturing": "制造业",
    "persona.industries.trade": "贸易/批发/零售",
    "persona.industries.service": "服务业",
    "persona.industries.education": "教育",
    "persona.industries.construction": "建筑业",
    "persona.industries.finance": "金融业",
    "persona.industries.government": "政府/事业单位",
    "persona.industries.medical_medicine": "医药医疗",
    "persona.industries.media": "文体/娱乐/传媒",
    "persona.industries.transportation": "运输/物流/仓储",
    "persona.industries.leasing": "商业服务/租赁",
    "persona.industries.estate": "房地产业",
    "persona.industries.agriculture": "农/林/牧/渔",
    "persona.industries.scientific": "科研服务",
    "persona.industries.social": "社会组织",
    "persona.industries.mining": "开采业",
    "persona.industries.resident": "居民服务",
    "persona.industries.electricity": "电热/燃气/水供应",
    "persona.industries.environment": "公共环境",
    "persona.job.boss": "老板",
    "persona.job.manager": "管理人员",
    "persona.job.staff": "普通职员",
    "persona.recommend.skip": "暂不安装",
    "persona.recommend.template": "应用模板",
    "persona.referrers.friend": "朋友推荐",
    "persona.referrers.friend.corp": "公司同事推荐",
    "persona.referrers.friend.private": "朋友私下推荐",
    "persona.referrers.friend.circle": "朋友圈",
    "persona.referrers.search": "网络搜索",
    "persona.referrers.search.form": '搜"表单"找到',
    "persona.referrers.search.flow": '搜"流程"找到',
    "persona.referrers.search.cooperate": '搜"协作软件"找到',
    "persona.referrers.zhihu": "知乎",
    "persona.referrers.zhihu.fx": "平台官方号",
    "persona.referrers.zhihu.influencer": "知乎大V",
    "persona.referrers.weChat": "微信公众号",
    "persona.referrers.weChat.fx": "平台公众号",
    "persona.referrers.weChat.excel": "Excel类公众号",
    "persona.referrers.weChat.data": "数据类公众号",
    "persona.referrers.weChat.manage": "管理类公众号",
    "persona.referrers.other.dingding": "阿里钉钉",
    "persona.referrers.other.wework": "企业微信",
    "persona.referrers.other.toutiao": "今日头条",
    "persona.referrers.other.qq": "QQ",
    "persona.referrers.other.online": "在线课程",
    "persona.referrers.other.maimai": "脉脉",
    "persona.your.company.industry": "你所在团队/企业所属行业：",
    "persona.your.company.name": "你的团队/企业名称：",
    "persona.your.company.size": "你的团队/企业规模：",
    "persona.your.job": "你的职位：",
    "persona.your.phone": "你的手机号：",
    "persona.your.referrer": "你从何处了解到「平台」：",
    "persona.broadcast.title": "您的信息尚未完善，完善账号信息有助于我们更好地为您服务",
    "persona.show.yes": "立即完善",
    "phone.bind": "绑定手机",
    "phone.bind.success": "手机号绑定成功",
    "phone.current": "当前手机号",
    "phone.new": "新手机号",
    "phone.invalid.warning": "请输入正确的手机号码",
    "phone.update": "修改手机",
    "phone.update.success": "手机号修改成功",
    "phone.unbind": "解绑手机",
    "phone.unbind.confirm": "您确定要解绑手机吗？",
    "phone.unbind.tip": "解绑手机需验证当前绑定手机号的真实性，且解绑后将无法通过原手机号登录平台，如需继续使用手机号登录，可以在解绑后重新绑定新手机号",
    "phone.unbind.success": "手机号解绑成功",
    "phone.stop": "手机已停机？",
    "phone.verify": "验证手机",
    "phone.conflict": "手机号码已存在",
    "publish.immediate": "立即发布",
    "publish.skip": "暂不发布",
    "publish.continue": "继续发布",
    "publish.flow.title": "流程未启用，是否继续发布？",
    "publish.flow.msg": "您可以继续发布表单，但提交的数据不会按照流程图所绘过程流转",
    "print.batch": "批量打印",
    "print.batch.expired.tip": "下载链接已失效，无法下载，如需下载请重新选择打印数据",
    "print.batch.expired.tip1": "下载链接已失效，请重新生成PDF",
    "print.batch.fail.tip": "批量打印失败，请稍候重试",
    "print.batch.log": "批量打印记录",
    "print.batch.log.deleteConfirm": "您确定要删除打印记录吗？",
    "print.batch.log.deleteTip": "删除打印记录后将不可下载这次生成的文件，且无法还原",
    "print.batch.log.none": "无批量打印记录",
    "print.batch.packing.tip": "您可以关闭页面，系统将会继续生成文件",
    "print.batch.waiting.tip": "正在生成PDF文件，请等待(您可以关闭页面，系统将会继续生成PDF)",
    "print.batch.finished.tip": "下载链接已完成，将于{{time}}失效，请尽快下载",
    "print.batch.finished.tip1": "下载链接已完成，将于{{time}}失效，请尽快下载",
    "print.batch.failed.tip": "PDF导出失败，打印文件过大，请调整打印模板或减少打印条数后再试",
    "print.batch.failed.tip1": "下载链接已失效，请调整打印模板或减少打印条数后再试",
    "print.batch.running.tip": "PDF导出中，请稍等",
    "print.batch.running.tip1": "下载链接还未生成，请稍等",
    "print.batch.delete.tip1": "删除链接记录后不可下载本次生成的PDF文件，是否确认删除这条记录？",
    "print.begin.point": "起始打印点（以当前单元格为基准）",
    "print.border": "边框线",
    "print.border.none": "无边框",
    "print.border.weight": "边框线粗细",
    "print.bg": "背景图",
    "print.bg.enable": "打印背景",
    "print.bg.tip": "请上传与纸张长宽比例一致的背景图",
    "print.cellHeight.auto": "动态单元格高度（推荐）",
    "print.cellHeight.auto.tip": "当表单内容超出单元格时，自动拉伸单元格高度以打印全部内容",
    "print.cellHeight.fix": "固定单元格高度",
    "print.cellHeight.fix.tip": "严格按照模板设定的单元格尺寸打印，当内容超出单元格时会被省略",
    "print.clear": "清除内容",
    "print.data.all": "打印全部数据",
    "print.data.filtered": "打印过滤后的数据",
    "print.delete.row": "删除行",
    "print.delete.col": "删除列",
    "print.hf": "页眉页脚",
    "print.hf.set": "页眉页脚设置",
    "print.hide.cancel": "取消隐藏",
    "print.hide.col": "隐藏列",
    "print.hide.row": "隐藏行",
    "print.insert.delete": "插入/删除",
    "print.insert.number": "插入页码",
    "print.insert.count": "插入总页码",
    "print.insert.row.above": "向上插入 1 行",
    "print.insert.row.below": "向下插入 1 行",
    "print.insert.row": "插入行",
    "print.insert.col": "插入列",
    "print.insert.col.left": "向左插入 1 列",
    "print.insert.col.right": "向右插入 1 列",
    "print.insert.img": "插入图片",
    "print.insert.img.cell": "插入单元格图片",
    "print.insert.img.count": "悬浮图片不得超过{{count}}个",
    "print.insert.img.float": "插入悬浮图片",
    "print.log.view": "查看打印记录",
    "print.merge": "合并单元格",
    "print.merge.confirm": "您确定要合并单元格吗？",
    "print.merge.confirm.tip": "选择的区域包含多个数据，合并单元格后将只保留编辑过的所有单元格中最左上角的数值",
    "print.name": "未命名模板",
    "print.page.bottom": "页脚底端距离：",
    "print.page.count": "{总页码}",
    "print.page.number": "{页码}",
    "print.page.count.text": "总页码",
    "print.page.number.text": "页码",
    "print.page.top": "页眉顶端距离：",
    "print.paper.dir": "纸张方向",
    "print.paper.dir.p": "纵向",
    "print.paper.dir.l": "横向",
    "print.paper.height": "高：",
    "print.paper.padding": "页边距",
    "print.paper.padding.top": "上：",
    "print.paper.padding.bottom": "下：",
    "print.paper.padding.left": "左：",
    "print.paper.padding.right": "右：",
    "print.paper.set": "打印纸张设置",
    "print.paper.size": "纸张大小",
    "print.paper.width": "宽：",
    "print.preview.loading.tip": "正在生成预览，请稍等",
    "print.qrcode.data": "数据二维码",
    "print.qrcode.data.tip": "将每条数据打印为对应的二维码，团队成员扫码即可查看对应数据",
    "print.qrcode.field": "字段二维码",
    "print.qrcode.field.tip": "将每条数据中一个字段的内容打印为对应的二维码，扫码即可录入对应内容",
    "print.qrcode.field.empty": "请选择需要打印的字段",
    "print.qrcode.field.placeholder": "请选择字段",
    "print.qrcode.layout.number": "二维码排版",
    "print.qrcode.padding.tip": "注：纸张设置仅支持A4纸，若页边距设置过大会出现二维码打印不完整的情况",
    "print.qrcode.type": "二维码类型",
    "print.repeat": "重复打印设置（请选中单行后设置）",
    "print.repeat.cross": "跨页时重复打印此行内容",
    "print.repeat.times": "重复打印次数：",
    "print.repeat.title": "当此分页上打印内容超出一页纸张时，在接下来的纸张顶部自动打印此行内容",
    "print.record": "打印记录",
    "print.save.tip": "当前模板未保存",
    "print.set.bgImg": "设置背景图",
    "print.set.cellHeight": "单元格高度设置",
    "print.set.paper": "纸张设置",
    "print.set.repeat": "重复打印设置",
    "print.sheet.add": "增加新的打印分页",
    "print.sheet.delete": "确定要删除分页？",
    "print.sheet.delete.tip": "删除此分页后，将不再使用此分页的模板打印",
    "print.sheet.exceed": "分页数量超出限制",
    "print.sheet.name": "分页{{num}}",
    "print.system.sequence": "系统序号",
    "print.unMerge": "取消合并单元格",
    "print.usage.empty": "暂无相关结果",
    "print.usage.flow": "仅显示启用中流程的节点，其他版本的节点打印模板，请到该节点属性中设置。",
    "print.usage.flow.empty": "流程版本未启用",
    "print.usage.flow.empty.desc": "请在流程设定中启用流程，然后为流程节点设置打印模板",
    "print.usage.range": "模板使用范围",
    "print.usage.set": "设置成功",
    "print.template.name": "模板名称",
    "print.template.scenes": "场景",
    "print.template.type": "类型",
    "print.template.time": "时间",
    "print.template.op": "操作人",
    "print.template.log.type.data": "数据打印",
    "print.template.log.type.batch_qr": "批量打印二维码",
    "print.template.log.type.batch_data": "批量打印",
    "print.template.log.scenes.flow": "流程提交并打印",
    "print.template.log.scenes.manage": "数据管理",
    "print.template.log.scenes.group": "数据权限组",
    "print.template.log.scenes.report": "报表",
    "print.template.log.scenes.button": "按钮打印",
    "print.template.log.scenes.publicQuery": "公开查询",
    "profile.person": "个人设置",
    "profile.corp": "企业设置",
    "profile.api": "数据接口",
    "profile.api.contact": "联系我们开通数据接口",
    "profile.api.empty": "您没有开通数据接口功能",
    "profile.api.intro": "数据接口为具备编程能力的用户提供了一个简单的方法来整合平台数据及其他外部数据。",
    "profile.bind.emailOrPhone": "请绑定邮箱或手机",
    "profile.bind.emailOrPhone.pass": "请绑定邮箱或手机，并设置密码",
    "profile.complete.warning": "请填写全部信息",
    "platform.empty": "这里什么都没有",
    "platform.empty.tip1": "请打开「应用编辑」，添加表单和报表",
    "platform.empty.tip2": "请联系贵司「平台」管理员，将表单/报表共享给您",
    "platform.filter.count": "（筛选出{{filterCount}}条 / 共{{totalCount}}条）",
    "platform.filter.totalCount": "（共{{totalCount}}条）",
    "platform.flow.currentNode.select": "请先选择当前节点",
    "platform.flow.filter.add": "添加字段筛选条件",
    "platform.flow.todo.latest": "最新的待办",
    "platform.flow.todo.earliest": "最早的待办",
    "platform.flow.create.latest": "最新发起的",
    "platform.flow.create.earliest": "最早发起的",
    "platform.flow.transactors.latest": "最新处理的",
    "platform.flow.transactors.earliest": "最早处理的",
    "platform.flow.cc.latest": "最新抄送的",
    "platform.flow.cc.earliest": "最早抄送的",
    "query.condition": "查询条件",
    "query.condition.set": "设置查询条件",
    "query.alter": "更改查询条件",
    "query.complete.warning": "查询条件须填写完整！",
    "query.pass.tip": "查询该数据需输入密码，请输入密码：",
    "query.pass.error": "密码错误",
    "query.pass.type": "请输入密码",
    "page.leave.confirm": "您确定要离开当前页吗？",
    "receipt.type": "发票类型",
    "receipt.type.special": "公司专票(纸质发票)",
    "receipt.type.plain": "公司普票(纸质发票)",
    "receipt.type.personal": "政府、事业单位、个人(纸质发票)",
    "receipt.type.plain.electric": "公司普票(电子发票)",
    "receipt.electric.tip": "电子发票与传统纸质发票具有同等法律效力，可作报销凭证",
    "receipt.tax.cert": "一般纳税人证明",
    "receipt.content.appPlatform": "平台应用平台",
    "receipt.content.techService": "技术服务费",
    "receipt.tax": "税率：{{taxRate}}",
    "receipt.info": "发票信息",
    "receipt.downloadTemplate": "下载模板",
    "receipt.downloadWordTemplate": "下载Word模板",
    "receipt.companyName": "公司名称",
    "receipt.taxNo": "税号",
    "receipt.taxNo.placeholder": "请输入18位税号",
    "receipt.taxNo.required": "请输入15位或18位税号",
    "receipt.fullName": "名称",
    "receipt.regAddress": "注册地址",
    "receipt.regPhone": "注册电话",
    "receipt.bank": "开户行",
    "receipt.account": "账号",
    "receipt.content": "发票内容",
    "receipt.sendMsg": "寄送信息",
    "receipt.receiverAddress": "邮寄地址",
    "receipt.submitSuccess.tip": "您的发票已提交，我们将在1-2个工作日寄出发票",
    "receipt.confirmInfo": "确认信息正确",
    "receipt.returnAndEdit": "返回修改",
    "receipt.submit.tip": "发票信息提交后不可修改，请确认信息正确",
    "receipt.send.warning": "本次开票金额不足1000元，需自付运费。（快递方式为顺丰到付，可向快递员索取运费发票）",
    "pagination.limit": "{{limit}} 条/页",
    "pagination.count": "共{{count}}条",
    "pagination.count.filtered": "筛选出{{count}}条",
    "recommend.app.all": "全部模板",
    "recommend.app.done": "开始探索平台",
    "recommend.app.title": "安装官方模板，快速开展业务",
    "recommend.app.info": "为你精选以下官方模板，帮你快速上手平台，最多选择3项",
    "recommend.color": "推荐颜色",
    "receiver.validate.success": "验证成功！",
    "receiver.validate.success.tip": "您已成为「{{- name}}」团队的消息接收人",
    "receiver.validate.fail": "链接已失效！",
    "receiver.validate.fail.tip": "请联系团队的账号创建者重新发送验证",
    "release.team": "团队成员",
    "release.team.link": "团队成员访问该链接需要登录并授权",
    "report.release": "发布报表",
    "report.release.mem": "将报表发布给团队成员，成员登录系统后即可查看报表",
    "report.release.link": "将报表发布为公开链接，无需登录即可查看报表",
    "report.release.team": "报表访问链接",
    "report.externalLink": "报表查看链接",
    "report.defaultName": "未命名报表",
    "report.chart.legend": "系列{{val}}",
    "report.chart.legend.label": "系列",
    "report.chart.category": "分类{{val}}",
    "report.chart.category.label": "分类",
    "report.load.fail": "加载报表失败！",
    "report.form.empty.tip": "您还没有创建表单，建议您先创建表单并录入数据，再使用报表功能。",
    "report.design": "报表设计",
    "report.dataSource.empty.tip": "请在右侧面板设置数据来源",
    "report.field.empty.tip": "请从右侧面板添加字段",
    "report.parameter.empty.tip": "请先拖入字段并添加字段",
    "report.dataTable": "数据表",
    "report.combinedTable": "汇总表",
    "report.barChart": "柱形图",
    "report.lineChart": "折线图",
    "report.pieChart": "饼图",
    "report.areaChart": "面积图",
    "report.radarChart": "雷达图",
    "report.shift": "排班表",
    "report.rili": "日历表",
    "report.map": "地图表",
    "report.empty.tip": "拖入左侧字段绘制报表",
    "report.field.empty.toast": "请先添加字段",
    "report.widget.filter": "条件过滤",
    "report.link": "联动",
    "report.value": "值",
    "report.dataAuth.editable": "可修改数据",
    "report.dataAuth.removable": "可删除数据",
    "report.dataAuth.exportable": "可导出数据",
    "report.stickyHead": "表头冻结",
    "report.stickyHead.row": "冻结行表头",
    "report.stickyHead.col": "冻结列表头",
    "report.rowHead": "行表头",
    "report.colHead": "列表头",
    "report.metric": "指标",
    "report.data.auth": "报表数据表权限组",
    "richtext.clear": "清除格式",
    "richtext.height": "行高",
    "richtext.strikethrough": "删除线",
    "richtext.resizeFull": "调整至 100%",
    "richtext.resizeHalf": "调整至 50%",
    "richtext.resizeQuarter": "调整至 25%",
    "richtext.floatLeft": "左浮动",
    "richtext.floatRight": "右浮动",
    "richtext.floatNone": "不浮动",
    "richtext.dragImageHere": "将图片拖至此处",
    "richtext.selectFromFiles": "从本地上传",
    "richtext.image.url": "图片地址",
    "richtext.remove": "删除图片",
    "richtext.original": "原始尺寸",
    "richtext.link": "链接",
    "richtext.insert.link": "插入链接",
    "richtext.unlink": "取消链接",
    "richtext.edit": "编辑链接",
    "richtext.textToDisplay": "显示文本",
    "richtext.openInNewWindow": "在新页面打开",
    "richtext.table": "表格",
    "richtext.insert.hr": "水平线",
    "richtext.style": "样式",
    "richtext.normal": "普通",
    "richtext.blockquote": "引用",
    "richtext.pre": "代码",
    "richtext.h1": "标题 1",
    "richtext.h2": "标题 2",
    "richtext.h3": "标题 3",
    "richtext.h4": "标题 4",
    "richtext.h5": "标题 5",
    "richtext.h6": "标题 6",
    "richtext.unordered": "无序列表",
    "richtext.ordered": "有序列表",
    "richtext.codeview": "源代码",
    "richtext.paragraph": "段落",
    "richtext.outdent": "减少缩进",
    "richtext.indent": "增加缩进",
    "richtext.justify": "两端对齐",
    "richtext.font.color": "字体颜色",
    "richtext.recent": "最近使用",
    "richtext.background": "背景",
    "richtext.foreground": "前景",
    "richtext.reset": "重置",
    "richtext.resetToDefault": "默认",
    "richtext.shortcuts": "快捷键",
    "richtext.textFormatting": "文本格式",
    "richtext.action": "动作",
    "richtext.paragraphFormatting": "段落格式",
    "richtext.documentStyle": "文档样式",
    "richtext.specialChar": "特殊字符",
    "richtext.select": "选择特殊字符",
    "search.max.show.tip": "仅显示前{{- count}}个搜索结果",
    "serial.number": "编号",
    "sms.available": "剩余短信条数：",
    "sms.log": "短信发送日志",
    "sms.log.empty": "暂无发送日志",
    "sms.log.used": "消耗条数",
    "sms.log.detail.prefix": "短信验证 - ",
    "sms.number": "短信条数：",
    "sms.order": "购买短信条数",
    "sms.pack": "短信包",
    "sms.pack.detail": "短信条数增购包",
    "sms.pack.number": "短信包数量：",
    "sms.pack.number.detail": "1000条",
    "sms.pack.order": "购买短信包",
    "sms.pack.price": "¥90.00",
    "sms.send.fail": "发送失败，请检查手机号是否输入正确",
    "sms.send.success": "发送成功",
    "sms.send.status": "发送状态",
    "sms.send.status.question1": "为什么会发送失败？",
    "sms.send.status.question2": "为什么发送成功却没有收到短信？",
    "sso": "单点登录",
    "sso.desc": "应用于企业账号URL和发布给成员的内链接中",
    "sso.config.guide": "如何配置?",
    "sso.config.title": "配置单点登录",
    "sso.config.method.tip": "请选择单点登录配置方式",
    "sso.config.saml.tip": "请从支持 SAML 认证协议的身份认证服务商中获取以下信息进行填写",
    "sso.config.saml.title": "SAML 2.0 Endpoint (HTTP)",
    "sso.config.idp.title": "IdP 公钥",
    "sso.config.algo.title": "SAML 加密算法",
    "sso.config.cert.title": "认证密钥",
    "sso.config.certAlgo.title": "认证加密算法",
    "sso.config.issuer.title": "Issuer URL",
    "sso.config.secret.title": "生成密钥",
    "sso.config.signin.title": "IdP 登录接口",
    "sso.config.signout.title": "IdP 登出接口",
    "sso.config.signout.tip": "若填写此项，用户登出后，会同时登出该 IdP 下所有应用",
    "sso.config.slo.title": "SLO Endpoint (HTTP)",
    "sso.config.slo.tip": "若填写此项，用户登出后，会同时登出该 IdP 下所有 SAML 应用",
    "sso.custom.api": "自定义接口",
    "sso.saml": "SAML 2.0 Endpoint",
    "sso.saml.short": "SAML 2.0",
    "sso.secret.maxLength": "密钥长度超出限制",
    "sso.cert": "认证返回地址",
    "sso.custom": "IdP Endpoint",
    "sso.meta": "Metadata 地址",
    "sso.signout": "注销地址",
    "sso.clearConfig.title": "您确定要清空配置吗？",
    "sso.clearConfig.msg": "清空后将无法使用单点登录",
    "sso.item.required": "信息不完整",
    "submit.success": "提交成功",
    "submit.fail": "提交失败",
    "submit.verify": "提交校验",
    "submit.select": "提交选中",
    "submit.end": "结束提交",
    "submit.finish": "提交完成",
    "submit.break": "提交中断",
    "submit.timeout": "提交超时",
    "satisfaction.survey.title": "平台用户满意度调查",
    "satisfaction.survey.subtitle": "参与即有机会赢取 8 折优惠券",
    "send.verify.email": "发送验证邮件",
    "send.verify.sms": "发送验证短信",
    "survey.recommend.question": "您有多大可能向朋友推荐平台？",
    "survey.recommend.not": "绝对不会",
    "survey.recommend.able": "非常可能",
    "survey.research.question": "您是否愿意让贵司平台用户也参与调研？",
    "survey.research.question.tip": "若愿意，调研结束后我们将会为您反馈贵司调研结果，方便您了解成员对平台的满意程度",
    "survey.recommend.unwilling": "不愿意",
    "survey.recommend.willing": "愿意",
    "survey.clickToParticipate": "点击参与",
    "survey.confirm": "您确定不参加本次调研吗？",
    "survey.confirm.manager.tip": "关闭后无法参与本次调研，您将失去赢取平台 8 折优惠券的机会。",
    "survey.confirm.member.tip": "关闭后无法参与本次调研，管理员将无法获知您对平台的满意度",
    "survey.confirm.info": "返回活动页面",
    "survey.thank": "感谢您的参与",
    "survey.confirm.close": "真的要放弃折扣券和平台周边吗？",
    "template.case": "使用案例",
    "template.copy.other": "复制到同应用其他表单",
    "template.copy.other.tip": "将打印模板复制到当前应用内的其他表单时，仅保留模板内所有的样式和文字，不会保留表单字段",
    "template.copy.current": "复制到当前表单",
    "template.copy.empty": "没有可选择的目标表单",
    "template.copy.form.empty.tip": "请选择目标表单",
    "template.demand.submit": "提交模板需求",
    "template.install": "安装应用",
    "template.install.fail": "安装失败",
    "template.install.withData": "保留示例数据",
    "template.install.withData.tip": "保留的数据会计入数据总量，请确保您的版本满足需求。",
    "template.install.withoutData": "不保留示例数据",
    "template.install.toGroup": "安装应用到分组",
    "template.copy.toGroup": "复制应用到下面分组",
    "template.install.target.group": "请选择应用安装的分组",
    "template.not.found": "没有搜索到相关结果",
    "template.not.suitable": "没有找到合适的模板？",
    "template.publisher": "开发者：{{- publisher}}",
    "template.search.tip": "输入模板名称来搜索",
    "template.search.result": "“{{- keyword}}”的搜索结果",
    "template.share": "请复制以下链接来分享应用",
    "template.trial": "模板中包含高级功能，是否领取试用？",
    "template.trial.time": "此模板中包含的功能已超出您当前使用的版本，是否领取高级功能{{day}}天试用期？",
    "template.upgrade": "此模板包含的高级功能已超出您当前使用的版本。如需体验请升级您的账号。",
    "template.welcome": "欢迎加入模板中心",
    "template.desc": "模板中心是平台用户公开发布、交流应用的平台。",
    "template.tip.share": "如果你只需让团队成员使用你的应用，那么将应用分享给团队成员即可",
    "template.tip.appLink": "如果你只需将应用分享给特定的用户，那么加入推广联盟后分享应用链接即可",
    "template.tip.data": "将应用发布至模板中心时，应用中的部分数据也会一并被发布，如果此应用中有隐私数据，请复制应用后并添加示例数据后发布。",
    "transfer.tip": "此操作仅调整已产生流程数据中的负责人，不影响流程配置",
    "transfer.charger.original": "原负责人",
    "transfer.charger.original.label": "原负责人：",
    "transfer.charger.original.select": "请选择原负责人",
    "transfer.charger.new": "新负责人",
    "transfer.charger.new.label": "新负责人：",
    "transfer.charger.new.select": "请选择新负责人",
    "transfer.charger.duplicate": "原负责人和新负责人相同",
    "transfer.record": "调整记录",
    "transfer.record.none": "无调整记录",
    "transfer.record.view": "查看调整记录",
    "transfer.success": "调整成功",
    "transfer.busy": "正在调整，请等待",
    "transfer.busy.tip": "您可以关闭页面，调整会继续进行",
    "transfer.time.label": "调整时间：",
    "transfer.count": "调整数据：{{count}}条",
    "transfer.count.success": "成功：{{count}}条",
    "transfer.count.fail": "失败：{{count}}条",
    "trigger.create": "新建智能助手",
    "trigger.empty": "智能助手可以在触发表单数据发生变动后，自动在目标表单中新增、修改、删除数据。",
    "trigger.afterCreate": "新增数据后",
    "trigger.afterUpdate": "数据修改后",
    "trigger.afterRemove": "删除数据后",
    "trigger.conditions": "当满足指定条件时",
    "trigger.entry.add": "在「{{- name}}」中新增数据",
    "trigger.entry.update": "修改「{{- name}}」的数据",
    "trigger.entry.remove": "删除「{{- name}}」的数据",
    "trigger.log.review": "查看执行日志",
    "trigger.log.failure.detail": "失败详情",
    "trigger.log.failure.detail.view": "查看失败详情",
    "trigger.log.failure.index": "序号",
    "trigger.log.failure.reason": "失败原因",
    "trigger.log.time": "执行时间",
    "trigger.log.user": "执行人",
    "trigger.log.count": "（{{count}}条）",
    "trigger.log.create.empty": "（0条，没有可新增的数据）",
    "trigger.log.update.empty": "（0条，没有可修改的数据）",
    "trigger.log.remove.empty": "（0条，没有可删除的数据）",
    "trigger.log.fail": "（失败-{{msg}}）",
    "trigger.log.fail.count": "（失败{{count}}条）",
    "trigger.log.error.1": "执行失败",
    "trigger.log.error.4809": "循环计算错误",
    "trigger.log.error.4806": "找不到目标表单",
    "trigger.log.error.3002": "找不到目标表单",
    "trigger.log.error.4813": "超出触发层级限制",
    "trigger.log.error.4812": "需修改数据>100条",
    "trigger.log.error.4817": "主字段或单个子表单不能使用不同子表单赋值",
    "trigger.log.error.4821": "最多新建200条数据",
    "trigger.log.error.4012": "数据正被其他用户编辑",
    "trigger.log.error.9007": "数据正被其他用户编辑",
    "trigger.log.error.9008": "数据正被其他用户编辑",
    "trigger.log.error.4000": "数据提交失败",
    "trigger.log.error.7212": "超出每月数据提交量",
    "trigger.log.error.7206": "超出总数据量/单表数据量",
    "trigger.log.error.4403": "聚合表校验公式错误",
    "trigger.log.error.4001": "数据不存在",
    "trigger.log.error.4815": "未生成有效的过滤条件",
    "trigger.log.error.4822": "修改字段设置有误",
    "trigger.log.error.4823": "触发条件设置有误",
    "trigger.log.error.4824": "删除数据超过100条",
    "trigger.log.error.4825": "触发数据不存在",
    "trigger.log.error.2010": "没有跨应用操作权限",
    "trigger.log.error.4827": "过滤条件目标表单子表单不支持使用触发表单子表单赋值",
    "trigger.log.error.4828": "过滤条件不支持配置子表单",
    "trigger.log.error.4829": "过滤条件未配置目标表单子表单字段使用触发表单主字段赋值",
    "trigger.log.error.4830": "过滤条件未配置目标表单主字段使用触发表单子表单字段赋值",
    "trigger.log.error.4831": "过滤条件子字段不支持使用触发表单主字段赋值",
    "trigger.log.error.4832": "过滤条件目标表单主字段仅可使用触发表单相同子表单字段赋值",
    "trigger.log.error.4833": "不支持对目标表单子字段修改",
    "trigger.log.error.4834": "过滤条件仅支持对目标表单同一个子表单的子字段进行过滤",
    "trigger.log.error.4835": "仅支持对目标表单同一个子表单的子字段进行赋值",
    "trigger.log.error.4836": "目标表单子表单不支持使用触发表单子表单赋值",
    "trigger.log.error.4837": "目标表单主字段仅可使用触发表单相同子表单字段赋值",
    "trigger.log.error.4838": "字段赋值和过滤条件中目标表单子表单字段不一致",
    "trigger.log.error.4839": "字段赋值和过滤条件中触发表单子表单字段不一致",
    "trigger.log.filter.empty": "没有符合筛选条件的执行日志",
    "trigger.depend.subform.tip": "确定要使用子表单字段赋值吗？",
    "trigger.depend.subform.conflict.tip": "主字段或单个子表单不能使用不同子表单字段赋值。此操作会清除部分已设置的字段赋值方式，无法还原。",
    "trigger.depend.subform.subfield.tip": "目标表单主字段和子字段不能同时使用子字段赋值。此操作可能会清除部分已设置的字段赋值方式，无法还原。",
    "trigger.config.subform.support": "目标表单字段支持使用触发表单子表单字段。",
    "trigger.delete.title": "确定要删除智能助手？",
    "trigger.delete.msg": "删除智能助手后将不再触发执行动作，之前的执行结果不受影响",
    "trigger.config.trigger": "设置触发动作",
    "trigger.config.run": "设置执行动作",
    "trigger.config.name": "智能助手名称",
    "trigger.config.field.add": "添加字段",
    "trigger.config.form": "触发表单",
    "trigger.config.form.tip": "数据助手触发执行动作修改其他表单的数据。",
    "trigger.config.action": "触发动作",
    "trigger.config.add.tip": "新增的数据满足以下条件，触发执行动作",
    "trigger.config.update.tip": "修改后的数据满足以下条件，触发执行动作",
    "trigger.config.remove.tip": "删除的数据满足以下条件，触发执行动作",
    "trigger.config.addFilter": "添加触发条件",
    "trigger.config.fieldAdd.tip": "在目标表单中新增数据，字段值设置如下",
    "trigger.config.helpDoc": "如何设置智能助手？",
    "trigger.config.next": "下一步：设置执行动作",
    "trigger.config.prev": "上一步：设置触发动作",
    "trigger.config.fail.tip1": "请输入数据助手名称",
    "trigger.config.fail.tip2": "数据助手名称不能超过10字",
    "trigger.config.fail.tip3": "请选择触发表单",
    "trigger.config.fail.tip4": "请选择触发动作",
    "trigger.config.fail.tip5": "触发表单是其他智能助手的目标表单，且嵌套超过3层",
    "trigger.config.addData": "新增数据",
    "trigger.config.addData.tip1": "在触发表单中填报新的数据",
    "trigger.config.addData.tip2": "在目标表单中新增数据",
    "trigger.config.updateData": "修改已有数据",
    "trigger.config.updateData2": "修改数据",
    "trigger.config.updateData.tip1": "在触发表单中修改已有数据，如流程状态等",
    "trigger.config.updateData.tip2": "在目标表单中查找某些数据并修改",
    "trigger.config.removeData": "删除已有数据",
    "trigger.config.removeData2": "删除数据",
    "trigger.config.removeData.tip1": "在触发表单中删除某条数据，不包含批量删除",
    "trigger.config.removeData.tip2": "在目标表单中查找某些数据并删除",
    "trigger.config.removeData.condition": "删除目标表单中的哪些数据",
    "trigger.config.removeData.info": "过滤条件可以限定删除目标表单中的哪些数据",
    "trigger.config.target": "目标表单",
    "trigger.config.target.tip": "目标表单是您想要通过智能助手自动新增、修改、删除数据的表单",
    "trigger.config.field.set": "设置为",
    "trigger.config.updateData.condition": "修改目标表单中的哪些数据",
    "trigger.config.updateData.info": "过滤条件可以限定修改目标表单中的哪些数据",
    "trigger.config.filter.add": "添加过滤条件",
    "trigger.config.field.updateTip": "对符合过滤条件的数据，进行以下字段的修改",
    "trigger.config.field.updateTip1": "对符合过滤条件的数据，进行以下字段的替换，未配置的字段数据替换为空",
    "trigger.config.action.add": "添加执行动作",
    "trigger.config.action.addTip": "执行动作不可超过5个",
    "trigger.config.entry.fieldValue": "字段值",
    "trigger.config.field.select": "请选择输出数据字段",
    "trigger.config.combo.placeholder": "请输入内容，多个值用“enter”隔开",
    "trigger.config.leaveConfirm": "您确定要关闭设置页面吗？",
    "trigger.config.leaveConfirm.msg": "关闭后已设置的数据不会保存，您需要重新设置智能助手，此操作无法还原",
    "trigger.config.tip.form": "{{- form }}{{- action}}{{- afterAction}}",
    "trigger.config.tip.afterAction": "后，触发设置的执行动作",
    "trigger.config.tip.afterActionWithCond": "满足指定的条件时，触发设置的执行动作",
    "trigger.config.tip.dataAdd": "表单新增数据",
    "trigger.config.tip.dataAddWithCond": "表单新增的数据",
    "trigger.config.tip.dataUpdate": "表单修改数据",
    "trigger.config.tip.dataUpdateWithCond": "表单修改的数据",
    "trigger.config.tip.dataRemove": "表单删除数据",
    "trigger.config.tip.dataRemoveWithCond": "表单删除的数据",
    "trigger.config.valid.sameAction": "触发动作与执行动作相同",
    "trigger.config.valid.circle": "当前智能助手的目标表单执行动作，和其他智能助手的触发表单触发动作相同",
    "trigger.config.subform.use.confirm": "确定要使用该子表单字段吗？",
    "trigger.config.subform.both.tip": "目标表单和触发表单不支持同时使用子表单字段，此操作会清除部分已设置的过滤条件和字段赋值方式，无法还原。",
    "trigger.config.subform.onlyOne.tip": "过滤条件仅允许添加同一个子表单中的字段，此操作会清除部分已设置的过滤条件和字段赋值方式，无法还原。",
    "trigger.config.operation.confirm": "确定要进行此操作吗？",
    "trigger.config.operation.tip": "此操作会清除部分已设置的字段赋值方式，无法还原。",
    "trigger.config.subformrely": "子表单联动",
    "datahelper.trigger.config.subform_to_rely": "联动子表单当前行",
    "datahelper.trigger.config.subform_to_rely.tip": "联动子表单触发行的控件数据",
    "datahelper.trigger.config.subform_fix_rely": "联动子表单指定行",
    "datahelper.trigger.config.subform_fix_rely.tip": "根据条件联动子表单指定行的控件数据",
    "datahelper.trigger.config.subform_add": "子表单添加数据",
    "datahelper.trigger.config.subform_add.tip": "添加符合条件的数据到子表单控件尾部",
    "datahelper.trigger.config.subform_delete": "子表单删除数据",
    "datahelper.trigger.config.subform_delete.tip": "根据条件删除子表单控件里的数据",
    "update.success": "修改成功",
    "update.inProcess.wait": "正在修改，请等待",
    "update.inProcess.wait.tip": "您可以关闭页面，修改会继续进行",
    "update.record": "修改记录",
    "update.record.none": "无修改记录",
    "update.field.label": "修改字段：",
    "update.time.label": "修改时间：",
    "update.dataCount": "修改数据：{{count}}条",
    "update.dataCount.success": "成功：{{count}}条",
    "update.dataCount.fail": "失败：{{count}}条",
    "username.valid.empty": "成员编号必填",
    "username.valid.length": "成员编号最长12个字符",
    "username.valid.regex": "成员编号仅支持字母、数字和下划线",
    "validCode.fetch": "获取验证码",
    "validCode.email": "邮件验证码",
    "validCode.shortMessage": "短信验证码",
    "variable.available": "可用变量",
    "variable.available.empty": "无可用变量",
    "saveInfo.saveTitle": "{{- key}}有修改，是否保存？",
    "saveInfo.saveMsg": "您修改了{{- key}}但没有保存，是否需要保存{{key}}并继续？",
    "saveInfo.save": "保存并继续",
    "saveInfo.cancel": "不保存",
    "saveInfo.fail": "保存失败",
    "saveInfo.success": "保存成功",
    "saveInfo.update.save": "修改已保存",
    "saveInfo.setting": "保存设置",
    "signature.tip": "扫描二维码，添加签名",
    "signature.add": "添加签名",
    "subform.maxCountTip": "子表单数据量已超过{{limit}}条最大限制",
    "subform.dataExistTip": "该条记录存在数据，数据删除后将无法恢复，确定删除？",
    "subform.mobileLocation": "移动端获取当前位置",
    "share.toQQ": "转发至QQ空间",
    "share.toRenRen": "转发至人人网",
    "share.toSina": "转发至新浪微博",
    "share.toDouBan": "转发至豆瓣",
    "share.toMingDao": "转发至明道",
    "title.appSet": "应用设置-{{- name}}",
    "title.dash": "新报表设计-{{- name}}",
    "title.form": "{{- title}}-{{- name}}",
    "title.page": "{{- title}}",
    "title.profile": "{{- title}}-账户中心",
    "title.report": "报表设计-{{- name}}",
    "upload.browserNotSupportTip": "您使用的浏览器版本过低，无法使用文件上传功能！",
    "upload.maxLimitTip": "文件大小超出限制",
    "upload.maxLimitTip0": "不允许上传0KB文件",
    "upload.maxSizeTip": "文件大小不得超过 {{size}} MB",
    "upload.failTip": "文件上传失败",
    "upload.success": "上传成功",
    "upload.fail": "上传失败",
    "upload.redo": "重新上传",
    "user.select": "点击选择成员",
    "user.searchEmpty": "暂无相关成员",
    "user.searchEmpty.resigned": "暂无相关已删除人员",
    "user.empty": "没有可选成员",
    "user.empty.resigned": "没有已删除人员",
    "upload.notSupportFileTip": "不支持选择的文件类型",
    "vip.systemLimitTip": "{{day}}天后系统将会受限。",
    "vip.advancedFeatures": "查看高级功能介绍",
    "vip.error.title.upgrade": "使用该功能需要升级版本，您是否要立即升级？",
    "vip.error.title.limit": "系统用量受到限制，您是否要立即升级？",
    "vip.error.7104.msg": "聚合表数量已达上限，您可以至会员中心查看版本使用情况和升级版本，或删除无用聚合表后再进行新建。",
    "vip.error.7104.memMsg": "聚合表数量已达上限，请联系企业创建者升级版本后再使用该功能。",
    "vip.error.7105.msg": "你所安装的应用中聚合表数量超出当前版本限制。请联系企业创建者升级版本后再安装应用。",
    "vip.error.7110.msg": "成员数量已超出上限，为了不影响您的正常使用，请尽快升级系统，否则系统将被禁用。",
    "vip.error.7110.memMsg": "成员数量已超出上限，请联系企业创建者升级版本。",
    "vip.error.7111.msg": "成员数量超出限制。您可以至会员中心查看版本使用详情和升级版本，以同步/邀请更多成员。",
    "vip.error.7111.memMsg": "成员数量超出限制。请联系创建者升级版本以同步/邀请更多成员。",
    "vip.error.7112.msg": "您当前使用的版本不包含自定义打印功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7112.memMsg": "您当前使用的版本不包含自定义打印功能，请联系企业创建者升级版本。",
    "vip.error.7113.msg": "自定义打印模板数量已达上限，您可以至会员中心查看版本使用情况和升级版本，或删除无用自定义打印模板后再进行新建。",
    "vip.error.7113.memMsg": "自定义打印模板数量已达上限，请联系企业创建者升级版本后再新建。",
    "vip.error.7114.msg": "您所安装的应用中自定义打印模板数量超出当前版本限制。请联系企业创建者升级版本后再安装应用。",
    "vip.error.7120.msg": "您当前使用的版本不包含数据推送功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7120.memMsg": "您当前使用的版本不包含数据推送功能，请联系企业创建者升级版本。",
    "vip.error.7121.msg": "您当前使用的版本不包含数据回收站功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7122.msg": "您当前使用的版本不包含导出附件功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7122.memMsg": "您当前使用的版本不包含导出附件功能，请联系企业创建者升级版本。",
    "vip.error.7123.msg": "您当前使用的版本不包含跨应用功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7123.memMsg": "您当前使用的版本不包含跨应用功能，请联系企业创建者升级版本。",
    "vip.error.7124.msg": "您当前使用的版本不包含自动同步功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7125.msg": "您当前使用的版本不包含自定义提交成功页面功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7125.memMsg": "您当前使用的版本不包含自定义提示页面功能，请联系企业创建者升级版本。",
    "vip.error.7130.msg": "您使用的当前版本中不包含手写签名功能，您可至会员中心查看版本详情和升级版本",
    "vip.error.7130.memMsg": "您当前使用的版本不包含手写签名功能，请联系企业创建者升级版本。",
    "vip.error.7132.msg": "数据流数量已达上限，您可以至会员中心查看版本使用情况和升级版本，或删除无用数据流后再进行新建。",
    "vip.error.7132.memMsg": "数据流数量已达上限，请联系企业创建者升级版本。",
    "vip.error.7133.msg": "数据流数量已超出当前版本限制，为避免系统受限影响您的正常使用，您可以点击查看详情删除无用数据流。",
    "vip.error.7133.memMsg": "数据流数量已超上限，请联系企业创建者升级版本或调整系统用量。",
    "vip.error.7134.msg": "您使用的当前版本中不包含智能助手功能，您可至会员中心查看版本详情和升级版本",
    "vip.error.7134.memMsg": "您所使用的版本不包含智能助手功能，请联系企业创建者升级版本。",
    "vip.error.7135.msg": "智能助手数量已达上限，您可以至会员中心查看版本使用情况和升级版本，或删除无用的智能助手后再进行新建。",
    "vip.error.7135.memMsg": "智能助手数量已达上限，无法新建智能助手。",
    "vip.error.7136.msg": "智能助手数量已超出当前版本限制，为避免系统受限影响您的正常使用，请点击查看详情删除无用智能助手。",
    "vip.error.7136.memMsg": "智能助手数量超出限制，请联系企业创建者升级版本或调整系统用量。",
    "vip.error.7139.msg": "您当前使用的版本不包含自定义样式功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7139.memMsg": "您当前使用的版本不包含自定义样式功能，请联系企业创建者升级版本。",
    "vip.error.7140.msg": "您当前使用的版本不包含自定义登录页功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7141.msg": "您当前使用的版本不包含单点登录功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7142.msg": "您当前使用的版本不包含数据预警功能，您可以至会员中心查看版本使用详情和升级版本。",
    "vip.error.7142.memMsg": "当前版本无法使用数据预警功能，请联系企业创建者升级版本",
    "vip.error.7212.msg": "表格中的数据条数已超出本月数据流量限制，请升级版本。",
    "vip.error.7212.memMsg": "表格中的数据条数已超出本月数据流量限制，请联系账号创建者升级版本。",
    "vip.pack.free": "免费版",
    "vip.pack.trial": "试用版",
    "vip.pack.lite": "青春版",
    "vip.pack.std": "标准版",
    "vip.pack.user": "按用户数购买",
    "vip.pack.pro": "专业版",
    "vip.pack.ent": "企业版",
    "vip.pack.logo": "去LOGO版",
    "vip.pack.oem": "定制版",
    "vip.pack.title": "有哪些版本可以选择",
    "vip.pack.detail": "版本明细",
    "vip.pack.oem.hotLine": "请致电：400-011-1850",
    "vip.pack.submit.request": "提交需求",
    "vip.pack.price": "{{price}}起/年",
    "vip.pack.count.title": "版本容量",
    "vip.pack.users": "用户数",
    "vip.pack.userPrice": "用户数增购单价",
    "vip.pack.userPriceUnit": "￥{{ price }}/人/年",
    "vip.pack.appCount": "应用数",
    "vip.pack.priceLimit": "不可增购",
    "vip.pack.manager.tip": "子管理员分为系统管理员和普通管理员，系统管理员拥有所有管理权限，普通管理员则可以实现企业的分级管理，拥有定向管理应用和部门的权限。如您需要在版本的基础上额外购买子管理员数量，请与我们联系：400-011-1850。",
    "vip.pack.manager.count": "{{count}}个子管理员 + {{sysCount}}个系统管理员",
    "vip.pack.manager.sysCount": "{{count}}个系统管理员",
    "vip.pack.formData.tip": "单个表单内最多储存的数据条数。",
    "vip.pack.data.freeTip": "（1000条/月）",
    "vip.pack.file.title": "每年可上传附件总量",
    "vip.pack.file.tip": "附件上传后即占用附件总量，删除已上传的附件不会减少已使用的附件总量。",
    "vip.pack.aggregate.tip": "对数据进行聚合汇总，聚合结果可被表单、报表调用。",
    "vip.pack.aggregate.count": "每个应用{{count}}个",
    "vip.pack.dataBackup": "数据回收/恢复",
    "vip.pack.dataBackup.tip": "保留限定天数内删除的数据，可恢复被误删除的数据。回收站中的数据不计入数据量且仅在回收站中可见。",
    "vip.pack.etl.tip": "数据视图可以对数据进行预处理，完成复杂的数据建模。",
    "vip.pack.trigger.tip": "智能助手可以在表单数据发生变动时，自动在另一张表单中增加或修改数据。",
    "vip.pack.feature.basic": "基础功能",
    "vip.pack.log.tip": "去除表单外链底部平台的logo。",
    "vip.pack.userSync": "自动同步用户",
    "vip.pack.userSync.tip": "企业号和钉钉模式下可自动进行成员同步，保持与集成账号通讯录一致。",
    "vip.pack.user.tip": "每个版本使用人数上限，付费版本可单独增购用户数",
    "vip.pack.appBridge.tip": "可从同一个账号内的其他应用的表单中调取数据。",
    "vip.pack.signature.tip": "手写签名将消耗极少量附件量，1M附件量可签名约100次。",
    "vip.pack.sso.tip": "与企业其他业务系统对接，实现一套账号登录多个系统（仅针对公共模式账号）。",
    "vip.pack.service": "服务项目",
    "vip.pack.baseService.tip": "加¥2500/年可升级高级服务",
    "vip.pack.support.base": "普通技术支持",
    "vip.pack.support.gold": "高级技术支持",
    "vip.pack.service.date": "服务时间",
    "vip.pack.service.dateBasic": "工作日：09:00-17:30",
    "vip.pack.service.dateGold1": "工作日：09:00-20:00",
    "vip.pack.service.dateGold2": "双休日：10:00-17:00",
    "vip.pack.doc": "文档/应用模板",
    "vip.pack.feature": "可用功能",
    "vip.pack.contact.title": "没有找到适合您的版本?",
    "vip.pack.contact.info": "请提交您的版本定制需求，我们的产品顾问会尽快与您联系。",
    "vip.pack.contact": "咨询我们",
    "vip.pack.submit": "提交版本定制需求",
    "vip.pack.hotLine": "咨询电话：400-011-1850",
    "vip.pack.bi.info": "平台同时提供私有云产品（平台报表FineReport／平台商业智能FineBI），帮助企业快速搭建数据采集、处理和可视化的一站式大数据分析平台。",
    "vip.pack.wechatTip": "您登录的不是企业创建者账号，无法完成购买，请从企业微信管理后台进入平台购买。",
    "vip.pack.dingtalkTip": "您登录的不是企业创建者账号，无法完成购买，请从钉钉管理后台进入平台购买。",
    "vip.pack.error.title": "请登录企业创建者账号后购买",
    "vip.pack.order.title": "您是否要立即处理？",
    "vip.pack.order.msg": "存在未支付的订单，请先支付或关闭已存在的订单再进行购买",
    "vip.pack.order.tip": "存在未支付的订单，您需要先支付或取消，才能创建新订单",
    "vip.pack.order.ok": "立即处理",
    "vip.pack.order.cancel": "稍后处理",
    "vip.service.basic.name": "基本服务",
    "vip.service.advanced.name": "高级服务",
    "vip.service.silver.description": "+2500元升级高级服务",
    "vip.center": "版本信息",
    "vip.center.renewNow": "立即续费",
    "vip.center.trial": "试用高级版",
    "vip.center.purchase": "购买",
    "vip.center.upgradePack": "升级版本",
    "vip.center.service.purchase": "购买高级服务",
    "vip.center.pack.purchase": "购买版本",
    "vip.center.contact": "联系我们",
    "vip.center.service": "服务等级",
    "vip.center.service.basicDescription": "升级版本可享受一对一专属客服",
    "vip.center.service.silverDescription": "最高服务等级，如需帮助，请联系我们。",
    "vip.center.logo": "外链去LOGO",
    "vip.center.logo.normal": "无法使用外链表单去Logo功能，如有需要，请升级版本。",
    "vip.center.logo.used": "可使用外链去Logo功能。",
    "vip.center.manager": "子管理员",
    "vip.center.timeStart": "即日起",
    "vip.center.manager.normal": "当前版本只能使用{{managers}}个子管理员和{{sysManagers}}个系统管理员，如需更多子管理员，请联系我们单独购买。",
    "vip.center.manager.free": "当前版本只能使用{{managers}}个系统管理员，如需要更多子管理员，请升级版本。",
    "vip.center.aggregate": "聚合表",
    "vip.center.aggregate.free": "每个应用中可使用{{num}}个聚合表，如需更多聚合表，请联系升级版本。",
    "vip.center.aggregate.normal": "每个应用中可使用{{num}}个聚合表，如需更多聚合表，请联系我们单独购买。",
    "vip.center.aggregate.trial": "免费版一个应用中可新建一张聚合表，为确保试用到期后正常使用，请根据使用情况升级合适的版本。",
    "vip.center.aggregate.trialOver": "试用版一个应用中可新建{{num}}张聚合表，您的当前用量已超试用版限制，请调整系统用量或根据使用情况升级合适的版本。",
    "vip.center.aggregate.used": "每个应用中可使用{{num}}个聚合表。",
    "vip.center.aggregate.total": "当前版本每个应用可使用{{num}}个聚合表",
    "vip.center.customLogin": "自定义登录页",
    "vip.center.customLogin.normal": "无法使用自定义登录页功能，如有需要，请联系我们单独购买。",
    "vip.center.customLogin.used": "可使用自定义登录页功能。",
    "vip.center.formData": "表单数据上限",
    "vip.center.formData.normal": "单表数据上限为{{num}}万条，如需提高单表数据上限，请联系我们单独购买。",
    "vip.center.formData.free": "单表数据上限为{{num}}万条，如需提高单表数据上限，请升级版本。",
    "vip.center.formData.trial": "免费版单表数据上限为2万条，为确保试用到期后正常使用，请根据使用情况升级合适的版本。",
    "vip.center.formData.trialOver": "试用版用量限制为{{num}}万条，您的当前用量已超试用版限制，请调整系统用量或根据使用情况升级合适的版本。",
    "vip.center.formData.used": "单表数据上限为{{num}}万条",
    "vip.center.formData.total": "当前版本表单数据上限为{{num}}万条",
    "vip.center.dataBackup": "数据回收站",
    "vip.center.dataBackup.invalid": "无法使用数据回收站功能，如有需要，请升级版本。升级后可恢复升级前15天内删除的数据。",
    "vip.center.dataBackup.normal": "数据回收站可将删除后的数据保留{{num}}天，如需保存更长时间，请联系我们单独购买。",
    "vip.center.dataBackup.free": "数据回收站可将删除后的数据保留{{num}}天，如需保存更长时间，请升级版本。",
    "vip.center.dataBackup.trial": "免费版不包含此功能，为确保试用到期后正常使用，请根据使用情况升级合适的版本。",
    "vip.center.dataBackup.used": "数据回收站可将删除后的数据保留{{num}}天。",
    "vip.center.appBridge": "跨应用",
    "vip.center.appBridge.normal": "无法使用跨应用功能，如有需要，请升级版本。",
    "vip.center.appBridge.used": "可跨应用调取数据或执行智能助手。",
    "vip.center.userSync": "成员自动同步",
    "vip.center.userSync.normal": "无法使用成员自动同步功能，如有需要，请升级版本。",
    "vip.center.userSync.used": "可使用成员自动同步功能。",
    "vip.center.print": "自定义打印",
    "vip.center.print.normal": "无法使用自定义打印功能，如有需要，请升级版本。",
    "vip.center.print.used": "当前版本的自定义打印模板数量无限制，可根据不同场景设置不同的打印模板。",
    "vip.center.print.limit": "当前版本可使用一个自定义打印模板，如需使用更多自定义打印模板，请升级版本。",
    "vip.center.print.total": "当前版本所有应用可使用{{num}}个打印模板",
    "vip.center.print.total.empty": "当前版本不支持自定义打印模板",
    "vip.center.print.total.unlimited": "当前版本的自定义打印模板数量无限制",
    "vip.center.print.emptyTip": "没有自定义打印模板",
    "vip.center.fileZip.normal": "无法使用批量导出附件功能，如有需要，请升级版本。",
    "vip.center.fileZip.used": "可使用批量导出附件功能。",
    "vip.center.sso": "单点登录",
    "vip.center.sso.normal": "无法使用单点登录功能，如有需要，请联系我们单独购买。",
    "vip.center.sso.used": "可使用单点登录功能。",
    "vip.center.submitPrompt": "自定义提交成功页面",
    "vip.center.submitPrompt.normal": "无法使用自定义提交成功页面功能，如有需要，请升级版本。",
    "vip.center.submitPrompt.used": "可使用自定义提交成功页面功能。",
    "vip.center.signature": "手写签名",
    "vip.center.signature.normal": "无法使用手写签名功能，如有需要，请升级版本。",
    "vip.center.signature.used": "可使用手写签名功能。",
    "vip.center.theme": "自定义表单外链样式",
    "vip.center.theme.normal": "无法使用自定义表单外链样式功能，如有需要，请升级版本。",
    "vip.center.theme.used": "可使用自定义表单外链样式功能。",
    "vip.center.threshold": "报表数据预警",
    "vip.center.threshold.normal": "无法使用报表数据预警功能，如有需要，请升级版本。",
    "vip.center.threshold.used": "可使用报表数据预警功能。",
    "vip.center.dataAPI.normal": "无法使用数据接口（API）功能，如有需要，请联系我们单独购买。",
    "vip.center.dataAPI.used": "可使用数据接口（API）功能。",
    "vip.center.etl": "数据视图",
    "vip.center.etl.free": "所有应用共可使用{{num}}个数据流，如需更多数据流，请升级版本。",
    "vip.center.etl.normal": "所有应用共可使用{{num}}个数据流，如需更多数据流，请联系我们单独购买。",
    "vip.center.etl.trial": "免费版所有应用共可使用{{num}}个数据流，为确保试用到期后正常使用，请根据使用情况升级合适的版本。",
    "vip.center.etl.trialOver": "试用版所有应用共可使用{{num}}个数据流，您的当前用量已超试用版限制，请调整系统用量或根据使用情况升级合适的版本。",
    "vip.center.etl.total": "当前版本所有应用可使用{{num}}个数据流",
    "vip.center.etl.emptyTip": "没有数据流",
    "vip.center.trigger": "智能助手",
    "vip.center.trigger.free": "所有应用共可使用{{num}}个智能助手，如需更多智能助手，请升级版本。",
    "vip.center.trigger.normal": "所有应用共可使用{{num}}个智能助手，如需更多智能助手，请联系我们单独购买。",
    "vip.center.trigger.trial": "免费版所有应用共可使用{{num}}个智能助手，为确保试用到期后可以正常使用，请根据使用情况升级合适的版本。",
    "vip.center.trigger.trialOver": "试用版所有应用共可使用{{num}}个智能助手，您的当前用量已超试用版限制，请调整系统用量或根据使用情况升级合适的版本。",
    "vip.center.trigger.total": "当前版本所有应用可使用{{num}}个智能助手",
    "vip.center.trigger.emptyTip": "没有智能助手",
    "vip.center.pack.buffer": "{{pack}}—缓冲期",
    "vip.center.pack": "会员版本",
    "vip.center.current": "（当前版本）",
    "vip.center.sysCount": "系统容量",
    "vip.center.feature": "高级功能",
    "vip.center.feature.purchase": "升级版本，享受更多高级功能",
    "vip.center.feature.desc": "高级功能介绍",
    "vip.center.serviceLevel": "当前服务",
    "vip.center.overflow": "已超量",
    "vip.center.limit": "已超限",
    "vip.center.limitTip": "您的系统用量已超出当前版本限制，部分高级功能已禁用。为避免系统受限给您的使用造成影响，请尽快调整系统用量，或升级更高版本。",
    "vip.center.sysOutage": "系统已停用",
    "vip.center.sysOutageTip": "您的系统用量已超出当前版本限制，系统整体已停用。为避免系统停用给您的使用造成影响，请尽快调整系统用量，或升级更高版本。",
    "vip.center.custom": "定制更高版本",
    "vip.center.vip.contact": "联系技术支持",
    "vip.center.service.basic": "基础服务",
    "vip.center.service.get": "升级高级服务",
    "vip.center.service1Text": "帮助中心 & 模板中心",
    "vip.center.service1Info": "提供丰富的资料供您学习",
    "vip.center.service2Text": "普通技术支持服务（在线&电话）",
    "vip.center.service2Text.advance": "高级技术支持服务（在线&电话）",
    "vip.center.service2Info": "多种高效的咨询渠道，确保您的问题得到及时处理",
    "vip.center.service2Info.advance": "多种高效的咨询渠道&资深的技术人员，确保您的问题得到及时专业的处理",
    "vip.center.service3Text": "基础服务时间",
    "vip.center.service3Text.advance": "超长服务时间",
    "vip.center.service3Info": "工作日 9:00-17:30",
    "vip.center.service3Info.advance": "工作日 9:00-17:30, 周末10:00-17:00，除法定节假日外全年无休",
    "vip.center.service.advance.tip": "升级至高级服务后，您可获得由资深技术支持提供的全年无休的服务（法定节假日除外）",
    "vip.center.qrcode": "扫码关注平台公众号",
    "vip.center.corpText1": "不错过每一次功能更新",
    "vip.center.corpText2": "获取最新客户案例",
    "vip.center.corpText3": "在微信里咨询在线客服",
    "vip.center.hotLine": "服务热线：400-011-1850",
    "vip.center.businessLine": "市场合作：400-011-1850",
    "vip.center.pack.start": "开通时间：{{startDate}}",
    "vip.center.pack.expireTip": "（版本到期后将变为免费版）",
    "vip.center.pack.expire": "到期时间：{{expireDate}}",
    "vip.center.user.noLimit": "不限人数",
    "vip.center.user.trialLimit": "（试用到期后限制为{{user}}人，请及时升级）",
    "vip.center.user": "{{users}}人",
    "vip.center.users": "用户量",
    "vip.center.user.used": "已用：{{users}}人",
    "vip.center.user.all": "总量：{{users}}",
    "vip.center.user.exceeded": "已超出限制",
    "vip.center.user.purchase": "购买用户量",
    "vip.center.exceededTip": "用量已超过当前版本限制，请尽快升级或调整用量",
    "vip.center.exceeded": "用量已超过当前版本限制，请尽快升级",
    "vip.center.version.privilege": "会员特权",
    "vip.center.file": "附件上传量",
    "vip.center.file.used": "当年已用：{{files}}",
    "vip.center.file.all": "每年总量：{{files}}",
    "vip.center.data": "总数据量",
    "vip.center.data.used": "已用：{{data}}",
    "vip.center.data.all": "总量：{{data}}",
    "vip.center.monthData": "每月数据提交量",
    "vip.center.monthData.used": "当月已用：{{monthData}}",
    "vip.center.monthData.all": "每月总量：{{monthData}}（每月1日重置）",
    "vip.center.dataCount": "{{count}}条",
    "vip.center.dataCount.tenThousands": "{{count}}万条",
    "vip.center.manager.count": "{{managers}}个子管理员",
    "vip.center.sms.used": "当前可用短信条数：{{-count}}条",
    "vip.center.sms.count": "短信条数",
    "vip.center.sms.count.tip": "注册即送5条短信，如需更多短信条数可在产品内自行选购",
    "vip.center.sysManager.presented.count": "{{managers}}个赠送的系统管理员",
    "vip.center.sysManager.count": "{{managers}}个系统管理员",
    "vip.center.manager.exceededTip": "您的子管理员已达到{{managers}}个",
    "vip.center.aggregate.count": "{{aggregate}}个/应用",
    "vip.center.aggregate.exceededTip": "您的聚合表最高已达到{{aggregate}}个/应用",
    "vip.center.formData.exceededTip": "您的单表数据量已达到{{count}}万条",
    "vip.center.dataBackup.count": "{{count}}天",
    "vip.center.print.unlimited": "无限制",
    "vip.center.print.exceededTip": "已使用{{count}}个自定义打印模板",
    "vip.center.print.count": "{{count}}个",
    "vip.center.etl.count": "{{count}}个数据流",
    "vip.center.etl.exceededTip": "您的数据流最高已达到{{count}}个",
    "vip.center.trigger.exceededTip": "已使用{{count}}个智能助手",
    "vip.center.data.purchase": "购买数据总量",
    "vip.center.dingTalkTrial.tip": "您需要在钉钉应用市场中升级平台。",
    "vip.center.dingTalkTrial.detail": "请在手机上打开钉钉，进入应用市场升级平台。",
    "vip.center.wechatCorpTrial.tip": "您需要在企业微信应用市场中升级平台",
    "vip.center.wechatCorpTrial.detail": "请用电脑访问企业微信管理后台，升级平台",
    "vip.center.renewAddon": "高级功能续费",
    "vip.center.renewAddon.fail.info": "您的高级功能未续费，无法完成购买",
    "vip.center.renewAddon.fail.tip": "请续费高级功能后重新购买。",
    "vip.center.align.tip": "增购功能已过期",
    "vip.center.upgradeTip.dingtalk": "剩余{{count}}天到期，为了不影响使用请至钉钉应用市场升级",
    "vip.center.upgradeTip.wechatCorp": "剩余{{count}}天到期，为了不影响使用请至企业微信应用市场升级",
    "vip.center.renewTip.dingtalk": "已超期，为了不影响使用请至钉钉应用市场续费",
    "vip.center.renewTip.wechatCorp": "已超期，为了不影响使用请至企业微信应用市场续费",
    "vip.template.title": "恭喜您，领取成功！",
    "vip.template.description": "您已领取{{day}}天试用期，我们为您准备了高级功能使用示例模板，立刻安装体验吧～",
    "vip.template.install": "安装使用",
    "vip.trial.no": "暂不试用",
    "vip.trial.success": "领取成功",
    "vip.trial.start": "开始试用",
    "vip.trial.time": "您已领取平台高级功能{{day}}天试用期。",
    "vip.trial.expire.tip": "您的试用版即将到期，到期后高级功能不可使用，请及时升级版本",
    "vip.trial.install": "成功领取{{day}}天试用期，您可以返回继续安装应用。",
    "vip.trial.tip": "您登录的不是企业创建者账号，无法领取试用，请登录企业创建者账号后领取。",
    "vip.trial.dingtalkTip": "您登录的不是企业创建者账号，无法领取试用，请从钉钉管理后台进入平台领取试用。",
    "vip.trial.wechatTip": "您登录的不是企业创建者账号，无法领取试用，请从企业微信管理后台进入平台领取试用。",
    "vip.trial.error.title": "请登录企业创建者账号后领取试用",
    "vip.upgrade.no": "暂不升级",
    "vip.upgrade.yes": "立即升级",
    "vip.use.start": "开始使用",
    "vip.usage.aggregate": "聚合表数量：",
    "vip.usage.aggregate.tip": "以下为聚合表超出限制的应用，请在各应用中删除无用聚合表或升级版本。",
    "vip.usage.aggregate.empty": "当前没有任何聚合表，请点击此处创建聚合表",
    "vip.usage.data": "数据量：",
    "vip.usage.data.count": "{{count}}万",
    "vip.usage.data.tip": "以下为数据量超出限制的表单，请在各表单中删除无用数据或升级版本。",
    "vip.usage.etl": "数据流数量：",
    "vip.usage.etl.overflow.tip": "以下为使用了数据流的应用，请及时在各应用中删除无用数据流或升级版本。",
    "vip.usage.etl.tip": "以下为使用了数据流的应用，点击查看即可进入该应用了解详情。",
    "vip.usage.print": "打印模板数量：",
    "vip.usage.print.overflow.tip": "以下为使用了打印模板的表单，请及时在各表单中删除无用打印模板或升级版本。",
    "vip.usage.print.tip": "以下为使用了打印模板的表单，点击查看即可进入该表单了解详情。",
    "vip.usage.trigger": "智能助手数量：",
    "vip.usage.trigger.overflow.tip": "以下为使用了智能助手的应用，请及时在各应用中删除无用智能助手或升级版本。",
    "vip.usage.trigger.tip": "以下为使用了智能助手的应用，点击查看即可进入该应用了解详情。",
    "view.click": "点击查看",
    "view.detail": "查看详情",
    "view.help": "查看帮助",
    "view.helpCenter": "查看帮助文档",
    "view.detailReason": "查看详细原因",
    "weChat.bind": "绑定微信",
    "weChat.unBind": "解绑企业微信",
    "weChat.authorization": "企业微信应用授权",
    "weChat.contacts.auth.title": "企业微信通讯录授权",
    "weChat.contacts.auth.tip": "企业微信通讯录授权方式变更，为保证通讯录正常同步，请尽快处理。",
    "weChat.contacts.auth.description": "因企业微信通讯录同步方式变更，您需要授权后同步通讯录。请输入以下信息完成授权。",
    "weChat.contacts.auth.description.id": "agent_id和agent_secret获取方法，请参考",
    "weChat.contacts.auth.success": "授权成功",
    "weChat.contacts.auth.fail": "授权失败，请重试",
    "weChat.contacts.auth.repeat": "您已成功授权，请勿重复操作",
    "weChat.contacts.auth.close.tip": "您可以稍后在「通讯录」中完成授权",
    "weChat.contacts.agentId.notEmpty": "agent_id不能为空",
    "weChat.contacts.agentSecret.notEmpty": "agent_secret不能为空",
    "view.byPass": "凭密码查看",
    "widget.address": "地址",
    "widget.address.district": "区/县",
    "widget.address.district.withMark": "(县/区)",
    "widget.address.detail": "请填写详细地址",
    "widget.address.detail.withMark": "(详细地址)",
    "widget.address.province": "省/自治区/直辖市",
    "widget.address.province.withMark": "(省/自治区/直辖市)",
    "widget.address.type.detail": "省-市-区-详细地址",
    "widget.address.type.district": "省-市-区",
    "widget.checkboxgroup": "复选框组",
    "widget.combo": "下拉框",
    "widget.combocheck": "下拉复选框",
    "widget.datetime": "日期时间",
    "widget.datetime.calendar": "日历",
    "widget.dept": "部门单选",
    "widget.dept.clickToSelect": "点击选择部门",
    "widget.dept.notSupportLink": "外链不支持部门字段",
    "widget.dept.listTitle": "部门列表",
    "widget.deptgroup": "部门多选",
    "widget.file.empty": "当前没有文件上传",
    "widget.file.maxCount": "最多允许选择{{num}}个文件",
    "widget.file.select": "选择文件",
    "widget.file.size": "文件大小：",
    "widget.file.uploaded": "上传完成",
    "widget.file.uploading": "正在上传...",
    "widget.file.uploadTime": "上传时间：",
    "widget.id": "字段ID",
    "widget.image": "图片",
    "widget.image.empty": "当前没有图片上传",
    "widget.image.maxCount": "最多允许选择{{num}}个图片",
    "widget.image.onlyCameraTip": "启用了「仅允许拍照上传」功能，该功能只支持微信服务号/企业微信和钉钉移动客户端",
    "widget.image.select": "选择图片",
    "widget.linkdata": "关联数据",
    "widget.linkdata.select": "选择数据",
    "widget.linkdata.empty": "没有符合条件的数据",
    "widget.linkquery": "关联查询",
    "widget.location": "定位",
    "widget.location.get": "获取当前位置",
    "widget.location.mobileOpen": "请在移动端打开表单获取位置信息",
    "widget.location.set": "定位设置",
    "widget.number": "数字",
    "widget.phone": "手机",
    "widget.phone.sms.disableInPreview": "预览时不支持手机验证",
    "widget.phone.sms.verify": "短信验证",
    "widget.phone.sms.count": "当前可用短信条数：{{count}}",
    "widget.phone.sms.verify.tip": "开启短信验证后，手机未通过验证的表单无法提交。短信验证将消耗短信条数，当短信条数为0时，表单将无法正常提交。",
    "widget.phone.sms.dingTalkTrial.tip": "当前为试用版，剩余{{- days}}天到期，到期后功能入口将被钉钉隐藏，如需继续使用请及时联系企业创建者升级版本。",
    "widget.phone.sms.wechatCorpTrial.tip": "当前为试用版，剩余{{- days}}天到期，到期后功能入口将被企业微信隐藏，如需继续使用请及时联系企业创建者升级版本。",
    "widget.phone.sms.code": "短信验证码",
    "widget.phone.sms.getCode": "获取验证码",
    "widget.phone.sms.getCodeAgain": "重新获取（{{second}}）",
    "widget.phone.sms.error": "短信验证码不正确",
    "widget.phone.not.purchase": "暂不购买",
    "widget.phone.now.purchase": "立即购买",
    "widget.phone.purchase.sms": "购买短信条数",
    "widget.phone.purchase.tip1": "短信余量过少，是否立即购买短信条数？",
    "widget.phone.purchase.tip2": "当前账号的可用短信条数不足100条，可能影响表单提交，您可以选择购买短信条数后再使用。",
    "widget.phone.purchase.tip3": "短信余量过少，请联系企业创建者购买短信条数",
    "widget.phone.purchase.tip4": "当前账号的可用短信条数不足100条，可能影响表单提交，您可以联系企业创建者购买短信条数后再使用。",
    "widget.phone.purchase.tip5": "短信余量为0，是否立即购买短信条数？",
    "widget.phone.purchase.tip6": "当前账号的可用短信条数为0条，无法开启短信验证功能。如需继续使用该功能，您可以选择购买短信条数后再开启。",
    "widget.phone.purchase.tip7": "短信余量为0，无法开启短信验证",
    "widget.phone.purchase.tip8": "当前账号的可用短信条数为0条，无法开启短信验证功能。如需使用该功能，请联系企业创建者购买短信条数。",
    "widget.phone.purchase.tip9": "请联系企业创建者购买短信条数",
    "widget.phone.validate.success": "已验证",
    "widget.radiogroup": "单选按钮组",
    "widget.separator": "分割线",
    "widget.signature": "手写签名",
    "widget.signature.rewrite": "重新手写",
    "widget.signature.useSaved.tip": "您要使用以下签名吗？",
    "widget.sn": "流水号",
    "widget.sn.count.num": "计数位数",
    "widget.sn.count.numText": "{{num}}位数字",
    "widget.sn.count.duration": "重置周期",
    "widget.sn.count.start": "初始值",
    "widget.sn.count.fix": "固定位数",
    "widget.sn.createTime.format": "提交日期显示格式",
    "widget.sn.oneTip": "表单中仅可添加一个流水号字段",
    "widget.sn.placeholder": "自动生成无需填写",
    "widget.sn.reset.empty": "不自动重置",
    "widget.sn.reset.emptyTip": "仅当计数达到最大值时，从0开始重新计数。",
    "widget.sn.reset.day": "每日重置",
    "widget.sn.reset.dayTip": "每日00:00:00，自动从初始值重新开始计数。一天内如果计数达到最大值，从0开始重新计数。",
    "widget.sn.reset.week": "每周重置",
    "widget.sn.reset.weekTip": "每周一00:00:00，自动从初始值重新开始计数。一周内如果计数达到最大值，从0开始重新计数。",
    "widget.sn.reset.month": "每月重置",
    "widget.sn.reset.monthTip": "每月首日00:00:00，自动从初始值重新开始计数。一月内如果计数达到最大值，从0开始重新计数。",
    "widget.sn.reset.year": "每年重置",
    "widget.sn.reset.yearTip": "每年首日00:00:00，自动从初始值重新开始计数。一年内如果计数达到最大值，从0开始重新计数。",
    "widget.sn.rule": "流水号规则",
    "widget.sn.rule.confirm": "若删除自动计数，现有的计数记录将无法延续。确定删除？",
    "widget.sn.start.tip": "请输入初始值",
    "widget.subform": "子表单",
    "widget.subform.addTip": "从左侧拖拽来添加字段",
    "widget.subform.allowBlank": "请填写至少一条记录",
    "widget.text": "单行文本",
    "widget.text.error.id": "请输入正确的身份证号码",
    "widget.text.error.mobile": "请输入正确的手机号码",
    "widget.text.error.tel": "请输入正确的电话号码",
    "widget.text.error.zip": "请输入正确的邮政编码",
    "widget.text.error.email": "请输入正确的电子邮箱",
    "widget.text.error.time": "请输入正确的时间格式",
    "widget.number.error.range1": "请输入小于等于{{n}}的数字",
    "widget.number.error.range2": "请输入大于等于{{n}}的数字",
    "widget.number.error.range3": "请输入{{n}}={{n1}}之间的数字",
    "widget.textarea": "多行文本",
    "widget.upload": "附件",
    "widget.user": "成员单选",
    "widget.user.listTitle": "成员列表",
    "widget.user.notSupportLink": "外链不支持成员字段",
    "widget.user.current": "当前用户",
    "widget.user.anonymous": "匿名用户",
    "widget.multiText.placeholder": "添加筛选值",
    "widget.multiText.placeholder.tip1": "添加自定义值",
    "widget.usergroup": "成员多选",
    "widget.timepicker.placeholder": "请设置自定义范围",
    "widget.web.page": "外部网页",
    "dashboard.title": "工作台",
    "module": "功能插件",
    "team.status.owned": "我创建的",
    "team.status.joined": "我加入的",
    "allapp": "全部",
    "app.creategroup": "新建分组",
    "app.othergroup": "其他常用分组",
    "login.return": "返回账号登录",
    phoneValidCode: "手机验证码",
    emailValidCode: "邮箱验证码",
    "time.countdown": "倒计时",
    "time.receive": "没收到？",
    resubmit: "重新发送",
    "verification.code": "请输入验证码",
    "Under.submission": "提交中...",
    "Has.sent": "已发送",
    "System.error": "系统错误，稍后再试",
    "fill.Email": "请填写Email地址",
    "fill.account": "请填写您的账号",
    "fill.password": "请填写您的密码",
    "password.long": "登录密码长度为6-16个字符",
    "phone.exists": "当前手机号码已存在，是否直接绑定已有账号？",
    "contact.technician": "系统错误,请联技术人员",
    basics: "基础",
    "vip.management": "会员管理",
    finance: "财务",
    recharge: "充值",
    "bills.consumption.details": "账单详情",
    "control.over.invoices": "开票记录",
    "purchased.module": "已购插件",
    "data.statistics": "数据统计",
    security: "安全",
    "operational.log": "操作日志",
    "security.setting": "安全设置",
    "head.portrait": "头像",
    "change.avatar": "更换头像",
    "replacement.failed": "用户头像更换失败！",
    "replacement.successful": "用户头像更换成功！",
    "picture.preview": "图片预览：",
    "picture.reset": "复位",
    "picture.rotate": "旋转",
    "picture.rotate.left": "向左旋转",
    "picture.rotate.right": "向右旋转",
    "picture.open.org": "查看原图",
    "picture.commutation": "换向",
    "current.balance": "当前余额",
    "yun.coin": "云币",
    replacement: "更换",
    "team.model": "团队模式",
    "current.package": "当前套餐",
    "membership.version": "会员版",
    "maturity.time": "到期时间",
    permanent: "永久",
    temporary: '临时',
    "buying.Members": "购买会员",
    "upper.limit.user": "成员数量上限(个)",
    ge: "个",
    tiao: "条",
    "number.invited.user": "已邀请成员数：",
    "upper.form.data": "所有表单数据量上限(条)",
    "total.upload.flow": "上传总流量(年)",
    used: "已使用：",
    usedst: "已使用",
    "data.view.user": "数据视图(个)",
    "total.user": "总量：",
    "create.apiKey": "创建 API Key",
    "click.view.apiKey": "点击查看API Key",
    "api.administrator.account": "WebAPI与您的管理员账户具有相同的权限",
    "api.reset": "重置API Key",
    "api.delete.user": "删除API Key",
    "enter.login.password": "请输入登录密码",
    "import.excel.size": "导入单个Excel文件大小",
    "maximum.import.execl": "单个Execl表导入的最大值 ",
    "single.upload.size": "单个上传附件大小",
    "maximum.upload.size": "单个上传附件大小的最大值 ",
    "recycling.bin.data": "回收站数据",
    "maximum.retention.data": "回收数据保留天数最大值",
    "allow.export": "允许导出",
    "not.allow.export": "不允许导出",
    "recharge.amount": "请输入充值金额",
    "recharge.method": "请选择充值方式",
    "public.payment": "对公支付",
    "immediate.recharge": "立即充值",
    "general.error": "{{ error }}",
    General: "通用",
    "delete.source.faild": "删除源码文件失败，错误信息：{{ error }}",
    "delete.log.faild": "删除日志文件失败，错误信息：{{ error }}",
    "rename.source.faild": "修改源码文件名称失败，错误信息：{{ error }}",
    "rename.log.faild": "修改日志文件名称失败，错误信息：{{ error }}",
    "rename.log.success": "修改日志文件名称成功",
    "rename.source.success": "修改源码文件名称成功",
    "copy.source.faild": "复制源码文件失败，错误信息：{{ error }}",
    "copy.log.faild": "复制日志文件失败，错误信息：{{ error }}",
    "copy.log.success": "复制日志文件成功",
    "copy.source.success": "复制源码文件成功",
    "create.source.faild": "新建源码文件失败，错误信息：{{ error }}",
    "create.source.success": "新建源码文件成功",
    "old.password": "旧密码",
    "confirm.new.password": "确认新密码",
    confirm: "确认",
    "error.password": "重复登录密码输入有误",
    "true.value": "请输入正确的数值",
    "installation.time": "安装时间",
    "installation.application": "安装应用",
    "installation.form": "安装表单",
    author: "作者",
    "version.number": "版本号",
    "sorry.module": "对不起，您还没有插件",
    "type.transaction": "交易类型",
    "type.operation": "操作类型",
    "ticket.issue": "出票",
    "send.out": "寄出",
    receipt: "收件",
    to: "至",
    start: "开始",
    end: "结束",
    user: "用户",
    project: "项目",
    content: "内容",
    "sorry.log": "您还没有操作日志",
    "name.buyer.payee": "抬头",
    "sorry.invoiced": "您还没有开票记录",
    "signed": "已签收",
    "check.carefully": "已寄出（请注意查收）",
    "ticketing.progress": "正在出票",
    "confirmation.receipt": "确认签收",
    "refusal.sign": "拒绝签收",
    "enter.correct.amount": "请输入正确的金额",
    "modify.login.password": "修改登录密码",
    "installed.module": "已安装插件",
    amount: "充值金额",
    "recharge.mode": "充值方式",
    "recharge.time": "充值时间",
    "recharge.total": "合",
    "logon.timeout": "登录超时,请重新登录",
    "recharge.system.error": "系统错误",
    "RMB.recharge": "人民币充值",
    "cancellation.invoice": "取消开票",
    "correct.order.number": "请输入正确的订单号",
    "transaction.time": "交易时间",
    "tickets.issued": "已出票",
    "no.need.invoice": "无需开票",
    "no.ticket.issued": "未出票",
    "activity.presentation": "活动赠送",
    "ten.thousand.data": "万条数据",
    "G.flow": "G流量",
    expire: "到期",
    "sorry.ordered": "您还没有订单",
    person: "人",
    "bby.group": "用户交流群",
    "application.customization": "申请定制",
    "online.service": "在线客服",
    "help.document": "帮助文档",
    "flow.visit.todo": "我的待办",
    "flow.visit.create": "我发起的",
    "flow.visit.cc": "抄送我的",
    "membership.purchase": "会员购买",
    "membership.upgrade": "会员版升级",
    "free.configuration": "自由配置",
    "user.number": "用户数/人",
    "contacts.number": "通讯录支持人数",
    "click.details": "点击详情",
    "already.have": "已拥有",
    "correct.tip": "请输入正确的数值,0为不购买。",
    "data.volume": "数据量/万",
    "total.number": "表单录入的数据支持的总条数",
    "every.thousand": "万条",
    flow: "流量",
    "uploaded.tip": "上传的图片和附件的大小，每年清空计算",
    "correct.tip20": "请输入正确的数值,0为不购买。",
    "more.configuration": "更多配置",
    existing: "已有",
    "sum.order": "总和",
    "aggregate.caching": "聚合表缓存",
    "batch.export.annex": "批量导出附件",
    "use.time": "使用时长",
    "order.price.title": "订单总额",
    "account.balance": "账户余额",
    "need.recharge": "还需充值",
    "operating.time": "操作时间",
    "discount": "折",
    "whether.payment": "是否开启付费功能",
    "my.module": "我的插件",
    "module.center": "插件中心",
    "verification.img.code": "请输入图片验证码",
    "verification.message.code": "请输入6位短信验证码",
    "immediate.activation": "立即激活",
    "successful.activation": "激活成功",
    "your.mobile.phone": "请输入您的手机号码",
    "correct.validation.code": "请输入正确的验证码",
    "mobile.validation.code": "请输入手机验证码",
    "new.login.password": "请输入新的登录密码",
    "user.login": "用户登录",
    "user.activation": "账户激活",
    "wechat.registration": "微信注册",
    "summary.title.alignment": "汇总标题对齐方式",
    "summary.title.alignment.tip": "汇总标题是指透视图左下角的标题",
    "data.table.sticky": "表格冻结",
    "data.table.sticky.before": "固定前",
    "data.table.sticky.tip": "子表单字段整体算一列；移动端暂不支持冻结表格。",
    "data.display.column": "列数据",
    "dash.dataSource.tip.etl": "{{- etl}}可以关联、合并、聚合多张表单的数据，得到输出表。",
    "dash.color.defaultTip": "更改默认项颜色，会修改所有没有自主设置颜色的项的颜色。",
    "dash.sort.custom": "自定义排序",
    "dash.sort.custom.maxTip": "当前数据项过多，仅显示前{{- count}}项",
    "dash.sort.custom.emptyTip": "没有可排序的数据项，请修改过滤条件或查看数据源",
    "dash.style": "报表样式",
    "dash.style.close": "关闭报表样式",
    "dash.style.closeConfirm": "关闭报表样式",
    "dash.style.closeConfirmMsg": "关闭报表样式",
    "dash.component.style": "控件样式",
    "dash.all": "报表整体",
    "dash.all.style": "风格",
    "datatable.all.style": "控件样式",
    "datatable.title.color": "标题颜色",
    "dash.component.all": "控件整体",
    "dash.component.table": "表格类控件",
    "etl.update.fail": "数据更新失败",
    "etl.update.fail.tip": "数据更新失败，当前不是最新数据。",
    "etl.update.check": "请检查数据流设置",
    "etl.update.nextRun": "数据待更新，{{ minutes }}分钟后自动更新",
    "etl.update.nextRun.tip": "数据待更新，{{ minutes }}分钟后可查看最新数据",
    "etl.update.success": "当前已是最新数据",
    "etl.update.running": "正在更新，请稍后…",
    "etl.update.running.tip": "正在更新，稍后可查看最新数据",
    "dash.percent.disabled.tip": "汇总方式为求和或计数时，才能设置占比。",
    "dash.conversion.disabled.tip": "只有漏斗图，才能设置转化率。",
    "filter.date.start": "开始时间",
    "filter.date.end": "结束时间",
    "unpaid.orders": "未支付订单",
    "data.helper": "数据助手",
    "data.helper.allow": "开启",
    "data.helper.allow1": "开启中",
    "data.helper.disable1": "已禁用",
    "data.helper.allow.tip": "请确认是否{{ action }}数据助手",
    "aggregate.table.alias": "聚合表别名",
    "aggregate.table.alias.tip": "同一应用下唯一，如果没有设置别名或者设置为空，则别名为默认，修改即保存",
    cache: "缓存",
    "cache.tip": "开启后，调用聚合表数据时可加快获取速度，如数据联动，关联数据等",
    "set.verification.conditions": "设置校验条件",
    "cannot.use.system.field.alias": "不能使用系统字段别名-",
    "aggregate.table.alias.modification.failed": "聚合表别名修改失败",
    "leave.page.tip": "当前页面未保存，是否确定离开？",
    "page.tip": "当前页面未保存",
    "leave": "离开",
    "setting.failed": "设置失败",
    "click.copy": "点击复制",
    "trigger.event": "是否触发事件（插件事件/_form事件）",
    "operator.tip": "操作人_id，默认使用应用所有者的_id",
    "widget.upload.signature": "附件、手写签名",
    "system.management": "系统管理",
    "cloud.application.management": "云应用管理",
    "incorrect.form.type": "表单类型不正确",
    "picture.upload.failed": "图片上传不成功",
    "aggregate.validation.failed": "聚合表校验失败",
    "exception.contact.administrator": "系统异常，请联系管理员",
    "empty.recycle.irreversible": "清空回收站中所有表单以及数据，此操作不可逆",
    "empty.recycle.forms": "清空回收站所有表单",
    "empty.recycle.field": "清空回收站所有字段",
    "emptying.recycle.forms": "回收站表单正在清理中,剩余{{ count1 }} / {{ count2 }}",
    "recycle.has.cleaned": "回收站的表单已经清理完成!",
    "clean.tip": "本次清理{{ cf }}个表单，有{{ fi }}个表单出错，请联系管理员检查处理",
    "application.more.tip": "当前应用表单数量超过{{ formNumberMax }}个，无法创建更多的表单，请先清空表单回收站无用表单再进行操作",
    "create.blank.flow.form": "创建空白流程表单",
    "unnamed.flow.form": "未命名流程表单",
    "unnamed.event.form": "未命名事件表单",
    "event.form": "事件表单",
    "unnamed.new.report": "未命名新报表",
    "unnamed.dash.report": "未命名分析报表",
    "unnamed.scenes.report": "未命名场景报表",
    "create.new.report": "创建报表",
    "create.old.report": "创建旧报表",
    "create.dash.report": "创建分析报表",
    "create.scenes.report": "创建场景报表",
    "scenes.report": "场景报表",
    "successfully.restored.form": "恢复表单成功",
    "failed.restored.form": "恢复表单失败",
    "switch.event.form": "切换为事件表单",
    "switch.notEvent.form": "切换为非事件表单",
    "application.exceed": "单个应用表单数量不能超过{{ formNumberMax }}个",
    "please.enter": "请输入",
    "confirm.delete.the": "请确认是否删除 \"{{ name }}\" ？",
    "completely.delete.irreversible": "请确认是否彻底删除 \"{{ name }} \"？此操作不可逆",
    "standard.application": "标准应用",
    "scenes.used": "使用场景",
    category: "行业分类",
    "functional.classification": "功能分类",
    "tutorial.case": "教程案例",
    "search.cloud.office.applications": "搜索云办公应用",
    "app.preview": "应用预览",
    "companies.use": "{{ installnum }}家公司使用",
    "installation.package.size.exceeds": "安装包大小超出限制",
    "selected.it": "已选择【{{ name }}】",
    "import.package.group": "导入安装包到分组",
    "import.package.group.tip": "是否保留示例数据",
    "select.file": "选择文件",
    "app.access": "应用访问",
    "backend.script": "后端脚本",
    "app.management": "应用管理",
    "module.design": "插件设计",
    "module.source": "插件源码",
    "pay.title": "充值支付 - ",
    "pay": "充值支付",
    "message.center": "消息中心",
    "no.access.contacts": "没有通讯录访问权限",
    "security.strategy": "安全策略",
    "export.management": "导出管理",
    "weChat.sweep": "微信'扫一扫'，分享给好友",
    "report.alias": "报表别名",
    "widget.alias.duplicate": "字段别名重复",
    "alias": "别名",
    "permissions.settings": "权限设置",
    "add.data.source": "新增数据源",
    "sure.add.form.data": "是否确认新增此表单数据？",
    "data.form.information": "数据表颜色信息",
    "data.table.default.sort": "数据表默认排序字段",
    "data.table.mobile.style": "数据表移动端样式",
    "schedule.specific.information": "排班具体信息",
    "shift.time.field": "排班时间字段",
    "calendar.displayed.tip": "操作日历以月或周显示，默认以月日历显示",
    "calendar.mode": "日历模式",
    "calendar.month": "月日历",
    "calendar.week": "周日历",
    "dynamic.row.field": "动态行表头字段",
    "calendar.specific.information": "日历具体信息",
    "calendar.color.information": "日历表颜色信息",
    "calendar.time.field": "日历时间字段",
    "corresponding.time.field": "对应数据表中的时间字段",
    "title.show": "展示",
    "add.search.box": "添加搜索框",
    "right.click.mark": "右键可标记",
    "display.data.list": "显示数据列表",
    "map.specific.information": "地图具体信息",
    "click.operate": "点击操作",
    "no": "否",
    "trigger.events": "是否触发后端事件",
    "button.events": "按钮事件",
    "map.effective.range.field": "辐射半径",
    "map.location.field": "地图位置字段",
    "report.link.title": "报表链接",
    "report.external.link": "报表外链",
    "phone.binding": "手机绑定",
    "created.invited": "我创建了报表，邀请大家来查看！-",
    "created.invited.form": "我创建了表单，邀请大家来查看！-",
    "external.link.tip2": "本内容由用户通过「{{ site_name }}」发布，并不代表{{ site_name }}的立场。 ",
    "app.group.name": "应用分组名称",
    "app.group.deleted": "当前分组中还有应用，不能删除!",
    "confirm.appGroup.deleted": "请确认是否删除分组-{{ name }}",
    "NoApps.currently.visible": "当前没有任何应用可见，",
    "share.app.permissions": "请您联系管理员给您分享应用权限",
    "appGroup.no.has": "当前分组没有应用",
    "clean.data": "清理数据",
    "moveTo.other.group": "移动到其他分组",
    "share.others.install": "分享给他人安装",
    "export.installation.package": "导出安装包",
    "export.installation.package.tip": "是否导出示例数据（每个表单最新20条数据）",
    "export.installation.package.yes": "包含示例数据下载",
    "export.installation.package.no": "不包含例数据下载",
    "app.batch.export.options.tip1": '用户安装以后禁止再次导出',
    "app.batch.export.options.tip2": '是否导出示例',
    "installing.app": "正在安装应用...",
    "select.app.group": "请先选择应用分组",
    "copy.app": "应用复制",
    "delete.app.name": "如确定删除，请输入应用名称",
    "want.delete.app": "您确定要删除应用 “{{ appname }}” 吗？",
    "delete.form.irreversible": "删除应用则表单、报表以及数据也都将一并删除，此操作不可逆！",
    "delete.form.data": "如确定清空数据，请输入表单名称",
    "want.clear.form.data": "您确定要清空表单 “{{ name }}” 中所有的数据吗？",
    "want.clear.form.data.filter": "您确定要清空表单 “{{ name }}” 筛选后的数据吗？",
    "want.clear.form.data.select": "您确定要清空表单 “{{ name }}” 中选择的 {{index}} 条数据吗？",
    "want.delete.form.data": "您确定要删除表单 “{{ name }}” 中所有的数据吗？",
    "clear.form.data.irreversible": "清空表单操作将彻底删除表单中的数据，此操作不可逆！",
    "delete.select.form.data": "如确定删除选择数据，请输入表单名称",
    "want.clear.select.form.data": "您确定要删除表单 “{{ name }}” 中选择的 {{index}} 条数据吗？",
    "clear.select.form.data.irreversible": "此操作将彻底删除当前选择的的数据，此操作不可逆！",
    "select.data.empty.tip": "当前没有选择数据，请先选择数据",
    "clear.field": "如确定清空回收站所有字段，请输入表单名称",
    "want.clear.field": "您确定要清空表单 “{{ name }}” 回收站中所有的字段吗？",
    "clear.field.irreversible": "此操作将清空回收站中的字段以及字段对应的数据，此操作不可逆！",
    "delete.field": "如确定删除回收站字段，请输入表单名称",
    "want.delete.field": "您确定要删除表单 “{{ name }}” 回收站中的字段吗？",
    "delete.field.irreversible": "此操作将彻底删除回收站中的字段以及字段对应的数据，此操作不可逆！",
    "select.field.empty.tip": "当前没有选择字段，请先选择字段",
    "clear.app.name": "如确定清空，请输入应用名称",
    "clear.data.app": "你确定要清空应用 “{{ appname }}” 中的所有数据吗？",
    "clear.data.irreversible": "执行清空操作应用中所有的数据将彻底删除，此操作不可逆！",
    "app.data.cleared": "应用数据已清空!",
    "download.immediately": "立即下载",
    "installation.link": "安装链接",
    "installation.app.link": "通过安装链接可以直接安装当前应用",
    "account.no.empty": "账号不能为空",
    "app.installation.link": "应用安装链接",
    "installation.copied.link.successfully": "安装链接复制成功!",
    "generate.copied.link.successfully": "生成安装二维码",
    "install.password": "凭密码安装",
    "limit.password": "密码不能为空且小于24位",
    "accounts.allowed.install": "允许安装的账号",
    "enter.app.accounts": "输入允许安装该应用的用户账号,多个账号使用换行输入",
    "view.installed.records": "查看被安装记录",
    "Share.app.install.others": "分享应用【{{ appname }}】给他人安装",
    "install.account": "安装人账号",
    "install.nickname": "安装人昵称",
    "install.time": "安装时间",
    "no.installation.record": "没有安装记录",
    "show.latest.record": "仅显示最新的50条记录",
    "installation.record": "安装记录",
    "failed.installation.record": "获取安装记录失败!",
    "enter.new.appName": "请输入新的应用名称",
    "add.new.source": "新增数据来源",
    button: "按钮",
    buttonext: "擴展操作",
    "data.loading": "数据加载",
    "corresponding.field": "对应字段",
    "old.perform.action": "执行动作(旧)",
    "perform.action": "执行动作",
    "form.source": "表单来源",
    "WPSTIP.7102": "系统用量超出限制，系统已暂停使用，您可以删除部分数据来恢复系统。",
    "WPSTIP.7104": "聚合表数量已达上限，请删除原先的聚合表后再进行新建。",
    "WPSTIP.7105": "您所安装的应用内聚合表数量超出WPS云表格限制，请重新选择应用安装。",
    "WPSTIP.7106": "您的聚合表数量已超出限制。",
    "WPSTIP.7107": "您本月的附件上传量已超出表格限制。",
    "WPSTIP.7108": "您系统内的总数据量已超出表格限制。",
    "WPSTIP.7109": "您系统内的单表数据量已超出表格限制。",
    "WPSTIP.7110": "您系统内的成员数量已超出表格限制。",
    "WPSTIP.7111": "成员数量超出限制，您可以删除部分成员，以邀请更多成员。",
    "to.minute": "分钟",
    "to.hour": "小时",
    "pin.top": "顶部冻结",
    "pin.right": "右侧冻结",
    "pin.none": "取消冻结",
    "file.fetch.failed": "文件获取失败",
    "source.add": "新建源文件",
    "source.add.python": "创建python文件",
    "source.add.lua": "创建lua文件",
    "not.alias.jumping": "当前面板不支持应用内表单别名跳转",
    "flow.wrong.help": "流程出错了，可联系链接发布者寻求帮助",
    "data.saved.submit": "您的数据已保存，请勿重复提交!",
    "not.current.data": "当前不是最新数据",
    "refresh.in.stop": "不刷新",
    "refresh.in.time": "及时刷新",
    "cyclic.in.refresh": "循环刷新",
    "periodic.in.refresh": "周期性刷新",
    "view.refresh.notSet": "当前没有设置此数据视图刷新规则",
    "update.immediately": "立即更新",
    "department.sub.department": "当前用户所处部门以及子部门",
    "department.hasCurrentParDept": "当前用户所处部门以及父部门",
    "top.department": "当前用户上级部门",
    "tertiary.department": "当前用户三级部门",
    "fourth.department": "当前用户四级部门",
    "fifth.department": "当前用户五级部门",
    "equal.to.filter": "等于筛选条件",
    "pivot.table": "透视图",
    "backend.table": "后端表",
    "back.form.design": "返回表单设计",
    "has.been.saved": "有修改，是否保存？",
    "not.save.continue": "您修改了{{ key }}但没有保存，是否需要保存{{ key }}并继续？",
    "lat": "纬度：",
    "lon": "经度：",
    "minute.ago": "分钟前",
    "flow.starting.point": "流程起点",
    "not.empty": "不能为空",
    "title.len": "{{ title }}长度不能大于{{ len }}个字符",
    "only.be": "只能中文,英文,数字,下划线,(,),-,空格",
    "alias.not.empty": "别名不能为空",
    "alias.only.be": "别名只能中文,数字,字母,下划线",
    "only.be.num": "只能字母,数字,下划线",
    "category.num": "类别{{ num }}",
    "series.num": "系列{{ num }}",
    "continued": "持续",
    "schedule": "进度",
    "data.no.content": "数据没有内容",
    "close.full.screen": "关闭全屏展示",
    "full.screen.show": "全屏展示",
    "shrink.toolbar": "收缩工具栏",
    "expand.toolbar": "展开工具栏",
    "latLon.not.exist": "标记经纬度不存在",
    "select.positioning.center": "选择定位中心",
    "latLon": '经纬度',
    "add.mark": "添加标记",
    "delete.targeting": "删除该定位",
    "latLon.marked": "该标记点的经纬度为：{{ lngNum }},{{ latNum }}",
    "address": "详细地址：",
    "location.failed1": "定位失败，时间未写入",
    "current.node": "当前节点：",
    "flow.charger.current.map": "当前负责人：",
    "view.look": "查看",
    "addressing": "寻址",
    "latLon.empty.tip": "经纬度为空不能进行定位",
    "complete.driving.route": "绘制驾车路线完成",
    "failed.driving.data": "获取驾车数据失败：",
    "notLoaded.positioning.permission": "定位未加载完成，请检查是否有定位权限",
    "lonLat.lon.lat": "[经纬度：经度{{ lon }},纬度{{ lat }}]",
    "select.delete.data": "您当前选中{{ num }}条数据，删除后将无法恢复，确定删除？",
    "filter.delete.data": "您筛选{{ num }}条数据，删除后将无法恢复，确定删除？",
    "select.mort.data": "您当前选中{{ num }}条数据，请确定后进行操作？",
    "data.cleared": "清空数据后将无法恢复，确定清空？",
    "selected.operation": "选中操作",
    "all.operation": "全部操作",
    "more.operation": "更多操作",
    "no.data.selected": "没有选择任何数据",
    "not.started": "未开始",
    "over": "已结束",
    "calendar.default.mode": "日历默认模式",
    "filter.color.settings": "数据筛选颜色设置",
    "set.data.source": "请设置数据源表",
    "set.field": "设置字段",
    "table.menu.bar": "数据表菜单栏",
    "sheet.menu.bar": "数据表菜单设置",
    "report.menu.bar": "报表菜单栏",
    "add.report.operation.menu": "添加报表操作菜单",
    "scheduled.tasks": "计划任务",
    "module.setting.timing": "根据设置定时执行功能插件",
    "new.edited.cloudApp": "(新建或者编辑计划任务必须要重启云应用才会生效)",
    "restart.app": "重启云应用",
    "selecting.source": "没有选择数据源，无法配置扩展功用",
    "extensions": "扩展功能",
    "map": "地图",
    "data.selection": "数据多选",
    "raw.data": "原始数据",
    "view.raw.data": "查看原始数据",
    "view.raw.data.tip": "查看图表的原始数据，当数据来源为数据视图/聚合表的时候，当前属性无效",
    "data.menu.sticky": "数据菜单冻结",
    "data.menu.sticky.tip": "只数据列宽度超过数据表宽度的时候，数据菜单冻结才会生效",
    "mobile.not.support": "移动端不支持数据多选功能",
    "report.type": "报表类型",
    "chart.linkage.settings": "图表自定义联动设置",
    "modifying.data.source.tip": "修改数据来源设置会清空已有的字段配置和条件过滤等选项，是否确认修改？",
    "add.data.source2": "添加数据源",
    "first.data.source": "请先添加数据源",
    "report.permissions": "报表权限",
    "source.before.permissions": "请选择数据源表后再进行报表权限设置",
    "dimension.length": "{{ name }}只支持{{ len }}个维度，不能再添加更多维度",
    "indicator.length": "{{ name }}只支持{{ len }}个指标，不能再添加更多指标",
    "report.menu.settings": "报表菜单设置",
    "field.exists.recycle": "字段别名重复(字段存在字段回收站中)",
    "alias.empty.saving": "字段别名同一表单下唯一，如果没有设置别名或者设置为空，则别名为默认，保存表单后生效",
    "function.module.settings": "功能扩展设置",
    "select.module.used.tip": "功能插件与后端事件同时只能触发一种，请根据实际需要选择。按钮触发事件与二维码生成功能以及扫码功能以及三者不能同时使用。",
    "backend.event": "后端事件",
    "data.assistant": "数据助手",
    "module.interface.settings": "插件接口设置",
    "pop.report.settings": "弹出报表设置",
    "pop.form.settings": "弹出表单设置",
    "print.doc.settings": "页面打印设置",
    "linkage.formula.converted": "字段内包含数据联动/公式编辑，无法转换",
    "formula.converted": "字段内包含公式编辑，无法转换",
    "otherData.converted": "字段内选项来源于其他表单数据/包含数据联动，无法转换",
    "widget.option.associations.converted": "字段内包含选项关联，无法转换",
    "flow.started.tip": "已开启流程，流程中的操作权限以节点设置为准",
    "excel.import.tip": "从excel导入数据",
    "focus.trigger": "焦点触发",
    "button.trigger": "按钮触发",
    "set.reminder.content": "请设置提示内容",
    "message.empty.triggered": "提示消息为空的情况下，不会触发弹出提示框",
    "subform.data.title": "子表单数据标题",
    "mobile.only.title": "子表单在移动端单行数据的标题，同一个子表单字段同时只能设置一个",
    "set.data.title": "设置为数据标题",
    "button.name": "按钮名称",
    "fill.button.name": "请填写按钮名称",
    "event.button.characters": "事件按钮名称不能大于{{ len }}个字符",
    "reminder.box.displayed": "是否显示提醒框",
    "reminder.title": "提醒标题",
    "fill.reminder.title": "请填写提醒框标题内容",
    "mode": "模式",
    "list.mode": "列表模式",
    "editable.mode": "可编辑模式(仅移动端有效)",
    "process.decision": "流程决策",
    "unprocessed": "未处理",
    "pass": "通过",
    "refuse": "拒绝",
    "flow.current.node": "流程当前节点",
    "flow.current.person": "流程当前负责人",
    "data.association.table": "数据关联表",
    "current.form": "当前表单的",
    "linkage.displayed.as": "联动显示为",
    "association.table": "关联表的",
    "corresponding.value": "中对应值",
    "linkage.trigger.field": "数据联动条件必须有一个当前表单的字段做为触发字段",
    "linkquery.trigger.field": "关联条件必须有一个当前表单的字段做为触发字段",
    "select.linked.sub": "请选择子表单的联动字段",
    "widget.width.takes": "字段宽度占整行的",
    "related.conditions": "关联条件限定",
    "HH.mm": "时分",
    "HH.mm.ss": "时分秒",
    "scan.code.QR": "扫码和二维码",
    "scan.code.QR.tip": "扫描二维码或者条形码，扫码功能与二维码生成功能以及按钮触发事件三者不能同时使用。",
    "generate.code.QR": "是否允许生成二维码",
    "button.text": "文本",
    "button.text.tip1": "文本修改失败，",
    "association.form.settings": "关联表单设置",
    "Current.Form": "[当前表]",
    "association.form": "关联表单",
    "decimal.allowed": "允许小数",
    "height": "高度",
    "height.according.content": "根据内容自适合高度",
    "other.at.bottom": "其他选项位于底部",
    "other.sort.field": "排序字段",
    "other.sort.mode": "排序规则",
    "other.sort.waterMark": "请选择需要排序的字段",
    "fill.current.time": "填写当前时间",
    "current.time": "当前时间",
    "yyyy.MM.time": "年月",
    "show.detailed.address": "显示详细地址",
    "automatic.trigger.positioning": "自动触发定位",
    "uploading.multiple.pictures": "允许上传多张图片",
    "wechat.service.dingding": "该功能仅对微信企业号/服务号和钉钉移动客户端有效",
    "Picture.Preview": "图片预览",
    "picture.hovering": "是否允许鼠标悬停在图片上的时候，预览大图。预览图片大小范围，最小100*100像素，最大1200*1200像素",
    "Real-time.preview.width": "实时预览宽度",
    "Real-time.preview.pixels": "实时预览宽度，最小值不能小于{{ minNumber }}像素，最大值不能超过{{ maxNumber }}像素",
    "Real-time.preview.height": "实时预览高度",
    "multiple.file.uploads": "允许多文件上传",
    "sub.empty.notLinkage": "子表单字段为空，不能设置数据联动",
    "sub.freeze": "子表单冻结",
    "Before.freeze": "PC端冻结前",
    "Before.freeze.mobile": "移动端冻结前",
    "Subform.data.loading": "数据加载",
    "data.loading.enabled": "是否开启数据加载",
    "sumEmpty.loading.enabled": "子表单字段为空，不能开启数据加载",
    "data.loading.settings": "数据加载设置",
    "Formula.Trigger": "公式触发",
    "note.depend": "子表单导入数据完成后，公式将自动执行",
    "sub.data.loading.settings": "数据加载设置",
    "LINE": "线条",
    "Popup.report": "弹出报表",
    "Form.report": "弹出表单",
    "Form.print": "页面打印",
    "Form.download": "打包下载",
    "button.color": "颜色",
    "added.no.more": "{{ name }}已经添加{{ num }}个指标，不能再添加更多维度",
    "added1.no.more": "{{ name }}已经添加{{ num }}个维度，不能再添加更多指标",
    "only.add.dimensions": "最多只能添加2个维度",
    "dimensions.address.view": "编辑界面只取数据源前200条作为查询数据预览，完整数据请访问页面查看。",
    "first200.preview.positioning": "维度只支持地址、定位字段",
    "basic.report": "基础报表",
    "analysis.report": "分析图表",
    "no.source.conditions": "所有图表都没有添加数据源，无法添加筛选条件",
    "no.source.conditions2": "当前报表中没的筛选条件，无法直接添加筛选按钮",
    "mobile.style": "移动布局",
    "set.filterButton.style": "设置筛选按钮属性",
    "chartData.automatically.loaded": "图表数据自动加载",
    "chartData.automatically.loaded.tip": "当筛选按钮字段关闭自动加载数据选择后，所有图表数据的加载必须通过点击筛选按钮才能触发数据加载功能",
    "no.indicator.data": "暂无指标数据",
    "no.data.perspective": "透视图暂无数据",
    "field.color.setting": "字段显色设置",
    "field.color": "字段颜色",
    "show.name": "显示名称",
    "picture.realTime.preview": "图片实时预览设置",
    "is.picture.realTime.preview": "是否开启图片实时预览",
    "Real-time.preview.pixels.height": "实时预览高度，最小值不能小于{{ minNumber }}像素，最大值不能超过{{ maxNumber }}像素",
    "is.editable": "是否可编辑",
    "is.preview.time": "是否实时预览",
    "Mobile.data.header": "移动端数据标题",
    "deling": "(已删除)",
    "field.default.value": "设置当前表字段值为筛选条件的默认值",
    "current.form1": "当前表单",
    "field.only.sub-form": "显示字段只支持一个子表单",
    "alias.only.saving.tip": "别名同一报表下唯一,如果没有设置别名或者设置为空,则别名为默认,保存报表后生效",
    "data.color.tip": "在数据表中可以根据选择字段的内容条件不同，显示对应的的颜色标识。颜色条件标识字段最多只能设置一个",
    "sort.field.set.tip": "数据表默认按数据的的创建时间进行倒序排序,当设置排序字段后，将用新的字段排序创建时间的排序规则",
    "shift.time.field.tip": "排班时间字段中，第一个字段为排班开始时间，第二个字段为排班结束时间。为确保移动端的排班表呈现效果，数据表中的日期字段格式请选择日期时间",
    "shift.corresponding.field": "排班行表头对应字段",
    "calendar.field.tip": "在日历表中可以根据选择字段的内容条件不同，显示对应的的颜色标识。颜色条件标识字段最多只能设置一个",
    "setting.trigger.tip": "设置将触发_reportevent 事件,会将当前坐标,手动标记的坐标,搜索的坐标,当前的数据项,定位激活的数据项传给后端处理",
    "number.type.circle": "数字类型,以位置字段为中心,设置的字段值为该坐标的辐射半径",
    "map.type.latLon": "用于在地图上面标点的字段,可选择定位字段或文本字段,文本字段格式为(纬度,经度)",
    "login.expired.again": "登录状态过期，请重新登录",
    "action.bar.style": "操作栏样式",
    "operation.menu.tip": "普通操作菜单中，图标与文字只能同时存在一种样式",
    "Text": "文字",
    "Icon": "图标",
    "operation.icon": "操作图标",
    "icon.color": "图标颜色",
    "action.bar.name": "操作栏名称",
    "action.bar.name.tip": "请输入操作栏名称，最多5个字符",
    "action.bar.name.tip1": "操作栏名称不允许重复",
    "action.bar.name.msg": "操作栏名称，最多5个字符",
    "action.bar.name.color": "操作栏名称颜色",
    "name.color": "名称颜色",
    "hint": "提示语",
    "enter.prompt": "请输入提示语",
    "refresh.mode": "刷新模式",
    "not.refresh": "不刷新",
    "whole.table.refresh": "整表刷新",
    "whole.table.custom": "刷新指定表",
    "whole.table.custom.form": "选择要刷新的图表",
    "multi.select.operation": "多选操作",
    "multi.all.operation": "多选操作+全部操作",
    "operation.mode": "操作模式",
    "select.docking.mode": "请选择对接模式",
    "enable.batch.selection": "是否开启批量选择",
    "open.all.operations": "是否开启操作全部",
    "drop.selection.form": "请下拉选择表单",
    "drop.selection.report": "请下拉选择报表",
    "open.prompt.box": "是否开启提示框",
    "Click.Settings": "(点击设置)",
    "set.content.prompt": "请设置提示的内容",
    "set.operation.field": "设置操作表单的字段值",
    "report.source.data": "报表源数据",
    "set.filter.reports": "设置弹出报表的筛选条件",
    "exist.select.reports": "报表不存在，请重新选择新的报表",
    "filters.available.reports": "报表没有可用筛选条件",
    "menu.name.empty": "菜单名称不允许为空",
    "menu.name.repeated": "菜单名称不允许重复",
    "must.selected.report": "当前为报表弹出模式，必须选择一个报表",
    "must.selected.form": "当前为表单弹出模式，必须选择一个表单",
    "linkable.charts": "可联动的图表",
    "select.charts.linked": "请选择需要联动的图表",
    "set.charts.linked": "设置图表联动的条件",
    "current.report": "当前报表",
    "add.linkage.conditions": "请添加联动条件",
    "select.association.chart": "请选择一个自定义关联图表",
    "set.associated.chart": "请设置自定义关联图表的条件",
    "field.sorting": "字段排序",
    "data.before": "条件的数据前",
    "supports.positive.integers": "仅支持1-500000正整数",
    "add.sorting.field": "添加排序字段",
    "calculated.field.name": "计算字段名称",
    "unnamed.data.view": "未命名数据视图",
    "unnamed.data.helper": "未命名数据助手",
    "view.saved.successfully": "数据视图保存成功",
    "data.view.design": "数据视图设计",
    "data.helper.design": "数据助手设计",
    "nodes.view.processes": "当前数据视图存在孤立节点或孤立流程",
    "input.view.output": "当前数据视图没有输入/输出节点",
    "calculated.field": "计算字段",
    "original.name": "原名：",
    "group.field.name": "分组节点配置字段名称",
    "according.fields.sheet": "按单张表中的指定字段进行排序操作。",
    "enhanced.controls": "增强字段",
    "department.member.controls": "部门成员字段",
    "click.set.member": "点击设置成员",
    "fieldAlias.modification.failed": "字段别名修改失败，",
    "button.width.unit": "宽度(单位:px)",
    "button.width.tip": "在PC端，字段的宽带与表单的整体布局相关，字段布局占带宽1/2时，最大宽度为350px，其他布局最大宽度为720px",
    "button.mode": "模式",
    "department.by": "由部门字段确定",
    "restricted.field.conditions": "关联字段条件限定",
    "add.related.conditions": "添加关联条件",
    "modified.form.tip": "您修改了表单设计但没有保存，是否需要保存并继续？",
    "modified.module.tip": "您修改了插件设计但没有保存，是否需要保存并继续？",
    "module.development.title": "插件设计 - 功能插件开发",
    "module.development.title.source": "插件源码 - 功能插件开发",
    "condition.setting": "条件设置",
    "qualified.data.flow": "符合条件的数据流转到下一节点",
    "form.link1": "表单链接",
    "form.link1.fill": "通过表单链接可以直接填写当前表单",
    "created.form.invited": "我创建了表单，邀请大家来填写！-",
    "external.chain.list": "扩展外链列表({{ extParams }})",
    "value.already.exists": "该值已存在",
    "extensionField.value.empty": "扩展字段或者值不能为空",
    "copy.external.link.tip": "外链复制成功",
    "normal.form": "普通表单",
    "flow.event.form": "流程事件表单",
    "form.type.switching": "表单类型切换",
    "widget.recycle.bin": "字段回收站",
    "widget.properties": "字段属性",
    "widget.sn.only": "表单只能添加一个流水号字段",
    "deleted.widget.tip": "若删除该字段，其对应的表单数据也会被清除。确定删除？",
    "deleted.widget.tip2": "当前字段配置了索引，无法直接删除。若要删除，请先删除该字段的索引。",
    "update.tip": "您当前使用的版本不包含字段回收站功能，您可以至会员中心查看版本使用详情和升级版本。",
    "form.edit.tip": "表单别名修改失败，",
    "widget.none.tip": "字段被隐藏时，不改变该字段的原有值",
    "widget.none.tip1": "字段被隐藏时，该字段提交空值",
    "widget.none.tip2": "字段的计算、提交逻辑，与没有隐藏时保持一致",
    "form.alias": "表单别名",
    "form.alias.tip": "表单别名同一应用下唯一，如果没有设置别名或者设置为空，则别名为默认，修改即生效",
    "form.sub.tip": "表单初始化，提交，编辑，删除时触发的功能插件或后端脚本设置",
    "form.sub.tip1": "表单初始化，提交，编辑，删除时触发的功能插件设置",
    "form.initialization": "表单初始化",
    "form.submission.data": "表单提交数据",
    "form.edit.data": "表单编辑数据",
    "form.other.properties": "表单其他属性",
    "save.data": "保存数据",
    "allow.submission.data": "允许提交数据",
    "form.data.cache": "表单数据缓存",
    "form.data.cache.all.field": "缓存全部字段",
    "form.data.cache.field": "缓存指定字段",
    "record.user.source": "记录用户来源",
    "interview.method": "访问方式",
    "interview.type": "访问类型",
    "operating.system": "操作系统",
    "interview.IP": "访问ip",
    "visitor.browser.type": "访问者浏览器类型",
    "hidden.widget.assignment": "隐藏字段赋值",
    "hidden.widget.tip": "对表单中需要隐藏的字段根据业务需要设置被隐藏字段的值的处理方式",
    "trigger.form.event": "触发_form事件",
    "event.form.communicate": "当前表单为事件表单，可与应用通信",
    "module.setting.layout": "插件设置界面布局",
    "show.loading.animation": "显示加载动画",
    "show.loading.animation.tip": "当字段触发功能插件的时候，是否显示加载状态动画（如果功能插件执行需较长时间，建议开启，可以改善用户体验）。",
    "module.setting": "插件设置",
    "pre.trigger": "前置触发",
    "post.trigger": "后置触发",
    "pre.trigger.run": "前置执行",
    "post.trigger.run": "后置执行",
    "show.multiple.labels": "显示多标签",
    "close.multiple.labels": "请确认是否关闭多标签？",
    "close.multiple.labels.tips": "多标签关闭后，标签页中所有字段将按字段顺序放回表单中",
    "flow.status.log": "查看权限",
    "allow.view.status.log": "允许查看流程状态/日志",
    "allow.view.status.comment": "允许查看评论",
    "flow.decision.tip": "开启流程决策之后，在移动端流程数据查看的时候，会显示流程通过/拒绝，显示审批的标题可以自行定义，最多支持6个字符",
    "flow.decision.switch": "流程决策开关",
    "passed.title": "通过标题",
    "approved": "审批通过",
    "fill.passed.title": "请填写通过标题内容",
    "fill.rejected.title": "请填写拒绝标题内容",
    "decision.passed.title": "决策通过标题",
    "decision.rejected.title": "决策拒绝标题",
    "rejected.title": "拒绝标题",
    "approval.rejected": "审批拒绝",
    "close.flow": "关闭流程",
    "close.flow.tip": "流程关闭后已经在流转的数据将终止流转，新提交的数据将不进入流程。",
    "save.flow.tip": "当前流程未保存，是否确定关闭？",
    "use.form.flow": "使用表单流程",
    "open.formFlow.workflow": "开启表单流程，设置流转条件搭建工作流",
    "flow.cond2": "流转条件",
    "print.template": "打印模版",
    "print.template.create.online": "创建在线模式",
    "print.template.create.word": "创建Word模式",
    "print.op.log": "打印日志",
    "field.index": "字段索引",
    "module.release": "插件发布",
    "module.icon": "插件图标",
    "module.type": "插件类型",
    "module.image.size": "*建议图片文件大小200KB以内，高宽100*100像素",
    "module.business.scenario": "插件业务场景",
    "module.business.scenario.tip": "*添加新的插件业务场景，请联系在线客服处理",
    "whole.website.installation": "全站安装",
    "this.website.installationUse": "本站安装使用",
    "whole.website.installationUse": "全站安装使用",
    "publishing.check.valid": "发布时勾选才有效",
    "module.description": "插件描述",
    "module.description.URL": "插件描述网址",
    "save.information": "保存信息",
    "module.save.tip": "插件描述网址格式不正确",
    "publish.module": "发布插件",
    "publish.module.set.tip": "插件发布时必须设置插件类型",
    "publish.module.set.tip2": "插件发布时必须设置业务场景",
    "publish.module.set.tip3": "插件描述网址格式不正确",
    "publish.module.set.tip4": "插件中心已经有在审核中的版本，请确认是否覆盖正在审核中的版本？",
    "data.sub.tip": "有新数据提交时{{ tipName }}提醒",
    "set.reminders": "点击设置提醒对象",
    "Email.submitted.tip": "有新数据提交时邮件提醒",
    "update.success1": "更新成功",
    "field.index.tip": "最多创建十个索引，组合索引最多支持三个，每个组合索引最少支持两个最多支持三个字段",
    "printing.form.tip": "打印表单时将按照使用中的模版格式打印",
    "server.address": "服务器地址：",
    "push.time": "推送时间：",
    "delete.operation.tip": "删除操作不可逆，是否确认删除？",
    "reminder.time": "提醒时间：",
    "reminder.condition": "提醒条件：",
    "reminder.method": "提醒方式：",
    "Email1": "邮件",
    "expand.external.link": "扩展外链",
    "this.year": "今年",
    "last.seven.day": "过去七天",
    "reminder.set.tip": "您的提醒设置未保存，确定离开当前页面？",
    "reminder.set.tip1": "您的提醒内容设置未保存，确定离开当前页面？",
    "new.scheduled.task": "新建计划任务",
    "up.planning.modules": "当前账户最多只能安装{{ num }}个任务计划插件",
    "schedule.task.module": "计划任务插件：",
    "schedule.task.type": "计划任务类型：",
    "schedule.task.type1": "计划任务类型",
    "timed.execution": "定时执行",
    "repeat.execution": "重复执行",
    "loop.execution": "循环执行",
    "task.execution.time": "任务执行时间：",
    "task.execution.last.start": "上次执行时间：",
    "task.execution.last.end": "上次结束时间：",
    "task.execution.last.msg": "上次执行结果：",
    "single.execution": "单次执行",
    "execution.everyDay": "每天 ",
    "until.end": " 执行，直到 ",
    "end.of": " 结束 ",
    "execution.day": "日 ",
    "execution.interval": " 执行间隔 ",
    "execution.minutes": " 分钟，",
    "execution.hour": " 小时，",
    "execution.day1": " 天，",
    "total.execution": " 总共执行 ",
    "unlimited.execution": " 不限制次数执行",
    "schedule.task.settings": "计划任务设置",
    "schedule.task.name": "计划任务名称",
    "schedule.task.save.tip": "您的计划任务设置未保存，确定离开当前页面？",
    "new.index": "新建索引",
    "singleColumn.index": "单列索引",
    "composite.index": "组合索引",
    "index.mode": "索引模式：",
    "field.type1": "字段类型：",
    "common.field": "普通字段",
    "index.subform": "子表单-",
    "index.field": "索引字段：",
    "set.index": "设置索引",
    "new.print.template": "新建打印模版",
    "del.print.tip": "你确定要删除此模版吗？删除此模版后，原先使用此模版的位置将会使用默认打印模版来打印表单。",
    "upgrade.package.tip": "如需要使用此功能请升级您的套餐",
    "backEnd.return.value": "后端返回值",
    "copy.link.address": "复制外链地址",
    "create.type.tip": "请选择您要创建的表单类型，开启应用搭建",
    "create.form.tip": "新建表单：用于数据提交，数据收集，带数据管理功能",
    "create.flowForm.tip": "新建流程表单：用于流程审批，申报，通知等场景",
    "create.report.tip": "新建报表：用于数据管理，汇总计算，趋势分析等场景",
    "create.etl.tip": "数据视图：用于对数据进行多表关联，汇总，分组排序计算",
    "form.recycle.bin": "表单回收站",
    "form.report": "表单/报表",
    "department.id": "部门id",
    "not.configured": "未配置",
    "configur.invalid": "配置失效",
    "s.alias": "的别名",
    "backEnd.virtual.form": "后端虚拟表单",
    "field.setting.field": "字段设置节点配置字段",
    "current.view.nodes": "当前数据视图已有{{ title }}节点",
    "view.nodes.name": "数据视图节点名称",
    "search.function.module": "请搜索您的功能插件",
    "search.data": "搜索数据",
    "new.function.module": "新建插件",
    "back.top.module": "回到功能插件列表顶部",
    "empty.module.tip": "没有任何功能插件，马上动手添加一个吧",
    "prompt": "提示：",
    "empty.module.tip2": "您暂时没有插件功能",
    "version": "版本：",
    'search.all': '搜索全部',
    'search.field': '搜索特定字段',
    'search.flow': '搜索流程信息',
    "del.tip": "你确定要删除吗？",
    "alias.error.tip": "别名同一报表下唯一，如果没有设置别名或者设置为空，则别名为默认，保存报表后生效",
    "nothing.error.tip": "还没有任何待办要处理",
    "nothing.error.tip1": "还没有参与任何流程",
    "has.timed.out": "已超时",
    "file": "文件",
    "file.wordtemplate": "word模板文件",
    "file.upload.wordtemplate.warning.tip": "请上传word模板文件",
    "select1": "请选择",
    "click.drag.image": "点击或拖拽上传图片",
    "button2": "按　钮",
    "click.select.data": "选择数据",
    "my.todo.status": "我的待办状态",
    "processed": "已处理",
    "process.status": "流程状态",
    "no.data.table": "数据表暂无数据",
    "not.query.data.tip": "没有符合条件的数据",
    "del.data.tip": "数据删除操作不可逆，是否确认删除此数据？",
    "formula.field": "公式字段",
    "enter.field.alias": "请输入字段别名",
    "duplicate.field.alias": "字段别名重复",
    "drag.field.tip": "拖动左侧字段到此处来添加筛选条件",
    "add.filter.field": "请先添加筛选条件字段。",
    "filter.condition.setting": "筛选条件设置",
    "filter.condition.relationship": "设置筛选条件与当前表字段关系",
    "filter.condition.filled": "当选择具体数据后，将按如下规则填充数据",
    "source.table.display": "数据源表显示",
    "add.operation.menu": "添加操作菜单",
    "Menu.Bar": "菜单栏：",
    "go.configuration": "【去配置】",
    "operation.menus": "最多只能添加{{ num }}个操作菜单",
    "menus": "菜单",
    "add.linkage.chart": "添加自定义联动图表",
    "add.chart.tip": "当前图表没有设置数据来源，无法添加图表自定义联动",
    "no.chart.available": "没有可用的图表",
    "add.quick.query": "添加快速查询",
    "ordinary.form.switch": "普通表单：用于数据提交,数据收集,带数据管理功能",
    "flow.form.switch": "流程表单：用于流程审批,申报,通知等场景",
    "event.form.switch": "事件表单：普通表单+开启后端脚本能力",
    "eventFlow.form.switch": "流程事件表单：流程表单+开启后端脚本能力",
    "print.template.settings": "打印模版设置",
    "print.template.settings.tip1": "文档存入附件字段",
    "print.template.settings.tip2": "选择存入的附件字段",
    "print.template.settings.tip3": "是否展示文档下载页面",
    "print.template.settings.tip4": "打印校验字段",
    "print.template.settings.tip41": "(生成打印文件前,需要效验哪些字段的必填和格式属性)",
    "print.template.settings.tip5": "选择需要校验的字段",
    "add.permission.group": "添加自定义权限组",
    "system.printing.template": "系统打印模版",
    "custom.print.template": "自定义打印模版",
    "understanding.print.templates": "了解打印模版",
    "custom.print.name": "填写自定义权限组名称",
    "Sure1": "确　定",
    "view.data.fields": "可查看数据那些字段",
    "page": "{{ val }} 条/页",
    "department.heads": "-部门主管",
    "node.alias.failed": "节点别名修改失败",
    "node": "节点",
    "node.alias": "节点别名",
    "node.alias.tip": "节点别名同一流程表单下唯一，如果没有设置别名或者设置为空，则别名为默认，保存流程表单后生效",
    "node.alias.tip2": "没有下级节点的节点会自动连接至流程结束节点；如果您需要在中途结束流程，请将需要结束流程的节点，连接到流程结束节点，并设置相应的流转条件。",
    "node.permissions": "节点权限",
    "departments.CC": "包含抄送人下级子部门",
    "node.print.template": "节点打印模版",
    "approval.operation": "对表单操作后可填写审批意见",
    "approval.operation.tip": "用户在处理流程时点击此按钮，将保存用户在此节点中对数据的更改，流程数据视图转至后续节点。",
    "allow.fallback.to": "允许回退到",
    "members.transfer.to": "转交成员可选范围",
    "flow.module": "流程插件",
    "cannot.triggered": "功能插件或者后端事件不能同时触发",
    "flow.briefing": "流程简报",
    "bulk.export": "批量导出",
    "bulk.move": "批量移动",
    "enterprise.user.id": "企业内用户ID",
    "have": "有",
    "not.join": "名成员未加入，",
    "invite.again": "再次全部邀请",
    "move.tip": "请选择需要移动部门的团队成员",
    "jobtitle.set.tip": "请选择需要设置职位的团队成员",
    "enterprise.tip": "组织架构中企业成员的唯一账号",
    "enterprise.tip1": "企业内成员的唯一标识，企业内可修改，企业内不可重复，推荐用于工号设置",
    "security.policy": "不受安全策略限制",
    "security.policy1": "受安全策略限制",
    "bulk.removal": "批量移除",
    "add.Security.Group": "添加安全组",
    "IP.restrictions": "IP限制",
    "Accessible.IP.settings": "可访问IP设置",
    "not.Security.Group": "您还没有创建安全组",
    "IP.address": "IP地址：",
    "team.invitation": "团队邀请",
    "mine": "@我的",
    "all.news": "全部消息",
    "unread.message": "未读消息",
    "read.message": "已读消息",
    "mark.all.read": "全部标为已读",
    "del.all.read": "删除全部已读消息",
    "System.reminder": "系统提醒",
    "Email.reminder": "邮箱提醒",
    "Set.recipient": "设置接收人",
    "add.recipient": "添加接收人",
    "recipient.management": "消息接收人管理",
    "unread1": "条未读)",
    "Auto.Start": "自动启动",
    "application.review": "应用审核中",
    "following.set.tip": "请勾选下面内容进行设置~",
    "page.sharing": "页面共享",
    "cross.application": "跨应用",
    "custom.menu": "自定义菜单",
    "Application.publishing": "应用发布",
    "select.app.tip": "请先在左边选择应用~",
    "workbench.mode": "工作台模式",
    "traditional.list": "传统列表",
    "Jiugongge.list": "九宫格列表",
    "menu.information": "菜单信息",
    "del.menu": "删除菜单",
    "name.menu": "菜单名称",
    "icon.menu": "菜单图标",
    "mode.menu": "菜单模式",
    "name.menu.tip": "建议菜单名称3-4个字符，以免影响美观",
    "icon.menu.tip": "请在系统图标库中选择对应图标",
    "form.view": "表单查看",
    "flow.toDo": "流程待办",
    "flow.toDo.tip": "流程待办模式，可以直接处理当前应用所有需要处理的流程事务。",
    "workbench.tip": "工作台，展示所有的表单信息，可以根据需要按列表或者九宫格模式展示。",
    "system.icon.library": "系统图标库",
    "view.mode.tip": "查看模式，可以直接进行数据提交或者查看报表具体数据信息。",
    "view.mode.tip1": "查看模式下，数据提交、报表数据查看，不受任何权限影响，完全公开。",
    "del.menu.tip": "删除后{{ name }}菜单下设置的内容将被删除",
    "app.brief": "应用简介",
    "app.brief.isempty": "应用简介不能为空",
    "app.baleing": "应用打包中",
    "app.version": "应用版本：",
    "Cloud.app.backend": "云应用后端：",
    "log.content": "日志内容",
    "log.time": "日志时间",
    "select.operator": "请选择操作人",
    "select.operator.type": "请选择操作类型",
    "Fuzzy.match.search": "模糊匹配搜索",
    "Creation.time": "创建时间：",
    "shut.accidentally": "意外关闭自动重启：",
    "Running": "运行中...",
    "NotRunning": "未运行",
    "Stop.backend.services": "停止后端服务",
    "Start.backend.services": "启动后端服务",
    "Application.URL.tip": "自定义应用URL, 可使用URL直接打开该应用",
    "Application.URL": "应用URL",
    "update.management": "更新管理",
    "Token.management": "Token管理",
    "Token.Access": "访问token",
    "Token.Access.tip": "你确定要冻结此访问token？冻结后此访问token的请求都会失效！",
    "Token.Access.tip1": "你确定要解冻此访问token？",
    "Token.Generate": "生成token",
    "Token.Generate1": "生成Token",
    "quantity.Generate": "生成数量",
    "normal": "正常",
    "thaw": "解冻",
    "Freeze": "冻结",
    "Set.notes": "设置备注",
    "Visit.link": "访问链接",
    "Set.Token.access": "设置Token访问备注",
    "Remarks.32.words": "备注不能超过32个字",
    "Post.link.words": "post接口访问链接：",
    "copy.Post.link.tip": "post接口访问链接复制成功",
    "Form.creation": "表单创建",
    "enter.URL": "请自定义输入url",
    "all1": "<全选>",
    "new.Management.Group": "新建管理组",
    "batch.Import": "批量导入",
    "Role.ID": "角色ID",
    "Role.New": "新建角色",
    "del.department": "删除部门",
    "Download.tip": "样表格式规范如下：",
    "Download.title": "批量导入角色",
    "Download.btn1": "下载表样",
    "Download1": "1、下载表样，按照表样格式进行填写。",
    "Download2": "2、表格中只需要第一行中有带“账号”的列，系统会自动识别。",
    "Download3": "3、批量导入最大数据500条。",
    "del.tip1": "删除成员会同时删除该成员权限，此操作不可逆。是否确认删除已选定成员？",
    "prompt1": "提示",
    "Export.tip": "导出{{ name }}所有成员吗",
    "Export.success": "导出成功",
    "Export.failed.tip1": "没有数据，导入失败",
    "remove.user.tip1": "请选择需要移除的成员",
    "Normal.mode": "普通模式",
    "enterprise.userID": "企业用户id",
    "invite.Download1": "1.导入账号直接生效",
    "invite.Download.title": "下载样表「样表文件格式」",
    "invite.Download2": "1.下载表样，不能增加、删除或修改本Excel表的成员信息类别，不填的留空即可。",
    "invite.Download3": "2.手机、姓名为必填，手机区号、企业内用户ID、部门、角色、邮箱为选填。",
    "invite.Download4": "3.部门格式为：上下级部门间用‘/’隔开，且从最上级部门开始，例如“总公司/长沙分部”；多个部门之间用英文‘,’隔开。",
    "invite.Download5": "4.部门为空，格式错误默认顶级部门。不存在的部门自动创建，不存在角色自动创建。",
    "invite.Download6": "5.批量导入最大数据200条。信息有误的成员不导入，如有超出，请分为多个文件导入。",
    "invite.Download7": "6.手机号作为唯一值，如果存在则修改其他字段信息。",
    "invite.Download9": "7.免激活模式的密码规则：6位到18位，不填写则默认为：123456  邮箱在免激活模式下有效。",
    "max.length.12": "最长12个字符",
    "max.length.16": "最长16个字符",
    "max.length.32": "最长32个字符",
    "max.length.64": "最长64个字符",
    "phone.tip1": "填写正确的手机号，会短信通知邀请",
    "phone.email.tip1": "填写正确的邮箱地址，会接收到邮件通知邀请",
    "enterprise.tip2": "建议使用员工工号等与公司统一的id",
    "del.member.tip2": "请选择需要删除的团队成员",
    "ip.tip2": "请检查IP是否填写错误",
    "ip.tip3": "删除安全组将无法还原，确定删除？",
    "ip.name": "安全组名称",
    "select.application": "请选择应用",
    "select.form": "请选择表单",
    "select.form1": "选择表单",
    "Data.management.export": "数据管理导出",
    "Attachment.bulk.export": "附件批量导出",
    "report.table.export": "新报表-数据表导出",
    "report.perspective.export": "新报表-透视图导出",
    "Installation.package.export": "安装包导出",
    "type.export": "请选择导出类型",
    "ing.export": "导出准备中",
    "download.export": "可下载",
    "status.export": "请选择状态",
    "time.export": "操作时间",
    "name.export": "应用/表单名称",
    "operating.instructions": "操作说明",
    "record.export.tip": "暂无导出记录",
    "no.data.tip": "目前还没有任何数据",
    "Upload.installation.package": "上传安装包",
    "select.app.module": "选择应用模板",
    "Import.installation.package": "导入安装包",
    "Name.in.team": "团队姓名",
    "to.be.verified": "待验证",
    "setting.recipient.title": "通知设置-接收人管理",
    "Recharge.status": "充值状态",
    "noRecharge.tip": "您还没有未支付订单",
    "more.module": "多插件",
    "more.module.tip": "多插件执行可支撑个数",
    "more.datahelper": "数据助手",
    "more.datahelper.tip": "数据助手执行可支撑个数",
    "form.link.style": "自定义表单外链样式",
    "CrossApp.access": "跨应用取数",
    "sys.num": "系统版本号",
    "sumb.num.tip": "是否立即提交订单",
    "sumb.type": "订单类型：",
    "buy.type": "购买套餐",
    "r.type": "续费套餐",
    "u.type": "升级套餐",
    "tip.type": "您当前使用的版本无法使用导出附件功能，如有需要，请升级套餐。",
    "logo.del": "外链去除logo",
    "Expire.date": "到期时间",
    "del.btn.date": "删除订单",
    "del.btn.tip": "是否删除此订单",
    "Total.payable": "应付总额",
    "upload.size": "上传附件大小",
    "more.module.run": "多插件执行",
    "sumb.type1": "订单类型",
    "sumb.time": "订单时间",
    "remaining.time": "剩余时间",
    "select.log.type": "请选择日志类型",
    "select.log.type1": "出票中",
    "select.log.type2": "团队日志",
    "select.log.type3": "个人日志",
    "select.log.type4": "添加/删除普通管理组",
    "select.log.type5": "添加/删除系统管理员",
    "select.log.type6": "添加/删除成员",
    "select.log.type7": "子管理员组权限分配",
    "select.log.type8": "清理应用数据",
    "select.log.type9": "绑定/解绑企业微信",
    "select.log.type10": "绑定/解绑微信",
    "select.log.type11": "企业微信的成员同步",
    "select.log.type12": "修改手机号",
    "select.log.type13": "绑定/解绑钉钉",
    "change.email": "换绑邮箱",
    "bing.registered.account": "绑定注册账号",
    "code.not.empty": "验证码不能为空",
    "bind.new.email": "绑定新邮箱",
    "bind.new.phone": "绑定新手机",
    "code.sent.to": "验证码已发送至",
    "wrong.input.enter": "手机号或邮箱输入有误？重新输入",
    "create.data.view": "新建数据视图",
    "set.alias": "设置别名",
    "last.refresh": "最后刷新：",
    "refresh.rule": "刷新规则",
    "repetition.cycle": "重复周期",
    "column.name": "列名：",
    "column.name1": "列名",
    "alias.name1": "别名：",
    "alias.set": "别名设置",
    "column.name1.tip": "表示的是数据视图输出字段标题原名。",
    "alias.name1.tip": "别名同一数据视图下唯一，别名命名规范",
    "alias.name1.tip2": "只能中文、数字和字母下划线组成的32个字符以内。",
    "alias.name1.tip3": "如果没有设置别名,则别名为默认别名。",
    "new.data.tip": "当前是最新数据",
    "refreshing.tip": "正在刷新，请稍等...",
    "new.time.tip": "循环刷新：每{{ time }}小时刷新一次",
    "data.view.noInput": "当前视图没有输出表",
    "data.view.error1": "数据视图刷新失败，请检查数据视图设置",
    "data.view.error2": "数据视图未保存输出节点字段信息",
    "refresh.data.view": "刷新视图列表",
    "data.view.del1": "删除数据视图后，该数据视图的输出数据也会一并被删除，删除的数据无法还原",
    "data.view.tip": "数据视图可对一个或多个数据源进行关联、聚合、追加合并等操作，形成输出表。\n 您可在报表中将输出表作为数据源使用。",
    "refresh.rule.tip1": "当视图的输入源表单有变动时，会在设置的时间间隔内刷新为最新数据，报表和表单调用时会调用最近一次视图刷新的数据",
    "refresh.rule.tip12": "适合场景：计算的及时性要求不高，分析类业务使用",
    "refresh.rule.tip13": "不适合场景：需要及时计算的场景",
    "refresh.rule.tip2": "会定时在天/周/月/年的某天某个时间刷新数据，报表和表单调用时会调用最近一次的视图刷新的数据。一般用于大数据量时，周期性汇总分析时使用",
    "refresh.rule.tip22": "适合场景：定期数据更新的场景",
    "refresh.rule.tip3": "及时刷新模式会在数据视图在访问时计算最新的数据并返回，访问的场景包含报表展示、数据联动、后端脚本查询等",
    "refresh.rule.tip32": "适合场景：常规的业务数据计算场景",
    "refresh.rule.tip33": "不适合场景：大数据计算的分析场景",
    "cycle.interval": "循环间隔",
    "data.view.alias": "数据视图别名",
    "refresh.log": "刷新日志",
    "refresh.log.tip": "（及时刷新不进日志，循环刷新和重复刷新进日志）",
    "sso.tip": "应用于企业账号URL",
    "permission.page.tip": "无权限访问此页",
    "my.team.name": "我的团队名称",
    "how.untie.WeChat": "怎样解绑企业微信授权？",
    "bills.details.tip": "请核对清楚开票信息，再确认",
    "bills.details.tip2": "抬头（名称）不能为空！",
    "bills.details.tip3": "纳税人识别号不能为空！",
    "bills.details.tip4": "收件人姓名不能为空！",
    "bills.details.tip5": "收件人联系方式不能为空！",
    "bills.details.tip6": "收件人邮箱地址或地址不能为空！",
    "bills.details.tip7": "开票提交成功，是否查看开票记录",
    "bills.details.tip8": "继续开票",
    "bills.details.tip9": "请选择需要合并开票的订单！",
    "Total.data": "总数据：",
    "Expired": "已到期",
    "renewal.duration": "续费时长",
    "gift.time": "赠送时间",
    "discounted.price": "优惠金额",
    "vip.renewal": "会员版续费",
    "vip.buy": "会员版购买",
    "Advisory.Service": "咨询客服",
    "Free.forever": "永久免费使用",
    "other.configure": "其他配置：",
    "vip.function": "会员功能：",
    "Import.excel.size": "导入excel大小",
    "Remove.LOGO.external": "外链去logo",
    "buy.webApi.tip": "（需要单独购买,3000元/年）",
    "Advanced.Features": "高级功能：",
    "No.Advanced.Features": "没有高级功能",
    "Independent.server.storage": "独立服务器存储",
    "Independent.IP": "独立ip",
    "domain.name": "域名(自定义)",
    "domain.name.Logo": "网站名和Logo(自定义)",
    "bind.name.public": "绑定企业公众号",
    "Service.level": "服务等级：",
    "All.apps.available": "可使用全部应用",
    "Service.time": "服务时间：",
    "Weekdays.time": "工作日09:00-17:30",
    "Weekdays.weekends": "工作日 09:00-17:30；双休日 10:00-17:00",
    "Alipay": "支付宝支付",
    "WeChat.payment": "微信支付",
    "Default.package": "默认套餐",
    "edit.avatar": "编辑头像",
    "upload.avatar": "上传本地图片",
    "Choose.package": "选择套餐",
    "Click.details": "（点击详情）",
    "Website.Terms": "《网站服务条款》",
    "Legal.Privacy": "《法律声明及隐私权政策》",
    "Package.contents": "套餐内容",
    "Total.paid": "实付总额",
    "paid.tip1": "通过创建视图，添加数据处理方式来对已有数据进行分析，同时还可调用数据",
    "paid.tip2": "满足企业内多人管理平台平台及企业内部分工明确的需求",
    "paid.tip3": "用来整合平台数据与任何外部数据",
    "Add.content": "加购内容",
    "release.title": "发布新报表",
    "Edit.Security.Group": "编辑安全组",
    "associated.control.settings": "选项关联字段设置",
    "Set.multiple.conditions": "设置多个关联条件限定关联数据",
    "Watch.video.started": "观看公式入门视频",
    "Watch.video.Advanced": "观看公式进阶视频",
    "Current.table.field": "当前表字段",
    "add.subform.field": "添加子表单字段",
    "Be.included": "被包含",
    "Current.field": "当前字段",
    "Linkage.table.field": "联动表字段",
    "subordinate.department.Contains": "包含负责人下级子部门",
    "pushmsg.department.Contains": "包含被提醒人下级子部门",
    "no.flow.log": "当前没有流程日志",
    "Select.file.tip": "当前套餐不包含批量导入成员，",
    "Select.file.tip2": "您是否要立即升级？",
    "no.department.widget": "表单中没有部门字段",
    "module.title1": "分类：",
    "module.title2": "安装次数：",
    "module.title3": "暂无说明",
    "module.title4": "说明：",
    "module.title5": "已加载全部",
    "flow.create.n2": "发起流程",
    "Import.data.img": "导出数据能否带图片",
    "Import.user": "批量导入成员",
    "form.scheduled.num": "表单计划任务个数",
    "replace.bound.phone": "更换绑定手机",
    "Invited": "已邀请",
    "unactivated": "未激活",
    "Editable.details": "可编辑详情",
    "Non-editable.details": "不可编辑详情",
    "Title": "职位",
    "Phone": "手机：",
    "EMAIL": "邮箱：",
    "Status": "状态：",
    "Account": "帐号：",
    "Invited.tip1": "成员没有绑定手机号，无法进行邀请",
    "Invited.tip2": "是否再次邀请手机号为{{ mobile }}的用户",
    "Invited.tip3": "发送邀请成功",
    "dept.tip": "子管理员权无法操作管理员权限面板",
    "add.dept.tip": "添加子部门成功",
    "dept.name": "部门名称",
    "edit.role.name": "修改角色名称",
    "dept.show.user": "显示子部门成员",
    "Test.account": "测试账号",
    "role.import.tip": "表样格式错误，无法导入，请检查或重新下载",
    "edit.Management.Group.tip": "修改普通管理组名称",
    "edit.dept.name": "修改部门名称",
    "department.ID": "部门ID",
    "form.data1": "表单数据",
    "phone.scan.signature": "手机扫码添加签名",
    "my.dept": "我的部门",
    "none.dept": "隐藏子部门成员",
    "pay.tip": "请确认是否支付此套餐？",
    "invite.Download8": "1.导入账号需要激活",
    "select.node.tip": "请先选择《当前节点》",
    "Set.quick.query": "设置快速查询名称",
    "Set.enter.query": "请输快速查询名称",
    "empty.app.tip": "点击此处创建应用，或直接从应用中心安装现有的成熟应用",
    "Invited.all.tip": "是否再次邀请全部未加入成员",
    "unbind.wechat.tip": "解除当前账号绑定关系吗？",
    "sn.config.tip": "仅当计数达到最大值时，从初始值开始重新计数。",
    "sn.config.tip2": "每日00:00:00，自动从初始值重新开始计数。一天内如果计数达到最大值，从初始值开始重新计数。",
    "sn.config.tip3": "每周一00:00:00，自动从初始值重新开始计数。一周内如果计数达到最大值，从初始值开始重新计数。",
    "sn.config.tip4": "每月首日00:00:00，自动从初始值重新开始计数。一月内如果计数达到最大值，从初始值开始重新计数。",
    "sn.config.tip5": "每年首日00:00:00，自动从初始值重新开始计数。一年内如果计数达到最大值，从初始值开始重新计数。",
    "Excel.title.tip": "上传的 Excel 表符合以下规范：",
    "Excel.title.tip2": "请使用",
    "Excel.title.tip3": "标准模版",
    "Excel.title.tip4": "导入数据",
    "Excel.title.tip5": "数据不能超过{{ limit }}行,最多只允许导入{{ limit }}行",
    "Excel.title.tip6": "仅支持 (*.xls 和 *.xlsx) 文件",
    "Excel.title.tip7": "文件大小不超过{{ size }}MB",
    "Excel.title.tip8": "文件中数据不能超过50000行、150列(子表单明细同样占用行数)",
    "Excel.title.tip9": "导入数据中如果包含图片字段，则文件数据行数不能超过{{ line }}行、150列",
    "Excel.title.tip10": "从最新数据开始",
    "Excel.title.tip11": "从最早数据开始",
    "Excel.title.tip12": "导出数据中图片总大小不能超过 {{ max }}M<br> ",
    "Excel.title.tip13": "带图片导出的excel文件大小会记录到上传总流量统计中",
    "Excel.title.tip14": "带图片导出",
    "Excel.title.tip15": "不带图片导出",
    "Excel.title.tip16": "可直接导出全部数据",
    "Excel.title.tip17": "一次只能导出{{ limit }}条数据",
    "Excel.title.tip18": "开始数据编号",
    "Excel.title.tip19": ",数据数量",
    "Excel.title.tip20": "若勾选「导入的数据触发流程」，则最多允许导入300条数据",
    "Excel.title.tip21": "子表单不参与数据更新",
    "clean.data.tip": "可清空的数据为有权限删除的数据，清空后将无法恢复，确定清空？",
    "index.title.tip": "索引名称",
    "index.title.tip2": "请输入此索引的名称",
    "index.title.tip3": "索引模式",
    "index.title.tip4": "未设置索引名称",
    "index.title.tip5": "索引设置名称",
    "index.title.tip6": "索引字段",
    "index.save.tip": "您的索引设置未保存，确定离开当前页面？",
    "switch.form.type.tip": "切换为非事件表单，云应用交互将不可用，是否确认切换？",
    "switch.form.type.tip1": "切换为事件表单，数据提交会与云应用交互，是否确认切换？",
    "switch.form.type.tip2": "切换为{{ text }}，是否确认切换？",
    "switch.form.type.tip3": "事件表单，数据提交会与云应用交互",
    "switch.form.type.tip4": "普通表单，流程相关功能将不可用并且云应用交互将不可用",
    "switch.form.type.tip5": "流程事件表单，数据管理权限设置将不可用并且数据提交会与云应用交互",
    "switch.form.type.tip6": "流程表单，数据管理权限设置将不可用",
    "schedule.name.tip1": "(计划任务名称必须唯一)",
    "schedule.Untitled.task": "未命名的计划任务",
    "schedule.time": "未设置执行时间",
    "schedule.time1": "执行时间必须大于当前时间至少2分钟",
    "schedule.time2": "未设置星期几执行",
    "schedule.time3": "未设置具体执行时间",
    "schedule.time4": "结束时间不能小于当前时间",
    "schedule.time5": "未设置循环次数",
    "schedule.time6": "未设置插件接口",
    "schedule.time7": "未设置插件接口参数",
    "schedule.time8": "未设置数据助手",
    "schedule.tip": "（日期和时间必须大于当前日期时间，才会生效）",
    "schedule.tip1": "（0表示无限循环执行，不会停止）",
    "schedule.tip2": "重复次数",
    "schedule.tip3": "重复间隔时间，不能小于30分钟",
    "report.edit.tip": "编辑界面只取数据源前200条作为查询数据预览，完整数据请访问页面查看。",
    "filter.add.tip": "请添加筛选条件",
    "filter.Default.tip": "添加字段",
    "filter.add.report": "报表的",
    "field.add.report": "字段值",
    "report.menu": "报表操作菜单",
    "phone.email.tip": "请输入正确的邮箱或手机",
    "money.tip": "请输入正确的充值金额",
    "zifu.tip": "请输入正确的字符",
    "flow.title": "待办流程",
    "exit.login": "退出登录",
    "switch.team": "切换团队",
    "waiting": "等待 ",
    "processing": " 的处理",
    "arrival.time": "到达时间：",
    "flow.num": "流程编号",
    "detailed.data": "详细数据",
    "display.show": "展开",
    "log.show": "... 展开",
    "Record.data": "添加记录",
    "etlEmpty.tip": "当前没有任何数据视图，请点击此处创建数据视图",
    "Province": "省份",
    "City": "城市",
    "Province.City.county": "省/自治区/直辖市",
    "print.no.tip": "您还没有为此表单创建过打印模版",
    "create.print.tip": "创建自定义打印模版",
    "add1": "新增",
    "report.menu1": "数据表操作菜单",
    "mobile.sumb": "提交并关闭",
    "mobile.dept1": "无效部门",
    "mobile.no.user": "无成员",
    "mobile.loading.more": "点击加载更多...",
    "mobile.user.set": "角色设置",
    "mobile.user.adds": "批量添加成员",
    "mobile.user.removes": "批量删除成员",
    "mobile.no.user.tip": "当前没有成员，请先添加！",
    "mobile.user.phone": "共{{ num }}个联系人",
    "mobile.user.select": "请选择成员！",
    "mobile.ok.len": "确定({{ len }})",
    "mobile.ok.pc": "还有没有角色，请在PC端新建，移动端只支持角色成员管理哦！",
    "mobile.ok.user.tip": "角色是什么？在组织架构之外的更加灵活便捷的业务组，适用于无差别的跨部门协作任务和流程审批等场景\n",
    "mobile.user.dept": "当前用户所在部门",
    "mobile.user.move": "批量移动成员",
    "mobile.user.creater.del": "创建者不能删除",
    "mobile.manage": "管理",
    "mobile.Synchronized": "同步成功",
    "mobile.Synchronized.user": "同步成员",
    "mobile.manage.set": "管理组设置",
    "mobile.Search": "搜索：",
    "mobile.account.no.tip": "当前账号无权限，请联系系统管理开通权限！",
    "mobile.Search.no.user": "找不到“{{ cont }}”相关的联系人",
    "mobile.no.user.ind": "还没有联系人，请邀请同事加入吧",
    "mobile.edit.user": "编辑成员信息",
    "mobile.user.cont": "成员信息",
    "mobile.no.more": "没有更多了",
    "mobile.user.ind": "邀请同事",
    "mobile.flow.data": "流程数据",
    "mobile.num": "请输入数字",
    "mobile.cont": "请选择内容",
    "mobile.read.all": "全部标记为已读",
    "not.used.template": "此模版未被任何位置使用",
    "Template.use.range": "模版使用范围",
    "dept.or.user": "部门或成员",
    "Custom.permission.group": "自定义权限组",
    "pay.mode.title": "支付方式：",
    "System.Administrator.Group": "系统管理员组",
    "Del.agg.table": "删除聚合表",
    "Del.agg.table.tip": "请确认是否删除聚合表{{ name }}，此操作不可逆",
    "Public.access": "公开权限",
    "delete.recycle.bin": "是否彻底删除回收站中选中的字段",
    "delete.recycle.filed": "请选择需要删除的字段",
    "delete.recycle.bin.tip": "字段彻底删除之后，对应的数据会一起删除。不可恢复",
    "flow.node.tip": "仅显示启用中流程的节点，其他版本的节点打印模版，请到该节点属性中设置。",
    "recover.are.tip": "确定恢复",
    "all.data.tip": "所有数据？",
    "del.are.tip": "确定彻底删除",
    "select.data.tip": "选中{{ len }}条数据，{{ cont }}？",
    "recover.fail.tip": "恢复失败",
    "recover.field.title": "是否恢复回收站中选中的字段",
    "recover.field.msg": "字段恢复之后，对应的数据会恢复正常访问",
    "recover.field": "请选择需要恢复的字段",
    "token.tip": "访问Token链接",
    "Trigger.formula": "触发公式：",
    "add.data.mode": "数据添加模式：",
    "Append.mode": "追加模式",
    "Overlay.mode": "覆盖模式",
    "select.Excel": "选择Excel表",
    "sub.set": "子表单设置",
    "dept.move.tip": "部门调整成功",
    "note.depend.tip": "当数据填充完成后，公式将自动执行",
    "del.widget.recycle.tip": "是否彻底删除回收站中所有的字段",
    "background": "背景颜色",
    "dept.move.tip1": "部门调整失败",
    "set.background.tip": "设置字段背景颜色显示条件",
    "set.noAuthority.tip": "当前没有可以设置的操作权限",
    "Add.extended.fields": "添加扩展字段",
    "set.extended.fields": "设置多个扩展字段",
    "title.State": "标题状态",
    "mobile.back.app": "返回应用主页",
    "mobile.msg.tip1": "请联系应用管理员，设置关联表单属性。",
    "mobile.msg.tip2": "请联系应用管理员，设置关联表单的数据来源。",
    "mobile.msg.tip3": "请联系应用管理员，设置关联表单的显示字段。",
    "mobile.msg.tip4": "请联系应用管理员，设置关联表单的字段的对应关系。",
    "mobile.msg.tip5": "请选择要加载的数据",
    "mobile.msg.tip6": "当前选择数据量已超过子表单最大数据限制，请重新选择",
    "mobile.msg.tip7": "事件触发失败",
    "mobile.msg.tip8": "角色名不能为空",
    "mobile.msg.tip9": "是否删除角色 ",
    "mobile.msg.tip10": "没有选择任何成员",
    "mobile.msg.tip11": "是否删除角色？",
    "mobile.msg.tip12": "角色名不能超过32个字",
    "mobile.msg.tip13": "签名保存成功",
    "mobile.msg.tip14": "签名保存失败，请及时联系平台官方技术人员处理",
    "mobile.msg.tip15": "添加员工",
    "mobile.msg.tip16": "创建部门成功",
    "mobile.msg.tip17": "请部门昵称不能为空",
    "mobile.msg.tip18": "删除部门会将部门所关联的权限一并删除，此操作不可逆。是否确认删除此部门？",
    "mobile.msg.tip19": "提交失败，找不到下个节点负责人。流程已暂存至「我的待办」中，请联系管理员检查节点负责人后重新提交。",
    "mobile.msg.tip20": "提交失败，不符合流转条件。流程已暂存至「我的待办」中，请联系管理员检查流转条件后重新提交。",
    "mobile.msg.tip21": "回退失败，找不到回退后的负责人。流程已暂存至「我的待办」中，请联系管理员检查节点负责人后重新提交。",
    "mobile.msg.tip22": "提交失败，不符合子流程节点流入条件。流程已暂存至「我的待办」中，请联系管理员检查节点负责人后重新提交。",
    "api.error4014": "有批量操作进行中，当前操作被拒绝",
    "api.error4003": "当前套餐不包含此功能",
    "api.error4005": "套餐用量超出限制",
    "api.error4006": "插入数据失败,后端代码返回错误：",
    "api.error4007": "图片大小超过套餐内允许的大小",
    "api.error4010": "数据插入成功,后端代码返回错误：",
    "api.error4015": "当前操作只支持团队模式为普通模式",
    "api.error4016": "企业内用户ID格式不正确,只能字母,数字,下划线32位内",
    "api.error4017": "企业内用户ID已存在",
    "api.error4018": "备注格式不正确，32位以内",
    "api.error4019": "职位格式不正确，16位以内",
    "api.error4020": "姓名格式不正确，只能中文,英文,数字,下划线,(,),-,空格,空格不能在头尾26位以内",
    "api.error4021": "部门参数不能为空",
    "api.error4022": "站点不允许注册用户",
    "api.error4023": "部门名称格式不合法，只能中文,英文,数字,下划线,(,),-,空格,空格不能在头尾16位以内",
    "api.error4024": "同级部门下存在同名子部门",
    "api.error4025": "父部门不存在",
    "api.error4026": "部门编号不合法",
    "api.error4027": "部门编号重复部门编号重复",
    "api.error4028": "存在子部门的部门不能被删除",
    "api.error4029": "存在成员的部门不能被删除",
    "api.error4030": "单次导入部门数量超出限制",
    "api.error4031": "部门级联层数超出限制",
    "api.error4032": "部门关系存在循环",
    "api.error4033": "至少需要一个子部门属于根部门",
    "api.error4034": "单次导入成员数量超出限制",
    "api.error4035": "企业内用户ID重复",
    "api.error4046": "批量创建数据超过100条限制",
    "api.error4047": "管理员不能删除",
    "api.error5001": "返回参数不为json格式",
    "api.error5002": "执行进程开启失败",
    "api.error5003": "获取源文件失败",
    "api.error5004": "脚本对象创建失败",
    "api.error5005": "读取脚本失败",
    "api.error5006": "_webapi函数不存在",
    "api.error5007": "脚本运行出错",
    "api.error6001": "角色组不存在",
    "api.error6002": "role_no已存在",
    "api.error6003": "角色组创建错误",
    "api.error6004": "角色组修改错误",
    "api.error6005": "角色组删除错误",
    "api.error6006": "添加失败",
    "api.error7001": "外部联系人分组不存在",
    "api.error7002": "分组名称不符合规则",
    "api.error7003": "和已有分组重名",
    "api.error7004": "分组重复",
    "api.error7005": "默认分组不可删除",
    "api.error7006": "分组有成员未删除",
    "api.error7007": "外部联系人已存在",
    "api.error7008": "修改外部联系人信息异常",
    "api.error7009": "用户已在通讯录成员，不能加入外部联系人",
    "api.error7010": "添加外部联系人不存在失败",
    "api.error8001": "企业创建者不能加入任何管理组",
    "api.error8002": "管理组名称不符合规则",
    "api.error8003": "系统管理员不能移出",
    "api.error8004": "已在其他分组",
    "api.error8005": "管理组已存在",
    "api.error10001": "应用分组创建失败",
    "api.error10002": "应用分组重命名失败",
    "api.error10003": "应用分组名称不符合规则",
    "api.error10004": "应用分组不存在",
    "api.error10005": "应用分组删除失败",
    "api.error10006": "表单不存在",
    "api.error11001": "数据重复",
    "api.error11002": "不允许转交",
    "api.error11003": "唯一字段对应的数据已存在",
    "api.error12001": "消息发送失败",
    "api.error12002": "消息内容错误",
    "api.error12003": "未匹配到合法的消息接收者",
    "api.error13001": "密钥不存在",
    "api.error13002": "当前套餐不包含平台级接口权限",
    "api.error13003": "团队信息不正确",
    "api.error13004": "赠送失败",
    "api.error13005": "账号不存在",
    "api.error13006": "应用安装失败",
    "Sharer.information": "分享人信息",
    "Installer": "安装者信息",
    "successfully.imported": "您成功导入了1条数据到表单[Unnamed form]中",
    "Download": "立即下载",
    "batch.edit": "批量修改后无法撤销，请谨慎操作:",
    "no.repeat": "设置不允许重复值的字段不支持修改:",
    "don't.support.batch": "文件字段、分割线、关联查询、关联数据、定位字段不支持修改。",
    "edit.log": "查看修改记录",
    "select.data.opreate": "请选择需要打印的数据",
    "no.edit.log": "无记录",
    "Node.dealing": "节点处理截止时间",
    "node.arrived": "流程到达节点",
    "After": "之后",
    "limit-time.action": "如何设置限时处理？",
    "Action.method": "处理方式",
    "Auto-notify.time": "自动提醒时间",
    "action.detail": "自动处理详情",
    "post.Code": "Post接口",
    "post.Code.tip": "以下接口路径中的app_id表示应用ID，可以前往会员中心的API文档进行查看。",
    "post.Code.tip1": "POST /api/v2/app/{app_id}/post -post接口",
    "post.Code.tip2": "能自定义传入json结构数据，将传入的数据发送给后端事件 _webapi，返回自定义json结构数据",
    "post.Code.tip3": "请求数据样例：",
    "post.Code.tip4": "_webapi事件原型",
    "post.Code.tip5": "自定义传入的json结构数据，转为内部可使用的数组格式",
    "post.Code.tip6": "附加信息，目前只包含ip信息",
    "post.Code.tip7": "_webapi事件接收和返回样例：",
    "post.Code.tip8": "自定义返回值",
    "post.Code.tip9": "自定义返回消息",
    "text.mode": "文本模式",
    "text.mode.text": "文本",
    "text.mode.password": "密码",
    "winxin.write": "请在手机微信中扫码填写此表单",
    "copy.form.link": "复制表单链接",
    'No.WeChat.public.account.configured': '当前系统未启用微信扫码登陆，无法开启微信增强功能',
    "view.data": "数据查看",
    "widget.map": "地图",
    "widget.card": "卡片",
    "widget.position": "位置",
    "switch.report.type.tip": "切换场景类型将会清空该报表所有设置，请确认是否进行此操作？",
    "switch.report.type": "切换此场景报表类型为：",
    "map.menu.bar": "地图表菜单栏",
    "sheet.map.menu.bar": "地图表菜单设置",
    "add.mapScope": "添加辐射半径",
    "add.mapScope.tip": "数字类型，用于地图上位置字段的有效范围的半径设置，以位置字段为中心，设置的字段值为半径的圆圈范围显示",
    "Nulllable": "不回写",
    "manualMarker": "设置手动标记点",
    "selectMarker": "设置搜索框标记点",
    "geolocationMarke": "设置当前位置标记点",
    "FunctionBtn.tip": "设置将触发_reportevent 事件，会将当前坐标，手动标记的坐标，搜索的坐标，当前的数据项，定位激活的数据项传给后端处理",
    "mapButton.tip": "用于显示操作按钮，点击后，可将地图上标记的坐标（点击地图或搜索地址生成的坐标点）设置到此条数据的[地图位置字段]中",
    "select.loc.tip": "搜索定位中心",
    "select.loc.list": "详情列表",
    "LAL.set.title": "坐标设置",
    "map.scale.title": "默认比例尺",
    "map.set.coordinates": "设置坐标",
    "scenes.set.tip": "*只能选择一种类型",
    "map.biaoshi": "地图标识",
    "map.menu1": "地图表操作菜单",
    "map.data.num": "共{{num}}条数据",
    "map.no.num": "当前表单内没有数字字段",
    "click.view.credentials": "点击查看凭证",
    "userVip.up.tip": "请选择升级或者续费",
    "app.install.tip2": "安装成功,返回应用管理",
    "app.install.tip3": "安装成功，3秒后返回应用管理",
    "app.install.tip4": "安装该应用需要密码，请输入密码：",
    "app.install": "安装",
    "del.Auth.tip": "删除权限组将无法还原，确定删除？",
    "formula.urlencode.intro": "URLENCODE函数可以将文本内容使用进行URL进行编码",
    "formula.urlencode.usage": "URLENCODE(text)",
    "formula.urlencode.example": "URLENCODE(文本)返回 %E6%96%87%E6%9C%AC",
    "formula.urlencode1.intro": "URLDECODE函数可以URLENCODE()函数编码过的内容进行解码",
    "formula.urlencode1.usage": "URLDECODE(text)",
    "formula.urlencode1.example": 'URLDECODE("%E6%96%87%E6%9C%AC")返回 文本',
    "formula.ISNAN.intro": 'ISNAN函数判断参数是否为特殊的非数字值NaN',
    "formula.ISNAN.usage": 'ISNAN(逻辑表达式1)',
    "formula.MD5.intro": '文本字符串的MD5值',
    yearTitle: "年",
    monthTitle: "月",
    "add.data": "追加数据",
    "cover.data": "覆盖数据",
    "import.data.tip": "您成功导入了{{len}}条数据到子表单中",
    "subform.import.data.tip": "子表单数据导入中 ",
    "entry.other.text": "请输入其他文本内容",
    "setFields.max.length": "最多添加{{ len1 }}个,已选<span>{{ len2 }}</span>个",
    "edit.field": "修改字段",
    "edit.field.empty.tip": "修改字段内容为空，会清空该字段的中符合条件的值，请确认是否需要修改",
    "install.module.tip": '请确认是否安装插件"{{name}}"吗？',
    "del.module.tip": '请确定是否删除插件"{{name}}"？',
    "del.datahelper.tip": '请确定是否删除数据助手"{{name}}"？',
    "datahelper.output.field.only": '至少保留一个字段，做为主表字段',
    "install.module": "插件安装",
    "update.module": "* 检测到插件有新版本可更新 *",
    "update.module.version": "更新版本",
    "no.flow.tip": "还没有任何流程要处理",
    "set.flow.tip": "请在流程设定中启用流程，然后为流程节点设置打印模版",
    "open.flow.fail": "启用流程版本失败！",
    "open.flow.update": "流程已启用，如需增删节点和连线，请添加新版本",
    "open.flow.overdue": "历史版本不可增删节点和连线，如需增删节点和连线，请切换至设计中的版本，或添加新版本",
    "left.form.select": "请选择左侧表",
    "left.form.field": "左侧当前表字段",
    "right.form.field": "右侧当前表字段",
    "right.form": "右侧表单",
    "left.form": "左侧表单",
    "left.relation.form": "左侧关联表",
    "right.relation.form": "右侧关联表",
    "left.form.drag": "请从左侧表单列表拖选一个表单/报表",
    "left.form.click": "点击左侧菜单进行编辑操作",
    "left.form.select.type": "左侧表单可选字段类型",
    "right.form.select.type": "右侧表单可选字段类型",
    "left.form.noSelect.type": "左侧表单字段类型限制",
    "right.form.noSelect.type": "右侧表单字段类型限制",
    "relation.form.source.mode": "关联表来源模式",
    "left.form.source.mode": "左侧表字段来源模式",
    "del.field.fictitious": "删除此虚拟字段",
    "free.no.export": "免费版不支持带附件/图片导出excel",
    "image.no.upFlow": "带附件/图片导出会计算上传流量",
    "current.data": "（当前数据）",
    "map.btn.tip": "用于显示操作按钮,点击触发动作,配置回写类型以后会把配置的标点坐标回写到当前数据项的[地图位置字段]中",
    "field.fictitious": "虚拟字段",
    "add.field.fictitious.form": "添加虚拟表字段",
    "output.table": "输出表",
    "select.address": "请选择地址",
    "select.address.sub": "选择地址",
    "select.date": "请选择日期",
    "select.start.date": "请选择起始日期",
    "select.end.date": "请选择结束日期",
    "signature.entry.tip": "请在空白区域横向书写签名",
    "linkageing.tip": "数据联动中，请稍后再试",
    "entry.flow.tip": "请填写流程审批意见..",
    "Approval.signature": "审批签名",
    "Approval.signature.required": "审批签名必填",
    "Collapse.all.details": "收起所有明细数据",
    "show.all.details": "展开所有明细数据",
    "data.all.show": "数据已全部显示",
    "mobile.leave.page.tip": "离开页面可能会丢失已填写的数据，确定要离开页面吗？",
    "no.process.toMe.tip": "没有抄送给我的流程",
    "initiated.process.yet.tip": "还没有发起任何流程",
    "no.data.yet.tip": "没有任何数据",
    "msg.all.read.tip": "消息已全部标为已读",
    "set.filter.criteria": "设置筛选条件",
    "set.Custom.filtering": "自定义筛选",
    "select.no": "当前无选项",
    "click.set.read": "点击置为已读",
    "type.dian": "类型：",
    "Me": "我",
    "view.all.log": "查看所有日志",
    "del.user.tip": "是否删除成员？",
    "del.source.file.tip": "请确认是否删除源文件 \"{{ name }}\" 吗？",
    "edit.field.fictitious.form": "编辑虚拟表字段",
    "flow.field": "流程字段",
    "successfully.uploaded": "凭证上传成功",
    "entry.phone": "请输入绑定手机号",
    "edit.user": "修改人：",
    "wechat.Bind": "微信绑定",
    "wechat.unBind": "微信解绑",
    "phone.replacement": "更换手机",
    "del.app.tip": "你确定要删除 “{{ name }}” 应用吗？",
    "please.del.tip": "请确认是否删除此条记录",
    "account.Ordinary": "普通账号",
    "recharge.less": "充值金额不能小于或等于零",
    "upload.transfer.voucher": "请上传转账凭证",
    "upload.transfer.voucher2": "联系人不能为空",
    "upload.transfer.voucher3": "手机号不能为空",
    "upload.transfer.voucher4": "打款账户名不能为空",
    "upload.transfer.voucher5": "打款账户号码不能为空",
    "sys.num.tip": "当前系统版本号为{{num}}",
    "vip.time.tip": "会员版本从{{ sTime }}起至{{ eTime }}到期",
    "Currently.contains.tip": "当前包含",
    "vip.center.sys_manager1": "您的{{ name }}已达总量",
    "vip.center.sys_manager2": "您的{{ name }}已超过总量",
    "vip.center.sys_manager3": "您目前版本{{ name }}已超过总量，如需更多，请升级套餐",
    "vip.center.sys_manager4": "您目前版本{{ name }}已达到总量，如需更多，请升级套餐",
    "vip.center.sys_manager5": "您当前版本不支持{{ name }}配置，如有需要，请升级套餐",
    "vip.center.sys_manager6": "{{ name }}总个数为{{ num }}，如需配置更多{{ name }}，请升级套餐",
    "vip.center.sys_manager7": "您当前版本不支持{{ name }}配置，如有需要，请联系管理员",
    "vip.center.sys_manager8": "{{ name }}总条数为{{ num }}，如需配置更多{{ name }}，请联系管理员",
    "vip.center.excel": "导入单个Excel文件最大值为{{ num }}，如需导入更大的Excel文件，请升级套餐",
    "vip.center.upload": "单个上传附件大小的最大值为{{ num }}，如需上传更大的附件，请升级套餐",
    "vip.center.hszTime": "回收站数据保留时间最长为{{ num }}天，如需保留时间更长，请升级套餐",
    "vip.center.dont": "您当前版本不支持{{ name }}，如有需要，请升级套餐",
    "vip.center.yes": "您当前版本支持{{ name }}哦~",
    "vip.center.img": "导出数据带图片",
    "vip.center.style": "表单外链自定义样式",
    "vip.center.module": "多插件执行可最多支撑个数为{{ num }}个，如需支持更多，请升级套餐",
    "vip.center.datahelper": "数据助手执行可最多支撑个数为{{ num }}个，如需支持更多，请升级套餐",
    "vip.center.scheduled": "表单计划任务最多支持个数为{{ num }}个，如需支持更多，请升级套餐",
    "vip.center.call": "请联系管理员",
    "vip.center.kefu": "请联系官方客服",
    "LALdimension.length": "{{ name }}只支持{{ len }}个位置字段，不能再添加更多了",
    "Electronic.invoice": "电子发票",
    "Electronic.invoice.tip": "请填写正确的手机号接收电子发票信息",
    "Electronic.invoice.tip2": "请填写正确的邮箱地址接收电子发票信息",
    "Paper.invoice": "纸质发票",
    "email.address": "邮箱地址",
    "phone.entry.tip": "请填写正确的手机号",
    "address.entry.tip": "请填写正确的收件地址",
    "header.name": "抬头（名称）",
    "Taxpayer.Number": "纳税人识别号",
    "phone.address": "电话、地址",
    "Bank.account": "开户行及账号",
    "Recipient.address": "收件地址",
    "Contact.information": "联系方式",
    "module.title.source": "插件源码",
    "module.development.title.release": "插件设计 - 功能插件设置",
    "Cache.tip": "进入表单时，自动加载上次的填写的内容。永久缓存，上次填写的内容会实时更新，且不会消失。提交缓存，当数据提交后，上次的填写内容缓存就会被清空",
    "navigation": "导航",
    "Shared.with": "共享给",
    "excel.export.tip": "有选择图片字段，请设置 [开始数据编号]",
    "excel.export.tip1": "有选择图片字段，请设置 [数据数量]",
    "excel.export.tip2": "有选择图片字段，[数据数量] 范围只支持1-{{ num }}",
    "excel.export.tip3": "数据编号<a style='color:#F5222D'>从大到小</a>，开始编号为<a style='color:#F5222D'>{{ start }}</a>，结束编号为<a style='color:#F5222D'>{{ end }}</a>，总共<a style='color:#F5222D'>{{ count }}</a>条",
    "excel.export.tip4": "数据编号<a style='color:#F5222D'>从小到大</a>，开始编号为<a style='color:#F5222D'>{{ start }}</a>，结束编号为<a style='color:#F5222D'>{{ end }}</a>，总共<a style='color:#F5222D'>{{ count }}</a>条",
    "excel.export.tip5": "当前图表数据来源为数据视图",
    "excel.export.tip6": "开始数据序号",
    "excel.export.tip7": "有选择图片字段，请设置 [初始数据序号]",
    "excel.export.tip8": "有选择图片字段，请设置 [初始数据编号]",
    "excel.export.tip9": "数据编号范围内没有数据，请重新设置数据编号范围",
    "excel.export.tip10": "数据开始序号为<a style='color:#F5222D'>{{ start }}</a>，结束序号为<a style='color:#F5222D'>{{ end }}</a>，总共<a style='color:#F5222D'>{{ count }}</a>条",
    "excel.export.tip11": "导入 Excel 数据到子表单",
    "excel.export.tip12": "excel文件超过{{ limit }}行数据，无法导入到子表单。请修改后重新导入",
    "excel.export.tip13": "excel文件中的数据包含合并单元，无法导入到子表单",
    "excel.export.tip14": "工作表名称",
    "excel.export.tip15": "导入数据错误较多，请返回上一步检查字段类型，或在原excel中进行修改后再重新导入。如不修改，则错误数据导入后为空值",
    "excel.export.tip16": "当前通讯录中匹配到以下姓名相同的成员，请修改成员姓名或者以“姓名(账号)”的格式编辑excel数据后重新导入",
    "excel.export.tip17": "当前通讯录中匹配到以下姓名与账号不对应的的成员，请修改成员姓名或者以“姓名(账号)”的格式编辑excel数据后重新导入",
    "excel.export.tip18": "当前通讯录中匹配到以下部门名称相同，请修改部门名称后重新导入",
    "excel.export.tip19": "以下字段存在重复值的，请修改正确值之后重新导入",
    "excel.export.tip20": "以下字段存在空值的，请修改正确值之后重新导入",
    "excel.export.tip21": "当前导出附件/图片大小 <a style='color:#F5222D'>{{ size }}M</a>，已经超过 <a style='color:#F5222D'>{{ max }}M</a> 的限制",
    "excel.export.tip22": "当前导出附件/图片大小 {{ size }}M，导出附件/图片的最大限制为 {{ max }}M",
    "excel.export.tip23": "当前图表数据来源于聚合表",
    "excel.export.error": "出错啦",
    "excel.export.tip24": "工作簿为空，请调整后重新导入",
    "excel.export.tip25": "工作簿表头为空，请调整后重新导入",
    "date.today1": "今",
    "my.address": "我的位置：",
    "address.seach.empty": "未搜索到数据",
    "address.all.show": "全部显示",
    "only.show1": "仅显省/市/县区",
    "only.show2": "仅显省/市",
    "only.show3": "仅显示省",
    "only.show4": "显示行政级别",
    "only.show5": "开启经纬度定位",
    "only.select.Map.address": "请选择地址",
    "etl.update.tip": "正在更新数据视图数据，更新完成后，图表会自动刷新",
    "down.refresh": "下拉刷新",
    "append": "追加",
    "cover": "覆盖",
    "release.refresh.data": "释放刷新数据",
    "empty.form.tip": "这是一张空表单",
    "administrator.no.permission": "子管理员无权限",
    "Member.moved.successfully": "成员移动成功",
    "Department.added.successfully": "添加部门成功",
    "Department.set.successfully": "设置部门成功",
    "move.members": "移动成员",
    "no.data.edit": "当前没有数据可以编辑",
    "edit.set.department": "修改/设置部门",
    "team": "团队",
    "new.department": "新建部门",
    "department.name.empty": "部门名不能为空",
    "department.name.del": "是否删除部门 {{ name }} ？",
    "add.administrator": "添加管理员",
    "Select.application.edited": "选择可编辑的应用",
    "Select.manageable.departments": "选择可管理的部门",
    "Administrative.all.applications": "对所有应用的管理权限",
    "all.access.functions": "对所有功能权限",
    "all.administrative.members": "对所有成员的管理权限",
    "Application.added.successfully": "添加应用成功",
    "Administrator.added.successfully": "添加管理员成功",
    "Management.group": "管理组",
    "New.general.management.group": "新建普通管理组",
    "General.management.name.empty": "普通管理组名不能为空",
    "del.management.tip": "是否删除普通管理组 {{ name }} ？",
    "add.role.tip": "请添加角色",
    "del.select.user.tip": "是否删除选中成员？",
    "no.operational.data": "没有可操作的数据",
    "Rename.role": "重命名角色",
    "phone.email.error.tip": "手机号码/邮箱输入有误",
    "phone.email.invitation": "手机/邮箱邀请",
    "invitation.success": "邀请成功",
    "invitation.phone.tip": "通过手机号邀请非中国大陆成员用户时，请在手机号前添加国际电话区号，例:+886912345689",
    "show.invited.members": "仅显示已经邀请的成员",
    "invitation.phone.tip2": "输入手机号或邮箱来邀请成员，多个成员之间用英文“,”隔开，或者换行输入",
    "invitation.phone.tip3": "通过手机号邀请成员时，请先确保手机号绑定了平台账号，否则无法接收到成员邀请消息。暂时不支持非大陆手机号绑定注册账号",
    "invitation.phone.tip4": "开启邀请链接后，只需访问此链接，即可加入您的团队",
    "invitation.phone.tip5": "公开链接复制成功",
    "empty.form.report.tip5": "这是一个空的表单/报表",
    "empty.report.tip6": "这是一张空报表",
    "empty.report.tip7": "查看过滤条件",
    "empty.report.tip8": "应用名称不正确",
    "empty.report.tip9": "请选择最小值",
    "empty.report.tip10": "请选择最大值",
    "empty.report.tip11": "请确认是否执行操作",
    "show.all": "显示全部",
    "empty.report.tip12": "该文件类型不支持预览",
    "empty.report.tip13": "最多只允许选择{{ maxFileCount }}个文件",
    "empty.report.tip14": "选择当前节点后，可以通过节点的可见字段来筛选流程数据",
    "empty.report.tip15": "筛选字段为空，请设置筛选字段",
    "empty.report.tip16": "过滤字段为空，请设置过滤字段",
    "empty.report.tip17": "请先选择流程表单",
    "date.ago.hours": "{{value}}小时前",
    "date.ago.day": "{{value}}天前",
    "empty.report.tip18": "空空如也，这里什么都没有耶",
    "empty.report.tip19": "当前没有审批意见..",
    "empty.report.tip20": "流程已撤回",
    "empty.report.tip21": "流程已结束",
    "empty.report.tip22": "数据已提交",
    "empty.report.tip23": "请选择回退节点",
    "empty.report.tip24": "是否确认结束流程",
    "empty.report.tip25": "转交负责人不能为空",
    "empty.report.tip26": "请先选择打印模板",
    "empty.report.tip27": "打印模板列表",
    "empty.report.tip28": "未找到打印模板，请联系管理员确认流程节点是否设置打印模板",
    "empty.report.tip29": "打印({{ text }})",
    "empty.report.tip30": "系统模板",
    "empty.report.tip31": "打印(系统模板)",
    "empty.report.tip32": "操作状态",
    "empty.report.tip33": "超时自动提交",
    "empty.report.tip34": "超时自动回退",
    "empty.report.tip35": "自动结束",
    "empty.report.tip36": "自动结束失败",
    "empty.report.tip37": "抄送给：",
    "empty.report.tip38": "暂无筛选结果",
    "empty.report.tip39": "匿名",
    "flow.list.multiNode1": "-多个节点",
    "flow.list.multiNode2": "未知状态",
    "flow.list.multiNode3": "没有查询到符合条件的流程",
    "flow.list.multiNode4": "请选择打印模板",
    "flow.list.multiNode5": "结束成功",
    "flow.list.multiNode6": "请选择需要激活的流程节点",
    "flow.list.multiNode7": "不支持选择的图片类型",
    "flow.list.multiNode8": "图片上传失败",
    "flow.list.multiNode9": "最多只允许选择{{ maxFileCount }}张图片",
    "flow.list.multiNode10": "正在定位中...",
    "flow.list.multiNode11": "清空地址",
    "flow.list.multiNode12": "汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|公共设施",
    "flow.list.multiNode13": "搜索的地点不存在或超出范围",
    "flow.list.multiNode14": "正在定位...",
    "flow.list.multiNode15": "定位失败请刷新重试...",
    "flow.list.multiNode16": "获取经纬度失败",
    "flow.list.multiNode17": "该标记点的经纬度为：",
    "flow.list.multiNode18": "该位置字段不能进行定位",
    "flow.list.multiNode19": "已读消息已全部删除",
    "flow.list.multiNode20": "消息内容",
    "flow.list.multiNode21": "点击设置部门",
    "flow.list.multiNode22": "打印模板列表为空",
    "quick.go": "快捷处理",
    "quick": "快捷",
    "time1": "时间：",
    "time2": "当天空闲",
    "time3": "查询字段",
    "time4": "请联系贵司 管理员，将表单/报表并共享给您",
    "time5": "不会操作？请点这里",
    "time6": "新建分组失败",
    "time7": "您没有团队可切换",
    "time8": "分享人账号",
    "time9": "筛选结果",
    "time10": "流程分组",
    "time11": "请选择流程表单",
    "time12": "请选择当前节点",
    "time13": "更改查询条件",
    "time14": "抱歉，您的流程消息已过期",
    "time15": "您还不在成员列表中",
    "time16": "请联系管理员同步成员",
    "time17": "本内容由用户通过 {{ site_name }} 发布，并不代表{{ site_name }}的立场。 ",
    "time18": "此项超出规定范围",
    "time19": "附件正在上传中,请稍后进行提交操作",
    "time20": "流程出错了，请联系发布者处理",
    "time21": "保存中",
    "time22": "二维码不存在或者已过期",
    "subform.data.load.tip": "请联系应用管理员，设置数据加载。",
    "subform.data.load.tip2": "请联系应用管理员，设置数据加载的来源。",
    "subform.data.load.tip3": "请联系应用管理员，设置数据加载的显示字段。",
    "subform.data.load.tip4": "请联系应用管理员，设置数据加载时字段的对应关系。",
    "subform.data.load.tip5": "普通管理组不能为空",
    "subform.data.load.tip6": "请确认是否执行 {{ triggerEventButton }} 功能",
    "subform.data.load.tip7": "文本内容为空，不能生成二维码",
    "subform.data.load.tip8": "通过扫一扫添加",
    "subform.data.load.tip9": "设置转交负责人",
    "subform.data.load.tip10": "当前环境不支持扫码功能",
    "subform.data.load.tip11": "请输入正确的值",
    "subform.data.load.tip12": "还没有普通管理组,请先创建！",
    "subform.data.load.tip13": "当前无权限管理，请联系系统管理员分配权限",
    "subform.data.load.tip14": "系统管理员(点击编辑系统管理员)",
    "subform.data.load.tip15": "通讯录权限",
    "subform.data.load.tip16": "应用权限(手机端只支持查看)",
    "subform.data.load.tip17": "通讯录管理范围(不选择任何部门时，默认可管理所有部门，手机端只支持查看)",
    "subform.data.load.tip18": "普通管理员(点击编辑普通管理员)",
    "subform.data.load.tip19": "普通管理员",
    "subform.data.load.tip20": "手机端不支持{{ title }}添加,只支持查看",
    "subform.data.load.tip21": "职位",
    "subform.data.load.tip22": "企业内ID",
    "subform.data.load.tip23": "已有账号站内信通知，新用户短信通知。",
    "subform.data.load.tip24": "确认并发送",
    "subform.data.load.tip25": "部门昵称",
    "subform.data.load.tip26": "部门设置",
    "subform.data.load.tip27": "添加主管",
    "subform.data.load.tip28": "选择主管",
    "subform.data.load.tip29": "邀请同事加入",
    "subform.data.load.tip30": "号码查看",
    "subform.data.load.tip31": "通讯录显示",
    "subform.data.load.tip32": "没有成员，请先添加成员！",
    "subform.data.load.tip33": "角色是什么？在组织架构之外的更加灵活便捷的业务组，适用于无差别的跨部门协作任务和流程审批等场景\n",
    "subform.data.load.tip34": "部门设置成功",
    "subform.data.load.tip35": "添加成员成功",
    "subform.data.load.tip36": "-移动成员",
    "subform.data.load.tip37": "当前数据没有设置坐标的权限",
    "subform.data.load.tip38": "请联系应用管理员，设置数据加载树菜单的配置。",
    "subform.data.load.tip39": "请联系应用管理员，设置数据加载树菜单配置中的标题字段。",
    "subform.data.load.tip40": "请联系应用管理员，设置数据加载树菜单配置中的标题节点id字段",
    "subform.data.load.tip41": "请联系应用管理员，设置数据加载树菜单配置中的标题父节点id字段",
    "subform.data.load.tip42": "请联系应用管理员，设置数据加载树菜单配置中的标题根节点",
    "card.show.top.left": "在卡片标题中显示左上字段",
    "card.show.top.right": "在卡片标题中显示右上字段",
    "card.show.down.right": "在卡片标题中显示右下字段",
    "card.show.down.left": "在卡片标题中显示左下字段",
    "Lng": "，经度：",
    "new.Date": "最新数据",
    "user.detail": "成员详情",
    "editer_browser": "浏览器",
    "editer_button_add": "添加",
    "editer_button_back_add": "返回添加",
    "editer_button_cancel": "取消",
    "editer_button_del": "删除",
    "editer_button_edit": "编辑",
    "editer_button_not_save": "不保存",
    "editer_button_ok": "确定",
    "editer_button_save": "保存",
    "editer_button_autosave": "自动保存",
    "editer_button_save_all": "保存全部",
    "editer_button_select_all": "全选/反选",
    "editer_button_set": "设置",
    "editer_button_submit": "提交",
    "editer_byte": "字节",
    "editer_can_not_repeat": "不允许重复",
    "editer_char_all_display": "显示不可见字符",
    "editer_clipboard": "查看剪贴板",
    "editer_clipboard_null": "剪贴板为空！",
    "editer_clipboard_state": "剪切板状态:",
    "editer_clone": "创建副本",
    "editer_close": "关闭",
    "editer_close_all": "关闭全部",
    "editer_close_others": "关闭其他",
    "editer_close_right": "关闭右侧标签",
    "editer_cloud": "云应用",
    "editer_code_mode": "高亮语法",
    "editer_code_theme": "代码风格",
    "editer_complete_current": "自动补全当前",
    "editer_contain": "包含",
    "editer_copy": "复制",
    "editer_copy_not_exists": "来源不存在",
    "editer_createLink": "创建快捷方式",
    "editer_createProject": "添加到编辑器工程",
    "editer_create_error": "新建失败,请检查目录权限！",
    "editer_create_success": "新建成功！",
    "editer_create_time": "创建时间",
    "editer_current_has_parent": "目标文件夹是源文件夹的子文件夹!",
    "editer_cute": "剪切",
    "editer_cute_past_success": "<b>剪切操作完成</b>(源文件被删除,剪贴板清空)",
    "editer_cute_success": "【剪切】—— 覆盖剪贴板成功!",
    "editer_data_error": "数据出错！",
    "editer_data_not_full": "数据提交不完整！",
    "editer_font_size": "字体",
    "editer_auto_complete": "自动提示",
    "editer_dialog_close_all": "关闭所有窗口",
    "editer_dialog_display_all": "显示所有窗口",
    "editer_dialog_min": "最小化",
    "editer_dialog_min_all": "最小化所有",
    "editer_edit": "编辑",
    "editer_edit_can_not": "不是文本文件",
    "editer_edit_too_big": "文件太大,不能大于2M",
    "editer_error": "操作失败",
    "editer_error_repeat": "'操作失败，请注意名称不能重复！'",
    "editer_file": "文件",
    "editer_file_type": "文件类型",
    "editer_full_screen": "全屏/退出全屏",
    "editer_function_list": "函数列表",
    "editer_get_success": "获取成功!",
    "editer_getting": "获取中...",
    "editer_go": "走着!",
    "editer_go_up": "上层",
    "editer_goto": "跳转到",
    "editer_gotoline": "跳转到行",
    "editer_search": "搜索",
    "editer_selectAll": "全选",
    "editer_if_remove": "确认删除",
    "editer_if_save_file": "文件尚未保存,是否保存？",
    "editer_info": "属性",
    "editer_menu_hidden": "隐藏",
    "editer_menu_move_del": "删除",
    "editer_menu_move_down": "下移",
    "editer_menu_move_up": "上移",
    "editer_menu_name": "菜单名",
    "editer_preview": "预览",
    "editer_redo": "反撤销",
    "editer_refresh": "刷新",
    "editer_reload": "重新载入",
    "editer_remove": "删除",
    "editer_remove_fali": "删除失败!",
    "editer_remove_info": "确认删除选中内容吗？",
    "editer_remove_item": "项内容",
    "editer_remove_success": "删除成功！",
    "editer_remove_title": "删除确认",
    "editer_rename": "重命名",
    "editer_replace": "替换",
    "editer_rname_success": "重命名成功！",
    "editer_root_path": "云系统",
    "editer_save_path": "保存路径",
    "editer_save_success": "保存成功!",
    "editer_shortcut": "快捷键",
    "editer_show_file": "新页面预览",
    "editer_size": "大小",
    "editer_sort_down": "递减",
    "editer_sort_type": "排序方式",
    "editer_sort_up": "递增",
    // "success": "操作成功",
    "editer_tips": "提示",
    "editer_tools": "工具",
    "editer_type": "类型",
    "editer_undo": "撤销",
    "editer_view": "视图",
    "editer_warning": "警告",
    "editer_width": "宽",
    "editer_wordwrap": "自动换行",
    "editer_Compile": "编译",
    "editer_Compile.error": "编译错误",
    "isOk.tip": "是否确认",
    "app.stop": "停止云应用",
    "app.start": "启动云应用",
    "app.restart": "重启云应用",
    "app.stop.tip": "是否停止云应用",
    "app.start.tip": "是否启动云应用",
    "app.restart.tip": "是否重启云应用",
    "app.notsave.tip": "请先保存所有的源文件",
    "create.py.app.tip": "当云应用包含python文件，云应用会自动转换为以python语言运行",
    "create.py.module.tip": "当功能插件包含python文件，功能插件会自动转换为以python语言运行",
    "custom.language": "当前语言类型：",
    my: "我的",
    "urge": "催一下",
    "flow.wait.time": "等待时长：",
    "flow.dealwith.time": "处理时长：",
    "flow.total.time": "累计时长：",
    "pending": "待处理",
    "flow.node.charger.more.tip": "当前节点所有负责人全部提交才允许通过",
    "flow.node.charger.single.tip": "当前节点任意负责人提交就允许通过",
    "flow.action.batchForward": "批量提交",
    "flow.todo.all": "全部流程",
    "webApi.lua1": "LUA 语法:",
    "webApi.python1": "Python 语法:",
    "webApi.sort": "排序（asc：正序；desc：倒序），不限制排序字段的数量，复选框组、下拉复选框、地址、定位、图片、附件、手写签名、成员单选、成员多选、部门单选、部门多选不可作为排序字段",
    "batch.forward.tip": "开启后，用户在处理流程时点击此按钮，可以批量提交流程待办。批量提交时不进行表单校验，不触发公式、联动，请谨慎使用。",
    "batch.forward.select.all": "全选本页",
    "batch.forward.select.tip": "已选中 {{- count}} 条（仅可选中有批量提交权限的待办)",
    "batch.forward.empty": "没有可操作的待办",
    "batch.forward.select.tip1": "已选中{{- count}}条",
    "batch.forward.select.tip2": "（仅可选中有批量提交权限的待办)",
    "batch.forward.warning.select": "请选择需要操作的待办",
    "batch.forward.warning.limit": "最多勾选{{count}}条待办",
    "batch.forward.progress.title": "正在提交，请勿离开当前页面",
    "batch.forward.progress.tip": "已提交{{count}}条/共{{total}}条",
    "batch.forward.finish.tip": "成功{{success}}条，失败{{fail}}条",
    "batch.forward.break.tip": "已提交{{total}}条（成功{{success}}条，失败{{fail}}条），未提交{{remain}}条",
    "webapi_forward": "webapi提交",
    "script_forward": "后端提交",
    "script_close": "后端结束流程",
    "app.common": "常用应用",
    "app.empty1": "暂无应用",
    "speedy.entry": "快捷入口",
    "chart.board": "报表看板",
    "api.getSortData": "排序查询数据",
    "api.query.sort": "根据排序查询多条数据接口",
    "api.skip.sort": "翻页起始值索引",
    "appEmpty": "当前您还没有应用，点击上方创建新应用",
    "app.custom.add.tip": "将常用的应用添加到此处",
    "entry.speedy.add.tip": "将应用内常用的表单、流程或报表添加到此处",
    "dash.custom.add.tip": "将您最常关注的报表添加到此处",
    "dash.custom": "自定义工作台",
    "dash.design.company": "设置企业默认工作台",
    "dash.design.custom": "设置我的工作台",
    "add.common.app": "点击下方应用进行添加",
    "show.dash.common.app": "显示在工作台",
    "edit.common.app": "编辑常用应用",
    "add.common.app.title": "添加常用应用",
    "flow.todo.empty.tip": "请选择表单处理相关流程信息",
    "flow.center": "流程中心",
    "save.data.tip": "保留示例数据（推荐）",
    "installed.app.tip": "*当前应用安装在",
    "Current.team.name": "当前团队名称",
    "custom.platform.usage": "右侧开关控制插件的显示&隐藏，拖动左侧按钮可进行排序",
    "to.do.management": "待办管理",
    "sign.out.tip": "确定要退出当前账号？",
    "sign.out.true": "确定退出",
    "app.select.mould": "从应用中心选择模板",
    "app.select.create.tip": "<span style='color: var(--bsy-base-color)'>{{ t1 }}</span>和<span style='color: var(--bsy-base-color)'>{{ t2 }}</span>请从PC端进行操作",
    "new.user.registration": "新用户注册",
    "enter.account.title": "输入账号",
    "enter.password.title": "输入密码",
    "Remember.login": "下次自动登录",
    "forgot.login": "忘记密码了？",
    "account.have.tip": "已有账号,",
    "m.msg.title.phone": "输入手机号",
    "m.msg.SMS.verification": "输入短信验证码",
    "p.msg.SMS.verification": "请输入短信验证码",
    "p.nickname.placeholder": "请输入昵称",
    "m.code.send": "发送验证码",
    "m.code.send.seconds": "{{time}}s后重新发送",
    "m.code.login.seconds": "注册/验证码登录",
    "m.account.password.login": "账号密码登录",
    "m.reset.password.tip": "输入您的账号，我们帮您重设密码",
    "m.reset.password": "重设密码",
    "m.reset.password.account": "设置密码的账号：",
    "m.reset.password.two": "请再次输入密码",
    "m.reset.password.success": "设置密码成功，请重新登录",
    "m.reset.password.success.ok": "知道了",
    "reset.filter": "重置所有筛选条件",
    "reset.filter.and.tip": "符合 所有 筛选条件的数据",
    "reset.filter.or.tip": "符合 任一 筛选条件的数据",
    "m.phone.entry.error": "手机号格式不正确，请重新输入",
    "m.tiaokuan.entry.error": "请阅读并勾选以上条款",
    "m.setting.home.page": "点击头像，进入「自定义工作台」设置首页内容 ",
    "quick.access.edit": "编辑快捷入口",
    "add.already.count": "已添加（{{count}}/{{max}}）",
    "add.speedy.app": "点击下方内容进行添加",
    "add.wait": "待添加",
    "add.already": "已添加",
    "add.max.count.tip": "最多添加{{count}}个",
    "no.processed": "您当前没有已处理的流程",
    "dash.edit": "编辑报表看板",
    "dash.edit.1": "编辑报表",
    "dept.op.fail.add": "普通账号模式才可以添加子部门",
    "dept.op.fail.rename": "普通账号模式才可以修改部门名称",
    "dept.op.fail.delete": "普通账号模式才可以删除部门名称",
    "import.mode": "导入模式",
    "import.mode.insert": "仅新增数据",
    "import.mode.update": "仅更新数据",
    "import.mode.upsert": "更新和新增数据",
    "import.update.finish.tip": "导入完成，共更新 {{count}} 条数据",
    "import.upsert.finish.tip": "导入完成，更新 {{update}} 条数据，新增 {{add}} 条数据",
    'import_forward': '导入数据提交',
    'import_forwardfail': '导入数据提交失败',
    "speedy.item.empty": "当前分类为空",
    "flow.count.tip": "您有{{ count }}条待办任务",
    "image.upload.empty": "暂无图片",
    "file.upload.empty": "暂无附件",
    "widget.signaturePad.save.tip": "保存签名以备下次调用",
    "dash.sort.add.field": "添加排序字段",
    "module.num.no": "您当前套餐内的多插件执行个数不足",
    "tracking.num": "快递单号：",
    "datahelper.delete.output.tip": "数据助手中的输出节点不允许删除",
    "datahelper.run.filter": "助手触发条件",
    "datahelper.filter.tip": "点击左上方添加执行字段，进行条件过滤",
    "etl.datasource.field.empty": "字段已在数据源表中删除",
    "datahelper.perform.action.add.description1": "即将与之连接的输出结果集，根据指定条件，对目标表单进行相应的增、删、改、查等操作",
    "datahelper.perform.action.add.description2": "页面录入数据后，和其他输入源的数据可以进行数据操作，",
    "datahelper.perform.action.add.description3": "将结果作为一条新的记录集写入到目标表单当中",
    "datahelper.perform.action.edit.description2": "页面录入数据后，",
    "datahelper.perform.action.edit.description3": "修改其他表单中的数据为当前输入的内容",
    "datahelper.perform.action.delete.description2": "页面录入数据后，",
    "datahelper.perform.action.delete.description3": "删除目标表单符合条件的数据",
    "datahelper.perform.action.dataRely.description2": "页面录入数据后，",
    "datahelper.perform.action.dataRely.description3": "根据当前录入内容，查询到需要的内容并将结果返回到前端页面",
    "datahelper.perform.action.field.description1": "主表字段：所有字段默认为主表字段，可以将子表单字段设置为主表字段，设置为主表字段后，会将数据以主表形式展示，在调用的时候可以对应普通字段",
    "datahelper.perform.action.field.description2": "子表单字段：可以将主表字段设置为子表单字段，设置为子表单字段后，会以所有主表字段作为条件，对数据进行分组并展示在子表单当中，在调用的时候可以对应子表单字段",
    "datahelper.edit.tip": "编辑数据助手",
    "datahelper.create.undefine.name": "未命名数据助手",
    "datahelper.type.event": "控件事件",
    "datahelper.type.submit": "表单数据提交",
    "datahelper.type.deleteform": "表单删除数据",
    "datahelper.type.updateform": "表单更新数据",
    "datahelper.type.editInitialize": "表单编辑初始化",
    "datahelper.type.floweditInitialize": "流程节点初始化",
    "datahelper.type.initialize": "表单初始化",
    "datahelper.type.flownodesave": "流程暂存",
    "datahelper.type.flownodeforward": "流程提交",
    "datahelper.type.flownodeback": "流程回退",
    "datahelper.type.flownodetransfer": "流程转交",
    "datahelper.type.flownodeclose": "流程关闭",
    "datahelper.type.datatable_menu": "数据表菜单",
    "datahelper.type.batch_menu": "报表菜单",
    "datahelper.type.schedule": "计划任务",
    "datahelper.type.import": "导入数据扩展操作",
    "datahelper.action.sort": "执行动作顺序",
    "datahelper.add.simulationData": "添加模拟数据",
    "datahelper.trigger.config.data_to_form": "常规模式",
    "datahelper.trigger.config.data_to_subform": "主表到子表单",
    "datahelper.trigger.config.subform_to_data": "合并新增到普通字段",
    "datahelper.trigger.config.subform_to_subform": "合并新增到子表单",
    "datahelper.trigger.config.update_data_to_form": "主表到普通字段",
    "datahelper.trigger.config.update_data_to_subform": "主表到子表单",
    "datahelper.trigger.config.update_subform_to_data": "合并到普通字段",
    "datahelper.trigger.config.update_subform_to_subform": "合并到子表单",
    "datahelper.trigger.config.rely_data_to_form": "数据联动",
    "datahelper.trigger.config.rely_data_to_subform": " 主表联动到子表单",
    "datahelper.trigger.config.rely_subform_to_data": "合并联动到普通字段",
    "datahelper.trigger.config.rely_subform_to_subform": "合并联动到子表单",
    "datahelper.trigger.config.data_to_form.tip": "输出表主表数据对应普通字段,子表单数据对应子表单",
    "datahelper.trigger.config.data_to_subform.tip": "输出表主表数据新增到子表单",
    "datahelper.trigger.config.subform_to_data.tip": "输出表主表数据和子表单数据进行合并，新增到普通字段",
    "datahelper.trigger.config.subform_to_subform.tip": "输出表数据主表数据和子表单数据进行合并，新增到子表单字段",
    "datahelper.trigger.config.update_data_to_form.tip": "只匹配输出表的主表数据，修改目标表的普通字段数据",
    "datahelper.trigger.config.update_data_to_subform.tip": "只匹配输出表的主表数据，修改目标表的子表单字段数据",
    "datahelper.trigger.config.update_subform_to_data.tip": "将输出表主表数据和子表单数据进行合并，修改目标表单符合条件的普通字段数据",
    "datahelper.trigger.config.update_subform_to_subform.tip": "将输出表主表数据和子表单数据进行合并，修改目标表单符合条件的子表单数据",
    "datahelper.trigger.config.rely_data_to_form.tip": "主表数据联动到普通字段，子表单数据联动到子表单",
    "datahelper.trigger.config.rely_data_to_subform.tip": "将输出表内符合条件的主表数据联动到子表单",
    "datahelper.trigger.config.rely_subform_to_data.tip": "将输出表主表数据和子表单数据进行合并，联动到普通字段",
    "datahelper.trigger.config.rely_subform_to_subform.tip": "将输出表主表数据和子表单数据进行合并，联动到子表单字段",
    "datahelper.trigger.config.delete_form": "删除主表数据",
    "datahelper.trigger.config.delete_subform": "删除子表单数据",
    "datahelper.trigger.config.delete_form.tip": "删除符合条件的主表数据",
    "datahelper.trigger.config.delete_subform.tip": "查找符合主表条件的数据，删除数据内符合子表条件的数据",
    "datahelper.trigger.config.update_replace_subform": "替换子表单",
    "datahelper.trigger.config.update_replace_subform.tip": "对符合条件的数据中的子表单进行直接覆盖替换",
    "datahelper.trigger.config.data_rely_form": "联动数据到主表字段",
    "datahelper.trigger.config.data_rely_subform": "联动数据到子表单字段",
    "datahelper.trigger.config.data_rely_form.tip": "联动数据到主表字段",
    "datahelper.trigger.config.data_rely_subform.tip": "联动数据到子表单字段",
    "datahelper.trigger.config.upsertData.add": "若找不到符合过滤条件的数据，则根据以下配置在目标表单中新增数据",
    "datahelper.trigger.config.rely.default": "若没有联动到任何数据，则根据默认值填写表单字段",
    "datahelper.trigger.config.run1": "设置字段对应关系",
    "datahelper.trigger.config.run1.Valid.tip": "请设置字段对应关系",
    "datahelper.trigger.config.run2": "设置其他选项",
    "datahelper.trigger.config.run3": "设置新增数据字段对应关系",
    "datahelper.trigger.config.run4": "设置数据联动失败的时候的默认值",
    "datahelper.trigger.config.next": "下一步：设置字段对应关系",
    "datahelper.trigger.config.next1": "其他设置",
    "datahelper.trigger.config.next2": "下一步：设置新增数据",
    "datahelper.trigger.config.next3": "下一步：设置联动数据",
    "datahelper.trigger.config.next4": "下一步：消息推送设置",
    "datahelper.trigger.config.prev": "上一步：设置触发动作",
    "datahelper.trigger.config.prev1": "上一步：设置字段对应关系",
    "datahelper.trigger.config.prev2": "上一步：设置消息推送",
    "datahelper.trigger.config.prev3": "上一步：消息推送设置",
    "datahelper.trigger.config.data_to_news": "单条数据推送",
    "datahelper.trigger.config.datas_to_news": "多条数据推送",
    "datahelper.trigger.config.data_to_news.tip": "单条数据推送",
    "datahelper.trigger.config.datas_to_news.tip": "多条数据推送",
    "datahelper.trigger.config.datas_to_news.tip1": "推送每条消息间隔",
    "datahelper.output.field.move.sn.fail": '子表单内不支持流水号字段',
    "datahelper.trigger.filter.add.tip1": '输出表数据满足以下',
    "datahelper.trigger.filter.update.tip1": '输出表数据满足以下',
    "datahelper.trigger.filter.delete.tip1": '输出表数据满足以下',
    "datahelper.trigger.filter.rely.tip1": '输出表数据满足以下',
    "datahelper.trigger.filter.datanews.tip1": '输出表数据满足以下',
    "datahelper.trigger.filter.tip2": '条件触发执行动作',
    "datahelper.trigger.filter.add.link.tip1": '筛选出符合以下',
    "datahelper.trigger.filter.add.link.tip2": '条件的数据',
    "datahelper.trigger.filter.delete.filter.tip1": '删除符合以下',
    "datahelper.trigger.filter.delete.filter.tip2": '删除子表单',
    "datahelper.trigger.filter.delete.filter.tip3": '中符合以下',
    "datahelper.trigger.config.entry.field": "输出表字段",
    "datahelper.trigger.config.target.field": "目标表单",
    "datahelper.trigger.config.target.fieldsubform": "目标子表单",
    "datahelper.trigger.add.filter": "请添过滤选条件",
    "datahelper.trigger.delete.filter": "请添过滤选条件",
    "datahelper.trigger.delete.filter.subform": "请添加子表单筛选条件",
    "datahelper.trigger.filter.update.filter.tip1": '修改符合以下',
    "datahelper.trigger.filter.update.filter.tip2": '修改子表单',
    "datahelper.trigger.filter.update.filter.tip3": '中符合以下',
    "datahelper.trigger.filter.update.filter.tip4": '联动符合以下',
    "datahelper.trigger.filter.update.filter.tip5": '添加联动符合以下',
    "datahelper.trigger.datarely.tip1": "按以下的字段设置，对目标表进行数据填充  ",
    "datahelper.trigger.datarely.tip2": "，并按以下的字段设置，对目标表进行数据填充  ",
    "datahelper.trigger.datarely.tip3": "请先选择子表单",
    "datahelper.trigger.datarely.tip4": "，并按以下的字段设置，进行数据新增",
    "datahelper.trigger.datarely.tip5": "限定范围为导入数据(后置触发)",
    "datahelper.trigger.output.tip1": "数据有效判断",
    "datahelper.trigger.success.tip": "开启执行动作完成后的提示信息",
    "datahelper.trigger.success.tip1": "有符合数据操作时候的设置",
    "datahelper.trigger.success.tip2": "没有符合数据操作时候的设置",
    "datahelper.trigger.success.tip3": "清空指定字段",
    "datahelper.trigger.success.tip4": "中断执行",
    "datahelper.trigger.success.tip5": "提示信息",
    "datahelper.trigger.success.tip6": "触发指定公式",
    "datahelper.trigger.success.tip7": "日志信息",
    "datahelper.trigger.success.tip8": "字段为空时忽略字段",
    "datahelper.trigger.success.tip9": "输出表某个字段内容为空时，不对目标表单字段进行修改",
    "datahelper.trigger.success.tip10": "当被替换的子表单整体为空时，不进行修改",
    "datahelper.trigger.success.tip11": "返回执行的条数提示",
    "datahelper.trigger.actionsMaxCount.error": "执行动作不能超过 {{count}} 个",
    "datahelper.trigger.actionsModuleMaxCount.error": "最多只能添加 {{count}} 个功能插件执行动作",
    "datahelper.trigger.output.filter.rel.and": "所有数据",
    "datahelper.trigger.output.filter.rel.or": "任意一条数据",
    "datahelper.trigger.output.filter.error.tip": "请填写错误信息",
    "datahelper.trigger.action.success.tip": "请填写提示信息",
    "datahelper.trigger.action.success.tip1": "请填写日志信息",
    "datahelper.trigger.output.filter.ok.tip": "保存成功",
    "datahelper.trigger.destform": "请先添加目标表",
    "datahelper.trigger.op.mode.tip": "点击查看，操作模式详细说明",
    "datahelper.trigger.dataoutput.name": "输出表[数据助手]",
    "datahelper.trigger.start.flow": "是否发起新的流程",
    "datahelper.trigger.dest.form.notsubform": "目标表没有子表单，不支持当前操作模式，请重新选择",
    "datahelper.trigger.action.filter.text": "执行条件",
    "datahelper.trigger.title1": "字段对应关系",
    "datahelper.output.error.tip1": "开启数据有效性判断，当出现错误后将直接返回，不继续往下执行",
    "datahelper.output.error.tip2": "当结果集为空的时候，提示下面错误信息并直接返回，不继续往下执行",
    "datahelper.output.error.tip3": "当结果集为空的时候，直接返回，不执行后续动作",
    "datahelper.output.error.tip4": "请填写具体的错误信息",
    "datahelper.output.error.tip5": "所有数据：整个结果集中全部数据不符合下面的条件 <br> 任意一条数据：结果集中的一条数据不符合下面的条件",
    "datahelper.output.error.tip6": "当结果集中",
    "datahelper.output.error.tip7": "条件时，继续往下执行",
    "datahelper.output.error.tip8": "否则，提示下面错误信息并直接返回，不继续往下执行",
    "datahelper.output.error.tip9": "否则，直接返回，不继续往下执行",
    "datahelper.output.error.tip10": "符合以下",
    "datahelper.inputdata.error.tip": "输入数据没有找到字段，请先保存表单字段",
    "datahelper.import.dataExt": "扩展操作",
    "datahelper.import.dataExt.open": "启用数据助手",
    "datahelper.import.dataExt.tip": "可在数据管理编辑数据助手",
    "datahelper.node.output.title": "输出表",
    "datahelper.guide.1": "1/5 选择并设置输入数据->设置数据处理方式->调整输出表->添加执行动作",
    "datahelper.guide.2": "2/5 选择并设置输入数据【可新增模拟数据】",
    "datahelper.guide.3": "3/5 设置数据处理方式【根据自己需求进行设置】",
    "datahelper.guide.4": "4/5 调整输出表【可设置主表模式和子表单模式】",
    "datahelper.guide.5": "5/5 添加执行动作【可设置多个并可调整执行顺序】",
    "datahelper.module.current.name": "[数据助手-输出表]",
    "datahelper.op.log": "数据助手日志",
    "datahelper.op.log.tip": "日志只记录最新100条，运行时长超过阈值和系统错误的会进行记录。",
    "datahelper.help.header.tip1": "表格背景色：",
    "datahelper.help.header.tip2": "文字颜色：",
    "datahelper.help.header.tip3": "新增的数据",
    "datahelper.help.header.tip4": "根据查询条件查找到的数据",
    "datahelper.help.header.tip5": "条件字段",
    "datahelper.help.header.tip6": "目标表原有数据",
    "datahelper.help.header.tip7": "后台数据处理过程",
    "datahelper.help.header.tip8": "被修改或联动显示的字段",
    "datahelper.trigger.addaction": "新增数据",
    "datahelper.trigger.deleteaction": "删除数据",
    "datahelper.trigger.editaction": "修改数据",
    "datahelper.trigger.relyction": "数据联动",
    "adv.set": "高级设置",
    "show.title": "显示标题",
    "border.radius": "圆角",
    "show.title.background": "填充背景",
    "funnel.chart": "漏斗图",
    "transformation.ratio": "转化率",
    "border.width": "描边线宽",
    "border.color": "描边颜色",
    "width": "宽度",
    "gap.between.each.trapezoid": "数据图形间距",
    "show.tip.tool": "显示提示框控件",
    "tooltip": "提示框",
    "opacity": "透明度",
    "mouse.click": "鼠标点击时",
    "mouse.moves": "鼠标经过时",
    "conditions.trigger.tooltip": "提示框触发条件",
    "follow.the.position.of.mouse": "跟随鼠标位置",
    "tooltip.prefix": "自定义系列名称",
    "tip.alert.reset": "是否重置{{ name }}属性？",
    "tip.reset": "重置{{ name }}属性",
    "Label": "标签",
    "inside": "内部",
    "outside": "外部",
    "dash.pie.common": "基础饼图",
    "dash.pie.rose": "玫瑰图",
    "dash.pie.doughnut": "环形图",
    "dash.interval.y": "Y轴间隔大小",
    "dash.interval.y.warning.tip": "Y轴间隔必须大于0",
    "dash.interval.y.warning.tip1": "Y轴间隔最大值必须大于最小值",
    "dash.interval.y.warning.tip2": "Y轴间隔最小值必须小于最大值",
    "dash.interval.y.tip": "Y轴间隔必须大于0，Y轴间隔过小会影响y轴刻度的显示，请适当调整间隔值的大小",
    "dash.radiusAxis.y": "极坐标系",
    "dash.Axis.y": "直角坐标系",
    "dash.gauge": "仪表盘",
    "dash.gaugeChart": "仪表盘",
    "dash.gaugeChart.tip": "1个指标",
    "dash.gaugeChart.range": "范围",
    "dash.gaugeChart.pointer.color": "指针颜色",
    "dash.gantt": "甘特图",
    'dash.gantt.starttime': "开始时间",
    'dash.gantt.enttime': "结束时间",
    'dash.gantt.progress': '进度',
    'dash.gantt.starttime.tip': '仅支持时间字段',
    'dash.gantt.progress.tip': '仅支持数字字段',
    'dash.gantt.starttime.tip1': "添加失败，仅可添加1个开始时间",
    'dash.gantt.enttime.tip1': "添加失败，仅可添加1个结束时间",
    'dash.gantt.progress.tip1': '添加失败，仅可添加1个进度字段',
    'dash.gantt.time.tip1': '添加失败，开始时间与结束时间不能相同',
    'dash.gantt.dimension.tip1': '「开始时间」、「结束时间」、「进度」以及「维度」中子表单字段必须同属于一个子表单',
    'dash.gantt.time.precision': '精度',
    'dash.gantt.zoomLevel.tip': '缩放等级',
    'dash.gantt.zoomLevel.title': '{{ level }}级',
    'dash.gantt.dependencies': '任务依赖关系',
    'dash.gantt.dependencies.tip1': '任务标识字段',
    'dash.gantt.dependencies.tip2': '任务依赖字段',
    'dash.gantt.dependencies.tooltip2': '任务标识字段用来唯一标识一个任务节点, 任务依赖字段：用来记录这个节点依赖哪个任务节点的完成,会产生连线效果',
    'dash.gantt.bar.start': '开始：',
    'dash.gantt.bar.end': '结束：',
    'dash.gantt.bar.progress': '进度：',
    'dash.gantt.field.add.guide': '拖拽左侧字段到上方「维度」、「开始时间」、「结束时间」来创建甘特图',
    'Year': '年',
    'Quarterly': '季度',
    'Month': '月',
    'Quarterly Month': '季度/月',
    'Week': '周',
    'Day': '天',
    'Half Day': '上午/下午',
    'Hour': '小时',
    'hourTime': '时',
    "schedule.update.start.tip": "当前计划任务处于停止状态，是否立即启动",
    "no.operation.authority": "无操作权限",
    "preview.view.data": "预览时不支持查看数据",
    "preview.create.data": "预览时不支持新增数据",
    "preview.triggerEvent": "预览时不支持功能扩展的触发",
    "preview.buttom.triggerEvent": "预览时不支持按钮操作",
    "data.manager.create.data": "数据管理不支持新增数据",
    "data.manager.view.data": "数据管理不支持查看数据",
    "data.manager.not.permission": "无权操作",
    "data.manager.have.permission.data": "仅执行有权限的数据",
    "data.manager.have.permission.data.tip": "已勾选{{total}}条，{{select}}条有权限。无权限的数据已取消勾选。",
    "link.form.op": "关联表操作",
    "linkdata.show.data.count": "显示数据条数",
    "link.form.addData": "允许新增关联表数据",
    "link.form.oneData": "一条",
    "link.form.manyData": "多条",
    "dingding.phone.placeholder": "请输入钉钉注册使用的手机号",
    "dingding.empty.team.tip": "您还没有加入任何钉钉团队！<br /><span>还未开通钉钉？</span> <a style='color:var(--bsy-base-color);' href='/dingding/login_guide' target='_blank'>如何开通</a>",
    "dingding.have.teams.tip": "系统检测到您有多个团队，请选择一个团队进行下一步扫码登录",
    "dingding.auto.syn.switch": "允许自动同步通讯录",
    "dingding.user.login": "钉钉成员登录",
    "form.flow.dingding": "接入钉钉审批套件",
    "form.flow.dingding.tip": "开启此功能的流程，发生流程流转时，将推送给对应的负责人，负责人可以在钉钉工作台审批应用的「OA审批」、「待处理」任务分组下查看并处理该流程。",
    "form.dingding.SSO.Obtain": "获取",
    "SSOsecret.dingding.tip1": "注意：SSOsecret主要用于钉钉后台进入应用操作，如无此需求可不修改",
    "SSOsecret.dingding.tip2": "修改SSOsecret",
    "SSOsecret.dingding.tip3": "（请根据下方步骤进行操作）",
    "SSOsecret.dingding.tip4": "操作步骤：",
    "SSOsecret.dingding.tip5": "1.打开链接：",
    "SSOsecret.dingding.tip6": "2.【点击查看】SSOsecret",
    "SSOsecret.dingding.tip7": "（需管理员点击查看）",
    "SSOsecret.dingding.tip8": "*SSOsecret仅用于从钉钉后台进入应用",
    "dingding.auto.syn.log": "通讯录日志",
    "dingding.auto.syn.log.edit.after": "修改前",
    "dingding.auto.syn.log.edit.before": "修改后",
    "print.guide.1": "<span style='color: var(--bsy-base-color);font-weight: bold;'>1</span>/6 点击【编辑】> 进入打印模板设计页面",
    "print.guide.2": "<span style='color: var(--bsy-base-color);font-weight: bold;'>2</span>/6 【纸张设置】确定实际打印范围 > 自行绘制打印样式",
    "print.guide.3": "<span style='color: var(--bsy-base-color);font-weight: bold;'>3</span>/6 双击【单元格】> 拖动【表单字段】自定义【编辑单元格内容】",
    "print.guide.4": "<span style='color: var(--bsy-base-color);font-weight: bold;'>4</span>/6 点击【批量打印】> 设置【分页打印】或【连续打印】",
    "print.guide.5": "<span style='color: var(--bsy-base-color);font-weight: bold;'>5</span>/6 点击【自定义水印】> 自定义设置【无水印】、【图片】水印或【文字水印】",
    "print.guide.6": "<span style='color: var(--bsy-base-color);font-weight: bold;'>6</span>/6 点击【背景设置】> 选择上传【背景图】> 按字段值的位置【绘制单元格】> 拖动字段至对应单元格内 > 【保存并配置模板使用范围】> 打开单条数据，点击【打印】按钮可按该模板打印",
    "edit.content.filed": "修改内容",
    "check.template": "选择模板",
    "check.template.tip1": "（必填）",
    "check.template.tip2": "<i style='color:#f5222d;font-size: 20px;vertical-align: middle;margin-right: 6px;'>*</i>",
    "check.template.table1": "消息表单内容",
    "color.black": "黑色",
    "color.gray": "灰色",
    "color.highlight": "高亮",
    "refresh.template": "刷新模板列表",
    "template.test": "测试",
    "template.test.user": "请选择测试用户",
    "template.sms.reminder": "短信提醒",
    "template.sms.set": "短信设置",
    "template.voice.reminder": "语音提醒",
    "template.voice.set": "语音设置",
    "template.email.set": "邮件设置",
    "template.dd.set": "钉钉设置",
    "template.wx.set": "微信设置",
    "template.qywx.set": "企业微信设置",
    "template.reminder.content": "提醒内容",
    "template.send.fail": "发送失败，请检查内容",
    "template.voice.sms.id": "模板ID",
    "template.voice.sms.btn": "获取消息内容",
    "template.we.refresh.tip": "请点击上方刷新按钮重新获取消息内容！",
    "template.url": "消息推送入口",
    "template.check.url": "表单链接设置",
    "template.check.url.detail": "数据详情",
    "template.add.cont": "添加内容",
    "template.create.title": "请在这里配置{{type}}模板",
    "template.create.title2": "请在这里制作{{type}}模板",
    "template.create.title3": "如何配置",
    mail: "邮件",
    "template.style.title": "填写样式预览",
    "template.select": "选择",
    "sms": "短信",
    "voice": "语音",
    "qywechat": "企业微信",
    "voice.title.tip": "（模板内容要和阿里云模板内容一致,否则无效！）",
    "flow.action.urge": "催办",
    "flow.action.cc": "抄送",
    "template.mail.tip": "成员用户必须先绑定邮箱，才能收到提醒。",
    "template.wx.tip": "成员用户必须先关注微信服务号，才能收到提醒。",
    "template.phone.tip": "成员用户必须手机号有效，才能收到提醒。",
    "template.phone.tip1": "成员用户必须手机号有效或文本控件有效，才能收到提醒。",
    "template.urge.tip": "使用流程催办模板进行提醒",
    "template.error.tip": "该功能需要私有云支持，配置后开启",
    "template.error.tip1": "该功能需要私有云支持，配置后开启",
    "check.template.waterMark": "请输入语音模板ID",
    "check.template.sms.waterMark": "请输入短信模板ID",
    "check.template.waterMark1": "请选择模板",
    "title.trigger": "触发条件",
    "sms.num": "短信条数",
    "voice.num": "语音条数",
    "empty.template.tip": "请先设置{{name}}模板",
    "error.template.tip1": "请检查模板内容是否填写完整",
    "error.template.tip3": "请至少选择一种提醒方式",
    "datahelper.subform.tip": "当前没有可用子表单",
    "datahelper.subform.tip1": "请选择消息推送入口",
    "template.id.empty.tip": "模板ID不能为空",
    "template.id.empty.tip1": "请先完成{{name}}设置",
    "template.id.empty.tip2": "请添加被提醒人",
    "edit.etl.stage.title": "修改节点名称：",
    "template.restore": "恢复默认",
    "template.length.tip": "消息表单内容最多不能超过{{len}}个",
    "api.add.data.batch": "批量新增数据",
    "api.create.batch": "新建多条数据接口",
    "api.create.desc.batch": "在指定表单中添加多条数据。",
    "api.res.create.batch.success": "成功的数据结果",
    "api.res.create.batch.failed": "失败的原数据",
    "api.res.create.batch.failedCode": "失败对应的错误码code",
    "api.res.create.batch.data": "响应内容：",
    "api.create.batch.data.desc": "限制100条 超出报错",
    "qyweixin.set.manage": "点击配置",
    "qyweixin.set.manage.title": "企业微信通讯录授权",
    "corp.qyweixin.Step.url": "URL",
    "corp.qyweixin.Step.Token": "Token",
    "corp.qyweixin.Step.EncodingAESKey": "EncodingAESKey",
    "corp.qyweixin.Step.title": "配置通讯录自动同步参数",
    "corp.qyweixin.Step.title.tip": "（请将以下参数复制粘贴到<a href='https://work.weixin.qq.com/wework_admin/frame#apps/contactsApi' style='color:var(--bsy-base-color);font-weight: bold;margin: 0 5px;padding-bottom: 1px;border-bottom: 1px solid var(--bsy-base-color);' target='_blank'>通讯录同步</a>的相应位置，详见参数配置操作引导）",
    "manage.qyweixin.explain": "配置说明",
    "set.password.new": "设置新密码",
    "set.name.new": "设置您的姓名",
    "set.name.new.p": "请设置您的姓名",
    "set.name.new.t": "建议您使用真实姓名,方便团队里面快速识别",
    "wxbind.tip": "该手机号<a style='color: var(--bsy-base-color);text-decoration: underline;'>{{value}}</a>已经存在",
    "wxbind.tip1": "请直接绑定此账号并登录",
    "wxbind.login": "绑定并登录",
    "entry.code.tip": "请输入{{len}}位验证码",
    "dingding.code.team.login": "手机钉钉扫码直接登录",
    "set.password.tip": '密码不符合规范，请重新设置',
    'feishu.login': '飞书登录',
    'mobile.login.empty.tip': '移动端没有合适的登录方式，请联系管理员或前往电脑端登录',
    'reg.login.empty.tip': '当前不能进行注册，请联系管理员',
    'switch.to.resignation': '转为已删除',
    'addressbook.joined.tip': '有<span style="color: #FF634E;margin:0 2px">{{num}}</span>名成员未加入，<span class="inv" style="color: var(--bsy-base-color);cursor: pointer;">再次全部邀请</span>',
    'batch.error.tip': '批量导入数据结果：成功{{success}}条，已存在{{exist}}条，失败{{error}}条',
    'batch.error.btn': '下载错误的数据',
    'dismission': '删除',
    'dismission.error.tip': '只能对普通成员进行删除操作',
    'dismission.error.tip2': '请选择需要删除的成员',
    'dismission.alert.tip': '您确定将所选成员转为已删除成员？',
    'dismission.alert.tip1': '转为已删除成员后，使用相同成员编号再次加入时，可恢复相关配置',
    'handover.work': '交接工作',
    'handover.work.loading': '正在将{{user}}的以下工作转交给{{to}}，请稍等......',
    'handover.auth.group': '表单权限组成员',
    'handover.notify': '推送提醒被提醒人',
    'handover.datahelper': '数据助手被提醒人',
    'handover.dash.auth': '报表权限组成员',
    'handover.name.tip': '有以下工作，可根据需要转交给其他成员',
    'handover.finish.tip': '转交完成，可继续转交其他工作',
    'handover.empty.tip': '该分类下暂无工作',
    'handover.empty.tip1': '当前未选中任何工作，请确认是否选择了需要转交的工作',
    'handover.error.tip': '不能将工作转交给自己',
    'handover.error.tip1': '请选择一名需要被转交工作的成员',
    "handover.finish": "成功{{success}}条",
    "handover.forward": "失败{{fail}}条",
    "handover.load.forward": "转交完成，但是存在失败的工作转交，可尝试再次转交",
    'todo.data': '待办数据',
    'todo.data.tip': '转交内容：当前用户审批中的流程',
    'todo.data.empty.tip': '无进行中流程',
    "todo.dataCount": "{{count}}条",
    'todo.data.tip1': '流程进行中',
    'creator.data': '当前用户提交的数据',
    'creator.data.empty.tip': '没有当前用户提交的数据',
    'creator.data.tip': '转交内容：当前用户提交的数据',
    'flow.user': '流程负责人',
    'flow.user.tip': '转交内容：节点负责人、节点抄送人、限时处理被提醒人、转交候选人',
    'flow.creator.data.tip': '转交内容：当前用户发起的流程数据',
    'flow.creator.data.empty.tip': '没有当前用户发起的流程数据',
    'form.dash.config': '表单、报表配置',
    'form.dash.config.tip': '转交内容：权限组、推送提醒、定时提醒',
    'role.tip': '支持转交【创建的角色】，通讯录其他配置请到通讯录中调整',
    'set.name.empty.tip': '姓名不能为空',
    'outsider.custom.group': "自定义分组",
    'outsider.custom.all': "全部联系人",
    'outsider.view.custom.all': "查看全部联系人",
    "outsider.add": "添加外部联系人分组",
    "outsider.name.required": "请填写分组名称",
    "outsider.name.empty": "分组名称不能为空",
    "outsider.group.delete.tip": "删除外部联系人分组会将所关联的权限一并删除，此操作不可逆",
    "outsider.member.delete.tip": "删除外部联系人会将所关联的权限一并删除，此操作不可逆",
    "outsider.group.edit": "修改分组名称",
    "outsider.miniapp.seting.tip": '分组成员分享微信小程序自动加入该组',
    "outsider.member.batch.recover": "批量恢复",
    "outsider.member.recover.groupempty.tip": "选择恢复到的分组",
    "outsider.member.remove.empty": "请选择需要删除的外部联系人",
    "outsider.member.remove.tip": "您确定删除所选外部联系人？",
    "outsider.member.recover.empty": "请选择需要恢复的外部联系人",
    "outsider.member.recover.tip": "您确定恢复所选外部联系人？",
    "outsider.member.add": "添加外部联系人",
    "outsider.member.singleAdd": "手动添加外部联系人",
    "outsider.member.batchAdd": "批量导入外部联系人",
    "outsider.member.in.group": "所在分组",
    "outsider.member.import.Download01": "1.导入账号直接生效",
    "outsider.member.import.Download11": "1.下载表样，不能增加、删除或修改本Excel表的成员信息类别，不填的留空即可。",
    "outsider.member.import.Download12": "2.手机、姓名、分组为必填，手机区号、用户ID、邮箱为选填。",
    "outsider.member.import.Download13": "3.分组不存在会自动创建",
    "outsider.member.import.Download14": "4.批量导入最大数据200条。手机号和用户ID已经在外部联系人内或信息有误的成员不导入，如有超出，请分为多个文件导入",
    "outsider.member.import.Download15": "5.免激活模式的密码规则：6位到18位，不填写则默认为：123456",
    "outsider.member.to.dept": '转部门成员',
    "outsider.member.from.dept": '转外部联系人', //部门成员转外部联系人
    "outsider.miniapp.seting": "微信小程序设置",
    "outsider.miniapp.seting.share.autojoin": "分享微信小程序自动加入",
    "outsider.miniapp.seting.share.autojoin.tip1": '开启以后,通讯录成员或外部联系人成员分享微信小程序,会自动注册并加入默认分组',
    "outsider.miniapp.seting.share.autojoin.tip2": '开启以后,本组外部联系人成员分享微信小程序,会自动注册并加入该外部联系人自定义分组,自定义分组的优先级要高于默认分组的设置',
    "outsider.miniapp.seting.share.qr": "二维码入口",
    "outsider.miniapp.seting.share.qr.tip": "开启以后,允许外部人员扫二维码访问特定的页面,并自动加入该外部联系人分组 ",
    "outsider.miniapp.seting.share.home": "设置入口页面",
    "outsider.miniapp.seting.share.expiretime": "分享链接和分享二维码有效截止时间设置",
    "outsider.miniapp.seting.share.regenerate": "重新生成",
    "outsider.miniapp.seting.share.qrsize": "分享二维码尺寸",
    "outsider.miniapp.seting.share.qrsize.8": "8cm*8cm",
    "outsider.miniapp.seting.share.qrsize.12": "12cm*12cm",
    "outsider.miniapp.seting.share.qrsize.15": "15cm*15cm",
    "outsider.miniapp.seting.share.qrsize.30": "30cm*30cm",
    "outsider.miniapp.seting.share.qrsize.50": "50cm*50cm",
    "outsider.miniapp.seting.share.Invalidation": " 二维码已失效，请重新生成",
    "outsider.miniapp.seting.share.EffectiveTimeire": "二维码有效时间",
    "outsider.miniapp.seting.share.permanentTime": "永久有效",
    "outsider.miniapp.seting.share.limitTime.tip1": "二维码有效时间必须大于当前时间30分钟",
    "outsider.miniapp.seting.share.limitTime.tip2": "二维码有效时间不能大于当前时间30天",
    "outsider.miniapp.seting.launcher": "设置入口页面",
    "outsider.miniapp.seting.launcher.clear": "清空入口页面",
    "approve.list.header.1": '申请人',
    "approve.list.header.2": '手机或邮箱',
    "approve.list.header.3": '申请时间',
    "approve.list.header.4": '申请理由',
    "handover.create.role": "角色/角色组",
    "resign.user": "已删除成员",
    "resign.user.1": "已不在通讯录成员",
    "resign.time": "删除时间",
    "resign.user.tip": "请选择需要恢复在职的成员",
    "resign.alert.tip": "确定恢复选中的已删除成员为在职吗？",
    "reinstatement": "恢复在职",
    "outsider.miniapp.seting.launcher.home": "应用主页",
    "resigned.user": "已删除",
    "off.on.use": "是否{{ dos }}该{{ type }}？",
    "scan.qr.signature": "扫描二维码，添加手写签名",
    "scan.qr.image": "手机扫描二维码，即可上传图片",
    "corp.feishu.authorization": "飞书应用授权",
    "corp.feishu.explain": "飞书应用绑定说明",
    "corp.feishu.href": "需要联系【团队管理员】登录飞书开放平台 <a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url}}</a> 进行绑定配置 ",
    "corp.feishu.text1": "飞书应用绑定采用了飞书【企业内部开发】的模式对接",
    "corp.feishu.text2": "为什么采用【企业内部开发】的模式",
    "corp.feishu.text3": "采用【企业内部开发】的模式可以获取更多的能力：比如，通讯录自动同步等，节约大量时间",
    "corp.feishu.help": "请根据 <a href='/feishu/guide' target='_blank' style='color: #FFB200;'><i class='icon-bsy-guide'></i>参数配置操作引导</a> 完成操作 ",
    "corp.feishu.Step.unbin.btn": "解除飞书授权",
    "corp.feishu.Step.unbind": "是否解除飞书授权？",
    "corp.feishu.Step.unbind.tip": "解除飞书绑定以后，账号将还原到本账号原来的通讯录信息，应用和数据信息将保留，重新绑定原飞书应用可以恢复。",
    feishu: "飞书",
    "dash.thresholds.msg.feishu": "飞书提醒",
    "template.feishu.set": "飞书设置",
    "corp.feishu.h5.url": "H5可信域名",
    "corp.feishu.redirect.url": "重定向URL",
    "corp.feishu.redirect2.url": "请求网址",
    "corp.feishu.ip.url": "IP白名单",
    "corp.feishu.pc.url": "桌面端主页",
    "corp.feishu.mobile.url": "移动端主页",
    "corp.feishu.omp.url": "管理后台主页",
    "corp.feishu.app.url": "2.配置应用权限并发布应用",
    "sign.out.team": "退出当前团队",
    "sign.out.team.waterMark": "请输入当前团队名",
    "sign.out.team.tip1": "请输入正确的团队名",
    "sign.out.team.tip": "成功退出{{teamName}}",
    "outsider.miniapp.seting.share.qrsize.tip": "点击下方图标选择相应的二维码尺寸进行下载",
    "role.empty.tip": "当前没有角色，请创建",
    "role.empty.tip1": "当前第三方团队没有角色",
    "create.role": "创建角色",
    "node_has_loop": "多分支流程存在循环，无法正常流转。请联系管理员检查流程设计",
    "flow-exception": "流程异常",
    "manager.delete.warning1": "删除普通管理组则相关管理员及权限也将一并删除，且无法还原。",
    'handover.work.empty': '当前没有可交接的工作',
    'app.store.search': '搜索应用系统',
    'app.store.search.tip': '该应用所在系统',
    'app.store.search.title': '以下为当前搜索结果',
    'app.store.list.empty': '当前类别暂无应用',
    'app.store.search.empty': '请输入需要搜索的内容',
    "form.select": "表单选择",
    "push.event": "推送事件",
    "activated.setting": "已启用设置",
    "stoped.setting": "已停用设置",
    "deactivate": "停用",
    "push.log.type": "推送日志类型",
    "push.logging": "推送日志记录",
    "pending.log": "待发送日志",
    "abandon.log": "放弃推送日志",
    "data.api.logTip.day": "仅保留{{day}}天的推送日志",
    "push.content": "推送内容",
    "push.event.tip": "请至少勾选一个推送事件",
    "secret.tip": "请填写secret",
    "activated.webhook.tip": "是否启用该推送？",
    "deactivated.webhook.tip": "是否停用该推送？",
    "delete.webhook.tip": "是否删除该推送？",
    "retry.webhook.tip": "是否重新推送？",
    "abandon.webhook.tip": "是否放弃推送？",
    "retry.webhook.tip1": "已重新请求该推送",
    "pending.status": "待发送",
    "open.platform": "开放平台",
    "server.url.tip": "该服务器地址不是以http://https://开头，或者不是网址",
    "server.url.tip1": "例如：http://www.xxxxx.com或者https://www.xxxxx.com",
    "open.platform.empty.tip": "当前没有数据推送，去新建一个吧~",
    "member.change": "成员变更",
    "dept.change": "部门变更",
    "role.change": "角色变更",
    "external.contact.change": "外部联系人变更",
    "member.contact.add": "通讯录成员增加",
    "member.contact.edit": "通讯录成员更改",
    "member.contact.del": "通讯录成员删除",
    "member.contact.recover": "通讯录成员删除恢复",
    "member.to.external": "通讯录成员转外部联系人",
    "member.to.dept": "通讯录成员移动部门",
    "dept.create": "通讯录企业部门创建",
    "dept.edit": "通讯录企业部门修改",
    "dept.del": "通讯录企业部门删除",
    "add.role": "增加角色组",
    "edit.role": "修改角色组",
    "edit.add.user": "增加角色组成员",
    "edit.del": "删除角色组",
    "edit.del.user": "删除角色组成员",
    "external.add.group": "增加外部联系人分组",
    "external.edit.group": "删除外部联系人分组",
    "external.del.group": "修改外部联系人分组",
    "external.add": "增加外部联系人",
    "external.del": "删除外部联系人",
    "external.edit": "修改外部联系人",
    "external.to.dept": "外部联系人转部门成员",
    "url.server.tip1": "该服务器地址连接正常",
    "url.server.tip2": "该服务器地址连接异常，错误码为{{code}}",
    "delete.webhook.tip1": "删除通讯录webhook回调设置，不再触发接口？",
    "deactivated.webhook.tip1": "停止通讯录webhook接口回调，启动后恢复",
    "activated.webhook.tip1": "启动通讯录webhook回调",
    "purview.webhook.tip1": "暂未获取开放平台权限",
    "push.event.flow": "流程事件",
    "outsider.to.user.tip": '外部联系人转成员为特殊操作，请核对身份，以免转换后导致部分设置和数据异常',
    "user.to.outsider.tip": '成员转外部联系人为特殊操作，请核对身份，以免转换后导致部分设置和数据异常',
    "outdiser.subadmin.tip1": '当子管理员为外部联系人的时候，此属性无效',
    "deactivated.form.tip1": "停止表单webhook接口回调，启动后恢复",
    "activated.form.tip1": "启动表单webhook回调",
    "searchApp": "请输入应用或表单名称",
    "searchAppForm": "搜索应用或表单名称",
    "recycle.bin": "回收站",
    "delete.webhook.form.tip1": "删除表单webhook回调设置，不再触发接口？",
    "edit.form": "编辑表单",
    "move.app.toGroup": "移动应用到下面分组",
    "name.form.report": "请输入表单/报表名称",
    "input.app.name": "请输入应用名称",
    "input.form.name": "请输入表单或报表名称",
    "corpid.Enter.title": "请先绑定团队的企业ID",
    "corpid.Enter.inputTip": "请填写企业ID",
    "corpid.edit": "修改企业ID",
    "form.dash.empty": "表单或报表不存在",
    "app.dash.form.empty": "当前应用没有可使用的表单或报表",
    "dash.not.select": "当前未选中任何报表",
    "dash.form.empty": "当前未搜索到相匹配的表单或报表",
    "app.all.empty": "当前未搜索到相匹配的应用",
    "add.already.num": "已添加{{num}}个",
    'Block.invalid': '报表已被删除',
    'Block.invalid.1': '报表无权限访问',
    "app.empty.tip1": '暂时还没有应用，去创建一个应用开启你的工作之旅吧',
    "platform.system": "平台体系",
    "address.book.system": "通讯录体系",
    "application.system": "应用体系",
    "key.management": "api密钥",
    "api.res.params": "返回参数：",
    "api.res.noParams": "返回参数：无",
    "webhook.key": "密钥：",
    "webhook.key.name": "密钥名称：",
    "webhook.key.name1": "密钥名称",
    "webhook.key.all.placeholder": "请输入密钥名称",
    "webhook.key.all.error": "请输入正确的密钥名称",
    "webhook.key.all.detail.tip": "拥有通讯录和应用的全部接口权限",
    "webhook.key.all": "全部接口",
    "webhook.key.all.msg": "*该密钥拥有通讯录接口和所有应用的接口权限",
    "webhook.key.detail": "密钥详情",
    "webhook.key.create": "创建密钥",
    "webhook.key.customize": "自定义密钥",
    "webhook.key.app.select.title": "应用选择",
    "webhook.key.del.title": "请确认是否删除“{{name}}”该权限？",
    "webhook.key.customize.del.title": "请确认是否删除该自定义权限？",
    "webhook.key.customize.menu": "自定义体系",
    "webhook.key.customize.empty": "当前没有自定义应用体系，去新建一个吧~",
    "webhook.key.customize.create": "新建自定义体系",
    "webhook.key.customize.edit": "编辑自定义体系",
    "webhook.key.customize.title": "表单自定义权限组",
    "webhook.key.app.empty.title": "当前没有应用体系，去新建一个吧~",
    "webhook.key.auth.empty.title": "当前没有平台体系权限，请联系管理员",
    "webhook.key.create.first.app": "开始新建你的第一个应用",
    "webhook.key.create.app": "新建应用",
    "webhook.create.app.blank.application": "新建空白应用",
    "webhook.create.app.office.apps": "自己动手搭建办公应用",
    "webhook.create.app.select.application.template": "选择应用模版",
    "webhook.create.applications.from.template.center": "从模版中心安装已有应用",
    "webhook.create.app.importing.installation.package": "导入安装包",
    "webhook.create.app.import.application.installation.package.system": "导入应用安装包到系统",
    "webhook.key.create.tip": "创建密钥（自定义密钥）",
    "webhook.re.key": "请确认是否重置“{{name}}”该密钥的Api Key？",
    "webhook.re.key.placeholder": "请输入密钥名称",
    "webhook.re.key.tip": "输入的密钥名称不正确，请确认后重新输入",
    "flow.ding.max.len": "最多只能钉{{num}}个表单",
    "flow.min.len": "当前菜单最少需要保留{{num}}个表单",
    "no.set.page": "当前没有设置入口页面",
    "form.backflowidName": "来自{{name}}的回退",
    "form.backflowidName.title": "来自{{name}}",
    "form.backflowidName.end": "的回退",
    "dash.agree": '符合',
    "dash.agree1": '筛选条件的数据',
    "dash.full.autoRefresh.tip": "全屏模式下会自动刷新数据",
    "webhook.key.empty.tip": "当前没有密钥，去新建一个吧~",
    "login.mirror.access": "访问镜像",
    "login.mirror.access.quit": "退出镜像访问模式",
    "login.mirror.access.title": "镜像访问",
    "login.mirror.access.title.mobile": "镜像访问模式",
    "login.mirror.access.tip.title": "镜像模式",
    "login.mirror.system.tip.title": "{{time}}系统镜像",
    "login.mirror.access.msg": "只读模式，可下载，不能进行编辑，用于找回误操作的数据。",
    "login.mirror.access.tip": "访问{{time}}的系统镜像，只读模式，可下载，用于找回误操作的数据。",
    "login.mirror.header.msg": "{{time}}的镜像数据，仅管理员登录",
    "login.mirror.access.msg1": "只读模式,可下载,不能进行编辑,用于找回误操作的数据，只有团队的系统管理员可以访问。",
    "login.mirror.title.msg": "仅管理员登录",
    "login.mirror.signin": "管理员登录",
    "dashboard.flow.todo.set": "拖动以下组件到右侧来设置工作台",
    "dashboard.page.components": "页面组件",
    "latest.to.do": "最新待办",
    "all.to.do": "全部待办",
    "latest.to.do.urge": "最新催办",
    "about.to.time.out": "即将超时",
    "todo.from": "来自",
    "todo.empty.msg": "暂无待办消息",
    "dashboard.all.app.tip": "配置过程仅展示部分应用，访问工作台时显示全部的应用",
    "dashboard.all.entry.tip": "配置过程仅展示部分表单，访问工作台时显示全部的表单",
    "self.build": "自建",
    "close.custom.dash": "关闭自定义工作台",
    "login.qywechat.self": "企业微信自建登录",
    "design.close.msg": "您常用的应用、表单、报表可以自由布局添加到工作台了！更快提升您的工作效率！",
    "design.custom.open": "开启自定义工作台",
    "design.close.alert.title": "您确定要关闭自定义工作台吗？",
    "dash.map.window.title": "信息列表",
    "dash.map.marker.empty.tip": "请在地图报表上添加需要设置的坐标点（点击地图或者通过搜索地址添加坐标点）",
    "design.close.alert.msg": "这会使您的工作台回到默认样式，此操作无法撤销。",
    "address.book.dept.set.title": "设置职位",
    'jobtitle.set': "设置成员所在部门的职位",
    'address.book.dept.set.title.select': "请选择职位",
    'address.book.dept.jobtitle.add': "添加职位",
    'address.book.dept.jobtitle.addnew': "添加新职位",
    'address.book.dept.jobtitle.addnew.tip': "每行代表一个职位，且不超过16个字符",
    'address.book.dept.jobtitle.addnew.no-permission': "用户不在当前部门",
    "qywechat.bind.activation.tip": "企业微信体验时间还剩余{{ day }}天，为了不影响您的正常体验，请马上激活",
    "qywechat.bind.select.user": "请选择需要登录的团队",
    "install.app.title": "安装【{{appName}}】应用",
    "install.app.tip": "获取后可以进行个性化改造",
    "install.app.wechat.title": "在线联系客服",
    "install.app.ok": "确认安装",
    "install.app.cancel": "取消安装",
    "package.base.title": "基础功能购买",
    "package.buy.title": "自定义套餐购买",
    "package.base.dataview.grouptable.begin": "{{num}}个起步升配",
    "package.base.member.begin": "{{num}}人起步升配",
    "package.base.flow.begin": "{{num}}G起步升配",
    "package.base.data.begin": "{{num}}万数据起步升配",
    "package.base.flow.num": "{{num}}G",
    "package.base.data": "数据量",
    "package.base.member": "用户数",
    "package.base.dataview.grouptable.unit": "{{num}}元/个/年",
    "package.base.member.unit": "{{num}}元/人/年",
    "package.base.flow.unit": "{{num}}元/G",
    "package.base.data.unit": "{{num}}元/万数据/年",
    "package.base.purchased": "已购：",
    "package.base.not.purchased": "未购：",
    "package.base.check.order": "查看订单",
    "package.base.update": "升配",
    "package.details": "套餐详情",
    "package.details.base": "基础配置：",
    "package.app.install.num": "应用安装个数",
    "package.site.webapi": "开放平台-平台级接口",
    "num.ge": "{{num}}个",
    "appstore.guide.step1.title": "创建您的<span>第一个应用</span>",
    "appstore.guide.step1.desc": "您可以<span>创建空白应用</span>，自行搭建",
    "appstore.guide.step2.desc": "或者，您也可以<span>安装应用中心的应用</span>，直接使用或自行进行个性化改造",
    "sso.empty.config.tip": "暂未配置单点登录，配置后可以更方便您登录操作",
    "purview.sso.tip": "暂未获取单点登录权限",
    "sso.config.content.title": "单点登录配置内容",
    "sso.other.team.tip": "第三方团队不支持单点登录",
    "qiyewechat.custom": "企业微信通讯录激活",
    "qiyewechat.custom.tip": "企业微信通讯录激活，激活后，才可以正常获取企业微信的通讯录信息",
    "qiyewechat.custom.active": "去激活",
    "qiyewechat.custom.active.code": "打开企业微信扫描下方二维码，授权待开发自建应用，激活通讯录",
    "qiyewechat.custom.active.code2": "授权完成后，请等待官方审核，审核通过后即可激活通讯录",
    "qiyewechat.phone.entry.tip": "请填写企业微信绑定的手机号",
    'clean.select.item': '清空所选项',
    'outlink.tip.user': '表单外链不支持成员控件',
    'outlink.tip.usergroup': '表单外链不支持成员多选控件',
    'outlink.tip.dept': '表单外链不支持部门控件',
    'outlink.tip.deptgroup': '表单外链不支持部门多选控件',
    'data.manager.alldata.edit': '全部数据',
    'data.manager.filterdata.edit': '筛选后的数据',
    'data.manager.alldata.exportfile': '全部数据的附件',
    'data.manager.filterdata.exportfile': '筛选后数据的附件',
    'data.manager.alldata.qrcode': '全部数据的二维码',
    'data.manager.filterdata.qrcode': '筛选后数据的二维码',
    'field.widget.name': '字段原始别名',
    'deleted.outdiser': '已删除的外部联系人',
    'default.group': '默认分组',
    'waiting.new': '已等待',
    'wps.xlsx.name1': '外部联系人批量导入模板.xlsx',
    'wps.xlsx.name2': '连接企业批量导入模板.xlsx',
    'wps.xlsx.file.name': '通讯录批量导入模板.xlsx',
    'invite.phone.required': '必须填写正确的手机号',
    'invite.email.required': '必须填写正确的邮箱',
    "email.entry.tip": "请填写正确的邮箱",
    'member.invitation.import': '成员邀请导入',
    'consolidate.departments.groups': '部门/角色组处理方式',
    'consolidate.departments.groups.tip': '当导入已存在的成员时，部门/角色组是覆盖模式还是合并模式，其他不需要验证的信息覆盖',
    'before.del': '删除前',
    'consolidate.departments.groups.title': '用户已存在，是否合并部门和角色？',
    merge: '合并',
    "dept.entry.tip": "请填写需要加入的部门",
    'url.join.dept.tip': '访问链接直接加入部门',
    'dept.entry.tip1': '最少需要选择一个部门',
    'personnel.invitation': '人员邀请',
    'personnel.invitation.tip': '具备对所有人员邀请权限',
    'member.invitation': '成员邀请',
    'external.contact.invitation': '外部联系人邀请',
    'personnel.deletion': '人员删除',
    'personnel.deletion.tip': '具备对所有人员删除权限',
    'member.deletion': '成员删除',
    'external.contact.deletion': '外部联系人删除',
    'department.external.group.deletion': '部门/外部联系人分组删除',
    'department.external.group.deletion.tip': '具备对所有部门/外部联系人分组删除权限',
    'department.deletion': '部门删除',
    'job.select.tip': '点击选择职位',
    'group.deletion': '外部联系人分组删除',
    "member.not.verify.tip1": '有<span style="color: #FF634E;margin:0 2px">{{num}}</span>个手机/邮箱未验证，<span class="inv" style="color: var(--bsy-base-color);cursor: pointer;">再次全部验证</span>',
    "click.ver": "点击验证",
    "contact.note.title": "备注",
    manager1: "管理员",
    'join.time': '加入时间',
    'department.ownership': '部门归属',
    'verified.phone.tip': '手机已验证，您无法修改。如需修改请联系成员在个人设置页面重新绑定。',
    'verified.email.tip': '邮箱已验证，您无法修改。如需修改请联系成员在个人设置页面重新绑定。',
    "verify.all.tip": "是否再次验证全部未验证的手机邮箱？",
    "corp.management": "企业管理",
    "select.loginer.placeholder": "请选择登录人",
    "applications.object.placeholder": "请选择应用/对象",
    "enter.old.password": "请输入旧密码",
    "enter.new.password": "请输入新密码",
    "enter.again.new.password": "请重新输入新密码",
    "app.belong": "所属应用",
    "corp.log.tip": "保存最近{{num}}个月的操作日志",
    "remind.setting": "提醒设置",
    "operate.detail": "操作详情",
    "corp.login.time": "登录时间",
    "corp.login.member": "登录人",
    "corp.login.city": "登录地",
    "corp.login.platform": "登录平台",
    "corp.login.info.tip": "保存最近{{num}}个月的登录日志",
    "corp.login.statistics.info": "统计最近30天的登录情况",
    "corp.op.statistics.info": "统计最近30天的操作情况",
    "corp.op.statistics": "操作统计",
    "corp.login.statistics": "登录统计",
    "corp.usage.range": "统计范围",
    "corp.usage.counts": "人数",
    "corp.usage.loginStats": "每日登录人数",
    "corp.usage.times": "次数",
    "corp.usage.dataCreateStats": "每日数据创建人数&次数",
    "corp.usage.dataDownStats": "每日文件下载人数&次数",
    "corp.usage.dataExportStats": "每日数据导出人数&次数",
    "corp.usage.dataUpdateStats": "每日数据修改人数&次数",
    "corp.usage.stats": "每日使用人数",
    "operate.object": "操作对象",
    "applications.object": "应用/对象",
    "corp.log.app.filter": "查询此应用",
    "corp.log.object.filter": "查询此对象",
    "member.deleted": "已删除成员",
    "outsider.deleted": "已删除外部联系人",
    "login.log": "登录日志",
    "enterprise.log": "企业日志",
    "platform.log": "平台日志",
    "application.log": "应用日志",
    "export.logs": "导出日志",
    "log.range": "日志范围",
    "log.type": "日志类型",
    "all.data.print": "拼接打印",
    "one.data.print": "逐条打印",
    "all.data.print.tip": "（所有数据合成一个打印文件）",
    "one.data.print.tip": "（每条数据合成一个打印文件）",
    "data.printTemplate1": "打印模板",
    "data.printTemplate1.tip": "请选择打印模板",
    "print.method": "打印方式",
    "data.word": "Word预览",
    "corp.coop": "互联组织",
    "corp.coop.authorization": "互联组织授权",
    "corp.coop.authorization.subtitle": "输入并验证手机即可授权，授权后可与合作伙伴基于本平台实现线上业务协作。",
    "corp.coop.contact.request.already": "对方已接管您的通讯录权限，无需重复操作。",
    "corp.coop.contact.request.already.title": "已移交通讯录权限",
    "corp.coop.contact.request.fail": "链接失效，无法移交通讯录权限，请联系对方企业负责人重新发送。",
    "corp.coop.contact.request.success": "对方可以帮助您管理成员，您也可以在「通讯录」重新接管权限。",
    "corp.coop.contact.request.success.title": "通讯录权限移交成功",
    "corp.coop.manage.prev.tip": "可预设代管对方通讯录，代管状态下可以自主给对方通讯录添加成员",
    "contact.corp.all": "全部企业",
    "contact.corp.connect.establish": "建立连接关系",
    "contact.corp.connect.established": "已建立连接关系",
    "contact.corp.connect.expired.tip": "链接失效，无法建立协作关系，请联系对方企业负责人重新发送链接。",
    "contact.corp.connect.expired.title": "链接已失效",
    "contact.corp.connect.fail": "连接建立失败",
    "contact.corp.connect.fail.creator": "您的手机号不是企业创建者身份，不能通过此链接建立连接关系，请联系对方确认。",
    "contact.corp.connect.fail.detail": "连接关系建立失败",
    "contact.corp.connect.fail.permission": "对方企业已不具备连接权限，请联系对方处理",
    "contact.corp.connect.fail.phone": "未匹配到手机号，请联系对方确认。",
    "contact.corp.connect.fail.tip": "对方企业连接剩余连接额度不足，请联系对方处理。",
    "external.dept": "外部企业",
    "contact.handover": "外部对接人",
    "contact.handover.add": "添加对接人",
    "contact.handover.add.again": "再次添加",
    "contact.handover.add.again.fail": "此企业的创建者尚未授权，暂时无法添加此成员，请先邀请创建者建立连接后再添加",
    "corp.coop.empty.tip1": "通过「互联组织」功能可以连接经销商、供应商、母子公司等外部合作伙伴",
    "corp.coop.empty.tip2": "连接后可以将你的表单/流程权限分配给对方，线上完成企业间数据填报、流程审批等",
    "corp.coop.empty.tip3": "快来连接合作伙伴，提升企业间协作效率吧",
    "contact.connection.new": "新建连接",
    "contact.connection.new.link": "公开链接邀请",
    "contact.connection.new.multi": "批量导入邀请",
    "contact.connection.remove": "解除连接",
    "contact.connection.remove.confirm.tip": "解除连接后，不能和该企业进行业务协作，此操作不可还原。",
    "contact.connection.remove.confirm.title": "确定要解除连接？",
    "contact.connection.remove.empty": "请选择要解除连接的企业",
    "contact.connection.selected.remove": "确定和选择的企业解除连接？",
    "contact.connection.selected.remove.tip": "解除连接后，不能和对应企业进行业务协作，此操作不可还原。",
    "contact.connection.tip.url.msg": "连接对方企业时需要发送邀请链接，您当前暂无可用的链接，请配置后重试。",
    "contact.connection.tip.url.title": "没有可用的邀请链接",
    "contact.connection.upgrade.tip.manager": "连接企业数量已达上限，您可以联系企业创建者升级版本，或移除无用连接后再新建。",
    "contact.connection.upgrade.tip.owner": "系统用量受到限制，您是否要立即升级？",
    "contact.connection.vip.upgrade": "您当前使用的版本不包含互联组织功能，您可以至「企业管理-版本信息」查看版本使用详情和升级版本。",
    "contact.connection.vip.upgrade.manager": "您当前使用的版本不包含互联组织功能，请联系企业创建者升级版本。",
    "dept.label.add": "添加企业标签",
    "contact.handover.all": "全部对接人",
    "contact.handover.click.select": "点击选择对接人",
    "contact.handover.corp": "归属企业",
    "contact.handover.corp.empty": "请选择对接人所属企业",
    "contact.handover.corp.placeholder": "必填，请选择对接人所属企业",
    "contact.handover.current": "我方对接人",
    "contact.handover.current.add.tip": "设置我方对接人可以让不同的员工和不同的连接企业对接，便捷的开展业务协作。",
    "contact.handover.empty": "此分类下暂无工作",
    "contact.handover.export.all": "导出全部",
    "contact.handover.guest": "可管理的外部对接人",
    "contact.handover.guest.empty": "对接人一般负责企业间的业务协作。您可以给连接企业的对接人分配本企业的应用/表单权限，开展相关协作事宜。请联系对方企业负责人设置对接人。",
    "contact.handover.host": "仅查看的外部对接人",
    "contact.handover.host.empty": "对方企业管理者没有设置对接人",
    "contact.handover.invite.tip": "代管通讯录企业中有 {{count}} 名对接人未加入",
    "contact.handover.list": "对接人列表",
    "contact.handover.name": "对接人姓名",
    "contact.handover.name.required": "请输入对接人姓名",
    "contact.handover.name.too.lang": "对接人姓名最长80个字符",
    "contact.handover.not.join.tip": "有 {{count}} 名对接人未授权加入企业",
    "contact.handover.other": "对方对接人",
    "contact.handover.phone.required": "请输入手机号",
    "contact.handover.role": "对接人角色",
    "contact.handover.role.empty": "当前没有角色，请创建",
    "contact.handover.title": "有以下工作，可根据需要转交给其他成员",
    "contact.is.owner": "是否为创建者",
    "label.list": "列表",
    "label.name": "名称",
    "label.name.input": "请输入标签名称",
    "label.name.notEmpty": "标签名称不能为空",
    "label.name.notSame": "标签名称不能重复",
    "label.name.tooLong": "标签名称不能超过{{length}}个字符",
    "label.select1": "点击选择企业",
    "label.target.add.max": "最多添加{{count}}个企业标签",
    enterprise: "企业",
    "contact.docker.empty": "暂无对接人",
    "contact.docker.empty.tip": "暂无相关对接人",
    "contact.docker.invite.success.tip": "添加邀请发送成功",
    "contact.docker.our.edit.tip": "我方对接人可以直接参与互联企业协作，修改后不可还原。",
    "contact.docker.our.edit.title": "确定修改我方对接人？",
    "contact.docker.remove.tip": "移除后，此对接人无法再参与和此连接企业的业务协作，此操作不可还原。",
    "contact.docker.remove.title": "确定移除此对接人？",
    "contact.docking.corp": "对接企业",
    "contact.docking.corp.tip": "对接已经建立和未来建立连接关系的所有企业",
    "contact.docking.people": "对接人",
    "contact.docking.people.require": "请选择对接人",
    "member.invite.phoneOrEmail.placeholder": "输入手机号或邮箱来邀请成员，多个成员之间使用逗号、分号或换行隔开每个手机号或邮箱每天最多邀请3次",
    "member.invite.public.link": "公开链接邀请",
    "member.invite.public.setLink": "设置链接",
    "member.invite.public.setLink.text": "将下方链接分享给合作伙伴，对方点击即可建立连接关系；建议预设企业标签、角色等属性后分享。",
    "member.invite.public.tip.title": "公开链接邀请适用场景",
    "member.invite.public.tip1": "当合作伙伴「已有{{productName}}账号」时，只能用公开链接邀请。推荐通过微信发送邀请链接。",
    "member.invite.public.tip2": "当合作伙伴「想在钉钉/企业微信/飞书上使用{{productName}}」时，需先在对应平台上完成对接后，再用公开链接邀请。",
    "member.invite.public.tip3": "当合作伙伴「没有{{productName}}账号」时，可以用公开链接邀请对方注册。",
    "member.invite.qrcode.brief": "尊敬的合作伙伴，诚挚邀请您扫码与我建立协作关系，基于「{{productName}}」实现企业间数据填报、流程审批等。",
    "member.invite.report": "你可以发布报表给他/她查看。",
    "member.invite.role": "你可以将他/她设置为不同角色，参与业务管理。",
    "member.invite.send": "发送邀请",
    "member.invite.sms.send": "发送邀请短信",
    "member.invite.success": "邀请成功！",
    "member.invite.tip": "邀请成员加入 一起管理企业的业务",
    "member.invite.title": "企业中没有成员，是否邀请？",
    "contact.connection.link.tip": "通过此链接邀请的企业/对接人默认设置如下",
    "persona.corp.dept.label": "企业标签",
    "manager.contactAuth": "通讯录权限",
    "link.add": "添加链接",
    "link.address": "链接地址",
    "link.copy.success": "链接已复制",
    "link.edit": "编辑链接",
    "link.edit.fail": "不能同时编辑多条链接，请保存后重试",
    "link.failure": "链接已失效",
    "link.qrcode": "链接二维码",
    "link.share": "分享链接",
    "openLink.auth.name.enterprise": "企业名称",
    "corp.search": "搜索企业",
    "corp.team.name": "企业/团队名称",
    "corp.coop.delete.tip": "删除企业标签不会删除此企业标签中包含的对接企业。",
    "corp.role.delete.tip": "删除角色会同时删除该角色的权限，但不会删除此角色中包含的对接人。",
    "contact.corp.panel.tip": "此页面展示你主动邀请的企业，邀请成功后给他们分配表单/流程权限即可协作",
    "contact.handover.panel.tip": "此页面展示你主动邀请的企业的成员，邀请成功后给他们分配表单/流程权限即可协作",
    "function.intro.detail": "功能详细介绍",
    "label.dept.new": "添加企业",
    "label.set": "设置标签",
    "role.set": "设置角色",
    "remove.out": "移出",
    "invite.link": "链接邀请",
    "qrCode.download": "下载二维码",
    "contact.escrow.setting.tip": "可设置代管对方通讯录，代管状态可以自主给对方通讯录添加成员",
    "label.setting": "设置企业标签",
    "contact.corp.handover.set": "设置对接人",
    "link.state": "链接状态",
    "links.at.least.one": "至少保留 1 条链接",
    "corp.coop.manage.apply.tip": "没有对方通讯录操作权限，无法添加对接人。请线下联系对方添加或申请对方通讯录管理权限",
    "corp.coop.dept.manage.apply.tip": "没有对方通讯录操作权限，无法添加对接部门。请线下联系对方添加或申请对方通讯录管理权限",
    "wechat.official.account.follow.instruction": "搜索或扫码关注「{{productName}}」官方公众号，手机实时查看信息&处理待办",
    "wechat.qrcode.instruction": "请使用微信扫码或在微信中长按识别",
    "wechat.rebind.tip": "当前登录账号已绑定其他微信账号，是否换绑到当前微信账号？",
    "contact.corp.connect.fail.title": "业务协作关系建立失败",
    "contact.corp.connect.fail.wrong.phone": "您的手机号不是企业创建者身份或已通过其他方式注册账号，不能通过此链接建立连接关系，请联系对方确认。",
    "contact.corp.connect.member.tip1": "您不是当前登录企业的创建者、系统管理员或无互联组织权限，无法建立连接",
    "contact.corp.connect.member.tip2": "如果您需要继续操作，请切换至您是创建者、系统管理员或有互联组织权限的企业",
    "contact.corp.connect.no.corp": "当前账号下没有任何企业，请创建新企业或加入其他企业后重试",
    "contact.corp.connect.query.tip": "连接关系建立后，我方成员可以访问对方开放权限的应用/表单，实现企业间数据填报、流程审批等。",
    "contact.corp.connect.query.title": "企业「{{name}}」想和您建立企业连接，开展业务协作，是否接受？",
    "contact.corp.connect.self.tip1": "当前登录企业是发送链接的企业，无法和自己建立连接",
    "contact.corp.connect.self.tip2": "如果要继续操作，请切换其他企业",
    "contact.corp.connect.success": "连接关系建立成功",
    "contact.corp.connect.success.register": "已成功注册并建立连接关系",
    "contact.corp.connect.success.tip": "您的合作伙伴已经用{{productName}}实现企业内部业务管理，后续双方可以基于【{{productName}}】开展企业间业务协作，预祝协作顺利！",
    "contact.corp.connect.success.tip1": "需要设置双方业务协作人，在{{productName}}中我们将协作人称为「对接人」",
    "contact.corp.connect.success.tip2": "你可以现在设置对接人，也可以后续在「通讯录-互联组织」中调整",
    "contact.corp.connect.success.title": "业务协作关系建立成功",
    "contact.corp.docker.set.success": "对接人设置完成",
    "contact.corp.empty": "没有对接此类的企业",
    "contact.corp.empty.tab": "暂无此类企业",
    "contact.corp.link.query.tip": "连接关系建立后，您可以使用对方制作的应用/表单等内容，实现企业间数据填写、流程审批等。如果已有{{productName}}账号请直接登录建立连接，没有账号请先注册。",
    "contact.corp.link.query.title": "企业「{{name}}」想基于{{productName}}和您建立企业连接，开展业务协作。",
    "contact.corp.list": "企业列表",
    "contact.corp.not.connection.single": "此企业创建者尚未授权建立连接关系",
    "contact.corp.owner.info": "创建者：{{name}}",
    "contact.corp.link.query.login": "已有账号，直接登录",
    "contact.corp.link.query.register": "注册新账号",
    "contact.corp.handover.set.not": "暂不设置",
    "contact.corp.has.connect.tip1": "已经和企业「{{name}}」建立连接",
    "contact.corp.has.connect.tip2": "请联系对方企业管理员给您分享应用/表单权限，实现企业间数据填报、流程审批等。",
    "contact.learn.bs": "了解{{productName}}",
    "receiver.enter.homepage": "进入{{productName}}",
    "corp.joined1": "已加入「{{corp}}」",
    "contact.corp.not.connection.tip": "有 <b style=\"color:#FF634E;font-weight: normal; \">{{count}}</b> 个导入的企业未同意建立连接关系",
    "member.invite.link.change": "修改邀请链接",
    "member.invite.link.copy": "复制邀请链接",
    "contact.docker.email.verify.tip": "邮箱未验证，不能接收消息，请联系该成员登录{{productName}}验证。",
    "contact.docker.phone.verify.tip": "手机未验证，不能接收消息，请联系该成员登录{{productName}}验证。",
    "label.select": "点击选择企业标签",
    "member.invite.copy.link": "尊敬的合作伙伴，诚挚邀请您与我建立连接关系，基于「{{productName}}」实现企业间数据填报、流程审批等。期待与您的合作！\n邀请人：{{name}}\n邀请链接：{{link}}",
    "member.invite.copy.link.brief": "尊敬的合作伙伴，诚挚邀请您与我建立连接关系，基于「{{productName}}」实现企业间数据填报、流程审批等。",
    "contact.corp.host": "邀请我协作的企业",
    "contact.corp.some": "部分企业",
    "contact.escrow": "代管通讯录",
    "escrow.disabled": "不代管",
    "docker.role.setting": "设置对接人角色",
    "member.invite.public.link.success.tip": "推荐您连接关键决策者，以便合理安排协作工作的内容与权限",
    "configuration.success": "配置成功！",
    "link.not.yet": "暂不连接",
    "label.dept.empty.corp.tip": "可以用企业标签给邀请的合作伙伴分类，如供应商、经销商等。当前标签下没有对接企业，请添加。",
    "label.dept.empty.tip": "可以用企业标签给邀请的合作伙伴分类，如供应商、经销商等。 当前你还没有企业标签，请先添加",
    "role.current.member.empty.add": "当前角色下没有成员，请添加",
    "contact.external.role.list": "外部角色列表",
    "organization.internal": "内部组织",
    "organization.external": "外部组织",
    "organization.interconnected": "互联组织",
    "contact.template.corp.cooperation.tip.1": "当合作伙伴「没有{{productName}}账号且不想自己注册」时，可以使用批量导入的方式。",
    "contact.template.corp.cooperation.title": "批量导入邀请适用场景",
    "contact.template.corp.import.tip": "每次最多导入{{corpCount}}家企业，每家企业最多导入{{memberCount}}名成员",
    "contact.template.download": "下载导入模板",
    "contact.template.download.tip": "请下载{{link}}，按格式修改后导入",
    "contact.template.import.after": "导入成功后会自动发送邀请短信，合作伙伴点击短信即可连接",
    "contact.template.import.link": "您也可以通过微信，直接分享下方链接给合作企业创建者，绑定官方公众号并建立连接",
    "file.select.detail": "选择或拖拽上传文件,单个{{num}}MB以内",
    "create.after.excel.import": "成功导入Excel后生成",
    "error.19004": "与目标企业不存在关联关系",
    "error.19008": "该名称已存在，请调整后重试",
    "error.19013": "最多添加 20 个对接人",
    "error.19014": "文件内没有可导入的企业，请调整后重新上传",
    "error.19017": "此用户已经是该企业的对接人，请勿重复添加",
    "error.19019": "角色名称不能重复",
    "error.19020": "最多添加200个角色",
    "error.19021": "每天仅可发送 1 次邀请，请明天重试",
    "corp.import.complete": "成功导入{{count}}家企业",
    "corp.import.complete.docker.fail": "成功导入{{count}}家企业，部分成员未导入",
    "corp.import.not.complete": "成功导入{{successCount}}家企业，失败<i style=\"color: var(--bsy-base-error-color)\">{{failCount}}</i>家",
    "app.dock": "外部应用",
    "corp.label.empty.tip": "企业标签名称不能为空",
    "corp.role.empty.tip": "对接人名称不能为空",
    "corp.label.max.tip": "企业标签名称最长不能超过{{length}}个字符",
    "corp.role.max.tip": "对接人名称最长不能超过{{length}}个字符",
    "contact.role.notEmpty": "对接人角色名称不能为空",
    "contact.manage.auth.request": "申请代管通讯录",
    "contact.manage.auth.request.success": "代管申请已发送",
    "contact.manage.auth.transfer": "移交代管权限",
    "contact.manage.auth.transfer.msg": "移交后将失去添加对方对接人的权限，将由连接的企业自主添加对接人，此操作不可还原。",
    "contact.manage.auth.transfer.title": "确定要移交代管权限？",
    "contact.member.join.success.tip": "可以和同事一起在【{{productName}}】填报数据、审批流程等，在线协同办公，提高工作效率。",
    "contact.member.join.success.title": "成功加入企业",
    "message.sended": "添加信息已发送",
    "contact.handover.add.all.again": "全部再次添加",
    "contact.connect.host.corp": "连接对方企业",
    "label.dept.remove.empty": "请选择要移出的对接企业",
    "label.dept.selected.remove": "确定从此企业标签中移出所选对接企业？",
    "label.dept.selected.remove.tip": "从此标签中移出所选对接企业不会解除与其建立的连接。",
    "contact.our.docker.remove.empty": "请选择要移除的对接人",
    "contact.our.docker.remove.out.empty": "请选择要移出的对接人",
    "contact.our.docker.remove.tip": "移除后，对接人无法再参与互联企业协作，此操作不可还原。",
    "contact.our.docker.remove.title": "确定移除所选对接人？",
    "contact.role.docker.remove.tip": "移出后，对接人无法再参与此角色相关的外部企业协作，此操作不可还原。",
    "contact.role.docker.remove.title": "确定从此角色中移出所选对接人？",
    "contact.handover.role.add": "添加对接人角色",
    "contact.take.over": "自主管理通讯录",
    "contact.take.over.msg": "自主管理后，协作企业将失去相关权限，与对方的业务协作对接人需要你自主维护。此操作不可还原。",
    "contact.take.over.tip1": "你的通讯录暂时由协作企业「{{corp}}」代为管理，你没有操作权限",
    "contact.take.over.tip2": "点击下方按钮获取权限，之后你可以进行邀请成员、添加部门等操作",
    "contact.take.over.title": "确定要自主管理通讯录吗？",
    "contact.dailog.over.title": "你确定要离开当前页面吗？",
    "contact.dailog.over.tip": "离开当页面后，你所做的修改不会被保存",
    "external.member.invite.tip1": "开启后，只需访问此链接，即可加入企业并自动成为对接人",
    "external.member.invite.tip2": "可将此链接分享给对方企业创建者，让其在企业内分发给相关员工",
    "organization.external.user": "外部组织成员",
    "organization.internal.user": "内部组织成员",
    "organization.external.flow": "外部流程",
    "organization.internal.flow": "内部流程",
    "contact.search.name": "搜索姓名",
    "corp.coop.manage.integrated.tip": "对方将{{productName}}集成在企业微信/钉钉/飞书等平台，无法直接添加对接人，请线下联系对方添加。",
    "dock.flow.todo": "外部待办",
    "signin.qrcode": "扫码登录",
    "mobile.num.login": "手机号登录",
    "crm.authority": "权限",
    "app.edit.child.group.create": "新建子分组",
    "app.edit.move.tip": "此分组内有子分组，不能通过「移动」的方式排序，请直接拖拽排序。",
    "main.department": "主部门",
    "max.two.level.group": "当前最多只能支持两级分组",
    "system": "系统",
    "trigger.create.app": "新建应用时推送",
    "trigger.create.form": "新建表单时推送",
    "page.error.tip": '系统出小差了，请联系管理员处理',
    "flow.time.start": "流程发起时间",
    "flow.my.transactors.time": "我最近处理的节点时间",
    "flow.my.cc.time": "节点抄送时间",
    "custom.dashboard.subtitle.layout": "布局组件",
    "custom.dashboard.subtitle.left.bar": "左侧边栏",
    "custom.dashboard.subtitle.middle.bar": "单栏",
    "custom.dashboard.subtitle.page": "页面组件",
    "custom.dashboard.subtitle.right.bar": "右侧边栏",
    "custom.dashboard.toast.empty": "保存失败，请添加「页面组件」",
    "custom.dashboard.subtitle.tab.bar": "标签容器",
    "manage.dashboard.design": "管理工作台",
    "set.worker.dashboard.design": "设置企业工作台",
    "create.dashboard.design": "新建工作台",
    "create.dashboard.design.tip": "请输入工作台名称",
    "select.dashboard.design": "选择工作台",
    "set.dashboard.design.auth": "配置权限",
    "set.dashboard.design.auth.msg": "添加成员，授权他们查看并使用该工作台",
    "set.dashboard.design": "设置工作台",
    "dashboard.design.delete.title": "您确定要删除工作台“{{name}}”吗？",
    "dashboard.design.delete.tip": "删除工作台则布局、表单、报表以及数据也都将一并删除，此操作不可逆！",
    "dashboard.design.auth.title": "配置查看使用权限",
    "dashboard.design.auth.msg": "在此分组内的成员可以查看并使用该工作台",
    "close.custom.design": "关闭我的工作台",
    "design.custom.close.alert.title": "您确定要关闭我的工作台吗？",
    "design.custom.close.alert.msg": "这会使我的工作台回到默认样式，此操作无法撤销。",
    "design.custom.create.alert.title": "如需进行此操作，请先保存当前工作台",
    "speedy.entry.settings": "设置快捷入口",
    "speedy.entry.tab.component": "组件属性",
    "speedy.entry.tab.entryItem": "入口属性",
    "speedy.entry.tab.entryItem.emptyTip": "在左侧点击选择入口来设置属性",
    "speedy.entry.title.overLength": "标题不能超过{{count}}个字符",
    "speedy.entry.unnamed": "未命名快捷入口",
    "speedy.entry.displayStyle": "入口样式",
    "speedy.entry.entryList": "入口列表",
    "speedy.entry.add.entry": "添加入口",
    "speedy.entry.add.title": "添加表单应用",
    "speedy.entry.add.max": "最多添加{count}个",
    "app.form": "表单应用",
    "print.file.name.custom": "自定义名称",
    "speedy.entry.entryItem.customIcon": "自定义图标",
    "speedy.entry.entryItem.openType": "打开方式",
    "speedy.entry.entryItem.openType.current": "当前页面",
    "speedy.entry.entryItem.openType.newPage": "新页面",
    "speedy.entry.entryItem.openType.tips": "仅在电脑端生效，移动端为当前页面打开",
    "speedy.entry.entryItem.source": "入口来源",
    "dash.report": "分析报表",
    "change.icon": "修改图标",
    "modify.system.icon": "系统图标",
    "modify.upload.maxLimit": "请选择5MB以内的jpg、gif、jpeg 或 png图片",
    "image.upload.size.tip": "建议尺寸{{width}}*{{height}}像素",
    "modify.upload.icon": "选择上传新图片",
    "avatar.image.change": "更换图片",
    "change.switch.design": "切换工作台",
    "dashboard.design.error.tip": "工作台名称不能为空",
    "my.dash": "我的报表",
    "add.my.dash": "添加我的报表",
    "my.chart.view.desc": "无需统一配置，由成员自行添加常用的图表",
    "my.chart.favorites.desc": "无需统一配置，由成员自行收藏常用的应用/表单/报表",
    "icon.replacement.failed": "自定义图标更换失败！",
    "icon.replacement.successful": "自定义图标更换成功！",
    "speedyEntry.empty.tip": "请在右侧组件属性中添加入口",
    "speedyEntry.card.style.horizontal": "卡片样式横排",
    "speedyEntry.card.style.row": "卡片样式竖排",
    "speedyEntry.card.list.style": "列表样式",
    "design.warning.msg": "自定义工作台名称不能为空",
    "design.warning.msg1": "自定义工作台名称长度不能超过26位",
    "user.relation": "成员关系",
    "add.user.relation": "添加成员",
    "add.relation.user": "添加成员关系",
    "add.relation": "新建成员关系名称",
    "new.relation": "新关系",
    "relation.duplicate.name": "关系名称不能重复",
    "relation.empty.name": "关系名称不能为空",
    "join.all.tip": "是否再次邀请全部未加入的成员？",
    "relation.save.user.tip": "有未填写完整的成员关系，请检查后再进行保存",
    "relation.name": "关系名称",
    "user.relation.list": "成员关系列表",
    "contact.handover.other.dept": "对方对接部门",
    "contact.handover.current.dept": "我方对接部门",
    "contact.docker.dept.empty": "暂无对接部门",
    "removal1": "移除",
    "close.detail": "关闭详情",
    "contact.docker.dept.user.empty": "当前对接部门暂无成员",
    "contact.handover.dept.add": "添加对接部门",
    "contact.dock.dept.empty": "暂无对接部门",
    "contact.dock.dept.empty.tip": "暂无相关对接部门",
    "contact.dock.dept.our.edit.tip": "我方对接部门可以直接参与互联企业协作，修改后不可还原。",
    "contact.dock.dept.our.edit.title": "确定修改我方对接部门？",
    "contact.dock.dept.remove.tip": "移除后，此对接部门无法再参与和此连接企业的业务协作，此操作不可还原。",
    "contact.dock.dept.remove.title": "确定移除此对接部门？",
    "contact.docking.dept": "对接部门",
    "contact.docking.dept.require": "请选择对接部门",
    "escrow": "代管",
    "my.contacts": "我的通讯录",
    "my.corp.contacts": "自己企业的通讯录",
    "escrow.contacts": "代管的通讯录",
    "open.contact.manage.transfer": "打开代管通讯录",
    "contact.dept.current.add.tip": "设置我方对接部门可以让不同的员工和不同的连接企业对接，便捷的开展业务协作。",
    "contact.our.dept.remove.empty": "请选择要移除的对接部门",
    "contact.our.dept.remove.out.empty": "请选择要移出的对接部门",
    "contact.our.dept.remove.tip": "移除后，对接部门无法再参与互联企业协作，此操作不可还原。",
    "contact.our.dept.remove.title": "确定移除所选对接部门？",
    "contact.search.dept": "搜索部门",
    "widget.dept.clickToSelect1": "选择部门",
    "widget.user.clickToSelect1": "选择成员",
    "change.flow.node.tip": "更换流程的当前节点，以及节点的负责人。",
    "flow.transfer.tip": "调整流程当前节点的负责人。",
    "reference.relationship.query": "查询模式",
    "referenceByFormList.label": "被引用对象",
    "referenceExtend.label": "插件",
    "referenceFormList.label": "引用对象",
    "referenceMode.label": "位置",
    "referenceType.label": "关系",
    "byReference.label": "引用方式：",
    "byReference.item1": "本表引用其他对象",
    "byReference.item2": "其他地方引用本表",
    "byFormInfo.label": "被引用对象",
    "extendInfo.label": "插件信息",
    "formInfo.label": "引用对象",
    "modeInfo.label": "引用位置",
    "typeInfo.label": "引用关系",
    "detailsInfo.label": "详细信息",
    "form.filter": "查询此表单",
    "reference.filter": "查询此插件",
    "view.reference.detail": "查看引用详情",
    "reference.relationship": "引用关系",
    "reference.empty.text": "在一些复杂业务中，一张表单通常会与其他表单、数据视图、聚合表、数据助手、插件等关联使用，进行数据协作和引用，通过「引用关系」即可查看表单的关联关系，便于管理员进行管理和维护。",
    "reference.open.text": "开启引用对象查询",
    "reference.opening.text": "引用对象查询正在开启中，请稍等一下...",
    "byReference.form.item1": "当前表单引用其他对象",
    "byReference.form.item2": "其他对象引用当前表单",
    "byReference.dash.item1": "当前报表引用其他对象",
    "byReference.dash.item2": "其他对象引用当前报表",
    "byReference.scenes.item1": "当前报表引用其他对象",
    "byReference.scenes.item2": "其他对象引用当前报表",
    "byReference.report.item1": "当前报表引用其他对象",
    "byReference.report.item2": "其他对象引用当前报表",
    "byReference.etl.item1": "当前视图引用其他对象",
    "byReference.etl.item2": "其他对象引用当前视图",
    "byReference.aggregate.item1": "当前聚合表引用其他对象",
    "byReference.aggregate.item2": "其他对象引用当前聚合表",
    "reference.relationship.view": "视图模式",
    "relationship.detail": "引用详情",
    "reference.relationship.view.tip": "该「视图模式」展示的为当前「查询模式」本页面的所有结果，如需查看更多，请配合「查询模式」翻页功能进行查看",
    "position.management": "职位管理",
    "position.name": "职位名称",
    "position.duplicate.name": "职位名称不能重复",
    "position.empty.name": "职位名称不能为空",
    "position.length.max.name": "职位名称不能超过16个字符",
    "position.placeholder.name": " 请输入职位名称",
    "relation.placeholder.name": " 请输入关系名称",
    "position.add.batch": " 批量添加新职位",
    "position.del.tip.title": "是否确认删除当前职位？",
    "position.del.tip.msg": "如果确认删除，会将成员的对应职位也删除",
    "position.add.tip1": "职位[{{name}}]字符超过 {{max}} 位",
    "position.add.tip2": "职位[{{name}}]已存在",
    "position.select.tip": "请选择一个职位",
    "relation.tip1": "同步的成员关系不支持编辑",
    "config.info": "配置信息",
    "push.method": "推送方式：",
    "encryption.aes_key": "加密 aes_key：",
    "signature.token": "签名 token：",
    "request.URL": "请求网址：",
    "event.subscription": "事件订阅：",
    "create.role.group": "创建角色组",
    "role.group.name": "角色组名称",
    "role.group.name.placeholder": "请输入角色组名称",
    "role.group.name.notEmpty": "角色组名称不能为空",
    "role.group.name.tooLong": "角色组名称不能超过{{length}}个字符",
    "target.group": "目标分组",
    "role.group.remove.tip": "非空角色分组不能删除",
    "and.sub.group": "及子分组的角色",
    "role.edit.group.moveTo": "移动到「{{- groupName}}」分组",
    "Role.group.ID": "角色组ID",
    "gzt": "赣政通",
    "user.in.dept": "成员所在部门",
    "all.dept": "所有部门",
    "deactivated": "已停用",
    'deactivate.error.tip': '创建者/管理员/邀请中成员 不能进行停用操作',
    'deactivate.error.tip2': '没有停用的成员',
    'deactivate.alert.tip': '您确定停用所选成员？',
    'deactivate.alert.tip1': '停用成员后，该成员无法访问本企业（已选中：{{length1}}个成员，可停用：{{length2}}个成员）',
    'enable.error.tip': '创建者/管理员/邀请中成员 不能进行启用操作',
    'enable.error.tip2': '没有启用的成员',
    'enable.alert.tip': '您确定启用所选成员？',
    'enable.alert.tip1': '启用成员后，该成员可以访问本企业并恢复所有权限（已选中：{{length1}}个成员，可启用：{{length2}}个成员）',
    'frozen.switch.tip': '同步的新成员账号授权状态默认为',
    'enable.success.tip': '成功启用了{{length}}个成员，将恢复成员的访问权限',
    'deactivate.success.tip': '成功停用了{{length}}个成员，将限制停用成员的访问权限',
    'select.approval.dept': '选择审批部门',
    'select.approval.dept.tip': '你同时为多个部门的成员，请选择需要审批流程的部门',
    'select.approval.dept.tip1': '请选择需要审批流程的部门',
    'select.approval.dept.tip2': '请选择部门',
    'group.id': "分组ID",
    'dashboard.see.more': '查看更多',
    'dashboard.link.type': '链接类型',
    'dashboard.open.internal.page': '打开内部页面',
    'dashboard.open.external.link': '打开外部链接',
    'dashboard.dynamic.data.source': '动态数据来源',
    'dashboard.Static.data.source': '静态数据来源',
    "dataload.tree.tip1": "展开文件夹查看更多数据内容",
    "dataload.tree.tip2": "搜索结果展示：",
    "installation.package.update": "安装包更新应用",
    "installation.package.update.title": "请点击上传安装包更新此应用",
    "installation.package.update.re": "更换安装包",
    "installation.package.update.tip": "请重新上传安装包对此应用进行更新操作",
    "virtual.address.book": "虚拟通讯录",
    "virtual.address.book.msg": "*虚拟通讯录用于标准应用的设计,需要发布更新设置虚拟通讯录的映射关系以后才能使用。",
    "name.correspondence.settings": "名称对应关系设置",
    "outsider.member": "外部联系人成员",
    "virtual.add": "新增{{name}}",
    "virtual.add.title": "新增{{name}}信息",
    "virtual.add.name.placeholder": "请输入{{name}}名称",
    "virtual.add.describe.placeholder": "请输入描述内容",
    "virtual.add.name.tip": "名称只能输入中文、英文、数字和下划线，最长为128个字符",
    "virtual.edit.title": "编辑{{name}}信息",
    "virtual.delete.title": "确认删除「{{name}}」{{type}}？",
    "virtual.name.correspondence.settings": "虚拟通讯录名称对应关系设置",
    "corresponding.address.book.dept": "对应通讯录部门",
    "select.role": "选择角色",
    "select.outsiderGroup": "选择外部联系人分组",
    "select.outsider.member": "选择外部联系人成员",
    "corresponding.member": "对应通讯录成员",
    "corresponding.role": "对应通讯录角色",
    "corresponding.outsiderGroup": "对应通讯录外部联系人分组",
    "corresponding.outsider.member": "对应通讯录外部联系人成员",
    "test.version": "测试版",
    "test.app.edit": "标准应用编辑",
    "release.management": "发布管理",
    "release.set": "发布设置",
    "release.install.update.log": "安装更新记录",
    "release.user.management": "安装用户管理",
    "install.package.mode": "安装包模式",
    "download.install.package": "下载安装包",
    "custom.user.install": "自定义用户安装",
    "custom.user.install.msg": "*只允许哪些站点的哪些用户使用安装包",
    "install.package.mode.msg": "*导出安装包随意安装",
    "project.release.management": "发布项目管理",
    "project.release.management.list": "发布项目列表",
    "add.project.release.management": "发布新项目",
    "add.project.release.management.type": "添加分类",
    "project.name": "项目名称",
    "project.remark": "项目描述",
    "Project.name": "项目名称：",
    "Project.remark": "项目描述：",
    "Select.release.standard.app": "当前版本打包的应用：",
    "project.name.placeholder": "请输入项目名称",
    "project.remark.placeholder": "请输入项目描述",
    "project.group.name": "项目分类名称",
    "project.info.enter": "项目信息填写",
    "project.info": "项目信息",
    "project.management": "项目管理",
    "project.create": "应用搭建",
    "unbind.key": "生成解绑key",
    "unbind.key.not.empty": "key不能为空",
    "unbind.key.hint": "请输入解绑key",
    "unbind.key.error": "解绑key错误，请重新输入",
    "unbind.validate.hit": "请输入[确定解绑]来完成最后的操作",
    "unbind.validate.text": "确定解绑",
    "select.release.standard.app": "选择要发布的标准应用",
    "select.release.standard.app.waterMark": "请选择要发布的标准应用",
    "project.set": "项目设置",
    "project.init.version": "项目初始化版本号：",
    "init.set": "初始设置",
    "select.user.install": "选择可安装用户：",
    "allow.anyone.install": "允许任何人安装",
    "only.allow.user.install": "只允许指定用户安装",
    "user.management": "用户管理",
    "trial.time.after.first.installation": "首次安装后的试用时间：",
    "installation.notes": "安装说明",
    "installation.notes.placeholder": "请输入安装说明",
    "not.limited": "不限制",
    "release.new.version": "发布新版本",
    "install.log": "安装日志",
    "history.version": "历史版本",
    "project.version": "当前版本 ",
    "project.site": "站点",
    "project.user.account": "用户账号",
    "project.user.name": "用户昵称",
    "current.version": "当前版本",
    "add.user": "添加用户",
    postpone: "延期",
    "disable.restore": "禁用/恢复",
    "unbind.management": "解除绑定管理",
    "project.user.detail": "用户详情",
    "user.site": "用户站点",
    "user.account": "用户账户",
    "user.name": "用户昵称",
    "begin.install.time": "开始安装时间",
    "end.update.time": "最后更新时间",
    "project.note": "备注",
    "project.state": "状态",
    "project.unbind.key": "解绑key",
    "project.unbind.key.clear": "清空解绑key",
    "project.debug": "调试",
    "project.debug.token.title": "调试权限",
    "project.debug.token": "token：{{token}}",
    "project.debug.token.time": "有效时间：{{time}}小时",
    "project.debug.token.permanent": "有效时间：永久",
    "project.debug.token.clear": "清空调试token",
    "project.debug.token.generate": "生成调试token",
    "project.debug.token.effective.time.error": "有效时间不能为0",
    "project.debug.token.empty": "调试token不能为空",
    "project.debug.token.error": "调试token错误，请重新输入",
    "project.debug.token.tip": "请输入token，开启调试功能",
    "effective.time": "有效时间",
    "project.update.state": "是否允许更新",
    "project.update.state.ing": "允许",
    "project.update.stop.ing": "允许",
    "project.update.stop": "停止",
    "project.update.restart": "允许",
    "project.update.stop.tip": "是否停止应用的更新？",
    "project.update.restart.tip": "是否恢复应用的更新？",
    "edit.note": "修改备注",
    "Operating.time": "操作时间：",
    "Operating.type": "操作类型：",
    "operating.cont": "操作内容",
    "please.enter.keyword": "请输入关键词",
    "edit.project.release.management": "编辑名称",
    "placeholder.project.site": "请输入站点名称",
    "placeholder.project.user.account": "请输入用户账号",
    "placeholder.project.user.name": "请输入用户昵称",
    "placeholder.maturity.time": "请选择到期时间",
    "search.data.operation.record": "搜索操作记录",
    "placeholder.contact.note": "请输入备注",
    "user.postpone": "用户延期",
    "postpone.note": "延期说明",
    "postpone.time": "延期时间",
    "placeholder.postpone.note": "请输入延期说明",
    "placeholder.postpone.time": "请选择延期时间",
    "placeholder.operating.time": "请选择操作时间",
    "restore": "恢复",
    "query.restore.title": "确认恢复「{{name}}」用户？",
    "query.disable.title": "确认禁用「{{name}}」用户？",
    "query.disable.msg": "用户被禁用以后不是立即生效，会在24小时内停止用户使用。",
    "unbind.management.msg": "注意：此模式会解绑用户标准应用管理，允许用户自己搭建，用户能进入编辑界面进行应用设计和编辑，无法进行更新操作。",
    "install.version": "安装版本",
    "release.time": "发布时间",
    "update.cont": "更新内容",
    "doc.link": "文档链接",
    "version.download": "版本下载",
    "Latest.version.number": "目前最新版本号：",
    "Applications.packaged.latest.version": "最新版本打包的应用：",
    "Update.cont": "更新内容：",
    "Doc.link": "文档链接：",
    "placeholder.update.cont": "请输入更新内容",
    "placeholder.doc.link": "请输入文档链接",
    "maturity.time.msg": "*选择空值代表永久",
    "only.allow.user.install.msg": "*切换至【用户管理】页添加用户",
    "create.new.standard": "新建空白标准应用",
    "create.new.standard1": "选择现有应用转为标准应用",
    "copy.standard.msg": "*复制普通应用模式，不影响原普通应用使用",
    "standard.search.placeholder": "输入关键字快速搜索应用",
    "has.standard.app.update": "有应用可更新",
    "go.update": "去更新",
    "app.package.import.export": "应用包导入导出",
    "update.app": "更新应用",
    "update.project.app": "更新项目应用",
    "Apps.need.update": "需要更新的应用：",
    "batch.export.app": "批量导出应用",
    "batch.import.app": "批量导入应用安装包",
    "app.batch.import-export": "应用包导入导出",
    "app.batch.import": "导入应用包安装包",
    "app.batch.import.tip": "应用包导入中",
    "app.batch.import.set": '导入设置',
    "app.batch.import.subtitle": "导入应用包安装文件",
    "app.batch.export": "导出应用包",
    "app.batch.export1": "导出应用",
    "app.batch.export.title": "批量导出应用",
    "app.batch.export.set": "导出设置",
    "app.batch.export.title.tip": "批量导入导出多个应用，视图，聚合表以及跨应用的设置",
    "update.cont.tip": "更新内容不能为空",
    "trial.time.after.first.tip": "首次安装后的试用时间只能在0 - 99999之间",
    "all.standard.application": "全部标准应用",
    "select.user.relation": "选择成员关系",
    "corresponding.user.relation": "对应通讯录成员关系",
    "select.release.app": "选择要发布的应用",
    "select.release.app.waterMark": "请选择要发布的应用",
    "batch.export.app.msg": "*批量导出应用不包含标准应用",
    "new.export.app": "新导入",
    "del.project.group.title": "是否删除该项目分类？",
    "del.project.group.tip": "只能删除空项目分类",
    "amap.sdk.load.fail": "高德SDK加载失败，请联系管理员处理",
    "workbench.img.link": "跳转指定链接",
    "workbench.noticeBoard.no": "暂未设置公告栏",
    "workbench.noticeBoard.thare.style": "其他样式",
    "workbench.noticeBoard.title": "标题栏",
    "workbench.noticeBoard.dataSource": "公告内容",
    "workbench.noticeBoard.setting": "配置公告",
    "workbench.noticeBoard.add": "添加公告",
    "workbench.noticeBoard.add.img": "公告配图",
    "workbench.noticeBoard.add.outlin": "内容来源",
    "workbench.noticeBoard.add.number": "数据条数",
    "workbench.noticeBoard.add.title": "公告栏标题",
    "workbench.carouselMap.bg.title": "图片填充方式",
    "workbench.myApp.title": "我管理的",
    "app.group.repeat": "分组名称不能重复",
    "not.create.report": "你还没有创建任何报表",
    "not.create.app.form.dash": "你还没有创建任何应用/表单/报表",
    "setting.app.group": "设置应用分组",
    "Graffiti": "涂鸦",
};

export default langCN